(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("xpKCW", function(module, exports) {

var $4Nugj = parcelRequire("4Nugj");

var $1KhuP = parcelRequire("1KhuP");
const $06470ecdd856c5ab$var$blocksEl = document.querySelector(".blocks");
const $06470ecdd856c5ab$var$btnDownUp = document.querySelector(".button-scroll-down");
$06470ecdd856c5ab$var$blocksEl.innerHTML = "";
$06470ecdd856c5ab$var$blocksEl.insertAdjacentHTML("beforeend", (0, $1KhuP.murkupFoundation)((0, $4Nugj.blocks)));
$06470ecdd856c5ab$var$btnDownUp.addEventListener("click", $06470ecdd856c5ab$var$scrollDownUp);
function $06470ecdd856c5ab$var$scrollDownUp() {
    let scrollBottom = $06470ecdd856c5ab$var$blocksEl.scrollHeight - $06470ecdd856c5ab$var$blocksEl.scrollTop - $06470ecdd856c5ab$var$blocksEl.clientHeight;
    if (scrollBottom > 1) $06470ecdd856c5ab$var$scrollDown();
    else $06470ecdd856c5ab$var$scrollUp();
}
function $06470ecdd856c5ab$var$scrollDown() {
    const { height: cardHeight } = document.querySelector(".blocks").firstElementChild.getBoundingClientRect();
    const element = document.getElementsByClassName("block")[0];
    const margin = window.getComputedStyle(element).marginBottom;
    $06470ecdd856c5ab$var$blocksEl.scrollBy({
        top: cardHeight + Number.parseInt(margin),
        behavior: "smooth"
    });
}
function $06470ecdd856c5ab$var$scrollUp() {
    $06470ecdd856c5ab$var$blocksEl.scrollBy({
        top: -$06470ecdd856c5ab$var$blocksEl.scrollHeight,
        behavior: "smooth"
    });
}

});
parcelRequire.register("4Nugj", function(module, exports) {

$parcel$export(module.exports, "elements", function () { return $37e33676934ad046$export$7a5d735b2ab6389d; });
$parcel$export(module.exports, "blocks", function () { return $37e33676934ad046$export$12a40731da9c9684; });

var $e6ztD = parcelRequire("e6ztD");

var $ipVXN = parcelRequire("ipVXN");

var $1GoMY = parcelRequire("1GoMY");

var $1XGYc = parcelRequire("1XGYc");

var $cyudu = parcelRequire("cyudu");

var $bv4pO = parcelRequire("bv4pO");

var $f5Iu7 = parcelRequire("f5Iu7");

var $jEW4Z = parcelRequire("jEW4Z");

var $2pfSv = parcelRequire("2pfSv");

var $24y4a = parcelRequire("24y4a");

var $eWpjs = parcelRequire("eWpjs");

var $9zvtd = parcelRequire("9zvtd");

var $6C4Kk = parcelRequire("6C4Kk");

var $5h9GQ = parcelRequire("5h9GQ");

var $dOcqj = parcelRequire("dOcqj");

var $ltABj = parcelRequire("ltABj");

var $1hd6c = parcelRequire("1hd6c");

var $9FWLX = parcelRequire("9FWLX");
const $37e33676934ad046$export$7a5d735b2ab6389d = {
    booksInfo: document.querySelector(".books-list"),
    modalMainBtn: document.querySelector(".js-modal-btn"),
    modalBookCard: document.querySelector(".js-modal-book"),
    modalBtnClose: document.querySelector(".js-modal-close"),
    modal: document.querySelector(".js-modal"),
    body: document.body,
    categoryList: document.querySelector(".category-list"),
    signUpBtn: document.querySelector("#signup"),
    signInBtn: document.querySelector("#signin"),
    signUpBtnHeader: document.querySelector(".signup-header"),
    signUpBtnBurger: document.querySelector(".signup-burger"),
    userNameText: document.querySelector(".text-stephen"),
    userNameTextMobile: document.querySelector("#text-stephen"),
    closeFormBtn: document.querySelector(".js-form-close"),
    formElSignIn: document.querySelector(".form-wrapper"),
    formElSignUp: document.querySelector(".form-wrapper-signup"),
    navList: document.querySelector(".nav"),
    signUpSvg: document.querySelector(".sign-up-svg"),
    userDivHeader: document.querySelector(".div-stephen-header"),
    mobileMenuSignUP: document.querySelector(".mobile-wrapper-signup"),
    btnLogOutList: document.querySelectorAll(".log-out"),
    formContainer: document.querySelector(".form-container")
};
let $37e33676934ad046$export$12a40731da9c9684 = [
    {
        id: 1,
        title: "Save the Children",
        url: "https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($e6ztD)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($e6ztD)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($ipVXN)))} 2x`
    },
    {
        id: 2,
        title: "Project HOPE",
        url: "https://www.projecthope.org/country/ukraine/",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($1GoMY)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($1GoMY)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($1XGYc)))} 2x`
    },
    {
        id: 3,
        title: "International Medical Corps",
        url: "https://internationalmedicalcorps.org/country/ukraine/",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($cyudu)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($cyudu)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($bv4pO)))} 2x`
    },
    {
        id: 4,
        title: "RAZOM",
        url: "https://www.razomforukraine.org/",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($f5Iu7)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($f5Iu7)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($jEW4Z)))} 2x`
    },
    {
        id: 5,
        title: "Action against hunger",
        url: "https://www.actionagainsthunger.org/location/europe/ukraine/",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($2pfSv)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($2pfSv)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($24y4a)))} 2x`
    },
    {
        id: 6,
        title: "Serhiy Prytula Charity Foundation",
        url: "https://prytulafoundation.org/en",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($eWpjs)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($eWpjs)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($9zvtd)))} 2x`
    },
    {
        id: 7,
        title: "Medicins Sans Frontieres",
        url: "https://www.msf.org/ukraine",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($6C4Kk)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($6C4Kk)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($5h9GQ)))} 2x`
    },
    {
        id: 8,
        title: "World vision",
        url: "https://www.wvi.org/emergencies/ukraine",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($dOcqj)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($dOcqj)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($ltABj)))} 2x`
    },
    {
        id: 9,
        title: "UNITED24",
        url: "https://u24.gov.ua/uk",
        img: `${(0, (/*@__PURE__*/$parcel$interopDefault($1hd6c)))}`,
        imgr: `${(0, (/*@__PURE__*/$parcel$interopDefault($1hd6c)))} 1x, ${(0, (/*@__PURE__*/$parcel$interopDefault($9FWLX)))} 2x`
    }
];

});
parcelRequire.register("e6ztD", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("f7gxa");

});
parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});


parcelRequire.register("ipVXN", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("h7xr9");

});

parcelRequire.register("1GoMY", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("j5410");

});

parcelRequire.register("1XGYc", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("cqMZH");

});

parcelRequire.register("cyudu", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("5EOPU");

});

parcelRequire.register("bv4pO", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("b3xSH");

});

parcelRequire.register("f5Iu7", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("bxQXn");

});

parcelRequire.register("jEW4Z", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("7fOH2");

});

parcelRequire.register("2pfSv", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("bVtxb");

});

parcelRequire.register("24y4a", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("gNgmT");

});

parcelRequire.register("eWpjs", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("5xjT1");

});

parcelRequire.register("9zvtd", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("gKGw8");

});

parcelRequire.register("6C4Kk", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("1lVbT");

});

parcelRequire.register("5h9GQ", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("aYuzo");

});

parcelRequire.register("dOcqj", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("lA8cL");

});

parcelRequire.register("ltABj", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("3XAoT");

});

parcelRequire.register("1hd6c", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("49EBR");

});

parcelRequire.register("9FWLX", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("dgUnf");

});


parcelRequire.register("1KhuP", function(module, exports) {

$parcel$export(module.exports, "createModalMarkup", function () { return $1457a8b41868a85b$export$fc0ff788b21a7621; });
$parcel$export(module.exports, "createCartBookMarcup", function () { return $1457a8b41868a85b$export$3e4db0e27c86b015; });
$parcel$export(module.exports, "murkupFoundation", function () { return $1457a8b41868a85b$export$a68dd502c280cf3c; });

var $jomp5 = parcelRequire("jomp5");

var $8nr9c = parcelRequire("8nr9c");

var $eBbzC = parcelRequire("eBbzC");

var $ibdE5 = parcelRequire("ibdE5");

var $5lfFX = parcelRequire("5lfFX");

var $7Dpa5 = parcelRequire("7Dpa5");

var $lBICG = parcelRequire("lBICG");

var $6BxDl = parcelRequire("6BxDl");

var $f9irG = parcelRequire("f9irG");
function $1457a8b41868a85b$export$fc0ff788b21a7621(book) {
    /**створюю об'єкт з даними про назви магазинів і посиланнь на зображення*/ const storesImgs = [
        {
            name: "Amazon",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($jomp5))),
                (0, (/*@__PURE__*/$parcel$interopDefault($ibdE5))),
                (0, (/*@__PURE__*/$parcel$interopDefault($5lfFX)))
            ]
        },
        {
            name: "Apple Books",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($8nr9c))),
                (0, (/*@__PURE__*/$parcel$interopDefault($7Dpa5))),
                (0, (/*@__PURE__*/$parcel$interopDefault($lBICG)))
            ]
        },
        {
            name: "Barnes and Noble",
            img: [
                (0, (/*@__PURE__*/$parcel$interopDefault($eBbzC))),
                (0, (/*@__PURE__*/$parcel$interopDefault($6BxDl))),
                (0, (/*@__PURE__*/$parcel$interopDefault($f9irG)))
            ]
        }
    ];
    /**шукаю посилання на сторінку магазинів і записую їх в попередній об'єкт */ storesImgs.forEach((i)=>{
        i.link = book.buy_links.find((item)=>item.name == i.name).url;
    });
    /**формую розмітку блоку "Магазини" */ const storesListMarkup = storesImgs.map((i)=>`<li class="modal-shops-item">
            <a class="modal-link" href="${i.link}"
               target="_blank" name="${i.name}"
                        rel="noreferrer noopener">
                        <img class="modal-img-shop" src="${i.img[0]}" alt="${i.name}" srcset="${i.img[1]} 1x, ${i.img[2]} 2x">
                    </a>
                </li>`).join("");
    /** перевіряю чи є картинка в відповіді з бекенда і повертаю розмітку картинки */ const imgModal = book.book_image ? `<img src="${book.book_image}" 
              alt="${book.list_name}" 
              id="${book._id}" class="modal-img"></img>` : "";
    /**формую картку модалки */ return `<div class="modal-img-wrap">
             ${imgModal}
          </div>
          <div>
            <h2 class="modal-title">${book.title}</h2>
            <h3 class="modal-autor">${book.author}</h3>
            <p class="modal-descr">${book.description || book.list_name}</p>
            <ul class="modal-shops">
                ${storesListMarkup}
            </ul>
          </div>`;
}
function $1457a8b41868a85b$export$3e4db0e27c86b015(data) {
    const cartBook = data.map(({ _id: _id, book_image: book_image, title: title, author: author })=>`<div class="book-card" tabindex="0" data-id="${_id}">
       <div class = "book-img">
         <img src="${book_image}" alt="${title}" class="book-card-img" width="300" height="300"  data-modal-open="true">
           <div class="overlay">
             <p class="overlay-text">quick view</p>
          </div>       
         </div>
         <h4 class="book-card-title">${title}</h4>
        <p class="book-card-author">${author}</p>
       </div>`).join("");
    return cartBook;
}
function $1457a8b41868a85b$export$a68dd502c280cf3c(arr) {
    // blocksEl.innerHTML=''
    return arr.map(({ title: title, url: url, img: img, id: id, imgr: imgr })=>`
    <li class="block">
   <div>
    <a href="${url}" class='gotofoundation' target="_blank">
        <p>0${id}</p>
        <img  class='image' src='${img}' srcset='${imgr}' alt="${title}">
    </a>
   </div>
  </li>`).join("");
}

});
parcelRequire.register("jomp5", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("ei4R3");

});

parcelRequire.register("8nr9c", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("c8Zp5");

});

parcelRequire.register("eBbzC", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("jeqkq");

});

parcelRequire.register("ibdE5", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("2kw6b");

});

parcelRequire.register("5lfFX", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("5iIId");

});

parcelRequire.register("7Dpa5", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("1WDfw");

});

parcelRequire.register("lBICG", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("dD20i");

});

parcelRequire.register("6BxDl", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("E6g71");

});

parcelRequire.register("f9irG", function(module, exports) {


module.exports = (parcelRequire("aNJCr")).getBundleURL("jXFiS") + (parcelRequire("iE7OH")).resolve("96m6w");

});



parcelRequire.register("i8Q71", function(module, exports) {

$parcel$export(module.exports, "openBurger", function () { return $d35165bd5db5382a$export$9e55a46131d59262; });
let $d35165bd5db5382a$var$currentPage = localStorage.getItem("currentPage") || "index";
const $d35165bd5db5382a$var$navList = document.querySelector(".nav-list");
$d35165bd5db5382a$var$navList.addEventListener("click", (evt)=>{
    const currentItem = evt.target.closest(".nav-item");
    if (currentItem) {
        $d35165bd5db5382a$var$currentPage = currentItem.getAttribute("data-page");
        localStorage.setItem("currentPage", $d35165bd5db5382a$var$currentPage);
        $d35165bd5db5382a$var$updateNavLinks();
    }
});
function $d35165bd5db5382a$var$updateNavLinks() {
    const homeLink = document.querySelector('.nav-item[data-page="index"]');
    const shoppingListLink = document.querySelector('.nav-item[data-page="shopping-list"]');
    homeLink.classList.toggle("nav-item-current", $d35165bd5db5382a$var$currentPage === "index");
    shoppingListLink.classList.toggle("nav-item-current", $d35165bd5db5382a$var$currentPage === "shopping-list");
}
const $d35165bd5db5382a$var$mobileMenuItems = document.querySelectorAll(".mobile-container [data-page]");
$d35165bd5db5382a$var$mobileMenuItems.forEach((item)=>{
    item.addEventListener("click", ()=>{
        $d35165bd5db5382a$var$currentPage = item.getAttribute("data-page");
        localStorage.setItem("currentPage", $d35165bd5db5382a$var$currentPage);
        $d35165bd5db5382a$var$updateMobileNavLinks();
    });
});
function $d35165bd5db5382a$var$updateMobileNavLinks() {
    $d35165bd5db5382a$var$mobileMenuItems.forEach((item)=>{
        const pageAttribute = item.getAttribute("data-page");
        item.classList.toggle("nav-item-current", $d35165bd5db5382a$var$currentPage === pageAttribute);
    });
}
$d35165bd5db5382a$var$updateNavLinks();
const $d35165bd5db5382a$var$userNameTextMobile = document.querySelector("#text-stephen");
const $d35165bd5db5382a$var$userNameLocal = localStorage.getItem("userName");
const $d35165bd5db5382a$var$menuBtnRef = document.querySelector("[data-menu-button]");
$d35165bd5db5382a$var$menuBtnRef.addEventListener("click", $d35165bd5db5382a$export$9e55a46131d59262);
function $d35165bd5db5382a$export$9e55a46131d59262() {
    const mobileMenuSignIN = document.querySelector(".mobile-wrapper");
    const expanded = $d35165bd5db5382a$var$menuBtnRef.getAttribute("aria-expanded") === "true" || false;
    $d35165bd5db5382a$var$menuBtnRef.classList.toggle("is-open");
    $d35165bd5db5382a$var$menuBtnRef.setAttribute("aria-expanded", !expanded);
    if ($d35165bd5db5382a$var$userNameLocal) {
        mobileMenuSignIN.classList.toggle("is-hidden");
        $d35165bd5db5382a$var$userNameTextMobile.textContent = localStorage.getItem("userName");
        if (!mobileMenuSignIN.classList.contains("is-hidden")) document.body.classList.toggle("no-scroll");
    } else {
        const mobileMenuSignUP = document.querySelector(".mobile-wrapper-signup");
        mobileMenuSignUP.classList.toggle("is-hidden");
        if (!mobileMenuSignUP.classList.contains("is-hidden")) document.body.classList.toggle("no-scroll");
    }
}

});

parcelRequire.register("k5quo", function(module, exports) {
parcelRequire("fkNhc");
var $MjY8E = parcelRequire("MjY8E");
parcelRequire("gQOBw");
var $gVFeG = parcelRequire("gVFeG");
parcelRequire("6m2hf");
var $221Dt = parcelRequire("221Dt");

var $i8Q71 = parcelRequire("i8Q71");

var $fivgP = parcelRequire("fivgP");

var $4Nugj = parcelRequire("4Nugj");
const $e9f8d2818c91b526$var$firebaseConfig = {
    apiKey: "AIzaSyBZmcnC_2fBns-z8P5Wk9Fw_wxB6fZENSM",
    authDomain: "project02-dreamteam.firebaseapp.com",
    projectId: "project02-dreamteam",
    storageBucket: "project02-dreamteam.appspot.com",
    messagingSenderId: "730112308415",
    appId: "1:730112308415:web:8b4126c6ce805ba77a020a"
};
const $e9f8d2818c91b526$var$app = (0, $MjY8E.initializeApp)($e9f8d2818c91b526$var$firebaseConfig);
const $e9f8d2818c91b526$var$auth = (0, $gVFeG.o)();
const $e9f8d2818c91b526$var$db = (0, $221Dt.getFirestore)($e9f8d2818c91b526$var$app);
(0, $4Nugj.elements).formContainer.addEventListener("click", $e9f8d2818c91b526$var$handleButtonClick);
function $e9f8d2818c91b526$var$handleButtonClick(evt) {
    if (evt.target.classList.contains("signupbtn")) {
        (0, $4Nugj.elements).formElSignUp.classList.remove("is-hidden");
        (0, $4Nugj.elements).formElSignIn.classList.add("is-hidden");
    } else if (evt.target.classList.contains("signinbtn")) {
        (0, $4Nugj.elements).formElSignUp.classList.add("is-hidden");
        (0, $4Nugj.elements).formElSignIn.classList.remove("is-hidden");
    }
    const signUpBtn = (0, $4Nugj.elements).formContainer.querySelector(".signupbtn");
    const signInBtn = (0, $4Nugj.elements).formContainer.querySelector(".signinbtn");
    (0, $4Nugj.elements).signUpBtn.classList.toggle("is-active", evt.target === signUpBtn);
    (0, $4Nugj.elements).signInBtn.classList.toggle("is-active", evt.target === signInBtn);
    document.body.classList.toggle("no-scroll", !(0, $4Nugj.elements).formElSignUp.classList.contains("is-hidden"));
}
(0, $4Nugj.elements).signUpBtn.addEventListener("click", $e9f8d2818c91b526$var$signUp);
(0, $4Nugj.elements).signInBtn.addEventListener("click", $e9f8d2818c91b526$var$signIn);
(0, $4Nugj.elements).btnLogOutList.forEach((btnLogOut)=>{
    btnLogOut.addEventListener("click", $e9f8d2818c91b526$var$logOut);
});
(0, $4Nugj.elements).signUpBtnHeader.addEventListener("click", $e9f8d2818c91b526$var$toggleForm);
(0, $4Nugj.elements).signUpBtnBurger.addEventListener("click", $e9f8d2818c91b526$var$mobileFormOpen);
(0, $4Nugj.elements).closeFormBtn.addEventListener("click", $e9f8d2818c91b526$var$toggleForm);
(0, $4Nugj.elements).signUpSvg.addEventListener("click", ()=>{
    (0, $4Nugj.elements).btnLogOutList.forEach((btnLogOut)=>{
        btnLogOut.classList.toggle("show");
    });
});
const $e9f8d2818c91b526$var$userNameLocal = localStorage.getItem("userName");
if ($e9f8d2818c91b526$var$userNameLocal) {
    (0, $4Nugj.elements).signUpBtnHeader.style.display = "none";
    (0, $4Nugj.elements).userNameText.textContent = localStorage.getItem("userName");
    (0, $4Nugj.elements).userDivHeader.style.display = "flex";
    (0, $4Nugj.elements).navList.style.display = "flex";
}
function $e9f8d2818c91b526$var$mobileFormOpen() {
    (0, $i8Q71.openBurger)();
    (0, $4Nugj.elements).formElSignIn.classList.toggle("is-hidden");
    if (!(0, $4Nugj.elements).formElSignIn.classList.contains("is-hidden")) document.body.classList.toggle("no-scroll");
}
function $e9f8d2818c91b526$var$toggleForm(evt) {
    (0, $4Nugj.elements).formElSignIn.classList.toggle("is-hidden");
    if (!(0, $4Nugj.elements).formElSignIn.classList.contains("is-hidden")) document.body.classList.toggle("no-scroll");
}
async function $e9f8d2818c91b526$var$signUp(evt) {
    try {
        const email = document.querySelector("#emailSignUp").value;
        const password = document.querySelector("#pswSignUp").value;
        const userName = document.querySelector("#userNameSignUp").value;
        const userAuth = await (0, $gVFeG.a8)($e9f8d2818c91b526$var$auth, email, password);
        const uid = userAuth.user.uid;
        // const userObj = {
        //   userName,
        //   email,  
        //   accountActivate: true,
        //   uid
        // }
        // console.log("authObj", userObj)
        // const userRef = doc(db, "users", userAuth.uid,);
        // const userDB = await setDoc(userRef, userObj);
        // console.log("authObj", userDB);
        localStorage.setItem("userUid", uid);
        localStorage.setItem("userName", userName);
        (0, $4Nugj.elements).userNameText.textContent = userName;
        (0, $4Nugj.elements).userNameTextMobile.textContent = userName;
        (0, $4Nugj.elements).navList.style.display = "flex";
        window.location.replace("./index.html");
    } catch (error) {
        const errorMessage = error.message;
        (0, $fivgP.Report).failure(`${errorMessage}`, '"Failure is simply the opportunity to begin again, this time more intelligently." <br/><br/>- Henry Ford', "Okey... Fix it", ()=>{
            location.reload();
        });
    }
}
async function $e9f8d2818c91b526$var$signIn(evt) {
    try {
        const email = document.querySelector("#email").value;
        const password = document.querySelector("#psw").value;
        const userName = document.querySelector("#userName").value;
        const userLogin = await (0, $gVFeG.a9)($e9f8d2818c91b526$var$auth, email, password);
        localStorage.setItem("userUid", userLogin.user.uid);
        localStorage.setItem("userName", userName);
        (0, $4Nugj.elements).userNameText.textContent = userName;
        (0, $4Nugj.elements).userNameTextMobile.textContent = userName;
        window.location.replace("./index.html");
    } catch (error) {
        const errorMessage = error.message;
        (0, $fivgP.Report).failure(`${errorMessage}`, '"Failure is simply the opportunity to begin again, this time more intelligently." <br/><br/>- Henry Ford', "Okey... Fix it", ()=>{
            location.reload();
        });
    }
}
async function $e9f8d2818c91b526$var$logOut() {
    (0, $gVFeG.B)($e9f8d2818c91b526$var$auth).then(()=>{
        localStorage.removeItem("userName");
        (0, $4Nugj.elements).userDivHeader.classList.add("is-hidden");
        localStorage.removeItem("userUid");
        window.location.replace("./index.html");
        (0, $4Nugj.elements).navList.style.display = "none";
        (0, $4Nugj.elements).signUpBtnHeader.style.display = "flex";
    }).catch((err)=>{
        console.log(err);
    });
}

});
parcelRequire.register("fkNhc", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("MjY8E")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("MjY8E")).registerVersion; });

var $MjY8E = parcelRequire("MjY8E");
var $b29ef28f0d58131e$var$name = "firebase";
var $b29ef28f0d58131e$var$version = "10.1.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $MjY8E.registerVersion)($b29ef28f0d58131e$var$name, $b29ef28f0d58131e$var$version, "app");

});
parcelRequire.register("MjY8E", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $0913f93b5b3c9bac$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $0913f93b5b3c9bac$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_removeServiceInstance", function () { return $0913f93b5b3c9bac$export$48d18de2ff1c45a5; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $0913f93b5b3c9bac$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $0913f93b5b3c9bac$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $0913f93b5b3c9bac$export$f9962582c9e66d99; });
$parcel$export(module.exports, "registerVersion", function () { return $0913f93b5b3c9bac$export$d29d5299a7137abc; });

var $6ExWU = parcelRequire("6ExWU");

var $kZfxc = parcelRequire("kZfxc");

var $2xDiJ = parcelRequire("2xDiJ");

var $ajgRO = parcelRequire("ajgRO");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0913f93b5b3c9bac$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($0913f93b5b3c9bac$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $0913f93b5b3c9bac$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $0913f93b5b3c9bac$var$name$o = "@firebase/app";
const $0913f93b5b3c9bac$var$version$1 = "0.9.15";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0913f93b5b3c9bac$var$logger = new (0, $kZfxc.Logger)("@firebase/app");
const $0913f93b5b3c9bac$var$name$n = "@firebase/app-compat";
const $0913f93b5b3c9bac$var$name$m = "@firebase/analytics-compat";
const $0913f93b5b3c9bac$var$name$l = "@firebase/analytics";
const $0913f93b5b3c9bac$var$name$k = "@firebase/app-check-compat";
const $0913f93b5b3c9bac$var$name$j = "@firebase/app-check";
const $0913f93b5b3c9bac$var$name$i = "@firebase/auth";
const $0913f93b5b3c9bac$var$name$h = "@firebase/auth-compat";
const $0913f93b5b3c9bac$var$name$g = "@firebase/database";
const $0913f93b5b3c9bac$var$name$f = "@firebase/database-compat";
const $0913f93b5b3c9bac$var$name$e = "@firebase/functions";
const $0913f93b5b3c9bac$var$name$d = "@firebase/functions-compat";
const $0913f93b5b3c9bac$var$name$c = "@firebase/installations";
const $0913f93b5b3c9bac$var$name$b = "@firebase/installations-compat";
const $0913f93b5b3c9bac$var$name$a = "@firebase/messaging";
const $0913f93b5b3c9bac$var$name$9 = "@firebase/messaging-compat";
const $0913f93b5b3c9bac$var$name$8 = "@firebase/performance";
const $0913f93b5b3c9bac$var$name$7 = "@firebase/performance-compat";
const $0913f93b5b3c9bac$var$name$6 = "@firebase/remote-config";
const $0913f93b5b3c9bac$var$name$5 = "@firebase/remote-config-compat";
const $0913f93b5b3c9bac$var$name$4 = "@firebase/storage";
const $0913f93b5b3c9bac$var$name$3 = "@firebase/storage-compat";
const $0913f93b5b3c9bac$var$name$2 = "@firebase/firestore";
const $0913f93b5b3c9bac$var$name$1 = "@firebase/firestore-compat";
const $0913f93b5b3c9bac$var$name = "firebase";
const $0913f93b5b3c9bac$var$version = "10.1.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $0913f93b5b3c9bac$export$9f30fa0c10967f7f = "[DEFAULT]";
const $0913f93b5b3c9bac$var$PLATFORM_LOG_STRING = {
    [$0913f93b5b3c9bac$var$name$o]: "fire-core",
    [$0913f93b5b3c9bac$var$name$n]: "fire-core-compat",
    [$0913f93b5b3c9bac$var$name$l]: "fire-analytics",
    [$0913f93b5b3c9bac$var$name$m]: "fire-analytics-compat",
    [$0913f93b5b3c9bac$var$name$j]: "fire-app-check",
    [$0913f93b5b3c9bac$var$name$k]: "fire-app-check-compat",
    [$0913f93b5b3c9bac$var$name$i]: "fire-auth",
    [$0913f93b5b3c9bac$var$name$h]: "fire-auth-compat",
    [$0913f93b5b3c9bac$var$name$g]: "fire-rtdb",
    [$0913f93b5b3c9bac$var$name$f]: "fire-rtdb-compat",
    [$0913f93b5b3c9bac$var$name$e]: "fire-fn",
    [$0913f93b5b3c9bac$var$name$d]: "fire-fn-compat",
    [$0913f93b5b3c9bac$var$name$c]: "fire-iid",
    [$0913f93b5b3c9bac$var$name$b]: "fire-iid-compat",
    [$0913f93b5b3c9bac$var$name$a]: "fire-fcm",
    [$0913f93b5b3c9bac$var$name$9]: "fire-fcm-compat",
    [$0913f93b5b3c9bac$var$name$8]: "fire-perf",
    [$0913f93b5b3c9bac$var$name$7]: "fire-perf-compat",
    [$0913f93b5b3c9bac$var$name$6]: "fire-rc",
    [$0913f93b5b3c9bac$var$name$5]: "fire-rc-compat",
    [$0913f93b5b3c9bac$var$name$4]: "fire-gcs",
    [$0913f93b5b3c9bac$var$name$3]: "fire-gcs-compat",
    [$0913f93b5b3c9bac$var$name$2]: "fire-fst",
    [$0913f93b5b3c9bac$var$name$1]: "fire-fst-compat",
    "fire-js": "fire-js",
    [$0913f93b5b3c9bac$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $0913f93b5b3c9bac$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0913f93b5b3c9bac$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $0913f93b5b3c9bac$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($0913f93b5b3c9bac$export$9566bce3835c0f28.has(componentName)) {
        $0913f93b5b3c9bac$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $0913f93b5b3c9bac$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $0913f93b5b3c9bac$export$b4e3c36c855b14b5.values())$0913f93b5b3c9bac$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $0913f93b5b3c9bac$export$9f30fa0c10967f7f) {
    $0913f93b5b3c9bac$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $0913f93b5b3c9bac$export$3685d89b9c3cdfaf() {
    $0913f93b5b3c9bac$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0913f93b5b3c9bac$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."
};
const $0913f93b5b3c9bac$var$ERROR_FACTORY = new (0, $2xDiJ.ErrorFactory)("app", "Firebase", $0913f93b5b3c9bac$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $0913f93b5b3c9bac$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $6ExWU.Component)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $0913f93b5b3c9bac$export$31499a9cd224b78c = $0913f93b5b3c9bac$var$version;
function $0913f93b5b3c9bac$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $0913f93b5b3c9bac$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $2xDiJ.getDefaultAppConfig)());
    if (!options) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $0913f93b5b3c9bac$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $2xDiJ.deepEqual)(options, existingApp.options) && (0, $2xDiJ.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $6ExWU.ComponentContainer)(name);
    for (const component of $0913f93b5b3c9bac$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $0913f93b5b3c9bac$var$FirebaseAppImpl(options, config, container);
    $0913f93b5b3c9bac$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $0913f93b5b3c9bac$export$f9962582c9e66d99(name = $0913f93b5b3c9bac$export$9f30fa0c10967f7f) {
    const app = $0913f93b5b3c9bac$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $0913f93b5b3c9bac$export$9f30fa0c10967f7f && (0, $2xDiJ.getDefaultAppConfig)()) return $0913f93b5b3c9bac$export$c55cfd413944906d();
    if (!app) throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $0913f93b5b3c9bac$export$68ddedf7d44b3bdf() {
    return Array.from($0913f93b5b3c9bac$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $0913f93b5b3c9bac$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($0913f93b5b3c9bac$export$b4e3c36c855b14b5.has(name)) {
        $0913f93b5b3c9bac$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $0913f93b5b3c9bac$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $0913f93b5b3c9bac$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $0913f93b5b3c9bac$var$logger.warn(warning.join(" "));
        return;
    }
    $0913f93b5b3c9bac$export$c930050e7bb63965(new (0, $6ExWU.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $0913f93b5b3c9bac$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $kZfxc.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $0913f93b5b3c9bac$export$c622e99c0ce7b1c9(logLevel) {
    (0, $kZfxc.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0913f93b5b3c9bac$var$DB_NAME = "firebase-heartbeat-database";
const $0913f93b5b3c9bac$var$DB_VERSION = 1;
const $0913f93b5b3c9bac$var$STORE_NAME = "firebase-heartbeat-store";
let $0913f93b5b3c9bac$var$dbPromise = null;
function $0913f93b5b3c9bac$var$getDbPromise() {
    if (!$0913f93b5b3c9bac$var$dbPromise) $0913f93b5b3c9bac$var$dbPromise = (0, $ajgRO.openDB)($0913f93b5b3c9bac$var$DB_NAME, $0913f93b5b3c9bac$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($0913f93b5b3c9bac$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $0913f93b5b3c9bac$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $0913f93b5b3c9bac$var$dbPromise;
}
async function $0913f93b5b3c9bac$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $0913f93b5b3c9bac$var$getDbPromise();
        const result = await db.transaction($0913f93b5b3c9bac$var$STORE_NAME).objectStore($0913f93b5b3c9bac$var$STORE_NAME).get($0913f93b5b3c9bac$var$computeKey(app));
        return result;
    } catch (e) {
        if (e instanceof (0, $2xDiJ.FirebaseError)) $0913f93b5b3c9bac$var$logger.warn(e.message);
        else {
            const idbGetError = $0913f93b5b3c9bac$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $0913f93b5b3c9bac$var$logger.warn(idbGetError.message);
        }
    }
}
async function $0913f93b5b3c9bac$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $0913f93b5b3c9bac$var$getDbPromise();
        const tx = db.transaction($0913f93b5b3c9bac$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($0913f93b5b3c9bac$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $0913f93b5b3c9bac$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $2xDiJ.FirebaseError)) $0913f93b5b3c9bac$var$logger.warn(e.message);
        else {
            const idbGetError = $0913f93b5b3c9bac$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $0913f93b5b3c9bac$var$logger.warn(idbGetError.message);
        }
    }
}
function $0913f93b5b3c9bac$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0913f93b5b3c9bac$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $0913f93b5b3c9bac$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $0913f93b5b3c9bac$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $0913f93b5b3c9bac$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider("platform-logger").getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $0913f93b5b3c9bac$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $0913f93b5b3c9bac$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return "";
        const date = $0913f93b5b3c9bac$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $0913f93b5b3c9bac$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $2xDiJ.base64urlEncodeWithoutPadding)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $0913f93b5b3c9bac$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $0913f93b5b3c9bac$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $0913f93b5b3c9bac$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($0913f93b5b3c9bac$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($0913f93b5b3c9bac$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $0913f93b5b3c9bac$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $2xDiJ.isIndexedDBAvailable)()) return false;
        else return (0, $2xDiJ.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $0913f93b5b3c9bac$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $0913f93b5b3c9bac$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $0913f93b5b3c9bac$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $0913f93b5b3c9bac$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $2xDiJ.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0913f93b5b3c9bac$var$registerCoreComponents(variant) {
    $0913f93b5b3c9bac$export$c930050e7bb63965(new (0, $6ExWU.Component)("platform-logger", (container)=>new $0913f93b5b3c9bac$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $0913f93b5b3c9bac$export$c930050e7bb63965(new (0, $6ExWU.Component)("heartbeat", (container)=>new $0913f93b5b3c9bac$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $0913f93b5b3c9bac$export$d29d5299a7137abc($0913f93b5b3c9bac$var$name$o, $0913f93b5b3c9bac$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $0913f93b5b3c9bac$export$d29d5299a7137abc($0913f93b5b3c9bac$var$name$o, $0913f93b5b3c9bac$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $0913f93b5b3c9bac$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $0913f93b5b3c9bac$var$registerCoreComponents("");

});
parcelRequire.register("6ExWU", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $4d80d01579d5bd6a$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $4d80d01579d5bd6a$export$436a80eea5d5c0c5; });

var $2xDiJ = parcelRequire("2xDiJ");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $4d80d01579d5bd6a$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $4d80d01579d5bd6a$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $2xDiJ.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($4d80d01579d5bd6a$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $4d80d01579d5bd6a$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $4d80d01579d5bd6a$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $4d80d01579d5bd6a$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $4d80d01579d5bd6a$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $4d80d01579d5bd6a$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $4d80d01579d5bd6a$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

});
parcelRequire.register("2xDiJ", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $1d9d263a787f8021$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $1d9d263a787f8021$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $1d9d263a787f8021$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultEmulatorHostnameAndPort", function () { return $1d9d263a787f8021$export$a3febcf1f14a3a0c; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $1d9d263a787f8021$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $1d9d263a787f8021$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $1d9d263a787f8021$export$85f6557964517f1a; });
$parcel$export(module.exports, "createMockUserToken", function () { return $1d9d263a787f8021$export$367bf224123348f1; });
$parcel$export(module.exports, "getUA", function () { return $1d9d263a787f8021$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $1d9d263a787f8021$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $1d9d263a787f8021$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $1d9d263a787f8021$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $1d9d263a787f8021$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isSafari", function () { return $1d9d263a787f8021$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $1d9d263a787f8021$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $1d9d263a787f8021$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $1d9d263a787f8021$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $1d9d263a787f8021$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $1d9d263a787f8021$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $1d9d263a787f8021$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $1d9d263a787f8021$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $1d9d263a787f8021$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $1d9d263a787f8021$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $1d9d263a787f8021$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $1d9d263a787f8021$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $6qd2L = parcelRequire("6qd2L");
const $1d9d263a787f8021$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $1d9d263a787f8021$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $1d9d263a787f8021$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $1d9d263a787f8021$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $1d9d263a787f8021$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d9d263a787f8021$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $1d9d263a787f8021$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $1d9d263a787f8021$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($1d9d263a787f8021$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $1d9d263a787f8021$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $1d9d263a787f8021$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $1d9d263a787f8021$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $1d9d263a787f8021$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $1d9d263a787f8021$var$stringToByteArray$1(str);
    return $1d9d263a787f8021$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $1d9d263a787f8021$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $1d9d263a787f8021$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $1d9d263a787f8021$export$c62426fdd000a97e = function(str) {
    try {
        return $1d9d263a787f8021$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $1d9d263a787f8021$export$6c40052bed430212(value) {
    return $1d9d263a787f8021$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $1d9d263a787f8021$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$1d9d263a787f8021$var$isValidKey(prop)) continue;
        target[prop] = $1d9d263a787f8021$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $1d9d263a787f8021$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $1d9d263a787f8021$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1d9d263a787f8021$var$getDefaultsFromGlobal = ()=>$1d9d263a787f8021$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $1d9d263a787f8021$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $6qd2L === "undefined" || typeof $6qd2L.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $1d9d263a787f8021$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $1d9d263a787f8021$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $1d9d263a787f8021$export$212bb2fc580a90a8 = ()=>{
    try {
        return $1d9d263a787f8021$var$getDefaultsFromGlobal() || $1d9d263a787f8021$var$getDefaultsFromEnvVariable() || $1d9d263a787f8021$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $1d9d263a787f8021$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $1d9d263a787f8021$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $1d9d263a787f8021$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $1d9d263a787f8021$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $1d9d263a787f8021$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $1d9d263a787f8021$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $1d9d263a787f8021$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $1d9d263a787f8021$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $1d9d263a787f8021$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d9d263a787f8021$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $1d9d263a787f8021$export$4b5284a3025a455(JSON.stringify(header)),
        $1d9d263a787f8021$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $1d9d263a787f8021$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $1d9d263a787f8021$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($1d9d263a787f8021$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $1d9d263a787f8021$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $1d9d263a787f8021$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $1d9d263a787f8021$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $1d9d263a787f8021$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $1d9d263a787f8021$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $1d9d263a787f8021$export$f2f6a8999f8ebd30() {
    return $1d9d263a787f8021$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $1d9d263a787f8021$export$7e7b1a9668aaed8() {
    const ua = $1d9d263a787f8021$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $1d9d263a787f8021$export$202944b2d2824246() {
    return $1d9d263a787f8021$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $1d9d263a787f8021$export$5d1d834fbbf8bab7() {
    return $1d9d263a787f8021$export$588c7fdda06fbb0a.NODE_CLIENT === true || $1d9d263a787f8021$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $1d9d263a787f8021$export$95df08bae54cb4df() {
    return !$1d9d263a787f8021$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $1d9d263a787f8021$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $1d9d263a787f8021$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $1d9d263a787f8021$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $1d9d263a787f8021$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $1d9d263a787f8021$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $1d9d263a787f8021$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $1d9d263a787f8021$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $1d9d263a787f8021$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $1d9d263a787f8021$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $1d9d263a787f8021$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $1d9d263a787f8021$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $1d9d263a787f8021$var$replaceTemplate(template, data) {
    return template.replace($1d9d263a787f8021$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $1d9d263a787f8021$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $1d9d263a787f8021$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $1d9d263a787f8021$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $1d9d263a787f8021$export$c5a53ce6a17cf18d($1d9d263a787f8021$export$c62426fdd000a97e(parts[0]) || "");
        claims = $1d9d263a787f8021$export$c5a53ce6a17cf18d($1d9d263a787f8021$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$5f870fcca7ae6a88 = function(token) {
    const claims = $1d9d263a787f8021$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$701c661ec91095f2 = function(token) {
    const claims = $1d9d263a787f8021$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $1d9d263a787f8021$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $1d9d263a787f8021$export$fc970ed23da99565 = function(token) {
    const claims = $1d9d263a787f8021$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d9d263a787f8021$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $1d9d263a787f8021$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $1d9d263a787f8021$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $1d9d263a787f8021$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $1d9d263a787f8021$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($1d9d263a787f8021$var$isObject(aProp) && $1d9d263a787f8021$var$isObject(bProp)) {
            if (!$1d9d263a787f8021$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $1d9d263a787f8021$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $1d9d263a787f8021$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $1d9d263a787f8021$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $1d9d263a787f8021$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $1d9d263a787f8021$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $1d9d263a787f8021$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $1d9d263a787f8021$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $1d9d263a787f8021$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $1d9d263a787f8021$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $1d9d263a787f8021$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($1d9d263a787f8021$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $1d9d263a787f8021$var$noop;
        if (observer.error === undefined) observer.error = $1d9d263a787f8021$var$noop;
        if (observer.complete === undefined) observer.complete = $1d9d263a787f8021$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $1d9d263a787f8021$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $1d9d263a787f8021$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $1d9d263a787f8021$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $1d9d263a787f8021$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $1d9d263a787f8021$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $1d9d263a787f8021$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($1d9d263a787f8021$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $1d9d263a787f8021$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($1d9d263a787f8021$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $1d9d263a787f8021$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($1d9d263a787f8021$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $1d9d263a787f8021$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $1d9d263a787f8021$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $1d9d263a787f8021$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $1d9d263a787f8021$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $1d9d263a787f8021$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $1d9d263a787f8021$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $1d9d263a787f8021$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $1d9d263a787f8021$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $1d9d263a787f8021$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $1d9d263a787f8021$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $1d9d263a787f8021$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $1d9d263a787f8021$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($1d9d263a787f8021$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $1d9d263a787f8021$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $1d9d263a787f8021$var$indicator(i);
}
function $1d9d263a787f8021$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $1d9d263a787f8021$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRequire.register("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});



parcelRequire.register("kZfxc", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $f4758df7279d6c6a$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $f4758df7279d6c6a$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $f4758df7279d6c6a$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $f4758df7279d6c6a$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $f4758df7279d6c6a$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $f4758df7279d6c6a$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($f4758df7279d6c6a$export$243e62d78d3b544d || ($f4758df7279d6c6a$export$243e62d78d3b544d = {}));
const $f4758df7279d6c6a$var$levelStringToEnum = {
    "debug": $f4758df7279d6c6a$export$243e62d78d3b544d.DEBUG,
    "verbose": $f4758df7279d6c6a$export$243e62d78d3b544d.VERBOSE,
    "info": $f4758df7279d6c6a$export$243e62d78d3b544d.INFO,
    "warn": $f4758df7279d6c6a$export$243e62d78d3b544d.WARN,
    "error": $f4758df7279d6c6a$export$243e62d78d3b544d.ERROR,
    "silent": $f4758df7279d6c6a$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $f4758df7279d6c6a$var$defaultLogLevel = $f4758df7279d6c6a$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $f4758df7279d6c6a$var$ConsoleMethod = {
    [$f4758df7279d6c6a$export$243e62d78d3b544d.DEBUG]: "log",
    [$f4758df7279d6c6a$export$243e62d78d3b544d.VERBOSE]: "log",
    [$f4758df7279d6c6a$export$243e62d78d3b544d.INFO]: "info",
    [$f4758df7279d6c6a$export$243e62d78d3b544d.WARN]: "warn",
    [$f4758df7279d6c6a$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $f4758df7279d6c6a$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $f4758df7279d6c6a$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $f4758df7279d6c6a$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $f4758df7279d6c6a$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $f4758df7279d6c6a$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $f4758df7279d6c6a$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $f4758df7279d6c6a$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $f4758df7279d6c6a$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $f4758df7279d6c6a$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $f4758df7279d6c6a$export$c622e99c0ce7b1c9(level) {
    $f4758df7279d6c6a$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $f4758df7279d6c6a$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $f4758df7279d6c6a$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $f4758df7279d6c6a$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $f4758df7279d6c6a$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRequire.register("ajgRO", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $7818c326be87ea84$export$ca0ed41b1a2af7e; });

var $kKOTz = parcelRequire("kKOTz");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $7818c326be87ea84$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $kKOTz.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $kKOTz.w)(request.result), event.oldVersion, event.newVersion, (0, $kKOTz.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $7818c326be87ea84$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $kKOTz.w)(request).then(()=>undefined);
}
const $7818c326be87ea84$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $7818c326be87ea84$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $7818c326be87ea84$var$cachedMethods = new Map();
function $7818c326be87ea84$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($7818c326be87ea84$var$cachedMethods.get(prop)) return $7818c326be87ea84$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $7818c326be87ea84$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $7818c326be87ea84$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $7818c326be87ea84$var$cachedMethods.set(prop, method);
    return method;
}
(0, $kKOTz.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$7818c326be87ea84$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$7818c326be87ea84$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRequire.register("kKOTz", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $f1bf9542bc9ee5ed$export$43caf9889c228507; });
const $f1bf9542bc9ee5ed$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $f1bf9542bc9ee5ed$var$idbProxyableTypes;
let $f1bf9542bc9ee5ed$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $f1bf9542bc9ee5ed$var$getIdbProxyableTypes() {
    return $f1bf9542bc9ee5ed$var$idbProxyableTypes || ($f1bf9542bc9ee5ed$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $f1bf9542bc9ee5ed$var$getCursorAdvanceMethods() {
    return $f1bf9542bc9ee5ed$var$cursorAdvanceMethods || ($f1bf9542bc9ee5ed$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $f1bf9542bc9ee5ed$var$cursorRequestMap = new WeakMap();
const $f1bf9542bc9ee5ed$var$transactionDoneMap = new WeakMap();
const $f1bf9542bc9ee5ed$var$transactionStoreNamesMap = new WeakMap();
const $f1bf9542bc9ee5ed$var$transformCache = new WeakMap();
const $f1bf9542bc9ee5ed$export$407448d2b89b1813 = new WeakMap();
function $f1bf9542bc9ee5ed$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $f1bf9542bc9ee5ed$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $f1bf9542bc9ee5ed$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $f1bf9542bc9ee5ed$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($f1bf9542bc9ee5ed$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $f1bf9542bc9ee5ed$var$transactionDoneMap.set(tx, done);
}
let $f1bf9542bc9ee5ed$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $f1bf9542bc9ee5ed$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $f1bf9542bc9ee5ed$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $f1bf9542bc9ee5ed$export$43caf9889c228507(callback) {
    $f1bf9542bc9ee5ed$var$idbProxyTraps = callback($f1bf9542bc9ee5ed$var$idbProxyTraps);
}
function $f1bf9542bc9ee5ed$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($f1bf9542bc9ee5ed$export$3b14a55fb2447963(this), storeNames, ...args);
        $f1bf9542bc9ee5ed$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($f1bf9542bc9ee5ed$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($f1bf9542bc9ee5ed$export$3b14a55fb2447963(this), args);
        return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b($f1bf9542bc9ee5ed$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(func.apply($f1bf9542bc9ee5ed$export$3b14a55fb2447963(this), args));
    };
}
function $f1bf9542bc9ee5ed$var$transformCachableValue(value) {
    if (typeof value === "function") return $f1bf9542bc9ee5ed$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $f1bf9542bc9ee5ed$var$cacheDonePromiseForTransaction(value);
    if ($f1bf9542bc9ee5ed$export$23f2a1d2818174ef(value, $f1bf9542bc9ee5ed$var$getIdbProxyableTypes())) return new Proxy(value, $f1bf9542bc9ee5ed$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $f1bf9542bc9ee5ed$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $f1bf9542bc9ee5ed$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($f1bf9542bc9ee5ed$var$transformCache.has(value)) return $f1bf9542bc9ee5ed$var$transformCache.get(value);
    const newValue = $f1bf9542bc9ee5ed$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $f1bf9542bc9ee5ed$var$transformCache.set(value, newValue);
        $f1bf9542bc9ee5ed$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $f1bf9542bc9ee5ed$export$3b14a55fb2447963 = (value)=>$f1bf9542bc9ee5ed$export$407448d2b89b1813.get(value);

});




parcelRequire.register("gQOBw", function(module, exports) {
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("gVFeG")).a8; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("gVFeG")).o; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("gVFeG")).a9; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("gVFeG")).B; });
parcelRequire("eMcUM");

});
parcelRequire.register("eMcUM", function(module, exports) {

$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("gVFeG")).a8; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("gVFeG")).o; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("gVFeG")).a9; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("gVFeG")).B; });

var $gVFeG = parcelRequire("gVFeG");
parcelRequire("2xDiJ");
parcelRequire("MjY8E");

parcelRequire("kZfxc");
parcelRequire("6ExWU");

});
parcelRequire.register("gVFeG", function(module, exports) {

$parcel$export(module.exports, "a8", function () { return $c531f4c621fcaa8c$export$c3950d9923825c02; });
$parcel$export(module.exports, "a9", function () { return $c531f4c621fcaa8c$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "B", function () { return $c531f4c621fcaa8c$export$ef35774e6d314e91; });
$parcel$export(module.exports, "o", function () { return $c531f4c621fcaa8c$export$ae1af26003f05816; });

var $2xDiJ = parcelRequire("2xDiJ");

var $MjY8E = parcelRequire("MjY8E");

var $4tSb9 = parcelRequire("4tSb9");

var $kZfxc = parcelRequire("kZfxc");

var $6ExWU = parcelRequire("6ExWU");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registed for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ]: "The supplied auth credential is malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend."
    };
}
function $c531f4c621fcaa8c$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $c531f4c621fcaa8c$export$96f57966bedc81b4 = $c531f4c621fcaa8c$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $c531f4c621fcaa8c$export$a9c23c6ac3fc3eca = $c531f4c621fcaa8c$var$_prodErrorMap;
const $c531f4c621fcaa8c$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $2xDiJ.ErrorFactory)("auth", "Firebase", $c531f4c621fcaa8c$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$2329c99376c9d0a4 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$logClient = new (0, $kZfxc.Logger)("@firebase/auth");
function $c531f4c621fcaa8c$var$_logWarn(msg, ...args) {
    if ($c531f4c621fcaa8c$var$logClient.logLevel <= (0, $kZfxc.LogLevel).WARN) $c531f4c621fcaa8c$var$logClient.warn(`Auth (${(0, $MjY8E.SDK_VERSION)}): ${msg}`, ...args);
}
function $c531f4c621fcaa8c$var$_logError(msg, ...args) {
    if ($c531f4c621fcaa8c$var$logClient.logLevel <= (0, $kZfxc.LogLevel).ERROR) $c531f4c621fcaa8c$var$logClient.error(`Auth (${(0, $MjY8E.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(authOrCode, ...rest) {
    throw $c531f4c621fcaa8c$var$createErrorInternal(authOrCode, ...rest);
}
function $c531f4c621fcaa8c$export$3d12bd131bb975d1(authOrCode, ...rest) {
    return $c531f4c621fcaa8c$var$createErrorInternal(authOrCode, ...rest);
}
function $c531f4c621fcaa8c$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $c531f4c621fcaa8c$export$a9c23c6ac3fc3eca()), {
        [code]: message
    });
    const factory = new (0, $2xDiJ.ErrorFactory)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $c531f4c621fcaa8c$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $c531f4c621fcaa8c$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $c531f4c621fcaa8c$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $c531f4c621fcaa8c$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(assertion, authOrCode, ...rest) {
    if (!assertion) throw $c531f4c621fcaa8c$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $c531f4c621fcaa8c$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $c531f4c621fcaa8c$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $c531f4c621fcaa8c$export$6554612db691658e(assertion, message) {
    if (!assertion) $c531f4c621fcaa8c$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $c531f4c621fcaa8c$var$_isHttpOrHttps() {
    return $c531f4c621fcaa8c$var$_getCurrentScheme() === "http:" || $c531f4c621fcaa8c$var$_getCurrentScheme() === "https:";
}
function $c531f4c621fcaa8c$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $c531f4c621fcaa8c$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($c531f4c621fcaa8c$var$_isHttpOrHttps() || (0, $2xDiJ.isBrowserExtension)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $c531f4c621fcaa8c$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $c531f4c621fcaa8c$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $c531f4c621fcaa8c$export$6554612db691658e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $2xDiJ.isMobileCordova)() || (0, $2xDiJ.isReactNative)();
    }
    get() {
        if (!$c531f4c621fcaa8c$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$_emulatorUrl(config, path) {
    $c531f4c621fcaa8c$export$6554612db691658e(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$export$faec65b429be379 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        $c531f4c621fcaa8c$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        $c531f4c621fcaa8c$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        $c531f4c621fcaa8c$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $c531f4c621fcaa8c$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$DEFAULT_API_TIMEOUT_MS = new $c531f4c621fcaa8c$var$Delay(30000, 60000);
function $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $c531f4c621fcaa8c$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $c531f4c621fcaa8c$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $2xDiJ.querystring)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $c531f4c621fcaa8c$export$faec65b429be379.fetch()($c531f4c621fcaa8c$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $c531f4c621fcaa8c$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $c531f4c621fcaa8c$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $c531f4c621fcaa8c$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $c531f4c621fcaa8c$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $c531f4c621fcaa8c$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $c531f4c621fcaa8c$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $c531f4c621fcaa8c$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $c531f4c621fcaa8c$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $2xDiJ.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $c531f4c621fcaa8c$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $c531f4c621fcaa8c$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $c531f4c621fcaa8c$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $c531f4c621fcaa8c$var$_emulatorUrl(auth.config, base);
}
class $c531f4c621fcaa8c$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $c531f4c621fcaa8c$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $c531f4c621fcaa8c$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $c531f4c621fcaa8c$export$3d12bd131bb975d1(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$deleteAccount(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $c531f4c621fcaa8c$var$deleteLinkedAccounts(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $c531f4c621fcaa8c$var$getAccountInfo(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$ab83b03e4111b1d0(user, forceRefresh = false) {
    return (0, $2xDiJ.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$1a82df3d29112e01(user, forceRefresh = false) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $c531f4c621fcaa8c$var$_parseToken(token);
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $c531f4c621fcaa8c$var$utcTimestampToDateString($c531f4c621fcaa8c$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $c531f4c621fcaa8c$var$utcTimestampToDateString($c531f4c621fcaa8c$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $c531f4c621fcaa8c$var$utcTimestampToDateString($c531f4c621fcaa8c$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $c531f4c621fcaa8c$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $c531f4c621fcaa8c$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $c531f4c621fcaa8c$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $2xDiJ.base64Decode)(payload);
        if (!decoded) {
            $c531f4c621fcaa8c$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $c531f4c621fcaa8c$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $c531f4c621fcaa8c$var$_tokenExpiresIn(token) {
    const parsedToken = $c531f4c621fcaa8c$var$_parseToken(token);
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $2xDiJ.FirebaseError) && $c531f4c621fcaa8c$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $c531f4c621fcaa8c$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $c531f4c621fcaa8c$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $c531f4c621fcaa8c$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $c531f4c621fcaa8c$var$_logoutIfInvalidated(user, $c531f4c621fcaa8c$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $c531f4c621fcaa8c$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $c531f4c621fcaa8c$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $c531f4c621fcaa8c$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$2f6ca3d3b1f80bf5(user) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    await $c531f4c621fcaa8c$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $c531f4c621fcaa8c$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $c531f4c621fcaa8c$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $4tSb9.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$requestStsToken(auth, refreshToken) {
    const response = await $c531f4c621fcaa8c$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $2xDiJ.querystring)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $c531f4c621fcaa8c$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $c531f4c621fcaa8c$export$faec65b429be379.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $c531f4c621fcaa8c$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $c531f4c621fcaa8c$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(!this.accessToken || this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $c531f4c621fcaa8c$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $c531f4c621fcaa8c$var$StsTokenManager();
        if (refreshToken) {
            $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $c531f4c621fcaa8c$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $c531f4c621fcaa8c$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$assertStringOrUndefined(assertion, appName) {
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $c531f4c621fcaa8c$export$b9a6b53f9be3734 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $4tSb9.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $c531f4c621fcaa8c$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $c531f4c621fcaa8c$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $c531f4c621fcaa8c$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $c531f4c621fcaa8c$export$1a82df3d29112e01(this, forceRefresh);
    }
    reload() {
        return $c531f4c621fcaa8c$export$2f6ca3d3b1f80bf5(this);
    }
    _assign(user) {
        if (this === user) return;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $c531f4c621fcaa8c$export$b9a6b53f9be3734(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $c531f4c621fcaa8c$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        const idToken = await this.getIdToken();
        await $c531f4c621fcaa8c$var$_logoutIfInvalidated(this, $c531f4c621fcaa8c$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $c531f4c621fcaa8c$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c531f4c621fcaa8c$var$assertStringOrUndefined(displayName, auth.name);
        $c531f4c621fcaa8c$var$assertStringOrUndefined(email, auth.name);
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c531f4c621fcaa8c$var$assertStringOrUndefined(phoneNumber, auth.name);
        $c531f4c621fcaa8c$var$assertStringOrUndefined(photoURL, auth.name);
        $c531f4c621fcaa8c$var$assertStringOrUndefined(tenantId, auth.name);
        $c531f4c621fcaa8c$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $c531f4c621fcaa8c$var$assertStringOrUndefined(createdAt, auth.name);
        $c531f4c621fcaa8c$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $c531f4c621fcaa8c$export$b9a6b53f9be3734({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $c531f4c621fcaa8c$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $c531f4c621fcaa8c$export$b9a6b53f9be3734({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $c531f4c621fcaa8c$var$_reloadWithoutSaving(user);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$instanceCache = new Map();
function $c531f4c621fcaa8c$export$890c4ad488842ce7(cls) {
    $c531f4c621fcaa8c$export$6554612db691658e(cls instanceof Function, "Expected a class definition");
    let instance = $c531f4c621fcaa8c$var$instanceCache.get(cls);
    if (instance) {
        $c531f4c621fcaa8c$export$6554612db691658e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $c531f4c621fcaa8c$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$c531f4c621fcaa8c$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$a07804094c3ecf2d = $c531f4c621fcaa8c$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$export$24baa2b76016ce0e(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $c531f4c621fcaa8c$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $c531f4c621fcaa8c$export$24baa2b76016ce0e(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $c531f4c621fcaa8c$export$24baa2b76016ce0e("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $c531f4c621fcaa8c$export$b9a6b53f9be3734._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $c531f4c621fcaa8c$var$PersistenceUserManager($c531f4c621fcaa8c$export$890c4ad488842ce7($c531f4c621fcaa8c$export$a07804094c3ecf2d), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $c531f4c621fcaa8c$export$890c4ad488842ce7($c531f4c621fcaa8c$export$a07804094c3ecf2d);
        const key = $c531f4c621fcaa8c$export$24baa2b76016ce0e(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $c531f4c621fcaa8c$export$b9a6b53f9be3734._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $c531f4c621fcaa8c$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $c531f4c621fcaa8c$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $c531f4c621fcaa8c$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($c531f4c621fcaa8c$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($c531f4c621fcaa8c$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($c531f4c621fcaa8c$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($c531f4c621fcaa8c$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($c531f4c621fcaa8c$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $c531f4c621fcaa8c$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($c531f4c621fcaa8c$export$1fbe638ecf81657e(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $c531f4c621fcaa8c$var$_isFirefox(ua = (0, $2xDiJ.getUA)()) {
    return /firefox\//i.test(ua);
}
function $c531f4c621fcaa8c$var$_isSafari(userAgent = (0, $2xDiJ.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $c531f4c621fcaa8c$var$_isChromeIOS(ua = (0, $2xDiJ.getUA)()) {
    return /crios\//i.test(ua);
}
function $c531f4c621fcaa8c$var$_isIEMobile(ua = (0, $2xDiJ.getUA)()) {
    return /iemobile/i.test(ua);
}
function $c531f4c621fcaa8c$export$1fbe638ecf81657e(ua = (0, $2xDiJ.getUA)()) {
    return /android/i.test(ua);
}
function $c531f4c621fcaa8c$var$_isBlackBerry(ua = (0, $2xDiJ.getUA)()) {
    return /blackberry/i.test(ua);
}
function $c531f4c621fcaa8c$var$_isWebOS(ua = (0, $2xDiJ.getUA)()) {
    return /webos/i.test(ua);
}
function $c531f4c621fcaa8c$export$493d36ec626b6698(ua = (0, $2xDiJ.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $c531f4c621fcaa8c$export$28f7fcd39efa255(ua = (0, $2xDiJ.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $c531f4c621fcaa8c$var$_isIOSStandalone(ua = (0, $2xDiJ.getUA)()) {
    var _a;
    return $c531f4c621fcaa8c$export$493d36ec626b6698(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $c531f4c621fcaa8c$var$_isIE10() {
    return (0, $2xDiJ.isIE)() && document.documentMode === 10;
}
function $c531f4c621fcaa8c$var$_isMobileBrowser(ua = (0, $2xDiJ.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $c531f4c621fcaa8c$export$493d36ec626b6698(ua) || $c531f4c621fcaa8c$export$1fbe638ecf81657e(ua) || $c531f4c621fcaa8c$var$_isWebOS(ua) || $c531f4c621fcaa8c$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $c531f4c621fcaa8c$var$_isIEMobile(ua);
}
function $c531f4c621fcaa8c$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $c531f4c621fcaa8c$export$23ebac1979863676(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $c531f4c621fcaa8c$var$_getBrowserName((0, $2xDiJ.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$c531f4c621fcaa8c$var$_getBrowserName((0, $2xDiJ.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $MjY8E.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$getRecaptchaParams(auth) {
    return (await $c531f4c621fcaa8c$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $c531f4c621fcaa8c$var$getRecaptchaConfig(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $c531f4c621fcaa8c$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $c531f4c621fcaa8c$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The reCAPTCHA enablement status of the {@link EmailAuthProvider} for the current tenant.
         */ this.emailPasswordEnabled = false;
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.emailPasswordEnabled = response.recaptchaEnforcementState.some((enforcementState)=>enforcementState.provider === "EMAIL_PASSWORD_PROVIDER" && enforcementState.enforcementState !== "OFF");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $c531f4c621fcaa8c$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise((resolve, reject)=>{
        const el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = (e)=>{
            const error = $c531f4c621fcaa8c$export$3d12bd131bb975d1("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $c531f4c621fcaa8c$var$getScriptParentElement().appendChild(el);
    });
}
function $c531f4c621fcaa8c$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $c531f4c621fcaa8c$var$RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
const $c531f4c621fcaa8c$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $c531f4c621fcaa8c$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $c531f4c621fcaa8c$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $c531f4c621fcaa8c$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $c531f4c621fcaa8c$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $c531f4c621fcaa8c$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($c531f4c621fcaa8c$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($c531f4c621fcaa8c$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $c531f4c621fcaa8c$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    $c531f4c621fcaa8c$var$_loadJS($c531f4c621fcaa8c$var$RECAPTCHA_ENTERPRISE_URL + siteKey).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $c531f4c621fcaa8c$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $c531f4c621fcaa8c$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$export$a05254e7c3aeba6e {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $c531f4c621fcaa8c$var$Subscription(this);
        this.idTokenSubscription = new $c531f4c621fcaa8c$var$Subscription(this);
        this.beforeStateQueue = new $c531f4c621fcaa8c$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $c531f4c621fcaa8c$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $c531f4c621fcaa8c$export$890c4ad488842ce7(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $c531f4c621fcaa8c$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $c531f4c621fcaa8c$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $c531f4c621fcaa8c$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $2xDiJ.getModularInstance)(userExtern) : null;
        if (user) $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($c531f4c621fcaa8c$export$890c4ad488842ce7(persistence));
        });
    }
    async initializeRecaptchaConfig() {
        const response = await $c531f4c621fcaa8c$var$getRecaptchaConfig(this, {
            clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
            version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
        });
        const config = new $c531f4c621fcaa8c$var$RecaptchaConfig(response);
        if (this.tenantId == null) this._agentRecaptchaConfig = config;
        else this._tenantRecaptchaConfigs[this.tenantId] = config;
        if (config.emailPasswordEnabled) {
            const verifier = new $c531f4c621fcaa8c$var$RecaptchaEnterpriseVerifier(this);
            verifier.verify();
        }
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $2xDiJ.ErrorFactory)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $c531f4c621fcaa8c$export$890c4ad488842ce7(popupRedirectResolver) || this._popupRedirectResolver;
            $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $c531f4c621fcaa8c$var$PersistenceUserManager.create(this, [
                $c531f4c621fcaa8c$export$890c4ad488842ce7(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>cb(this.currentUser));
        if (typeof nextOrObserver === "function") return subscription.addObserver(nextOrObserver, error, completed);
        else return subscription.addObserver(nextOrObserver);
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $c531f4c621fcaa8c$export$23ebac1979863676(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $c531f4c621fcaa8c$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth) {
    return (0, $2xDiJ.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class $c531f4c621fcaa8c$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $2xDiJ.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $c531f4c621fcaa8c$export$7f8ddf7c7c20b3cd(app, deps) {
    const provider = (0, $MjY8E._getProvider)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $2xDiJ.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $c531f4c621fcaa8c$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($c531f4c621fcaa8c$export$890c4ad488842ce7);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$9bb611d729802a56(auth, url, options) {
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $c531f4c621fcaa8c$var$extractProtocol(url);
    const { host: host, port: port } = $c531f4c621fcaa8c$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $c531f4c621fcaa8c$var$emitEmulatorWarning();
}
function $c531f4c621fcaa8c$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $c531f4c621fcaa8c$var$extractHostAndPort(url) {
    const protocol = $c531f4c621fcaa8c$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $c531f4c621fcaa8c$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $c531f4c621fcaa8c$var$parsePort(port)
        };
    }
}
function $c531f4c621fcaa8c$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $c531f4c621fcaa8c$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$b4171a6734a65d42 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $c531f4c621fcaa8c$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $c531f4c621fcaa8c$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $c531f4c621fcaa8c$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $c531f4c621fcaa8c$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$resetPassword(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
async function $c531f4c621fcaa8c$var$updateEmailPassword(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $c531f4c621fcaa8c$var$applyActionCode$1(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$signInWithPassword(auth, request) {
    return $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
async function $c531f4c621fcaa8c$var$sendOobCode(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
async function $c531f4c621fcaa8c$var$sendEmailVerification$1(auth, request) {
    return $c531f4c621fcaa8c$var$sendOobCode(auth, request);
}
async function $c531f4c621fcaa8c$var$sendPasswordResetEmail$1(auth, request) {
    return $c531f4c621fcaa8c$var$sendOobCode(auth, request);
}
async function $c531f4c621fcaa8c$var$sendSignInLinkToEmail$1(auth, request) {
    return $c531f4c621fcaa8c$var$sendOobCode(auth, request);
}
async function $c531f4c621fcaa8c$var$verifyAndChangeEmail(auth, request) {
    return $c531f4c621fcaa8c$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$signInWithEmailLink$1(auth, request) {
    return $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
async function $c531f4c621fcaa8c$var$signInWithEmailLinkForLinking(auth, request) {
    return $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$3466f893ebf79586 extends $c531f4c621fcaa8c$export$b4171a6734a65d42 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $c531f4c621fcaa8c$export$3466f893ebf79586(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $c531f4c621fcaa8c$export$3466f893ebf79586(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        var _a;
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                if ((_a = auth._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
                    const requestWithRecaptcha = await $c531f4c621fcaa8c$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ );
                    return $c531f4c621fcaa8c$var$signInWithPassword(auth, requestWithRecaptcha);
                } else return $c531f4c621fcaa8c$var$signInWithPassword(auth, request).catch(async (error)=>{
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                        console.log("Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                        const requestWithRecaptcha = await $c531f4c621fcaa8c$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ );
                        return $c531f4c621fcaa8c$var$signInWithPassword(auth, requestWithRecaptcha);
                    } else return Promise.reject(error);
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $c531f4c621fcaa8c$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                return $c531f4c621fcaa8c$var$updateEmailPassword(auth, {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password
                });
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $c531f4c621fcaa8c$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$signInWithIdp(auth, request) {
    return $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$61196ced6d74a310 extends $c531f4c621fcaa8c$export$b4171a6734a65d42 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $c531f4c621fcaa8c$export$61196ced6d74a310(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $c531f4c621fcaa8c$export$d66dc83d8cfc8dd("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $4tSb9.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $c531f4c621fcaa8c$export$61196ced6d74a310(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $c531f4c621fcaa8c$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $2xDiJ.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$sendPhoneVerificationCode(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
async function $c531f4c621fcaa8c$var$signInWithPhoneNumber$1(auth, request) {
    return $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
async function $c531f4c621fcaa8c$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $c531f4c621fcaa8c$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $c531f4c621fcaa8c$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $c531f4c621fcaa8c$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, apiRequest), $c531f4c621fcaa8c$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$3a1a48c8f6ef640e extends $c531f4c621fcaa8c$export$b4171a6734a65d42 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $c531f4c621fcaa8c$export$3a1a48c8f6ef640e({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $c531f4c621fcaa8c$export$3a1a48c8f6ef640e({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $c531f4c621fcaa8c$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $c531f4c621fcaa8c$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $c531f4c621fcaa8c$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $c531f4c621fcaa8c$export$3a1a48c8f6ef640e({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $c531f4c621fcaa8c$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $c531f4c621fcaa8c$var$parseDeepLink(url) {
    const link = (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$ee7c8ad385a60b7b {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $2xDiJ.querystringDecode)((0, $2xDiJ.extractQuerystring)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $c531f4c621fcaa8c$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $c531f4c621fcaa8c$var$parseDeepLink(link);
        try {
            return new $c531f4c621fcaa8c$export$ee7c8ad385a60b7b(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$995eb9fca571757(link) {
    return $c531f4c621fcaa8c$export$ee7c8ad385a60b7b.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$3722cfe417b6ed86 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $c531f4c621fcaa8c$export$3722cfe417b6ed86.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $c531f4c621fcaa8c$export$3466f893ebf79586._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $c531f4c621fcaa8c$export$ee7c8ad385a60b7b.parseLink(emailLink);
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c531f4c621fcaa8c$export$3466f893ebf79586._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $c531f4c621fcaa8c$export$3722cfe417b6ed86.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $c531f4c621fcaa8c$export$3722cfe417b6ed86.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $c531f4c621fcaa8c$export$3722cfe417b6ed86.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $c531f4c621fcaa8c$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $c531f4c621fcaa8c$var$BaseOAuthProvider extends $c531f4c621fcaa8c$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $c531f4c621fcaa8c$export$78acf4525d8a74c4 extends $c531f4c621fcaa8c$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c531f4c621fcaa8c$export$61196ced6d74a310._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $c531f4c621fcaa8c$export$61196ced6d74a310._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c531f4c621fcaa8c$export$78acf4525d8a74c4.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c531f4c621fcaa8c$export$78acf4525d8a74c4.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $c531f4c621fcaa8c$export$78acf4525d8a74c4(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $c531f4c621fcaa8c$export$3a6d5c9ae78a2c08 extends $c531f4c621fcaa8c$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $c531f4c621fcaa8c$export$61196ced6d74a310._fromParams({
            providerId: $c531f4c621fcaa8c$export$3a6d5c9ae78a2c08.PROVIDER_ID,
            signInMethod: $c531f4c621fcaa8c$export$3a6d5c9ae78a2c08.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c531f4c621fcaa8c$export$3a6d5c9ae78a2c08.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c531f4c621fcaa8c$export$3a6d5c9ae78a2c08.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $c531f4c621fcaa8c$export$3a6d5c9ae78a2c08.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $c531f4c621fcaa8c$export$3a6d5c9ae78a2c08.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $c531f4c621fcaa8c$export$3a6d5c9ae78a2c08.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $c531f4c621fcaa8c$export$e7c866399fa523f5 extends $c531f4c621fcaa8c$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $c531f4c621fcaa8c$export$61196ced6d74a310._fromParams({
            providerId: $c531f4c621fcaa8c$export$e7c866399fa523f5.PROVIDER_ID,
            signInMethod: $c531f4c621fcaa8c$export$e7c866399fa523f5.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c531f4c621fcaa8c$export$e7c866399fa523f5.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c531f4c621fcaa8c$export$e7c866399fa523f5.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $c531f4c621fcaa8c$export$e7c866399fa523f5.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $c531f4c621fcaa8c$export$e7c866399fa523f5.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $c531f4c621fcaa8c$export$e7c866399fa523f5.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $c531f4c621fcaa8c$export$71cec2538cb2c617 extends $c531f4c621fcaa8c$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ static credential(accessToken) {
        return $c531f4c621fcaa8c$export$61196ced6d74a310._fromParams({
            providerId: $c531f4c621fcaa8c$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $c531f4c621fcaa8c$export$71cec2538cb2c617.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c531f4c621fcaa8c$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c531f4c621fcaa8c$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $c531f4c621fcaa8c$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $c531f4c621fcaa8c$export$71cec2538cb2c617.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $c531f4c621fcaa8c$export$71cec2538cb2c617.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $c531f4c621fcaa8c$export$c03999cb2f36933f extends $c531f4c621fcaa8c$export$b4171a6734a65d42 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $c531f4c621fcaa8c$export$c03999cb2f36933f(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $c531f4c621fcaa8c$export$c03999cb2f36933f(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $c531f4c621fcaa8c$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$8743009a87fcb00f extends $c531f4c621fcaa8c$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(providerId.startsWith($c531f4c621fcaa8c$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c531f4c621fcaa8c$export$8743009a87fcb00f.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c531f4c621fcaa8c$export$8743009a87fcb00f.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $c531f4c621fcaa8c$export$c03999cb2f36933f.fromJSON(json);
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $c531f4c621fcaa8c$export$c03999cb2f36933f._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $c531f4c621fcaa8c$export$dc98b0b04f4c7758 extends $c531f4c621fcaa8c$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $c531f4c621fcaa8c$export$61196ced6d74a310._fromParams({
            providerId: $c531f4c621fcaa8c$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $c531f4c621fcaa8c$export$dc98b0b04f4c7758.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c531f4c621fcaa8c$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c531f4c621fcaa8c$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $c531f4c621fcaa8c$export$dc98b0b04f4c7758.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $c531f4c621fcaa8c$export$dc98b0b04f4c7758.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $c531f4c621fcaa8c$export$dc98b0b04f4c7758.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$signUp(auth, request) {
    return $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $c531f4c621fcaa8c$export$b9a6b53f9be3734._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $c531f4c621fcaa8c$var$providerIdForResponse(idTokenResponse);
        const userCred = new $c531f4c621fcaa8c$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $c531f4c621fcaa8c$var$providerIdForResponse(response);
        return new $c531f4c621fcaa8c$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $c531f4c621fcaa8c$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$71511d61b312f219(auth) {
    var _a;
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $c531f4c621fcaa8c$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $c531f4c621fcaa8c$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $c531f4c621fcaa8c$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$MultiFactorError extends (0, $2xDiJ.FirebaseError) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c531f4c621fcaa8c$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $c531f4c621fcaa8c$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $c531f4c621fcaa8c$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $c531f4c621fcaa8c$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $c531f4c621fcaa8c$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$306ddfe3a8403e2(user, providerId) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    await $c531f4c621fcaa8c$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $c531f4c621fcaa8c$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $c531f4c621fcaa8c$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $c531f4c621fcaa8c$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $c531f4c621fcaa8c$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $c531f4c621fcaa8c$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $c531f4c621fcaa8c$var$_assertLinkedStatus(expected, user, provider) {
    await $c531f4c621fcaa8c$var$_reloadWithoutSaving(user);
    const providerIds = $c531f4c621fcaa8c$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $c531f4c621fcaa8c$var$_logoutIfInvalidated(user, $c531f4c621fcaa8c$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $c531f4c621fcaa8c$var$_parseToken(response.idToken);
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $c531f4c621fcaa8c$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $c531f4c621fcaa8c$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $c531f4c621fcaa8c$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$3d8c2f653ac9d0b9(auth, credential) {
    return $c531f4c621fcaa8c$var$_signInWithCredential($c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$34aec0b863436764(user, credential) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    await $c531f4c621fcaa8c$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $c531f4c621fcaa8c$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$3c2fa207a37baaea(user, credential) {
    return $c531f4c621fcaa8c$var$_reauthenticate((0, $2xDiJ.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$signInWithCustomToken$1(auth, request) {
    return $c531f4c621fcaa8c$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$ce26c07117d59d6a(auth, customToken) {
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    const response = await $c531f4c621fcaa8c$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $c531f4c621fcaa8c$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $c531f4c621fcaa8c$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $c531f4c621fcaa8c$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $c531f4c621fcaa8c$var$PhoneMultiFactorInfoImpl extends $c531f4c621fcaa8c$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $c531f4c621fcaa8c$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $c531f4c621fcaa8c$var$TotpMultiFactorInfoImpl extends $c531f4c621fcaa8c$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $c531f4c621fcaa8c$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$6559d589eb85fbb6(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $c531f4c621fcaa8c$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
        if (actionCodeSettings) $c531f4c621fcaa8c$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
        await $c531f4c621fcaa8c$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
    } else {
        if (actionCodeSettings) $c531f4c621fcaa8c$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        await $c531f4c621fcaa8c$var$sendPasswordResetEmail$1(authInternal, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log("Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.");
                const requestWithRecaptcha = await $c531f4c621fcaa8c$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
                if (actionCodeSettings) $c531f4c621fcaa8c$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                await $c531f4c621fcaa8c$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    }
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$efca4cbe5dd06740(auth, oobCode, newPassword) {
    await $c531f4c621fcaa8c$var$resetPassword((0, $2xDiJ.getModularInstance)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$a8550f7dbe79f93a(auth, oobCode) {
    await $c531f4c621fcaa8c$var$applyActionCode$1((0, $2xDiJ.getModularInstance)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$2e2af4578d910ddf(auth, oobCode) {
    const authModular = (0, $2xDiJ.getModularInstance)(auth);
    const response = await $c531f4c621fcaa8c$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $c531f4c621fcaa8c$var$MultiFactorInfoImpl._fromServerResponse($c531f4c621fcaa8c$export$a33b77bbdbb8366c(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$a93c5207d687da10(auth, code) {
    const { data: data } = await $c531f4c621fcaa8c$export$2e2af4578d910ddf((0, $2xDiJ.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$c3950d9923825c02(auth, email, password) {
    var _a;
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    let signUpResponse;
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $c531f4c621fcaa8c$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ );
        signUpResponse = $c531f4c621fcaa8c$var$signUp(authInternal, requestWithRecaptcha);
    } else signUpResponse = $c531f4c621fcaa8c$var$signUp(authInternal, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log("Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.");
            const requestWithRecaptcha = await $c531f4c621fcaa8c$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ );
            return $c531f4c621fcaa8c$var$signUp(authInternal, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
    const response = await signUpResponse.catch((error)=>{
        return Promise.reject(error);
    });
    const userCredential = await $c531f4c621fcaa8c$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$a9c996f45e5784d0(auth, email, password) {
    return $c531f4c621fcaa8c$export$3d8c2f653ac9d0b9((0, $2xDiJ.getModularInstance)(auth), $c531f4c621fcaa8c$export$3722cfe417b6ed86.credential(email, password));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$7910e0436ed8d1de(auth, email, actionCodeSettings) {
    var _a;
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $c531f4c621fcaa8c$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    if ((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled) {
        const requestWithRecaptcha = await $c531f4c621fcaa8c$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
        setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
        await $c531f4c621fcaa8c$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
    } else {
        setActionCodeSettings(request, actionCodeSettings);
        await $c531f4c621fcaa8c$var$sendSignInLinkToEmail$1(authInternal, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log("Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                const requestWithRecaptcha = await $c531f4c621fcaa8c$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true);
                setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                await $c531f4c621fcaa8c$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    }
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$555508cbc6add439(auth, emailLink) {
    const actionCodeUrl = $c531f4c621fcaa8c$export$ee7c8ad385a60b7b.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$2219238a014317b0(auth, email, emailLink) {
    const authModular = (0, $2xDiJ.getModularInstance)(auth);
    const credential = $c531f4c621fcaa8c$export$3722cfe417b6ed86.credentialWithLink(email, emailLink || $c531f4c621fcaa8c$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $c531f4c621fcaa8c$export$3d8c2f653ac9d0b9(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$createAuthUri(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$4c3d22f3d993c33f(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $c531f4c621fcaa8c$var$_isHttpOrHttps() ? $c531f4c621fcaa8c$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $c531f4c621fcaa8c$var$createAuthUri((0, $2xDiJ.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$f787f51d84a910ad(user, actionCodeSettings) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $c531f4c621fcaa8c$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $c531f4c621fcaa8c$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$c9170ad7d4cd7e57(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $c531f4c621fcaa8c$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $c531f4c621fcaa8c$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$var$updateProfile$1(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$f38c853ae54ed474(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $c531f4c621fcaa8c$var$_logoutIfInvalidated(userInternal, $c531f4c621fcaa8c$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$3b513254972cfc9c(user, newEmail) {
    return $c531f4c621fcaa8c$var$updateEmailOrPassword((0, $2xDiJ.getModularInstance)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$21579262ef46735b(user, newPassword) {
    return $c531f4c621fcaa8c$var$updateEmailOrPassword((0, $2xDiJ.getModularInstance)(user), null, newPassword);
}
async function $c531f4c621fcaa8c$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $c531f4c621fcaa8c$var$_logoutIfInvalidated(user, $c531f4c621fcaa8c$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $c531f4c621fcaa8c$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $c531f4c621fcaa8c$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $c531f4c621fcaa8c$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $c531f4c621fcaa8c$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $c531f4c621fcaa8c$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $c531f4c621fcaa8c$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $c531f4c621fcaa8c$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $c531f4c621fcaa8c$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $c531f4c621fcaa8c$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $c531f4c621fcaa8c$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $c531f4c621fcaa8c$var$FederatedAdditionalUserInfoWithUsername extends $c531f4c621fcaa8c$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $c531f4c621fcaa8c$var$FacebookAdditionalUserInfo extends $c531f4c621fcaa8c$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $c531f4c621fcaa8c$var$GithubAdditionalUserInfo extends $c531f4c621fcaa8c$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $c531f4c621fcaa8c$var$GoogleAdditionalUserInfo extends $c531f4c621fcaa8c$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $c531f4c621fcaa8c$var$TwitterAdditionalUserInfo extends $c531f4c621fcaa8c$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$7a38258bbe170828(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $c531f4c621fcaa8c$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $c531f4c621fcaa8c$export$9e5f44173e64f162(auth, persistence) {
    return (0, $2xDiJ.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$625550452a3fa3ec(auth) {
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    return authInternal.initializeRecaptchaConfig();
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$90a7f3efeed30595(auth, nextOrObserver, error, completed) {
    return (0, $2xDiJ.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $c531f4c621fcaa8c$export$efccba1c4a2ef57b(auth, callback, onAbort) {
    return (0, $2xDiJ.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $2xDiJ.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$4a5767248b18ef41(auth) {
    (0, $2xDiJ.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$df995fae86a55f06(auth, user) {
    return (0, $2xDiJ.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$ef35774e6d314e91(auth) {
    return (0, $2xDiJ.getModularInstance)(auth).signOut();
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$e7094788287c5e9b(user) {
    return (0, $2xDiJ.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $c531f4c621fcaa8c$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $c531f4c621fcaa8c$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $c531f4c621fcaa8c$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $c531f4c621fcaa8c$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$c531f4c621fcaa8c$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $c531f4c621fcaa8c$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $c531f4c621fcaa8c$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $c531f4c621fcaa8c$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $c531f4c621fcaa8c$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$8a5498727ef6be21(auth, error) {
    var _a;
    const authModular = (0, $2xDiJ.getModularInstance)(auth);
    const errorInternal = error;
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $c531f4c621fcaa8c$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$startEnrollPhoneMfa(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
function $c531f4c621fcaa8c$var$finalizeEnrollPhoneMfa(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
function $c531f4c621fcaa8c$var$startEnrollTotpMfa(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
function $c531f4c621fcaa8c$var$finalizeEnrollTotpMfa(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
function $c531f4c621fcaa8c$var$withdrawMfa(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
class $c531f4c621fcaa8c$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$c531f4c621fcaa8c$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $c531f4c621fcaa8c$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $c531f4c621fcaa8c$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $c531f4c621fcaa8c$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $c531f4c621fcaa8c$var$_logoutIfInvalidated(this.user, $c531f4c621fcaa8c$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $c531f4c621fcaa8c$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$d24c54395ce0c509(user) {
    const userModular = (0, $2xDiJ.getModularInstance)(user);
    if (!$c531f4c621fcaa8c$var$multiFactorUserCache.has(userModular)) $c531f4c621fcaa8c$var$multiFactorUserCache.set(userModular, $c531f4c621fcaa8c$var$MultiFactorUserImpl._fromUser(userModular));
    return $c531f4c621fcaa8c$var$multiFactorUserCache.get(userModular);
}
const $c531f4c621fcaa8c$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $c531f4c621fcaa8c$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($c531f4c621fcaa8c$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($c531f4c621fcaa8c$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$_iframeCannotSyncWebStorage() {
    const ua = (0, $2xDiJ.getUA)();
    return $c531f4c621fcaa8c$var$_isSafari(ua) || $c531f4c621fcaa8c$export$493d36ec626b6698(ua);
}
// The polling period in case events are not supported
const $c531f4c621fcaa8c$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $c531f4c621fcaa8c$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $c531f4c621fcaa8c$var$BrowserLocalPersistence extends $c531f4c621fcaa8c$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        this.safariLocalStorageNotSynced = $c531f4c621fcaa8c$var$_iframeCannotSyncWebStorage() && $c531f4c621fcaa8c$var$_isIframe();
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $c531f4c621fcaa8c$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        // Safari embedded iframe. Storage event will trigger with the delta
        // changes but no changes will be applied to the iframe localStorage.
        if (this.safariLocalStorageNotSynced) {
            // Get current iframe page value.
            const storedValue = this.storage.getItem(key);
            // Value not synchronized, synchronize manually.
            if (event.newValue !== storedValue) {
                if (event.newValue !== null) // Value changed from current value.
                this.storage.setItem(key, event.newValue);
                else // Current value deleted.
                this.storage.removeItem(key);
            } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
            return;
        }
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($c531f4c621fcaa8c$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $c531f4c621fcaa8c$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $c531f4c621fcaa8c$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$c531f4c621fcaa8c$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$8b22cf2602fb60ce = $c531f4c621fcaa8c$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$BrowserSessionPersistence extends $c531f4c621fcaa8c$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$c531f4c621fcaa8c$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$407448d2b89b1813 = $c531f4c621fcaa8c$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $c531f4c621fcaa8c$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $c531f4c621fcaa8c$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $c531f4c621fcaa8c$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $c531f4c621fcaa8c$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$c531f4c621fcaa8c$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$export$91477dc880baac21(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $c531f4c621fcaa8c$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $c531f4c621fcaa8c$export$91477dc880baac21("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $c531f4c621fcaa8c$var$_window() {
    return window;
}
function $c531f4c621fcaa8c$var$_setWindowLocation(url) {
    $c531f4c621fcaa8c$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$_isWorker() {
    return typeof $c531f4c621fcaa8c$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $c531f4c621fcaa8c$var$_window()["importScripts"] === "function";
}
async function $c531f4c621fcaa8c$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $c531f4c621fcaa8c$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $c531f4c621fcaa8c$var$_getWorkerGlobalScope() {
    return $c531f4c621fcaa8c$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$DB_NAME = "firebaseLocalStorageDb";
const $c531f4c621fcaa8c$var$DB_VERSION = 1;
const $c531f4c621fcaa8c$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $c531f4c621fcaa8c$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $c531f4c621fcaa8c$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $c531f4c621fcaa8c$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $c531f4c621fcaa8c$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($c531f4c621fcaa8c$var$DB_OBJECTSTORE_NAME);
}
function $c531f4c621fcaa8c$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($c531f4c621fcaa8c$var$DB_NAME);
    return new $c531f4c621fcaa8c$var$DBPromise(request).toPromise();
}
function $c531f4c621fcaa8c$var$_openDatabase() {
    const request = indexedDB.open($c531f4c621fcaa8c$var$DB_NAME, $c531f4c621fcaa8c$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($c531f4c621fcaa8c$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $c531f4c621fcaa8c$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($c531f4c621fcaa8c$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $c531f4c621fcaa8c$var$_deleteDatabase();
                resolve(await $c531f4c621fcaa8c$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $c531f4c621fcaa8c$var$_putObject(db, key, value) {
    const request = $c531f4c621fcaa8c$var$getObjectStore(db, true).put({
        [$c531f4c621fcaa8c$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $c531f4c621fcaa8c$var$DBPromise(request).toPromise();
}
async function $c531f4c621fcaa8c$var$getObject(db, key) {
    const request = $c531f4c621fcaa8c$var$getObjectStore(db, false).get(key);
    const data = await new $c531f4c621fcaa8c$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $c531f4c621fcaa8c$var$_deleteObject(db, key) {
    const request = $c531f4c621fcaa8c$var$getObjectStore(db, true).delete(key);
    return new $c531f4c621fcaa8c$var$DBPromise(request).toPromise();
}
const $c531f4c621fcaa8c$var$_POLLING_INTERVAL_MS = 800;
const $c531f4c621fcaa8c$var$_TRANSACTION_RETRY_COUNT = 3;
class $c531f4c621fcaa8c$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $c531f4c621fcaa8c$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $c531f4c621fcaa8c$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $c531f4c621fcaa8c$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $c531f4c621fcaa8c$var$Receiver._getInstance($c531f4c621fcaa8c$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $c531f4c621fcaa8c$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $c531f4c621fcaa8c$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $c531f4c621fcaa8c$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $c531f4c621fcaa8c$var$_openDatabase();
            await $c531f4c621fcaa8c$var$_putObject(db, $c531f4c621fcaa8c$var$STORAGE_AVAILABLE_KEY, "1");
            await $c531f4c621fcaa8c$var$_deleteObject(db, $c531f4c621fcaa8c$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$c531f4c621fcaa8c$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$c531f4c621fcaa8c$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$c531f4c621fcaa8c$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $c531f4c621fcaa8c$var$getObjectStore(db, false).getAll();
            return new $c531f4c621fcaa8c$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $c531f4c621fcaa8c$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$c531f4c621fcaa8c$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$23f2a1d2818174ef = $c531f4c621fcaa8c$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$startSignInPhoneMfa(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
function $c531f4c621fcaa8c$var$finalizeSignInPhoneMfa(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
function $c531f4c621fcaa8c$var$finalizeSignInTotpMfa(auth, request) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $c531f4c621fcaa8c$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$_SOLVE_TIME_MS = 500;
const $c531f4c621fcaa8c$var$_EXPIRATION_TIME_MS = 60000;
const $c531f4c621fcaa8c$var$_WIDGET_ID_START = 1000000000000;
class $c531f4c621fcaa8c$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $c531f4c621fcaa8c$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $c531f4c621fcaa8c$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $c531f4c621fcaa8c$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $c531f4c621fcaa8c$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $c531f4c621fcaa8c$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $c531f4c621fcaa8c$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $c531f4c621fcaa8c$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $c531f4c621fcaa8c$var$_EXPIRATION_TIME_MS);
        }, $c531f4c621fcaa8c$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $c531f4c621fcaa8c$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $c531f4c621fcaa8c$var$_JSLOAD_CALLBACK = $c531f4c621fcaa8c$var$_generateCallbackName("rcb");
const $c531f4c621fcaa8c$var$NETWORK_TIMEOUT_DELAY = new $c531f4c621fcaa8c$var$Delay(30000, 60000);
const $c531f4c621fcaa8c$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $c531f4c621fcaa8c$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $c531f4c621fcaa8c$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd($c531f4c621fcaa8c$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $c531f4c621fcaa8c$var$isV2($c531f4c621fcaa8c$var$_window().grecaptcha)) return Promise.resolve($c531f4c621fcaa8c$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $c531f4c621fcaa8c$var$_window().setTimeout(()=>{
                reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $c531f4c621fcaa8c$var$NETWORK_TIMEOUT_DELAY.get());
            $c531f4c621fcaa8c$var$_window()[$c531f4c621fcaa8c$var$_JSLOAD_CALLBACK] = ()=>{
                $c531f4c621fcaa8c$var$_window().clearTimeout(networkTimeout);
                delete $c531f4c621fcaa8c$var$_window()[$c531f4c621fcaa8c$var$_JSLOAD_CALLBACK];
                const recaptcha = $c531f4c621fcaa8c$var$_window().grecaptcha;
                if (!recaptcha || !$c531f4c621fcaa8c$var$isV2(recaptcha)) {
                    reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the greptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$c531f4c621fcaa8c$var$RECAPTCHA_BASE}?${(0, $2xDiJ.querystring)({
                onload: $c531f4c621fcaa8c$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $c531f4c621fcaa8c$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $c531f4c621fcaa8c$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $c531f4c621fcaa8c$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $c531f4c621fcaa8c$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $c531f4c621fcaa8c$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $c531f4c621fcaa8c$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $c531f4c621fcaa8c$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $c531f4c621fcaa8c$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $c531f4c621fcaa8c$var$MockReCaptchaLoaderImpl() : new $c531f4c621fcaa8c$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $c531f4c621fcaa8c$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd($c531f4c621fcaa8c$var$_isHttpOrHttps() && !$c531f4c621fcaa8c$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $c531f4c621fcaa8c$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $c531f4c621fcaa8c$var$getRecaptchaParams(this.auth);
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $c531f4c621fcaa8c$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $c531f4c621fcaa8c$export$3a1a48c8f6ef640e._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    const verificationId = await $c531f4c621fcaa8c$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $2xDiJ.getModularInstance)(appVerifier));
    return new $c531f4c621fcaa8c$var$ConfirmationResultImpl(verificationId, (cred)=>$c531f4c621fcaa8c$export$3d8c2f653ac9d0b9(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    await $c531f4c621fcaa8c$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $c531f4c621fcaa8c$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $2xDiJ.getModularInstance)(appVerifier));
    return new $c531f4c621fcaa8c$var$ConfirmationResultImpl(verificationId, (cred)=>$c531f4c621fcaa8c$export$34aec0b863436764(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    const verificationId = await $c531f4c621fcaa8c$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $2xDiJ.getModularInstance)(appVerifier));
    return new $c531f4c621fcaa8c$var$ConfirmationResultImpl(verificationId, (cred)=>$c531f4c621fcaa8c$export$3c2fa207a37baaea(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $c531f4c621fcaa8c$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(verifier.type === $c531f4c621fcaa8c$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $c531f4c621fcaa8c$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $c531f4c621fcaa8c$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $c531f4c621fcaa8c$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$3b14a55fb2447963(user, credential) {
    await $c531f4c621fcaa8c$var$_link$1((0, $2xDiJ.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $c531f4c621fcaa8c$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $c531f4c621fcaa8c$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $c531f4c621fcaa8c$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $2xDiJ.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $c531f4c621fcaa8c$export$3a1a48c8f6ef640e._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $c531f4c621fcaa8c$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $c531f4c621fcaa8c$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $c531f4c621fcaa8c$export$3a1a48c8f6ef640e._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $c531f4c621fcaa8c$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $c531f4c621fcaa8c$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $c531f4c621fcaa8c$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $c531f4c621fcaa8c$export$890c4ad488842ce7(resolverOverride);
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$IdpCredential extends $c531f4c621fcaa8c$export$b4171a6734a65d42 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $c531f4c621fcaa8c$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $c531f4c621fcaa8c$var$_signIn(params) {
    return $c531f4c621fcaa8c$var$_signInWithCredential(params.auth, new $c531f4c621fcaa8c$var$IdpCredential(params), params.bypassAuthState);
}
function $c531f4c621fcaa8c$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $c531f4c621fcaa8c$var$_reauthenticate(user, new $c531f4c621fcaa8c$var$IdpCredential(params), params.bypassAuthState);
}
async function $c531f4c621fcaa8c$var$_link(params) {
    const { auth: auth, user: user } = params;
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $c531f4c621fcaa8c$var$_link$1(user, new $c531f4c621fcaa8c$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $c531f4c621fcaa8c$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $c531f4c621fcaa8c$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $c531f4c621fcaa8c$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $c531f4c621fcaa8c$var$_reauth;
            default:
                $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $c531f4c621fcaa8c$export$6554612db691658e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $c531f4c621fcaa8c$export$6554612db691658e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $c531f4c621fcaa8c$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$db3b6bfb95261072(auth, provider, resolver) {
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    $c531f4c621fcaa8c$var$_assertInstanceOf(auth, provider, $c531f4c621fcaa8c$var$FederatedAuthProvider);
    const resolverInternal = $c531f4c621fcaa8c$var$_withDefaultResolver(authInternal, resolver);
    const action = new $c531f4c621fcaa8c$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    $c531f4c621fcaa8c$var$_assertInstanceOf(userInternal.auth, provider, $c531f4c621fcaa8c$var$FederatedAuthProvider);
    const resolverInternal = $c531f4c621fcaa8c$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $c531f4c621fcaa8c$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    $c531f4c621fcaa8c$var$_assertInstanceOf(userInternal.auth, provider, $c531f4c621fcaa8c$var$FederatedAuthProvider);
    const resolverInternal = $c531f4c621fcaa8c$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $c531f4c621fcaa8c$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $c531f4c621fcaa8c$var$PopupOperation extends $c531f4c621fcaa8c$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($c531f4c621fcaa8c$var$PopupOperation.currentPopupAction) $c531f4c621fcaa8c$var$PopupOperation.currentPopupAction.cancel();
        $c531f4c621fcaa8c$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $c531f4c621fcaa8c$export$6554612db691658e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $c531f4c621fcaa8c$export$91477dc880baac21();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $c531f4c621fcaa8c$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $c531f4c621fcaa8c$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$c531f4c621fcaa8c$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $c531f4c621fcaa8c$var$redirectOutcomeMap = new Map();
class $c531f4c621fcaa8c$var$RedirectAction extends $c531f4c621fcaa8c$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $c531f4c621fcaa8c$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $c531f4c621fcaa8c$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $c531f4c621fcaa8c$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $c531f4c621fcaa8c$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $c531f4c621fcaa8c$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $c531f4c621fcaa8c$var$pendingRedirectKey(auth);
    const persistence = $c531f4c621fcaa8c$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $c531f4c621fcaa8c$var$_setPendingRedirectStatus(resolver, auth) {
    return $c531f4c621fcaa8c$var$resolverPersistence(resolver)._set($c531f4c621fcaa8c$var$pendingRedirectKey(auth), "true");
}
function $c531f4c621fcaa8c$export$53a70dd1ebbae346() {
    $c531f4c621fcaa8c$var$redirectOutcomeMap.clear();
}
function $c531f4c621fcaa8c$export$cf2f7c5792f80b46(auth, result) {
    $c531f4c621fcaa8c$var$redirectOutcomeMap.set(auth._key(), result);
}
function $c531f4c621fcaa8c$var$resolverPersistence(resolver) {
    return $c531f4c621fcaa8c$export$890c4ad488842ce7(resolver._redirectPersistence);
}
function $c531f4c621fcaa8c$var$pendingRedirectKey(auth) {
    return $c531f4c621fcaa8c$export$24baa2b76016ce0e($c531f4c621fcaa8c$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$2d1720544b23b823(auth, provider, resolver) {
    return $c531f4c621fcaa8c$var$_signInWithRedirect(auth, provider, resolver);
}
async function $c531f4c621fcaa8c$var$_signInWithRedirect(auth, provider, resolver) {
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    $c531f4c621fcaa8c$var$_assertInstanceOf(auth, provider, $c531f4c621fcaa8c$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $c531f4c621fcaa8c$var$_withDefaultResolver(authInternal, resolver);
    await $c531f4c621fcaa8c$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $c531f4c621fcaa8c$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $c531f4c621fcaa8c$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    $c531f4c621fcaa8c$var$_assertInstanceOf(userInternal.auth, provider, $c531f4c621fcaa8c$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $c531f4c621fcaa8c$var$_withDefaultResolver(userInternal.auth, resolver);
    await $c531f4c621fcaa8c$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $c531f4c621fcaa8c$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$39b482c5e57630a8(user, provider, resolver) {
    return $c531f4c621fcaa8c$var$_linkWithRedirect(user, provider, resolver);
}
async function $c531f4c621fcaa8c$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $2xDiJ.getModularInstance)(user);
    $c531f4c621fcaa8c$var$_assertInstanceOf(userInternal.auth, provider, $c531f4c621fcaa8c$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $c531f4c621fcaa8c$var$_withDefaultResolver(userInternal.auth, resolver);
    await $c531f4c621fcaa8c$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $c531f4c621fcaa8c$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $c531f4c621fcaa8c$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c531f4c621fcaa8c$export$35e795649ee09318(auth, resolver) {
    await $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth)._initializationPromise;
    return $c531f4c621fcaa8c$export$158acd800e1ef08b(auth, resolver, false);
}
async function $c531f4c621fcaa8c$export$158acd800e1ef08b(auth, resolverExtern, bypassAuthState = false) {
    const authInternal = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(auth);
    const resolver = $c531f4c621fcaa8c$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $c531f4c621fcaa8c$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $c531f4c621fcaa8c$var$prepareUserForRedirect(user) {
    const eventId = $c531f4c621fcaa8c$export$91477dc880baac21(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $c531f4c621fcaa8c$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $c531f4c621fcaa8c$export$9d398bebfec1c039 {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$c531f4c621fcaa8c$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$c531f4c621fcaa8c$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($c531f4c621fcaa8c$export$3d12bd131bb975d1(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $c531f4c621fcaa8c$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($c531f4c621fcaa8c$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($c531f4c621fcaa8c$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $c531f4c621fcaa8c$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $c531f4c621fcaa8c$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $c531f4c621fcaa8c$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $c531f4c621fcaa8c$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c531f4c621fcaa8c$export$9fa96a7d116ea3ce(auth, request = {}) {
    return $c531f4c621fcaa8c$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $c531f4c621fcaa8c$var$HTTP_REGEX = /^https?/;
async function $c531f4c621fcaa8c$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $c531f4c621fcaa8c$export$9fa96a7d116ea3ce(auth);
    for (const domain of authorizedDomains)try {
        if ($c531f4c621fcaa8c$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $c531f4c621fcaa8c$var$matchDomain(expected) {
    const currentUrl = $c531f4c621fcaa8c$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$c531f4c621fcaa8c$var$HTTP_REGEX.test(protocol)) return false;
    if ($c531f4c621fcaa8c$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$NETWORK_TIMEOUT = new $c531f4c621fcaa8c$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $c531f4c621fcaa8c$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $c531f4c621fcaa8c$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $c531f4c621fcaa8c$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $c531f4c621fcaa8c$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $c531f4c621fcaa8c$var$resetUnloadedGapiModules();
                    reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $c531f4c621fcaa8c$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $c531f4c621fcaa8c$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $c531f4c621fcaa8c$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $c531f4c621fcaa8c$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $c531f4c621fcaa8c$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($c531f4c621fcaa8c$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $c531f4c621fcaa8c$var$_loadJS(`https://apis.google.com/js/api.js?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $c531f4c621fcaa8c$var$cachedGApiLoader = null;
        throw error;
    });
}
let $c531f4c621fcaa8c$var$cachedGApiLoader = null;
function $c531f4c621fcaa8c$var$_loadGapi(auth) {
    $c531f4c621fcaa8c$var$cachedGApiLoader = $c531f4c621fcaa8c$var$cachedGApiLoader || $c531f4c621fcaa8c$var$loadGapi(auth);
    return $c531f4c621fcaa8c$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$PING_TIMEOUT = new $c531f4c621fcaa8c$var$Delay(5000, 15000);
const $c531f4c621fcaa8c$var$IFRAME_PATH = "__/auth/iframe";
const $c531f4c621fcaa8c$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $c531f4c621fcaa8c$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $c531f4c621fcaa8c$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $c531f4c621fcaa8c$var$getIframeUrl(auth) {
    const config = auth.config;
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $c531f4c621fcaa8c$var$_emulatorUrl(config, $c531f4c621fcaa8c$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$c531f4c621fcaa8c$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $MjY8E.SDK_VERSION)
    };
    const eid = $c531f4c621fcaa8c$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $2xDiJ.querystring)(params).slice(1)}`;
}
async function $c531f4c621fcaa8c$var$_openIframe(auth) {
    const context = await $c531f4c621fcaa8c$var$_loadGapi(auth);
    const gapi1 = $c531f4c621fcaa8c$var$_window().gapi;
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $c531f4c621fcaa8c$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $c531f4c621fcaa8c$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $c531f4c621fcaa8c$export$3d12bd131bb975d1(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $c531f4c621fcaa8c$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $c531f4c621fcaa8c$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $c531f4c621fcaa8c$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $c531f4c621fcaa8c$var$DEFAULT_WIDTH = 500;
const $c531f4c621fcaa8c$var$DEFAULT_HEIGHT = 600;
const $c531f4c621fcaa8c$var$TARGET_BLANK = "_blank";
const $c531f4c621fcaa8c$var$FIREFOX_EMPTY_URL = "http://localhost";
class $c531f4c621fcaa8c$export$9f4f30ee63539e24 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $c531f4c621fcaa8c$var$_open(auth, url, name, width = $c531f4c621fcaa8c$var$DEFAULT_WIDTH, height = $c531f4c621fcaa8c$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $c531f4c621fcaa8c$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $2xDiJ.getUA)().toLowerCase();
    if (name) target = $c531f4c621fcaa8c$var$_isChromeIOS(ua) ? $c531f4c621fcaa8c$var$TARGET_BLANK : name;
    if ($c531f4c621fcaa8c$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $c531f4c621fcaa8c$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($c531f4c621fcaa8c$var$_isIOSStandalone(ua) && target !== "_self") {
        $c531f4c621fcaa8c$var$openAsNewWindowIOS(url || "", target);
        return new $c531f4c621fcaa8c$export$9f4f30ee63539e24(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $c531f4c621fcaa8c$export$9f4f30ee63539e24(newWin);
}
function $c531f4c621fcaa8c$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $c531f4c621fcaa8c$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $c531f4c621fcaa8c$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $c531f4c621fcaa8c$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $c531f4c621fcaa8c$export$92108d983e8ee699(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $MjY8E.SDK_VERSION),
        eventId: eventId
    };
    if (provider instanceof $c531f4c621fcaa8c$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $2xDiJ.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $c531f4c621fcaa8c$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endipointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$c531f4c621fcaa8c$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$c531f4c621fcaa8c$var$getHandlerBase(auth)}?${(0, $2xDiJ.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $c531f4c621fcaa8c$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$c531f4c621fcaa8c$var$WIDGET_PATH}`;
    return $c531f4c621fcaa8c$var$_emulatorUrl(config, $c531f4c621fcaa8c$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $c531f4c621fcaa8c$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $c531f4c621fcaa8c$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $c531f4c621fcaa8c$export$407448d2b89b1813;
        this._completeRedirectFn = $c531f4c621fcaa8c$export$158acd800e1ef08b;
        this._overrideRedirectResult = $c531f4c621fcaa8c$export$cf2f7c5792f80b46;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $c531f4c621fcaa8c$export$6554612db691658e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $c531f4c621fcaa8c$export$92108d983e8ee699(auth, provider, authType, $c531f4c621fcaa8c$var$_getCurrentUrl(), eventId);
        return $c531f4c621fcaa8c$var$_open(auth, url, $c531f4c621fcaa8c$export$91477dc880baac21());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $c531f4c621fcaa8c$export$92108d983e8ee699(auth, provider, authType, $c531f4c621fcaa8c$var$_getCurrentUrl(), eventId);
        $c531f4c621fcaa8c$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $c531f4c621fcaa8c$export$6554612db691658e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $c531f4c621fcaa8c$var$_openIframe(auth);
        const manager = new $c531f4c621fcaa8c$export$9d398bebfec1c039(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($c531f4c621fcaa8c$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $c531f4c621fcaa8c$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$c531f4c621fcaa8c$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $c531f4c621fcaa8c$export$d66dc83d8cfc8dd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $c531f4c621fcaa8c$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $c531f4c621fcaa8c$var$_isMobileBrowser() || $c531f4c621fcaa8c$var$_isSafari() || $c531f4c621fcaa8c$export$493d36ec626b6698();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $c531f4c621fcaa8c$export$342063e11d6c3cad = $c531f4c621fcaa8c$var$BrowserPopupRedirectResolver;
class $c531f4c621fcaa8c$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $c531f4c621fcaa8c$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $c531f4c621fcaa8c$var$PhoneMultiFactorAssertionImpl extends $c531f4c621fcaa8c$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $c531f4c621fcaa8c$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $c531f4c621fcaa8c$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $c531f4c621fcaa8c$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $c531f4c621fcaa8c$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $c531f4c621fcaa8c$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $c531f4c621fcaa8c$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $c531f4c621fcaa8c$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $c531f4c621fcaa8c$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $c531f4c621fcaa8c$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $c531f4c621fcaa8c$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $c531f4c621fcaa8c$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $c531f4c621fcaa8c$var$TotpMultiFactorAssertionImpl extends $c531f4c621fcaa8c$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $c531f4c621fcaa8c$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $c531f4c621fcaa8c$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c531f4c621fcaa8c$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $c531f4c621fcaa8c$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $c531f4c621fcaa8c$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $c531f4c621fcaa8c$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($c531f4c621fcaa8c$var$_isEmptyString(accountName) || $c531f4c621fcaa8c$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($c531f4c621fcaa8c$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($c531f4c621fcaa8c$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $c531f4c621fcaa8c$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $c531f4c621fcaa8c$var$name = "@firebase/auth";
var $c531f4c621fcaa8c$var$version = "1.1.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c531f4c621fcaa8c$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c531f4c621fcaa8c$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $c531f4c621fcaa8c$var$registerAuth(clientPlatform) {
    (0, $MjY8E._registerComponent)(new (0, $6ExWU.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $c531f4c621fcaa8c$export$91c6e00c14e7e6fd(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $c531f4c621fcaa8c$export$23ebac1979863676(clientPlatform)
        };
        const authInstance = new $c531f4c621fcaa8c$export$a05254e7c3aeba6e(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $c531f4c621fcaa8c$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $MjY8E._registerComponent)(new (0, $6ExWU.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $c531f4c621fcaa8c$export$a33b77bbdbb8366c(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $c531f4c621fcaa8c$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $MjY8E.registerVersion)($c531f4c621fcaa8c$var$name, $c531f4c621fcaa8c$var$version, $c531f4c621fcaa8c$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $MjY8E.registerVersion)($c531f4c621fcaa8c$var$name, $c531f4c621fcaa8c$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c531f4c621fcaa8c$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $c531f4c621fcaa8c$var$authIdTokenMaxAge = (0, $2xDiJ.getExperimentalSetting)("authIdTokenMaxAge") || $c531f4c621fcaa8c$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $c531f4c621fcaa8c$var$lastPostedIdToken = null;
const $c531f4c621fcaa8c$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $c531f4c621fcaa8c$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($c531f4c621fcaa8c$var$lastPostedIdToken === idToken) return;
        $c531f4c621fcaa8c$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $c531f4c621fcaa8c$export$ae1af26003f05816(app = (0, $MjY8E.getApp)()) {
    const provider = (0, $MjY8E._getProvider)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $c531f4c621fcaa8c$export$7f8ddf7c7c20b3cd(app, {
        popupRedirectResolver: $c531f4c621fcaa8c$export$342063e11d6c3cad,
        persistence: [
            $c531f4c621fcaa8c$export$23f2a1d2818174ef,
            $c531f4c621fcaa8c$export$8b22cf2602fb60ce,
            $c531f4c621fcaa8c$export$407448d2b89b1813
        ]
    });
    const authTokenSyncUrl = (0, $2xDiJ.getExperimentalSetting)("authTokenSyncURL");
    if (authTokenSyncUrl) {
        const mintCookie = $c531f4c621fcaa8c$var$mintCookieFactory(authTokenSyncUrl);
        $c531f4c621fcaa8c$export$efccba1c4a2ef57b(auth, mintCookie, ()=>mintCookie(auth.currentUser));
        $c531f4c621fcaa8c$export$90a7f3efeed30595(auth, (user)=>mintCookie(user));
    }
    const authEmulatorHost = (0, $2xDiJ.getDefaultEmulatorHost)("auth");
    if (authEmulatorHost) $c531f4c621fcaa8c$export$9bb611d729802a56(auth, `http://${authEmulatorHost}`);
    return auth;
}
$c531f4c621fcaa8c$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );

});
parcelRequire.register("4tSb9", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $3433e5a3eb89c040$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3433e5a3eb89c040$var$extendStatics = function(d, b) {
    $3433e5a3eb89c040$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3433e5a3eb89c040$var$extendStatics(d, b);
};
function $3433e5a3eb89c040$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3433e5a3eb89c040$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3433e5a3eb89c040$export$18ce0697a983be9b = function() {
    $3433e5a3eb89c040$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3433e5a3eb89c040$export$18ce0697a983be9b.apply(this, arguments);
};
function $3433e5a3eb89c040$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3433e5a3eb89c040$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $3433e5a3eb89c040$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $3433e5a3eb89c040$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $3433e5a3eb89c040$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $3433e5a3eb89c040$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $3433e5a3eb89c040$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $3433e5a3eb89c040$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $3433e5a3eb89c040$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3433e5a3eb89c040$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $3433e5a3eb89c040$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $3433e5a3eb89c040$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $3433e5a3eb89c040$export$45d3717a4c69092e(o, m, p);
}
function $3433e5a3eb89c040$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $3433e5a3eb89c040$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $3433e5a3eb89c040$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($3433e5a3eb89c040$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $3433e5a3eb89c040$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $3433e5a3eb89c040$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $3433e5a3eb89c040$export$10c90e4f7922046c(v) {
    return this instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? (this.v = v, this) : new $3433e5a3eb89c040$export$10c90e4f7922046c(v);
}
function $3433e5a3eb89c040$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $3433e5a3eb89c040$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $3433e5a3eb89c040$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $3433e5a3eb89c040$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $3433e5a3eb89c040$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $3433e5a3eb89c040$export$19a8beecd37a4c45 === "function" ? $3433e5a3eb89c040$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $3433e5a3eb89c040$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $3433e5a3eb89c040$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $3433e5a3eb89c040$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3433e5a3eb89c040$export$45d3717a4c69092e(result, mod, k);
    }
    $3433e5a3eb89c040$var$__setModuleDefault(result, mod);
    return result;
}
function $3433e5a3eb89c040$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $3433e5a3eb89c040$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $3433e5a3eb89c040$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $3433e5a3eb89c040$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $3433e5a3eb89c040$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $3433e5a3eb89c040$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $3433e5a3eb89c040$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $3433e5a3eb89c040$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $3433e5a3eb89c040$export$2e2bcd8739ae039 = {
    __extends: $3433e5a3eb89c040$export$a8ba968b8961cb8a,
    __assign: $3433e5a3eb89c040$export$18ce0697a983be9b,
    __rest: $3433e5a3eb89c040$export$3c9a16f847548506,
    __decorate: $3433e5a3eb89c040$export$29e00dfd3077644b,
    __param: $3433e5a3eb89c040$export$d5ad3fd78186038f,
    __metadata: $3433e5a3eb89c040$export$f1db080c865becb9,
    __awaiter: $3433e5a3eb89c040$export$1050f835b63b671e,
    __generator: $3433e5a3eb89c040$export$67ebef60e6f28a6,
    __createBinding: $3433e5a3eb89c040$export$45d3717a4c69092e,
    __exportStar: $3433e5a3eb89c040$export$f33643c0debef087,
    __values: $3433e5a3eb89c040$export$19a8beecd37a4c45,
    __read: $3433e5a3eb89c040$export$8d051b38c9118094,
    __spread: $3433e5a3eb89c040$export$afc72e2116322959,
    __spreadArrays: $3433e5a3eb89c040$export$6388937ca91ccae8,
    __spreadArray: $3433e5a3eb89c040$export$1216008129fb82ed,
    __await: $3433e5a3eb89c040$export$10c90e4f7922046c,
    __asyncGenerator: $3433e5a3eb89c040$export$e427f37a30a4de9b,
    __asyncDelegator: $3433e5a3eb89c040$export$bbd80228419bb833,
    __asyncValues: $3433e5a3eb89c040$export$e3b29a3d6162315f,
    __makeTemplateObject: $3433e5a3eb89c040$export$4fb47efe1390b86f,
    __importStar: $3433e5a3eb89c040$export$c21735bcef00d192,
    __importDefault: $3433e5a3eb89c040$export$da59b14a69baef04,
    __classPrivateFieldGet: $3433e5a3eb89c040$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $3433e5a3eb89c040$export$d40a35129aaff81f,
    __classPrivateFieldIn: $3433e5a3eb89c040$export$81fdc39f203e4e04,
    __addDisposableResource: $3433e5a3eb89c040$export$88ac25d8e944e405,
    __disposeResources: $3433e5a3eb89c040$export$8f076105dc360e92
};

});




parcelRequire.register("6m2hf", function(module, exports) {
$parcel$export(module.exports, "getFirestore", function () { return (parcelRequire("221Dt")).getFirestore; });
parcelRequire("221Dt");

});
parcelRequire.register("221Dt", function(module, exports) {

$parcel$export(module.exports, "getFirestore", function () { return $17ad0981586945ee$export$f06a05d14c3a6678; });

var $MjY8E = parcelRequire("MjY8E");

var $6ExWU = parcelRequire("6ExWU");

var $kZfxc = parcelRequire("kZfxc");

var $2xDiJ = parcelRequire("2xDiJ");

var $aSES4 = parcelRequire("aSES4");

var $6qd2L = parcelRequire("6qd2L");
const $17ad0981586945ee$var$S = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $17ad0981586945ee$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $17ad0981586945ee$var$User.UNAUTHENTICATED = new $17ad0981586945ee$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$17ad0981586945ee$var$User.GOOGLE_CREDENTIALS = new $17ad0981586945ee$var$User("google-credentials-uid"), $17ad0981586945ee$var$User.FIRST_PARTY = new $17ad0981586945ee$var$User("first-party-uid"), $17ad0981586945ee$var$User.MOCK_USER = new $17ad0981586945ee$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $17ad0981586945ee$var$b = "10.1.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$D = new (0, $kZfxc.Logger)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $17ad0981586945ee$var$__PRIVATE_getLogLevel() {
    return $17ad0981586945ee$var$D.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $17ad0981586945ee$export$c622e99c0ce7b1c9(e) {
    $17ad0981586945ee$var$D.setLogLevel(e);
}
function $17ad0981586945ee$var$__PRIVATE_logDebug(e, ...t) {
    if ($17ad0981586945ee$var$D.logLevel <= (0, $kZfxc.LogLevel).DEBUG) {
        const n = t.map($17ad0981586945ee$var$__PRIVATE_argToString);
        $17ad0981586945ee$var$D.debug(`Firestore (${$17ad0981586945ee$var$b}): ${e}`, ...n);
    }
}
function $17ad0981586945ee$var$__PRIVATE_logError(e, ...t) {
    if ($17ad0981586945ee$var$D.logLevel <= (0, $kZfxc.LogLevel).ERROR) {
        const n = t.map($17ad0981586945ee$var$__PRIVATE_argToString);
        $17ad0981586945ee$var$D.error(`Firestore (${$17ad0981586945ee$var$b}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $17ad0981586945ee$export$86cd73f49cc6e0bb(e, ...t) {
    if ($17ad0981586945ee$var$D.logLevel <= (0, $kZfxc.LogLevel).WARN) {
        const n = t.map($17ad0981586945ee$var$__PRIVATE_argToString);
        $17ad0981586945ee$var$D.warn(`Firestore (${$17ad0981586945ee$var$b}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $17ad0981586945ee$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $17ad0981586945ee$var$fail(e = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const t = `FIRESTORE (${$17ad0981586945ee$var$b}) INTERNAL ASSERTION FAILED: ` + e;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $17ad0981586945ee$var$__PRIVATE_logError(t), new Error(t);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $17ad0981586945ee$var$__PRIVATE_hardAssert(e, t) {
    e || $17ad0981586945ee$var$fail();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $17ad0981586945ee$export$1d2b90eea9bba017(e, t) {
    e || $17ad0981586945ee$var$fail();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $17ad0981586945ee$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$v = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $17ad0981586945ee$export$8fada0bf726bf278 extends (0, $2xDiJ.FirebaseError) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $17ad0981586945ee$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($17ad0981586945ee$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $17ad0981586945ee$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $17ad0981586945ee$var$__PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $17ad0981586945ee$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $17ad0981586945ee$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $17ad0981586945ee$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $17ad0981586945ee$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken();
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($17ad0981586945ee$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $17ad0981586945ee$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($17ad0981586945ee$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($17ad0981586945ee$var$__PRIVATE_hardAssert("string" == typeof t.accessToken), new $17ad0981586945ee$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.auth.removeAuthTokenListener(this.o);
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $17ad0981586945ee$var$__PRIVATE_hardAssert(null === e || "string" == typeof e), new $17ad0981586945ee$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $17ad0981586945ee$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = $17ad0981586945ee$var$User.FIRST_PARTY, this.I = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ T() {
        return this.P ? this.P() : null;
    }
    get headers() {
        this.I.set("X-Goog-AuthUser", this.l);
        // Use array notation to prevent minification
        const e = this.T();
        return e && this.I.set("Authorization", e), this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h), this.I;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $17ad0981586945ee$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.l = e, this.h = t, this.P = n;
    }
    getToken() {
        return Promise.resolve(new $17ad0981586945ee$var$__PRIVATE_FirstPartyToken(this.l, this.h, this.P));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($17ad0981586945ee$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $17ad0981586945ee$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $17ad0981586945ee$var$__PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(e){
        this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
    }
    start(e, t) {
        const onTokenChanged = (e)=>{
            null != e.error && $17ad0981586945ee$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.R;
            return this.R = e.token, $17ad0981586945ee$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $17ad0981586945ee$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.appCheck.addTokenListener(this.o);
        };
        this.A.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.A.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $17ad0981586945ee$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($17ad0981586945ee$var$__PRIVATE_hardAssert("string" == typeof e.token), this.R = e.token, new $17ad0981586945ee$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.appCheck.removeTokenListener(this.o);
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $17ad0981586945ee$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $17ad0981586945ee$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $17ad0981586945ee$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_AutoId {
    static V() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = Math.floor(256 / e.length) * e.length;
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $17ad0981586945ee$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % e.length));
        }
        return n;
    }
}
function $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $17ad0981586945ee$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $17ad0981586945ee$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\x00";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $17ad0981586945ee$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < -62135596800) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $17ad0981586945ee$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $17ad0981586945ee$export$d9bcbd5e1ff81430.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor(1e6 * (e - 1e3 * t));
        return new $17ad0981586945ee$export$d9bcbd5e1ff81430(t, n);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $17ad0981586945ee$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $17ad0981586945ee$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexiographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexiographical ordering.
        const e = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $17ad0981586945ee$var$SnapshotVersion {
    constructor(e){
        this.timestamp = e;
    }
    static fromTimestamp(e) {
        return new $17ad0981586945ee$var$SnapshotVersion(e);
    }
    static min() {
        return new $17ad0981586945ee$var$SnapshotVersion(new $17ad0981586945ee$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $17ad0981586945ee$var$SnapshotVersion(new $17ad0981586945ee$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ class $17ad0981586945ee$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $17ad0981586945ee$var$fail(), void 0 === n ? n = e.length - t : n > e.length - t && $17ad0981586945ee$var$fail(), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $17ad0981586945ee$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $17ad0981586945ee$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = e.get(r), i = t.get(r);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $17ad0981586945ee$var$ResourcePath extends $17ad0981586945ee$var$BasePath {
    construct(e, t, n) {
        return new $17ad0981586945ee$var$ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and traling slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $17ad0981586945ee$var$ResourcePath(t);
    }
    static emptyPath() {
        return new $17ad0981586945ee$var$ResourcePath([]);
    }
}
const $17ad0981586945ee$var$C = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $17ad0981586945ee$export$b7871852b967eaf1 extends $17ad0981586945ee$var$BasePath {
    construct(e, t, n) {
        return new $17ad0981586945ee$export$b7871852b967eaf1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $17ad0981586945ee$var$C.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $17ad0981586945ee$export$b7871852b967eaf1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $17ad0981586945ee$export$b7871852b967eaf1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $17ad0981586945ee$export$b7871852b967eaf1(t);
    }
    static emptyPath() {
        return new $17ad0981586945ee$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $17ad0981586945ee$export$afc2e57c475b7810 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $17ad0981586945ee$var$ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $17ad0981586945ee$var$ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $17ad0981586945ee$export$afc2e57c475b7810(new $17ad0981586945ee$var$ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $17ad0981586945ee$var$FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $17ad0981586945ee$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $17ad0981586945ee$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $17ad0981586945ee$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $17ad0981586945ee$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $17ad0981586945ee$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $17ad0981586945ee$var$IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $17ad0981586945ee$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $17ad0981586945ee$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $17ad0981586945ee$var$IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $17ad0981586945ee$var$IndexState(0, $17ad0981586945ee$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $17ad0981586945ee$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $17ad0981586945ee$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $17ad0981586945ee$export$d9bcbd5e1ff81430(n + 1, 0) : new $17ad0981586945ee$export$d9bcbd5e1ff81430(n, r));
    return new $17ad0981586945ee$var$IndexOffset(i, $17ad0981586945ee$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $17ad0981586945ee$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $17ad0981586945ee$var$IndexOffset(e.readTime, e.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $17ad0981586945ee$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $17ad0981586945ee$var$IndexOffset($17ad0981586945ee$var$SnapshotVersion.min(), $17ad0981586945ee$export$afc2e57c475b7810.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $17ad0981586945ee$var$IndexOffset($17ad0981586945ee$var$SnapshotVersion.max(), $17ad0981586945ee$export$afc2e57c475b7810.empty(), -1);
    }
}
function $17ad0981586945ee$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $17ad0981586945ee$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$F = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $17ad0981586945ee$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $17ad0981586945ee$var$v.FAILED_PRECONDITION || e.message !== $17ad0981586945ee$var$F) throw e;
    $17ad0981586945ee$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $17ad0981586945ee$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $17ad0981586945ee$var$fail(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $17ad0981586945ee$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $17ad0981586945ee$var$PersistencePromise ? t : $17ad0981586945ee$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $17ad0981586945ee$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $17ad0981586945ee$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $17ad0981586945ee$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $17ad0981586945ee$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $17ad0981586945ee$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $17ad0981586945ee$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $17ad0981586945ee$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $17ad0981586945ee$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $17ad0981586945ee$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let o = 0;
            for(let _ = 0; _ < i; _++){
                const a = _;
                t(e[a]).next((e)=>{
                    s[a] = e, ++o, o === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $17ad0981586945ee$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $17ad0981586945ee$var$__PRIVATE_SimpleDbTransaction {
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.m = new $17ad0981586945ee$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.m.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.m.reject(new $17ad0981586945ee$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.m.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $17ad0981586945ee$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.m.reject(new $17ad0981586945ee$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    static open(e, t, n, r) {
        try {
            return new $17ad0981586945ee$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $17ad0981586945ee$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    get g() {
        return this.m.promise;
    }
    abort(e) {
        e && this.m.reject(e), this.aborted || ($17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    p() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $17ad0981586945ee$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $17ad0981586945ee$var$__PRIVATE_SimpleDb {
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.S = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $17ad0981586945ee$var$__PRIVATE_SimpleDb.D((0, $2xDiJ.getUA)()) && $17ad0981586945ee$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /** Deletes the specified database. */ static delete(e) {
        return $17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "Removing database:", e), $17ad0981586945ee$var$__PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static v() {
        if (!(0, $2xDiJ.isIndexedDBAvailable)()) return !1;
        if ($17ad0981586945ee$var$__PRIVATE_SimpleDb.C()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $2xDiJ.getUA)(), t = $17ad0981586945ee$var$__PRIVATE_SimpleDb.D(e), n = 0 < t && t < 10, r = $17ad0981586945ee$var$__PRIVATE_SimpleDb.F(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static C() {
        var e;
        return "undefined" != typeof $6qd2L && "YES" === ((e = {}, void 0 === e) ? void 0 : e.M);
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static O(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static D(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */ static F(e) {
        const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async N(e) {
        return this.db || ($17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $17ad0981586945ee$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $17ad0981586945ee$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.S.B(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.L && (this.db.onversionchange = (e)=>this.L(e)), this.db;
    }
    k(e) {
        this.L = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.N(e);
                const t = $17ad0981586945ee$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.p(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $17ad0981586945ee$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.g, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $17ad0981586945ee$var$__PRIVATE_IterationController {
    constructor(e){
        this.q = e, this.K = !1, this.$ = null;
    }
    get isDone() {
        return this.K;
    }
    get U() {
        return this.$;
    }
    set cursor(e) {
        this.q = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.K = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ W(e) {
        this.$ = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $17ad0981586945ee$var$__PRIVATE_wrapRequest(this.q.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbTransactionError extends $17ad0981586945ee$export$8fada0bf726bf278 {
    constructor(e, t){
        super($17ad0981586945ee$var$v.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $17ad0981586945ee$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $17ad0981586945ee$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "ADD", this.store.name, e, e);
        return $17ad0981586945ee$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $17ad0981586945ee$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "DELETE", this.store.name, e);
        return $17ad0981586945ee$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "COUNT", this.store.name);
        return $17ad0981586945ee$var$__PRIVATE_wrapRequest(this.store.count());
    }
    G(e, t) {
        const n = this.options(e, t);
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster. Unfortunately, getAll() does not support custom indices.
        if (n.index || "function" != typeof this.store.getAll) {
            const e = this.cursor(n), t = [];
            return this.j(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
        {
            const e = this.store.getAll(n.range);
            return new $17ad0981586945ee$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ H(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $17ad0981586945ee$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    J(e, t) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.Y = !1;
        const r = this.cursor(n);
        return this.j(r, (e, t, n)=>n.delete());
    }
    Z(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.j(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ X(e) {
        const t = this.cursor({});
        return new $17ad0981586945ee$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $17ad0981586945ee$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    j(e, t) {
        const n = [];
        return new $17ad0981586945ee$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $17ad0981586945ee$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                if (o instanceof $17ad0981586945ee$var$PersistencePromise) {
                    const e = o.catch((e)=>(s.done(), $17ad0981586945ee$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.U ? i.continue() : i.continue(s.U);
            };
        }).next(()=>$17ad0981586945ee$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.Y ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $17ad0981586945ee$var$__PRIVATE_wrapRequest(e) {
    return new $17ad0981586945ee$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $17ad0981586945ee$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $17ad0981586945ee$var$M = !1;
function $17ad0981586945ee$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_SimpleDb.D((0, $2xDiJ.getUA)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $17ad0981586945ee$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $17ad0981586945ee$var$M || ($17ad0981586945ee$var$M = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
/** This class is responsible for the scheduling of Index Backfiller. */ class $17ad0981586945ee$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.ee = t, this.task = null;
    }
    start() {
        this.te(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    te(e) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("IndexBackiller", `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                $17ad0981586945ee$var$__PRIVATE_logDebug("IndexBackiller", `Documents written: ${await this.ee.ne()}`);
            } catch (e) {
                $17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(e) ? $17ad0981586945ee$var$__PRIVATE_logDebug("IndexBackiller", "Ignoring IndexedDB error during index backfill: ", e) : await $17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.te(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $17ad0981586945ee$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ne(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.re(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ re(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $17ad0981586945ee$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $17ad0981586945ee$var$__PRIVATE_logDebug("IndexBackiller", `Processing collection: ${t}`), this.ie(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ ie(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.se(r, n)).next((n)=>($17ad0981586945ee$var$__PRIVATE_logDebug("IndexBackiller", `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ se(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $17ad0981586945ee$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $17ad0981586945ee$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $17ad0981586945ee$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $17ad0981586945ee$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.oe(e), this._e = (e)=>t.writeSequenceNumber(e));
    }
    oe(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this._e && this._e(e), e;
    }
}
$17ad0981586945ee$var$__PRIVATE_ListenSequence.ae = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $17ad0981586945ee$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $17ad0981586945ee$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $17ad0981586945ee$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$17ad0981586945ee$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $17ad0981586945ee$var$__PRIVATE_encodeSeparator(t)), t = $17ad0981586945ee$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $17ad0981586945ee$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $17ad0981586945ee$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\x00":
                n += "\x01\x10";
                break;
            case "\x01":
                n += "\x01\x11";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $17ad0981586945ee$var$__PRIVATE_encodeSeparator(e) {
    return e + "\x01\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $17ad0981586945ee$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($17ad0981586945ee$var$__PRIVATE_hardAssert(t >= 2), 2 === t) return $17ad0981586945ee$var$__PRIVATE_hardAssert("\x01" === e.charAt(0) && "\x01" === e.charAt(1)), $17ad0981586945ee$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf("\x01", i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $17ad0981586945ee$var$fail();
        switch(e.charAt(t + 1)){
            case "\x01":
                const s = e.substring(i, t);
                let o;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "\x10":
                r += e.substring(i, t), r += "\x00";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $17ad0981586945ee$var$fail();
        }
        i = t + 2;
    }
    return new $17ad0981586945ee$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$x = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $17ad0981586945ee$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $17ad0981586945ee$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $17ad0981586945ee$var$O = {}, $17ad0981586945ee$var$N = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $17ad0981586945ee$var$B = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $17ad0981586945ee$var$L = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $17ad0981586945ee$var$k = [
    "canonicalId",
    "targetId"
], $17ad0981586945ee$var$q = [
    "targetId",
    "path"
], $17ad0981586945ee$var$Q = [
    "path",
    "targetId"
], $17ad0981586945ee$var$K = [
    "collectionId",
    "parent"
], $17ad0981586945ee$var$$ = [
    "indexId",
    "uid"
], $17ad0981586945ee$var$U = [
    "uid",
    "sequenceNumber"
], $17ad0981586945ee$var$W = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $17ad0981586945ee$var$G = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $17ad0981586945ee$var$z = [
    "userId",
    "collectionPath",
    "documentId"
], $17ad0981586945ee$var$j = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $17ad0981586945ee$var$H = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $17ad0981586945ee$var$J = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $17ad0981586945ee$var$Y = [
    ...$17ad0981586945ee$var$J,
    "documentOverlays"
], $17ad0981586945ee$var$Z = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $17ad0981586945ee$var$X = $17ad0981586945ee$var$Z, $17ad0981586945ee$var$ee = [
    ...$17ad0981586945ee$var$X,
    "indexConfiguration",
    "indexState",
    "indexEntries"
];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbTransaction extends $17ad0981586945ee$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.ue = e, this.currentSequenceNumber = t;
    }
}
function $17ad0981586945ee$var$__PRIVATE_getStore(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return $17ad0981586945ee$var$__PRIVATE_SimpleDb.O(n.ue, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $17ad0981586945ee$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $17ad0981586945ee$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $17ad0981586945ee$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $17ad0981586945ee$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $17ad0981586945ee$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $17ad0981586945ee$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $17ad0981586945ee$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $17ad0981586945ee$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $17ad0981586945ee$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $17ad0981586945ee$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $17ad0981586945ee$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $17ad0981586945ee$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $17ad0981586945ee$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $17ad0981586945ee$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $17ad0981586945ee$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $17ad0981586945ee$var$LLRBNode.RED, this.left = null != r ? r : $17ad0981586945ee$var$LLRBNode.EMPTY, this.right = null != i ? i : $17ad0981586945ee$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $17ad0981586945ee$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $17ad0981586945ee$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $17ad0981586945ee$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $17ad0981586945ee$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $17ad0981586945ee$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $17ad0981586945ee$var$fail();
        if (this.right.isRed()) throw $17ad0981586945ee$var$fail();
        const e = this.left.check();
        if (e !== this.right.check()) throw $17ad0981586945ee$var$fail();
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$17ad0981586945ee$var$LLRBNode.EMPTY = null, $17ad0981586945ee$var$LLRBNode.RED = !0, $17ad0981586945ee$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$17ad0981586945ee$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $17ad0981586945ee$var$fail();
    }
    get value() {
        throw $17ad0981586945ee$var$fail();
    }
    get color() {
        throw $17ad0981586945ee$var$fail();
    }
    get left() {
        throw $17ad0981586945ee$var$fail();
    }
    get right() {
        throw $17ad0981586945ee$var$fail();
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $17ad0981586945ee$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $17ad0981586945ee$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $17ad0981586945ee$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $17ad0981586945ee$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $17ad0981586945ee$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $17ad0981586945ee$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $17ad0981586945ee$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $17ad0981586945ee$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $17ad0981586945ee$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $17ad0981586945ee$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($17ad0981586945ee$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $17ad0981586945ee$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$export$b7871852b967eaf1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $17ad0981586945ee$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $17ad0981586945ee$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $17ad0981586945ee$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $17ad0981586945ee$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $17ad0981586945ee$export$67460cdabfa21253 {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $17ad0981586945ee$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $17ad0981586945ee$export$67460cdabfa21253(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $17ad0981586945ee$export$67460cdabfa21253(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$17ad0981586945ee$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $17ad0981586945ee$export$67460cdabfa21253("");
const $17ad0981586945ee$var$te = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($17ad0981586945ee$var$__PRIVATE_hardAssert(!!e), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $17ad0981586945ee$var$te.exec(e);
        if ($17ad0981586945ee$var$__PRIVATE_hardAssert(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $17ad0981586945ee$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $17ad0981586945ee$export$67460cdabfa21253.fromBase64String(e) : $17ad0981586945ee$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $17ad0981586945ee$var$__PRIVATE_isServerTimestamp(e) {
    var t, n;
    return "server_timestamp" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $17ad0981586945ee$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields.__previous_value__;
    return $17ad0981586945ee$var$__PRIVATE_isServerTimestamp(t) ? $17ad0981586945ee$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $17ad0981586945ee$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields.__local_write_time__.timestampValue);
    return new $17ad0981586945ee$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, o, _, a){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $17ad0981586945ee$export$4c3ccc07620ae30a {
    constructor(e, t){
        this.projectId = e, this.database = t || "(default)";
    }
    static empty() {
        return new $17ad0981586945ee$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(e) {
        return e instanceof $17ad0981586945ee$export$4c3ccc07620ae30a && e.projectId === this.projectId && e.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$ne = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $17ad0981586945ee$var$re = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $17ad0981586945ee$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $17ad0981586945ee$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $17ad0981586945ee$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : 10 /* TypeOrder.ObjectValue */  : $17ad0981586945ee$var$fail();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $17ad0981586945ee$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    const n = $17ad0981586945ee$var$__PRIVATE_typeOrder(e);
    if (n !== $17ad0981586945ee$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $17ad0981586945ee$var$__PRIVATE_getLocalWriteTime(e).isEqual($17ad0981586945ee$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $17ad0981586945ee$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($17ad0981586945ee$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $17ad0981586945ee$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $17ad0981586945ee$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.integerValue) === $17ad0981586945ee$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    const n = $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $17ad0981586945ee$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $17ad0981586945ee$var$__PRIVATE_isNegativeZero(n) === $17ad0981586945ee$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $17ad0981586945ee$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $17ad0981586945ee$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                const n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($17ad0981586945ee$var$__PRIVATE_objectSize(n) !== $17ad0981586945ee$var$__PRIVATE_objectSize(r)) return !1;
                for(const e in n)if (n.hasOwnProperty(e) && (void 0 === r[e] || !$17ad0981586945ee$var$__PRIVATE_valueEquals(n[e], r[e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $17ad0981586945ee$var$fail();
    }
}
function $17ad0981586945ee$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$17ad0981586945ee$var$__PRIVATE_valueEquals(e, t));
}
function $17ad0981586945ee$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $17ad0981586945ee$var$__PRIVATE_typeOrder(e), r = $17ad0981586945ee$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $17ad0981586945ee$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $17ad0981586945ee$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $17ad0981586945ee$var$__PRIVATE_compareTimestamps($17ad0981586945ee$var$__PRIVATE_getLocalWriteTime(e), $17ad0981586945ee$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $17ad0981586945ee$var$__PRIVATE_normalizeByteString(e), r = $17ad0981586945ee$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $17ad0981586945ee$var$__PRIVATE_primitiveComparator($17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.latitude), $17ad0981586945ee$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $17ad0981586945ee$var$__PRIVATE_primitiveComparator($17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.longitude), $17ad0981586945ee$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_compareArrays(e, t) {
                const n = e.values || [], r = t.values || [];
                for(let e = 0; e < n.length && e < r.length; ++e){
                    const t = $17ad0981586945ee$var$__PRIVATE_valueCompare(n[e], r[e]);
                    if (t) return t;
                }
                return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $17ad0981586945ee$var$ne.mapValue && t === $17ad0981586945ee$var$ne.mapValue) return 0;
                if (e === $17ad0981586945ee$var$ne.mapValue) return 1;
                if (t === $17ad0981586945ee$var$ne.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $17ad0981586945ee$var$__PRIVATE_primitiveComparator(r[e], s[e]);
                    if (0 !== t) return t;
                    const o = $17ad0981586945ee$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== o) return o;
                }
                return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $17ad0981586945ee$var$fail();
    }
}
function $17ad0981586945ee$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e, t);
    const n = $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(e), r = $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(t), i = $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $17ad0981586945ee$var$canonicalId(e) {
    return $17ad0981586945ee$var$__PRIVATE_canonifyValue(e);
}
function $17ad0981586945ee$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $17ad0981586945ee$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $17ad0981586945ee$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $17ad0981586945ee$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$17ad0981586945ee$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$var$__PRIVATE_estimateByteSize(e) {
    switch($17ad0981586945ee$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $17ad0981586945ee$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $17ad0981586945ee$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $17ad0981586945ee$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $17ad0981586945ee$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $17ad0981586945ee$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $17ad0981586945ee$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $17ad0981586945ee$var$fail();
    }
}
function $17ad0981586945ee$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $17ad0981586945ee$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $17ad0981586945ee$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $17ad0981586945ee$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $17ad0981586945ee$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $17ad0981586945ee$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Creates a deep copy of `source`. */ function $17ad0981586945ee$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $17ad0981586945ee$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $17ad0981586945ee$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $17ad0981586945ee$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $17ad0981586945ee$var$__PRIVATE_isMaxValue(e) {
    return "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */ function $17ad0981586945ee$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $17ad0981586945ee$var$re : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $17ad0981586945ee$var$__PRIVATE_refValue($17ad0981586945ee$export$4c3ccc07620ae30a.empty(), $17ad0981586945ee$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? {
        mapValue: {}
    } : $17ad0981586945ee$var$fail();
}
/** Returns the largest value for the given value type (exclusive). */ function $17ad0981586945ee$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $17ad0981586945ee$var$__PRIVATE_refValue($17ad0981586945ee$export$4c3ccc07620ae30a.empty(), $17ad0981586945ee$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? {
        mapValue: {}
    } : "mapValue" in e ? $17ad0981586945ee$var$ne : $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $17ad0981586945ee$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $17ad0981586945ee$var$ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $17ad0981586945ee$var$ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$17ad0981586945ee$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $17ad0981586945ee$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $17ad0981586945ee$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $17ad0981586945ee$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $17ad0981586945ee$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $17ad0981586945ee$var$__PRIVATE_valueEquals(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $17ad0981586945ee$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $17ad0981586945ee$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $17ad0981586945ee$var$ObjectValue($17ad0981586945ee$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $17ad0981586945ee$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $17ad0981586945ee$var$forEach(e.fields, (e, n)=>{
        const r = new $17ad0981586945ee$export$b7871852b967eaf1([
            e
        ]);
        if ($17ad0981586945ee$var$__PRIVATE_isMapValue(n)) {
            const e = $17ad0981586945ee$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $17ad0981586945ee$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $17ad0981586945ee$var$MutableDocument {
    constructor(e, t, n, r, i, s, o){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $17ad0981586945ee$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $17ad0981586945ee$var$SnapshotVersion.min(), /* readTime */ $17ad0981586945ee$var$SnapshotVersion.min(), /* createTime */ $17ad0981586945ee$var$SnapshotVersion.min(), $17ad0981586945ee$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $17ad0981586945ee$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $17ad0981586945ee$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $17ad0981586945ee$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $17ad0981586945ee$var$SnapshotVersion.min(), /* createTime */ $17ad0981586945ee$var$SnapshotVersion.min(), $17ad0981586945ee$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $17ad0981586945ee$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $17ad0981586945ee$var$SnapshotVersion.min(), /* createTime */ $17ad0981586945ee$var$SnapshotVersion.min(), $17ad0981586945ee$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($17ad0981586945ee$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $17ad0981586945ee$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $17ad0981586945ee$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $17ad0981586945ee$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $17ad0981586945ee$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $17ad0981586945ee$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $17ad0981586945ee$var$Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $17ad0981586945ee$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $17ad0981586945ee$export$afc2e57c475b7810.comparator($17ad0981586945ee$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $17ad0981586945ee$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $17ad0981586945ee$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$17ad0981586945ee$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $17ad0981586945ee$var$OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $17ad0981586945ee$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$Filter {
}
class $17ad0981586945ee$var$FieldFilter extends $17ad0981586945ee$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $17ad0981586945ee$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $17ad0981586945ee$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $17ad0981586945ee$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $17ad0981586945ee$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $17ad0981586945ee$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $17ad0981586945ee$var$FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $17ad0981586945ee$var$__PRIVATE_KeyFieldInFilter(e, n) : new $17ad0981586945ee$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && this.matchesComparison($17ad0981586945ee$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $17ad0981586945ee$var$__PRIVATE_typeOrder(this.value) === $17ad0981586945ee$var$__PRIVATE_typeOrder(t) && this.matchesComparison($17ad0981586945ee$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $17ad0981586945ee$var$fail();
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
    getFirstInequalityField() {
        return this.isInequality() ? this.field : null;
    }
}
class $17ad0981586945ee$var$CompositeFilter extends $17ad0981586945ee$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.ce = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $17ad0981586945ee$var$CompositeFilter(e, t);
    }
    matches(e) {
        return $17ad0981586945ee$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.ce || (this.ce = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.ce;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
    getFirstInequalityField() {
        const e = this.le((e)=>e.isInequality());
        return null !== e ? e.field : null;
    }
    // Performs a depth-first search to find and return the first FieldFilter in the composite filter
    // that satisfies the predicate. Returns `null` if none of the FieldFilters satisfy the
    // predicate.
    le(e) {
        for (const t of this.getFlattenedFilters())if (e(t)) return t;
        return null;
    }
}
function $17ad0981586945ee$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $17ad0981586945ee$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $17ad0981586945ee$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $17ad0981586945ee$var$__PRIVATE_compositeFilterIsFlat(e) && $17ad0981586945ee$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $17ad0981586945ee$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $17ad0981586945ee$var$CompositeFilter) return !1;
    return !0;
}
function $17ad0981586945ee$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $17ad0981586945ee$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $17ad0981586945ee$var$canonicalId(e.value);
    if ($17ad0981586945ee$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$17ad0981586945ee$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$17ad0981586945ee$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $17ad0981586945ee$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $17ad0981586945ee$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $17ad0981586945ee$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $17ad0981586945ee$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $17ad0981586945ee$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $17ad0981586945ee$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $17ad0981586945ee$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $17ad0981586945ee$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $17ad0981586945ee$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $17ad0981586945ee$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$17ad0981586945ee$var$canonicalId(e.value)}`;
    }(e) : e instanceof $17ad0981586945ee$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($17ad0981586945ee$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $17ad0981586945ee$var$__PRIVATE_KeyFieldFilter extends $17ad0981586945ee$var$FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = $17ad0981586945ee$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $17ad0981586945ee$export$afc2e57c475b7810.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $17ad0981586945ee$var$__PRIVATE_KeyFieldInFilter extends $17ad0981586945ee$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $17ad0981586945ee$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $17ad0981586945ee$var$__PRIVATE_KeyFieldNotInFilter extends $17ad0981586945ee$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $17ad0981586945ee$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $17ad0981586945ee$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((e)=>$17ad0981586945ee$export$afc2e57c475b7810.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $17ad0981586945ee$var$__PRIVATE_ArrayContainsFilter extends $17ad0981586945ee$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $17ad0981586945ee$var$isArray(t) && $17ad0981586945ee$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $17ad0981586945ee$var$__PRIVATE_InFilter extends $17ad0981586945ee$var$FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $17ad0981586945ee$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $17ad0981586945ee$var$__PRIVATE_NotInFilter extends $17ad0981586945ee$var$FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($17ad0981586945ee$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && !$17ad0981586945ee$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $17ad0981586945ee$var$__PRIVATE_ArrayContainsAnyFilter extends $17ad0981586945ee$var$FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$17ad0981586945ee$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$17ad0981586945ee$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $17ad0981586945ee$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, o = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.he = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $17ad0981586945ee$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, o = null) {
    return new $17ad0981586945ee$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $17ad0981586945ee$var$__PRIVATE_canonifyTarget(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    if (null === t.he) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$17ad0981586945ee$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $17ad0981586945ee$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$17ad0981586945ee$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$17ad0981586945ee$var$canonicalId(e)).join(",")), t.he = e;
    }
    return t.he;
}
function $17ad0981586945ee$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$17ad0981586945ee$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$17ad0981586945ee$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$17ad0981586945ee$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $17ad0981586945ee$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $17ad0981586945ee$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $17ad0981586945ee$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $17ad0981586945ee$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $17ad0981586945ee$var$FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $17ad0981586945ee$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $17ad0981586945ee$var$re, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $17ad0981586945ee$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $17ad0981586945ee$var$re, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $17ad0981586945ee$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $17ad0981586945ee$var$re;
        }
        $17ad0981586945ee$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $17ad0981586945ee$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $17ad0981586945ee$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $17ad0981586945ee$var$ne, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $17ad0981586945ee$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $17ad0981586945ee$var$ne, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $17ad0981586945ee$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $17ad0981586945ee$var$ne;
        }
        $17ad0981586945ee$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $17ad0981586945ee$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $17ad0981586945ee$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , o = null, _ = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.Pe = null, // The corresponding `Target` of this `Query` instance.
        this.Ie = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $17ad0981586945ee$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $17ad0981586945ee$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $17ad0981586945ee$var$__PRIVATE_newQueryForPath(e) {
    return new $17ad0981586945ee$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $17ad0981586945ee$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
function $17ad0981586945ee$var$__PRIVATE_getFirstOrderByField(e) {
    return e.explicitOrderBy.length > 0 ? e.explicitOrderBy[0].field : null;
}
function $17ad0981586945ee$var$__PRIVATE_getInequalityFilterField(e) {
    for (const t of e.filters){
        const e = t.getFirstInequalityField();
        if (null !== e) return e;
    }
    return null;
}
/**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $17ad0981586945ee$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the implicit order by constraint that is used to execute the Query,
 * which can be different from the order by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`).
 */ function $17ad0981586945ee$var$__PRIVATE_queryOrderBy(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    if (null === t.Pe) {
        t.Pe = [];
        const e = $17ad0981586945ee$var$__PRIVATE_getInequalityFilterField(t), n = $17ad0981586945ee$var$__PRIVATE_getFirstOrderByField(t);
        if (null !== e && null === n) // In order to implicitly add key ordering, we must also add the
        // inequality filter field for it to be a valid query.
        // Note that the default inequality field and key ordering is ascending.
        e.isKeyField() || t.Pe.push(new $17ad0981586945ee$var$OrderBy(e)), t.Pe.push(new $17ad0981586945ee$var$OrderBy($17ad0981586945ee$export$b7871852b967eaf1.keyField(), "asc" /* Direction.ASCENDING */ ));
        else {
            let e = !1;
            for (const n of t.explicitOrderBy)t.Pe.push(n), n.field.isKeyField() && (e = !0);
            if (!e) {
                // The order of the implicit key ordering always matches the last
                // explicit order by
                const e = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ ;
                t.Pe.push(new $17ad0981586945ee$var$OrderBy($17ad0981586945ee$export$b7871852b967eaf1.keyField(), e));
            }
        }
    }
    return t.Pe;
}
/**
 * Converts this `Query` instance to it's corresponding `Target` representation.
 */ function $17ad0981586945ee$var$__PRIVATE_queryToTarget(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    if (!t.Ie) {
        if ("F" /* LimitType.First */  === t.limitType) t.Ie = $17ad0981586945ee$var$__PRIVATE_newTarget(t.path, t.collectionGroup, $17ad0981586945ee$var$__PRIVATE_queryOrderBy(t), t.filters, t.limit, t.startAt, t.endAt);
        else {
            // Flip the orderBy directions since we want the last results
            const e = [];
            for (const n of $17ad0981586945ee$var$__PRIVATE_queryOrderBy(t)){
                const t = "desc" /* Direction.DESCENDING */  === n.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
                e.push(new $17ad0981586945ee$var$OrderBy(n.field, t));
            }
            // We need to swap the cursors to match the now-flipped query ordering.
            const n = t.endAt ? new $17ad0981586945ee$var$Bound(t.endAt.position, t.endAt.inclusive) : null, r = t.startAt ? new $17ad0981586945ee$var$Bound(t.startAt.position, t.startAt.inclusive) : null;
            // Now return as a LimitType.First query.
            t.Ie = $17ad0981586945ee$var$__PRIVATE_newTarget(t.path, t.collectionGroup, e, t.filters, t.limit, n, r);
        }
    }
    return t.Ie;
}
function $17ad0981586945ee$var$__PRIVATE_queryWithAddedFilter(e, t) {
    t.getFirstInequalityField(), $17ad0981586945ee$var$__PRIVATE_getInequalityFilterField(e);
    const n = e.filters.concat([
        t
    ]);
    return new $17ad0981586945ee$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $17ad0981586945ee$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $17ad0981586945ee$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $17ad0981586945ee$var$__PRIVATE_queryEquals(e, t) {
    return $17ad0981586945ee$var$__PRIVATE_targetEquals($17ad0981586945ee$var$__PRIVATE_queryToTarget(e), $17ad0981586945ee$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $17ad0981586945ee$var$__PRIVATE_canonifyQuery(e) {
    return `${$17ad0981586945ee$var$__PRIVATE_canonifyTarget($17ad0981586945ee$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
}
function $17ad0981586945ee$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$17ad0981586945ee$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $17ad0981586945ee$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$17ad0981586945ee$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$17ad0981586945ee$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($17ad0981586945ee$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $17ad0981586945ee$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $17ad0981586945ee$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $17ad0981586945ee$var$__PRIVATE_queryOrderBy(e))// order by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $17ad0981586945ee$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $17ad0981586945ee$var$__PRIVATE_queryOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $17ad0981586945ee$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $17ad0981586945ee$var$__PRIVATE_queryOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $17ad0981586945ee$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $17ad0981586945ee$var$__PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $17ad0981586945ee$var$__PRIVATE_queryOrderBy(e)){
            const e = $17ad0981586945ee$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $17ad0981586945ee$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $17ad0981586945ee$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $17ad0981586945ee$var$__PRIVATE_valueCompare(r, i) : $17ad0981586945ee$var$fail();
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $17ad0981586945ee$var$fail();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $17ad0981586945ee$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $17ad0981586945ee$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $17ad0981586945ee$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$ie = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
function $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap() {
    return $17ad0981586945ee$var$ie;
}
const $17ad0981586945ee$var$se = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
function $17ad0981586945ee$var$documentMap(...e) {
    let t = $17ad0981586945ee$var$se;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $17ad0981586945ee$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $17ad0981586945ee$var$se;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $17ad0981586945ee$var$__PRIVATE_newOverlayMap() {
    return $17ad0981586945ee$var$__PRIVATE_newDocumentKeyMap();
}
function $17ad0981586945ee$var$__PRIVATE_newMutationMap() {
    return $17ad0981586945ee$var$__PRIVATE_newDocumentKeyMap();
}
function $17ad0981586945ee$var$__PRIVATE_newDocumentKeyMap() {
    return new $17ad0981586945ee$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $17ad0981586945ee$var$oe = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
const $17ad0981586945ee$var$_e = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$export$afc2e57c475b7810.comparator);
function $17ad0981586945ee$var$__PRIVATE_documentKeySet(...e) {
    let t = $17ad0981586945ee$var$_e;
    for (const n of e)t = t.add(n);
    return t;
}
const $17ad0981586945ee$var$ae = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_primitiveComparator);
function $17ad0981586945ee$var$__PRIVATE_targetIdSet() {
    return $17ad0981586945ee$var$ae;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $17ad0981586945ee$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $17ad0981586945ee$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $17ad0981586945ee$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $17ad0981586945ee$var$toNumber(e, t) {
    return $17ad0981586945ee$var$isSafeInteger(t) ? $17ad0981586945ee$var$__PRIVATE_toInteger(t) : $17ad0981586945ee$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $17ad0981586945ee$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $17ad0981586945ee$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $17ad0981586945ee$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $17ad0981586945ee$var$__PRIVATE_isServerTimestamp(t) && (t = $17ad0981586945ee$var$__PRIVATE_getPreviousValue(t)), t && (n.fields.__previous_value__ = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $17ad0981586945ee$var$__PRIVATE_ArrayUnionTransformOperation ? $17ad0981586945ee$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $17ad0981586945ee$var$__PRIVATE_ArrayRemoveTransformOperation ? $17ad0981586945ee$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $17ad0981586945ee$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $17ad0981586945ee$var$asNumber(n) + $17ad0981586945ee$var$asNumber(e.Te);
        return $17ad0981586945ee$var$isInteger(n) && $17ad0981586945ee$var$isInteger(e.Te) ? $17ad0981586945ee$var$__PRIVATE_toInteger(r) : $17ad0981586945ee$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $17ad0981586945ee$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $17ad0981586945ee$var$__PRIVATE_ArrayUnionTransformOperation ? $17ad0981586945ee$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $17ad0981586945ee$var$__PRIVATE_ArrayRemoveTransformOperation ? $17ad0981586945ee$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $17ad0981586945ee$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $17ad0981586945ee$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $17ad0981586945ee$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $17ad0981586945ee$var$__PRIVATE_ServerTimestampTransform extends $17ad0981586945ee$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $17ad0981586945ee$var$__PRIVATE_ArrayUnionTransformOperation extends $17ad0981586945ee$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $17ad0981586945ee$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$17ad0981586945ee$var$__PRIVATE_valueEquals(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $17ad0981586945ee$var$__PRIVATE_ArrayRemoveTransformOperation extends $17ad0981586945ee$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $17ad0981586945ee$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $17ad0981586945ee$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$17ad0981586945ee$var$__PRIVATE_valueEquals(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $17ad0981586945ee$var$__PRIVATE_NumericIncrementTransformOperation extends $17ad0981586945ee$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Te = t;
    }
}
function $17ad0981586945ee$var$asNumber(e) {
    return $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $17ad0981586945ee$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $17ad0981586945ee$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $17ad0981586945ee$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $17ad0981586945ee$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $17ad0981586945ee$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $17ad0981586945ee$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $17ad0981586945ee$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $17ad0981586945ee$var$__PRIVATE_ArrayRemoveTransformOperation ? $17ad0981586945ee$var$__PRIVATE_arrayEquals(e.elements, t.elements, $17ad0981586945ee$var$__PRIVATE_valueEquals) : e instanceof $17ad0981586945ee$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $17ad0981586945ee$var$__PRIVATE_NumericIncrementTransformOperation ? $17ad0981586945ee$var$__PRIVATE_valueEquals(e.Te, t.Te) : e instanceof $17ad0981586945ee$var$__PRIVATE_ServerTimestampTransform && t instanceof $17ad0981586945ee$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $17ad0981586945ee$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $17ad0981586945ee$var$Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $17ad0981586945ee$var$Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $17ad0981586945ee$var$Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $17ad0981586945ee$var$Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $17ad0981586945ee$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $17ad0981586945ee$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $17ad0981586945ee$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $17ad0981586945ee$var$__PRIVATE_DeleteMutation(e.key, $17ad0981586945ee$var$Precondition.none()) : new $17ad0981586945ee$var$__PRIVATE_SetMutation(e.key, e.data, $17ad0981586945ee$var$Precondition.none());
    {
        const n = e.data, r = $17ad0981586945ee$var$ObjectValue.empty();
        let i = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$export$b7871852b967eaf1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $17ad0981586945ee$var$__PRIVATE_PatchMutation(e.key, r, new $17ad0981586945ee$var$FieldMask(i.toArray()), $17ad0981586945ee$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $17ad0981586945ee$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $17ad0981586945ee$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $17ad0981586945ee$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $17ad0981586945ee$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$17ad0981586945ee$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $17ad0981586945ee$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($17ad0981586945ee$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $17ad0981586945ee$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $17ad0981586945ee$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$17ad0981586945ee$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $17ad0981586945ee$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $17ad0981586945ee$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$17ad0981586945ee$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $17ad0981586945ee$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($17ad0981586945ee$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($17ad0981586945ee$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $17ad0981586945ee$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $17ad0981586945ee$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $17ad0981586945ee$var$ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $17ad0981586945ee$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $17ad0981586945ee$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$17ad0981586945ee$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $17ad0981586945ee$var$__PRIVATE_SetMutation extends $17ad0981586945ee$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $17ad0981586945ee$var$__PRIVATE_PatchMutation extends $17ad0981586945ee$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $17ad0981586945ee$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $17ad0981586945ee$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $17ad0981586945ee$var$__PRIVATE_hardAssert(e.length === n.length);
    for(let i = 0; i < n.length; i++){
        const s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $17ad0981586945ee$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $17ad0981586945ee$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $17ad0981586945ee$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $17ad0981586945ee$var$__PRIVATE_DeleteMutation extends $17ad0981586945ee$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $17ad0981586945ee$var$__PRIVATE_VerifyMutation extends $17ad0981586945ee$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $17ad0981586945ee$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $17ad0981586945ee$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $17ad0981586945ee$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $17ad0981586945ee$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $17ad0981586945ee$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = t.has(r.key) ? null : o;
            const _ = $17ad0981586945ee$var$__PRIVATE_calculateOverlayMutation(s, o);
            null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($17ad0981586945ee$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $17ad0981586945ee$var$__PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $17ad0981586945ee$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$17ad0981586945ee$var$__PRIVATE_mutationEquals(e, t)) && $17ad0981586945ee$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$17ad0981586945ee$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $17ad0981586945ee$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $17ad0981586945ee$var$__PRIVATE_hardAssert(e.mutations.length === n.length);
        let r = function __PRIVATE_documentVersionMap() {
            return $17ad0981586945ee$var$oe;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $17ad0981586945ee$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $17ad0981586945ee$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $17ad0981586945ee$var$__PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.Ee = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $17ad0981586945ee$var$ue, $17ad0981586945ee$var$ce;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $17ad0981586945ee$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        default:
            return $17ad0981586945ee$var$fail();
        case $17ad0981586945ee$var$v.CANCELLED:
        case $17ad0981586945ee$var$v.UNKNOWN:
        case $17ad0981586945ee$var$v.DEADLINE_EXCEEDED:
        case $17ad0981586945ee$var$v.RESOURCE_EXHAUSTED:
        case $17ad0981586945ee$var$v.INTERNAL:
        case $17ad0981586945ee$var$v.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $17ad0981586945ee$var$v.UNAUTHENTICATED:
            return !1;
        case $17ad0981586945ee$var$v.INVALID_ARGUMENT:
        case $17ad0981586945ee$var$v.NOT_FOUND:
        case $17ad0981586945ee$var$v.ALREADY_EXISTS:
        case $17ad0981586945ee$var$v.PERMISSION_DENIED:
        case $17ad0981586945ee$var$v.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $17ad0981586945ee$var$v.ABORTED:
        case $17ad0981586945ee$var$v.OUT_OF_RANGE:
        case $17ad0981586945ee$var$v.UNIMPLEMENTED:
        case $17ad0981586945ee$var$v.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $17ad0981586945ee$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $17ad0981586945ee$var$__PRIVATE_logError("GRPC error has no .code"), $17ad0981586945ee$var$v.UNKNOWN;
    switch(e){
        case $17ad0981586945ee$var$ue.OK:
            return $17ad0981586945ee$var$v.OK;
        case $17ad0981586945ee$var$ue.CANCELLED:
            return $17ad0981586945ee$var$v.CANCELLED;
        case $17ad0981586945ee$var$ue.UNKNOWN:
            return $17ad0981586945ee$var$v.UNKNOWN;
        case $17ad0981586945ee$var$ue.DEADLINE_EXCEEDED:
            return $17ad0981586945ee$var$v.DEADLINE_EXCEEDED;
        case $17ad0981586945ee$var$ue.RESOURCE_EXHAUSTED:
            return $17ad0981586945ee$var$v.RESOURCE_EXHAUSTED;
        case $17ad0981586945ee$var$ue.INTERNAL:
            return $17ad0981586945ee$var$v.INTERNAL;
        case $17ad0981586945ee$var$ue.UNAVAILABLE:
            return $17ad0981586945ee$var$v.UNAVAILABLE;
        case $17ad0981586945ee$var$ue.UNAUTHENTICATED:
            return $17ad0981586945ee$var$v.UNAUTHENTICATED;
        case $17ad0981586945ee$var$ue.INVALID_ARGUMENT:
            return $17ad0981586945ee$var$v.INVALID_ARGUMENT;
        case $17ad0981586945ee$var$ue.NOT_FOUND:
            return $17ad0981586945ee$var$v.NOT_FOUND;
        case $17ad0981586945ee$var$ue.ALREADY_EXISTS:
            return $17ad0981586945ee$var$v.ALREADY_EXISTS;
        case $17ad0981586945ee$var$ue.PERMISSION_DENIED:
            return $17ad0981586945ee$var$v.PERMISSION_DENIED;
        case $17ad0981586945ee$var$ue.FAILED_PRECONDITION:
            return $17ad0981586945ee$var$v.FAILED_PRECONDITION;
        case $17ad0981586945ee$var$ue.ABORTED:
            return $17ad0981586945ee$var$v.ABORTED;
        case $17ad0981586945ee$var$ue.OUT_OF_RANGE:
            return $17ad0981586945ee$var$v.OUT_OF_RANGE;
        case $17ad0981586945ee$var$ue.UNIMPLEMENTED:
            return $17ad0981586945ee$var$v.UNIMPLEMENTED;
        case $17ad0981586945ee$var$ue.DATA_LOSS:
            return $17ad0981586945ee$var$v.DATA_LOSS;
        default:
            return $17ad0981586945ee$var$fail();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($17ad0981586945ee$var$ce = $17ad0981586945ee$var$ue || ($17ad0981586945ee$var$ue = {}))[$17ad0981586945ee$var$ce.OK = 0] = "OK", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.CANCELLED = 1] = "CANCELLED", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.UNKNOWN = 2] = "UNKNOWN", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.NOT_FOUND = 5] = "NOT_FOUND", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.ABORTED = 10] = "ABORTED", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.INTERNAL = 13] = "INTERNAL", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.UNAVAILABLE = 14] = "UNAVAILABLE", $17ad0981586945ee$var$ce[$17ad0981586945ee$var$ce.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Manages "testing hooks", hooks into the internals of the SDK to verify
 * internal state and events during integration tests. Do not use this class
 * except for testing purposes.
 *
 * There are two ways to retrieve the global singleton instance of this class:
 * 1. The `instance` property, which returns null if the global singleton
 *      instance has not been created. Use this property if the caller should
 *      "do nothing" if there are no testing hooks registered, such as when
 *      delivering an event to notify registered callbacks.
 * 2. The `getOrCreateInstance()` method, which creates the global singleton
 *      instance if it has not been created. Use this method if the instance is
 *      needed to, for example, register a callback.
 *
 * @internal
 */ class $17ad0981586945ee$export$3ab3ff3652492b82 {
    constructor(){
        this.onExistenceFilterMismatchCallbacks = new Map;
    }
    /**
     * Returns the singleton instance of this class, or null if it has not been
     * initialized.
     */ static get instance() {
        return $17ad0981586945ee$var$le;
    }
    /**
     * Returns the singleton instance of this class, creating it if is has never
     * been created before.
     */ static getOrCreateInstance() {
        return null === $17ad0981586945ee$var$le && ($17ad0981586945ee$var$le = new $17ad0981586945ee$export$3ab3ff3652492b82), $17ad0981586945ee$var$le;
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ onExistenceFilterMismatch(e) {
        const t = Symbol();
        return this.onExistenceFilterMismatchCallbacks.set(t, e), ()=>this.onExistenceFilterMismatchCallbacks.delete(t);
    }
    /**
     * Invokes all currently-registered `onExistenceFilterMismatch` callbacks.
     * @param info Information about the existence filter mismatch.
     */ notifyOnExistenceFilterMismatch(e) {
        this.onExistenceFilterMismatchCallbacks.forEach((t)=>t(e));
    }
}
/** The global singleton instance of `TestingHooks`. */ let $17ad0981586945ee$var$le = null;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $17ad0981586945ee$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$he = new (0, $aSES4.Integer)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $17ad0981586945ee$var$__PRIVATE_getMd5HashValue(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $aSES4.Md5);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $17ad0981586945ee$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $aSES4.Integer)([
            n,
            r
        ], 0),
        new (0, $aSES4.Integer)([
            i,
            s
        ], 0)
    ];
}
class $17ad0981586945ee$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $17ad0981586945ee$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $17ad0981586945ee$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $17ad0981586945ee$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $17ad0981586945ee$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.de = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.Ae = (0, $aSES4.Integer).fromNumber(this.de);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    Re(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $aSES4.Integer).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($17ad0981586945ee$var$he) && (r = new (0, $aSES4.Integer)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.Ae).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    Ve(e) {
        return 0 != (this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.de) return !1;
        const t = $17ad0981586945ee$var$__PRIVATE_getMd5HashValue(e), [n, r] = $17ad0981586945ee$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Re(n, r, e);
            if (!this.Ve(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $17ad0981586945ee$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.de) return;
        const t = $17ad0981586945ee$var$__PRIVATE_getMd5HashValue(e), [n, r] = $17ad0981586945ee$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.Re(n, r, e);
            this.me(t);
        }
    }
    me(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $17ad0981586945ee$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $17ad0981586945ee$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $17ad0981586945ee$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $17ad0981586945ee$var$RemoteEvent($17ad0981586945ee$var$SnapshotVersion.min(), r, new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$var$__PRIVATE_primitiveComparator), $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap(), $17ad0981586945ee$var$__PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $17ad0981586945ee$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $17ad0981586945ee$var$TargetChange(n, t, $17ad0981586945ee$var$__PRIVATE_documentKeySet(), $17ad0981586945ee$var$__PRIVATE_documentKeySet(), $17ad0981586945ee$var$__PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $17ad0981586945ee$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.fe = e, this.removedTargetIds = t, this.key = n, this.ge = r;
    }
}
class $17ad0981586945ee$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.pe = t;
    }
}
class $17ad0981586945ee$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $17ad0981586945ee$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $17ad0981586945ee$var$__PRIVATE_TargetState {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.ye = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.we = $17ad0981586945ee$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Se = $17ad0981586945ee$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.be = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.De = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.be;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Se;
    }
    /** Whether this target has pending target adds or target removes. */ get ve() {
        return 0 !== this.ye;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Ce() {
        return this.De;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Fe(e) {
        e.approximateByteSize() > 0 && (this.De = !0, this.Se = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ Me() {
        let e = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), t = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), n = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        return this.we.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $17ad0981586945ee$var$fail();
            }
        }), new $17ad0981586945ee$var$TargetChange(this.Se, this.be, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ xe() {
        this.De = !1, this.we = $17ad0981586945ee$var$__PRIVATE_snapshotChangesMap();
    }
    Oe(e, t) {
        this.De = !0, this.we = this.we.insert(e, t);
    }
    Ne(e) {
        this.De = !0, this.we = this.we.remove(e);
    }
    Be() {
        this.ye += 1;
    }
    Le() {
        this.ye -= 1;
    }
    ke() {
        this.De = !0, this.be = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $17ad0981586945ee$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.qe = e, /** The internal state of all tracked targets. */ this.Qe = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.Ke = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.$e = $17ad0981586945ee$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Ue = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ We(e) {
        for (const t of e.fe)e.ge && e.ge.isFoundDocument() ? this.Ge(t, e.ge) : this.ze(t, e.key, e.ge);
        for (const t of e.removedTargetIds)this.ze(t, e.key, e.ge);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ je(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.He(t);
            switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.Je(t) && n.Fe(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Le(), n.ve || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.xe(), n.Fe(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Le(), n.ve || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.Je(t) && (n.ke(), n.Fe(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.Je(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.Ye(t), n.Fe(e.resumeToken));
                    break;
                default:
                    $17ad0981586945ee$var$fail();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Qe.forEach((e, n)=>{
            this.Je(n) && t(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ Ze(e) {
        var t, n;
        const r = e.targetId, i = e.pe.count, s = this.Xe(r);
        if (s) {
            const o = s.target;
            if ($17ad0981586945ee$var$__PRIVATE_targetIsDocumentTarget(o)) {
                if (0 === i) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $17ad0981586945ee$export$afc2e57c475b7810(o.path);
                    this.ze(r, e, $17ad0981586945ee$var$MutableDocument.newNoDocument(e, $17ad0981586945ee$var$SnapshotVersion.min()));
                } else $17ad0981586945ee$var$__PRIVATE_hardAssert(1 === i);
            } else {
                const s = this.et(r);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (s !== i) {
                    // Apply bloom filter to identify and mark removed documents.
                    const i = this.tt(e, s);
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i.status) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.Ye(r);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i.status ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Ue = this.Ue.insert(r, e);
                    }
                    null === (t = $17ad0981586945ee$export$3ab3ff3652492b82.instance) || void 0 === t || t.notifyOnExistenceFilterMismatch(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r) {
                        var i, s, o, _, a, u;
                        const c = {
                            localCacheCount: n,
                            existenceFilterCount: r.count
                        }, l = r.unchangedNames;
                        l && (c.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === e,
                            hashCount: null !== (i = null == l ? void 0 : l.hashCount) && void 0 !== i ? i : 0,
                            bitmapLength: null !== (_ = null === (o = null === (s = null == l ? void 0 : l.bits) || void 0 === s ? void 0 : s.bitmap) || void 0 === o ? void 0 : o.length) && void 0 !== _ ? _ : 0,
                            padding: null !== (u = null === (a = null == l ? void 0 : l.bits) || void 0 === a ? void 0 : a.padding) && void 0 !== u ? u : 0
                        }, t && (c.bloomFilter.mightContain = t));
                        return c;
                    }(i.status, null !== (n = i.nt) && void 0 !== n ? n : null, s, e.pe));
                }
            }
        }
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ tt(e, t) {
        const { unchangedNames: n, count: r } = e.pe;
        if (!n || !n.bits) return {
            status: 1
        };
        const { bits: { bitmap: i = "", padding: s = 0 }, hashCount: o = 0 } = n;
        let _, a;
        try {
            _ = $17ad0981586945ee$var$__PRIVATE_normalizeByteString(i).toUint8Array();
        } catch (e) {
            if (e instanceof $17ad0981586945ee$var$__PRIVATE_Base64DecodeError) return $17ad0981586945ee$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), {
                status: 1
            };
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            a = new $17ad0981586945ee$var$BloomFilter(_, s, o);
        } catch (e) {
            return $17ad0981586945ee$export$86cd73f49cc6e0bb(e instanceof $17ad0981586945ee$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), {
                status: 1
            };
        }
        const __PRIVATE_bloomFilterMightContain = (e)=>{
            const t = this.qe.rt();
            return a.mightContain(`projects/${t.projectId}/databases/${t.database}/documents/${e}`);
        };
        if (0 === a.de) return {
            status: 1
        };
        return {
            status: r === t - this.it(e.targetId, __PRIVATE_bloomFilterMightContain) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ,
            nt: __PRIVATE_bloomFilterMightContain
        };
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ it(e, t) {
        const n = this.qe.getRemoteKeysForTarget(e);
        let r = 0;
        return n.forEach((n)=>{
            t(n.path.canonicalString()) || (this.ze(e, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ st(e) {
        const t = new Map;
        this.Qe.forEach((n, r)=>{
            const i = this.Xe(r);
            if (i) {
                if (n.current && $17ad0981586945ee$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = new $17ad0981586945ee$export$afc2e57c475b7810(i.target.path);
                    null !== this.Ke.get(t) || this.ot(r, t) || this.ze(r, t, $17ad0981586945ee$var$MutableDocument.newNoDocument(t, e));
                }
                n.Ce && (t.set(r, n.Me()), n.xe());
            }
        });
        let n = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.$e.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.Xe(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.Ke.forEach((t, n)=>n.setReadTime(e));
        const r = new $17ad0981586945ee$var$RemoteEvent(e, t, this.Ue, this.Ke, n);
        return this.Ke = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap(), this.$e = $17ad0981586945ee$var$__PRIVATE_documentTargetMap(), this.Ue = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Ge(e, t) {
        if (!this.Je(e)) return;
        const n = this.ot(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.He(e).Oe(t.key, n), this.Ke = this.Ke.insert(t.key, t), this.$e = this.$e.insert(t.key, this._t(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    ze(e, t, n) {
        if (!this.Je(e)) return;
        const r = this.He(e);
        this.ot(e, t) ? r.Oe(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Ne(t), this.$e = this.$e.insert(t, this._t(t).delete(e)), n && (this.Ke = this.Ke.insert(t, n));
    }
    removeTarget(e) {
        this.Qe.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ et(e) {
        const t = this.He(e).Me();
        return this.qe.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ Be(e) {
        this.He(e).Be();
    }
    He(e) {
        let t = this.Qe.get(e);
        return t || (t = new $17ad0981586945ee$var$__PRIVATE_TargetState, this.Qe.set(e, t)), t;
    }
    _t(e) {
        let t = this.$e.get(e);
        return t || (t = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_primitiveComparator), this.$e = this.$e.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ Je(e) {
        const t = null !== this.Xe(e);
        return t || $17ad0981586945ee$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ Xe(e) {
        const t = this.Qe.get(e);
        return t && t.ve ? null : this.qe.ut(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ Ye(e) {
        this.Qe.set(e, new $17ad0981586945ee$var$__PRIVATE_TargetState);
        this.qe.getRemoteKeysForTarget(e).forEach((t)=>{
            this.ze(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ ot(e, t) {
        return this.qe.getRemoteKeysForTarget(e).has(t);
    }
}
function $17ad0981586945ee$var$__PRIVATE_documentTargetMap() {
    return new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
}
function $17ad0981586945ee$var$__PRIVATE_snapshotChangesMap() {
    return new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
}
const $17ad0981586945ee$var$Pe = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $17ad0981586945ee$var$Ie = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $17ad0981586945ee$var$Te = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $17ad0981586945ee$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $17ad0981586945ee$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $17ad0981586945ee$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $17ad0981586945ee$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $17ad0981586945ee$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $17ad0981586945ee$var$__PRIVATE_toVersion(e, t) {
    return $17ad0981586945ee$var$toTimestamp(e, t.toTimestamp());
}
function $17ad0981586945ee$var$__PRIVATE_fromVersion(e) {
    return $17ad0981586945ee$var$__PRIVATE_hardAssert(!!e), $17ad0981586945ee$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(e);
        return new $17ad0981586945ee$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $17ad0981586945ee$var$__PRIVATE_toResourceName(e, t) {
    return (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $17ad0981586945ee$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents").child(t).canonicalString();
}
function $17ad0981586945ee$var$__PRIVATE_fromResourceName(e) {
    const t = $17ad0981586945ee$var$ResourcePath.fromString(e);
    return $17ad0981586945ee$var$__PRIVATE_hardAssert($17ad0981586945ee$var$__PRIVATE_isValidResourceName(t)), t;
}
function $17ad0981586945ee$var$__PRIVATE_toName(e, t) {
    return $17ad0981586945ee$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $17ad0981586945ee$var$fromName(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $17ad0981586945ee$var$__PRIVATE_toQueryPath(e, t) {
    return $17ad0981586945ee$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $17ad0981586945ee$var$__PRIVATE_fromQueryPath(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $17ad0981586945ee$var$ResourcePath.emptyPath() : $17ad0981586945ee$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $17ad0981586945ee$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $17ad0981586945ee$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $17ad0981586945ee$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $17ad0981586945ee$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $17ad0981586945ee$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $17ad0981586945ee$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $17ad0981586945ee$var$__PRIVATE_fromDocument(e, t, n) {
    const r = $17ad0981586945ee$var$fromName(e, t.name), i = $17ad0981586945ee$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $17ad0981586945ee$var$__PRIVATE_fromVersion(t.createTime) : $17ad0981586945ee$var$SnapshotVersion.min(), o = new $17ad0981586945ee$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $17ad0981586945ee$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $17ad0981586945ee$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $17ad0981586945ee$var$__PRIVATE_hardAssert(!!t.found), t.found.name, t.found.updateTime;
        const n = $17ad0981586945ee$var$fromName(e, t.found.name), r = $17ad0981586945ee$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $17ad0981586945ee$var$__PRIVATE_fromVersion(t.found.createTime) : $17ad0981586945ee$var$SnapshotVersion.min(), s = new $17ad0981586945ee$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $17ad0981586945ee$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $17ad0981586945ee$var$__PRIVATE_hardAssert(!!t.missing), $17ad0981586945ee$var$__PRIVATE_hardAssert(!!t.readTime);
        const n = $17ad0981586945ee$var$fromName(e, t.missing), r = $17ad0981586945ee$var$__PRIVATE_fromVersion(t.readTime);
        return $17ad0981586945ee$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $17ad0981586945ee$var$fail();
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($17ad0981586945ee$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t), $17ad0981586945ee$export$67460cdabfa21253.fromBase64String(t || "")) : ($17ad0981586945ee$var$__PRIVATE_hardAssert(void 0 === t || t instanceof Uint8Array), $17ad0981586945ee$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $17ad0981586945ee$var$v.UNKNOWN : $17ad0981586945ee$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $17ad0981586945ee$export$8fada0bf726bf278(t, e.message || "");
        }(o);
        n = new $17ad0981586945ee$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $17ad0981586945ee$var$fromName(e, r.document.name), s = $17ad0981586945ee$var$__PRIVATE_fromVersion(r.document.updateTime), o = r.document.createTime ? $17ad0981586945ee$var$__PRIVATE_fromVersion(r.document.createTime) : $17ad0981586945ee$var$SnapshotVersion.min(), _ = new $17ad0981586945ee$var$ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $17ad0981586945ee$var$MutableDocument.newFoundDocument(i, s, o, _), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $17ad0981586945ee$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $17ad0981586945ee$var$fromName(e, r.document), s = r.readTime ? $17ad0981586945ee$var$__PRIVATE_fromVersion(r.readTime) : $17ad0981586945ee$var$SnapshotVersion.min(), o = $17ad0981586945ee$var$MutableDocument.newNoDocument(i, s), _ = r.removedTargetIds || [];
        n = new $17ad0981586945ee$var$__PRIVATE_DocumentWatchChange([], _, o.key, o);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $17ad0981586945ee$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $17ad0981586945ee$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $17ad0981586945ee$var$fail();
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $17ad0981586945ee$var$ExistenceFilter(r, i), o = e.targetId;
            n = new $17ad0981586945ee$var$__PRIVATE_ExistenceFilterChange(o, s);
        }
    }
    return n;
}
function $17ad0981586945ee$var$toMutation(e, t) {
    let n;
    if (t instanceof $17ad0981586945ee$var$__PRIVATE_SetMutation) n = {
        update: $17ad0981586945ee$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $17ad0981586945ee$var$__PRIVATE_DeleteMutation) n = {
        delete: $17ad0981586945ee$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $17ad0981586945ee$var$__PRIVATE_PatchMutation) n = {
        update: $17ad0981586945ee$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $17ad0981586945ee$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $17ad0981586945ee$var$__PRIVATE_VerifyMutation)) return $17ad0981586945ee$var$fail();
        n = {
            verify: $17ad0981586945ee$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $17ad0981586945ee$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $17ad0981586945ee$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $17ad0981586945ee$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $17ad0981586945ee$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Te
            };
            throw $17ad0981586945ee$var$fail();
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $17ad0981586945ee$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $17ad0981586945ee$var$fail();
    }(e, t.precondition)), n;
}
function $17ad0981586945ee$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $17ad0981586945ee$var$Precondition.updateTime($17ad0981586945ee$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $17ad0981586945ee$var$Precondition.exists(e.exists) : $17ad0981586945ee$var$Precondition.none();
    }(t.currentDocument) : $17ad0981586945ee$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $17ad0981586945ee$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue), n = new $17ad0981586945ee$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $17ad0981586945ee$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $17ad0981586945ee$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $17ad0981586945ee$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $17ad0981586945ee$var$fail();
            const r = $17ad0981586945ee$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $17ad0981586945ee$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $17ad0981586945ee$var$fromName(e, t.update.name), s = new $17ad0981586945ee$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $17ad0981586945ee$var$FieldMask(t.map((e)=>$17ad0981586945ee$export$b7871852b967eaf1.fromServerFormat(e)));
            }(t.updateMask);
            return new $17ad0981586945ee$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $17ad0981586945ee$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $17ad0981586945ee$var$fromName(e, t.delete);
        return new $17ad0981586945ee$var$__PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = $17ad0981586945ee$var$fromName(e, t.verify);
        return new $17ad0981586945ee$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($17ad0981586945ee$var$__PRIVATE_hardAssert(void 0 !== t), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $17ad0981586945ee$var$__PRIVATE_fromVersion(e.updateTime) : $17ad0981586945ee$var$__PRIVATE_fromVersion(t);
            return n.isEqual($17ad0981586945ee$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $17ad0981586945ee$var$__PRIVATE_fromVersion(t)), new $17ad0981586945ee$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $17ad0981586945ee$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $17ad0981586945ee$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $17ad0981586945ee$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    null !== t.collectionGroup ? (n.parent = $17ad0981586945ee$var$__PRIVATE_toQueryPath(e, r), n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (n.parent = $17ad0981586945ee$var$__PRIVATE_toQueryPath(e, r.popLast()), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]);
    const i = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $17ad0981586945ee$var$__PRIVATE_toFilter($17ad0981586945ee$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    i && (n.structuredQuery.where = i);
    const s = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $17ad0981586945ee$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    s && (n.structuredQuery.orderBy = s);
    const o = $17ad0981586945ee$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== o && (n.structuredQuery.limit = o), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), n;
}
function $17ad0981586945ee$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $17ad0981586945ee$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $17ad0981586945ee$var$__PRIVATE_hardAssert(1 === r);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_fromFilter(e);
        if (t instanceof $17ad0981586945ee$var$CompositeFilter && $17ad0981586945ee$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $17ad0981586945ee$var$OrderBy($17ad0981586945ee$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $17ad0981586945ee$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $17ad0981586945ee$var$Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $17ad0981586945ee$var$Bound(n, t);
    }(n.endAt)), $17ad0981586945ee$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $17ad0981586945ee$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $17ad0981586945ee$var$fail();
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $17ad0981586945ee$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $17ad0981586945ee$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $17ad0981586945ee$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $17ad0981586945ee$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $17ad0981586945ee$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $17ad0981586945ee$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $17ad0981586945ee$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $17ad0981586945ee$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $17ad0981586945ee$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return $17ad0981586945ee$var$fail();
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $17ad0981586945ee$var$FieldFilter.create($17ad0981586945ee$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return $17ad0981586945ee$var$fail();
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $17ad0981586945ee$var$CompositeFilter.create(e.compositeFilter.filters.map((e)=>$17ad0981586945ee$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $17ad0981586945ee$var$fail();
            }
        }(e.compositeFilter.op));
    }(e) : $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$var$__PRIVATE_toDirection(e) {
    return $17ad0981586945ee$var$Pe[e];
}
function $17ad0981586945ee$var$__PRIVATE_toOperatorName(e) {
    return $17ad0981586945ee$var$Ie[e];
}
function $17ad0981586945ee$var$__PRIVATE_toCompositeOperatorName(e) {
    return $17ad0981586945ee$var$Te[e];
}
function $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $17ad0981586945ee$var$__PRIVATE_fromFieldPathReference(e) {
    return $17ad0981586945ee$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $17ad0981586945ee$var$__PRIVATE_toFilter(e) {
    return e instanceof $17ad0981586945ee$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($17ad0981586945ee$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($17ad0981586945ee$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($17ad0981586945ee$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($17ad0981586945ee$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e.field),
                op: $17ad0981586945ee$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $17ad0981586945ee$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$17ad0981586945ee$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $17ad0981586945ee$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $17ad0981586945ee$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $17ad0981586945ee$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $17ad0981586945ee$var$SnapshotVersion.min(), s = $17ad0981586945ee$var$SnapshotVersion.min(), o = $17ad0981586945ee$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $17ad0981586945ee$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $17ad0981586945ee$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $17ad0981586945ee$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $17ad0981586945ee$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $17ad0981586945ee$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.ct = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $17ad0981586945ee$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $17ad0981586945ee$var$__PRIVATE_fromDocument(e.ct, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $17ad0981586945ee$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $17ad0981586945ee$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $17ad0981586945ee$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $17ad0981586945ee$var$fail();
        {
            const e = $17ad0981586945ee$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r = $17ad0981586945ee$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $17ad0981586945ee$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $17ad0981586945ee$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $17ad0981586945ee$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $17ad0981586945ee$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $17ad0981586945ee$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $17ad0981586945ee$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $17ad0981586945ee$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $17ad0981586945ee$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.ct, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $17ad0981586945ee$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $17ad0981586945ee$var$fail();
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $17ad0981586945ee$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $17ad0981586945ee$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $17ad0981586945ee$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $17ad0981586945ee$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $17ad0981586945ee$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $17ad0981586945ee$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $17ad0981586945ee$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$17ad0981586945ee$var$__PRIVATE_fromMutation(e.ct, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$17ad0981586945ee$var$__PRIVATE_fromMutation(e.ct, t)), i = $17ad0981586945ee$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $17ad0981586945ee$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $17ad0981586945ee$var$__PRIVATE_fromDbTarget(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $17ad0981586945ee$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $17ad0981586945ee$var$SnapshotVersion.min();
    let r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        return $17ad0981586945ee$var$__PRIVATE_hardAssert(1 === e.documents.length), $17ad0981586945ee$var$__PRIVATE_queryToTarget($17ad0981586945ee$var$__PRIVATE_newQueryForPath($17ad0981586945ee$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $17ad0981586945ee$var$__PRIVATE_queryToTarget($17ad0981586945ee$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $17ad0981586945ee$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $17ad0981586945ee$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $17ad0981586945ee$var$__PRIVATE_toDbTarget(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $17ad0981586945ee$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $17ad0981586945ee$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $17ad0981586945ee$var$__PRIVATE_toDocumentsTarget(e.ct, t.target) : $17ad0981586945ee$var$__PRIVATE_toQueryTarget(e.ct, t.target);
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $17ad0981586945ee$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $17ad0981586945ee$var$__PRIVATE_fromBundledQuery(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $17ad0981586945ee$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $17ad0981586945ee$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $17ad0981586945ee$var$Overlay(t.largestBatchId, $17ad0981586945ee$var$__PRIVATE_fromMutation(e.ct, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $17ad0981586945ee$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $17ad0981586945ee$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t.uid || "",
        sequenceNumber: n,
        readTime: $17ad0981586945ee$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $17ad0981586945ee$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $17ad0981586945ee$var$__PRIVATE_toDbTimestamp($17ad0981586945ee$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $17ad0981586945ee$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: $17ad0981586945ee$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $17ad0981586945ee$var$__PRIVATE_toDbTimestamp($17ad0981586945ee$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $17ad0981586945ee$var$__PRIVATE_bundlesStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $17ad0981586945ee$var$__PRIVATE_namedQueriesStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static lt(e, t) {
        const n = t.uid || "";
        return new $17ad0981586945ee$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_documentOverlayStore(e).get($17ad0981586945ee$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $17ad0981586945ee$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_newOverlayMap();
        return $17ad0981586945ee$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $17ad0981586945ee$var$Overlay(t, i);
            r.push(this.ht(e, s));
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($17ad0981586945ee$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($17ad0981586945ee$var$__PRIVATE_documentOverlayStore(e).J("collectionPathOverlayIndex", r));
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_newOverlayMap(), i = $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $17ad0981586945ee$var$__PRIVATE_documentOverlayStore(e).G("collectionPathOverlayIndex", s).next((e)=>{
            for (const t of e){
                const e = $17ad0981586945ee$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $17ad0981586945ee$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $17ad0981586945ee$var$__PRIVATE_documentOverlayStore(e).Z({
            index: "collectionGroupOverlayIndex",
            range: o
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $17ad0981586945ee$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    ht(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $17ad0981586945ee$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $17ad0981586945ee$var$toMutation(e.ct, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $17ad0981586945ee$var$__PRIVATE_documentOverlayStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $17ad0981586945ee$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Pt(e, t) {
        this.It(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.Tt();
    }
    It(e, t) {
        if ("nullValue" in e) this.Et(t, 5);
        else if ("booleanValue" in e) this.Et(t, 10), t.dt(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.Et(t, 15), t.dt($17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.Et(t, 13) : (this.Et(t, 15), $17ad0981586945ee$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.dt(0) : t.dt(n));
        } else if ("timestampValue" in e) {
            const n = e.timestampValue;
            this.Et(t, 20), "string" == typeof n ? t.At(n) : (t.At(`${n.seconds || ""}`), t.dt(n.nanos || 0));
        } else if ("stringValue" in e) this.Rt(e.stringValue, t), this.Vt(t);
        else if ("bytesValue" in e) this.Et(t, 30), t.ft($17ad0981586945ee$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.Vt(t);
        else if ("referenceValue" in e) this.gt(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.Et(t, 45), t.dt(n.latitude || 0), t.dt(n.longitude || 0);
        } else "mapValue" in e ? $17ad0981586945ee$var$__PRIVATE_isMaxValue(e) ? this.Et(t, Number.MAX_SAFE_INTEGER) : (this.yt(e.mapValue, t), this.Vt(t)) : "arrayValue" in e ? (this.wt(e.arrayValue, t), this.Vt(t)) : $17ad0981586945ee$var$fail();
    }
    Rt(e, t) {
        this.Et(t, 25), this.St(e, t);
    }
    St(e, t) {
        t.At(e);
    }
    yt(e, t) {
        const n = e.fields || {};
        this.Et(t, 55);
        for (const e of Object.keys(n))this.Rt(e, t), this.It(n[e], t);
    }
    wt(e, t) {
        const n = e.values || [];
        this.Et(t, 50);
        for (const e of n)this.It(e, t);
    }
    gt(e, t) {
        this.Et(t, 37);
        $17ad0981586945ee$export$afc2e57c475b7810.fromName(e).path.forEach((e)=>{
            this.Et(t, 60), this.St(e, t);
        });
    }
    Et(e, t) {
        e.dt(t);
    }
    Vt(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.dt(2);
    }
}
$17ad0981586945ee$var$__PRIVATE_FirestoreIndexValueWriter.bt = new $17ad0981586945ee$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $17ad0981586945ee$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 == 0 && // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 == 0 && // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $17ad0981586945ee$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $17ad0981586945ee$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $17ad0981586945ee$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Dt(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.vt(n.value), n = t.next();
        this.Ct();
    }
    Ft(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Mt(n.value), n = t.next();
        this.xt();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Ot(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.vt(e);
            else if (e < 2048) this.vt(960 | e >>> 6), this.vt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.vt(480 | e >>> 12), this.vt(128 | 63 & e >>> 6), this.vt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.vt(240 | e >>> 18), this.vt(128 | 63 & e >>> 12), this.vt(128 | 63 & e >>> 6), this.vt(128 | 63 & e);
            }
        }
        this.Ct();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ Nt(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Mt(e);
            else if (e < 2048) this.Mt(960 | e >>> 6), this.Mt(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Mt(480 | e >>> 12), this.Mt(128 | 63 & e >>> 6), this.Mt(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Mt(240 | e >>> 18), this.Mt(128 | 63 & e >>> 12), this.Mt(128 | 63 & e >>> 6), this.Mt(128 | 63 & e);
            }
        }
        this.xt();
    }
    Bt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.Lt(e), n = $17ad0981586945ee$var$__PRIVATE_unsignedNumLength(t);
        this.kt(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    qt(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.Lt(e), n = $17ad0981586945ee$var$__PRIVATE_unsignedNumLength(t);
        this.kt(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ Qt() {
        this.Kt(255), this.Kt(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ $t() {
        this.Ut(255), this.Ut(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.kt(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Wt() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Lt(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = 0 != (128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ vt(e) {
        const t = 255 & e;
        0 === t ? (this.Kt(0), this.Kt(255)) : 255 === t ? (this.Kt(255), this.Kt(0)) : this.Kt(t);
    }
    /** Writes a single byte descending to the buffer.  */ Mt(e) {
        const t = 255 & e;
        0 === t ? (this.Ut(0), this.Ut(255)) : 255 === t ? (this.Ut(255), this.Ut(0)) : this.Ut(e);
    }
    Ct() {
        this.Kt(0), this.Kt(1);
    }
    xt() {
        this.Ut(0), this.Ut(1);
    }
    Kt(e) {
        this.kt(1), this.buffer[this.position++] = e;
    }
    Ut(e) {
        this.kt(1), this.buffer[this.position++] = ~e;
    }
    kt(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $17ad0981586945ee$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.Gt = e;
    }
    ft(e) {
        this.Gt.Dt(e);
    }
    At(e) {
        this.Gt.Ot(e);
    }
    dt(e) {
        this.Gt.Bt(e);
    }
    Tt() {
        this.Gt.Qt();
    }
}
class $17ad0981586945ee$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.Gt = e;
    }
    ft(e) {
        this.Gt.Ft(e);
    }
    At(e) {
        this.Gt.Nt(e);
    }
    dt(e) {
        this.Gt.qt(e);
    }
    Tt() {
        this.Gt.$t();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.Gt = new $17ad0981586945ee$var$__PRIVATE_OrderedCodeWriter, this.zt = new $17ad0981586945ee$var$__PRIVATE_AscendingIndexByteEncoder(this.Gt), this.jt = new $17ad0981586945ee$var$__PRIVATE_DescendingIndexByteEncoder(this.Gt);
    }
    seed(e) {
        this.Gt.seed(e);
    }
    Ht(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.zt : this.jt;
    }
    Wt() {
        return this.Gt.Wt();
    }
    reset() {
        this.Gt.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $17ad0981586945ee$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.indexId = e, this.documentKey = t, this.arrayValue = n, this.directionalValue = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Jt() {
        const e = this.directionalValue.length, t = 0 === e || 255 === this.directionalValue[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.directionalValue, 0), t !== e ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $17ad0981586945ee$var$__PRIVATE_IndexEntry(this.indexId, this.documentKey, this.arrayValue, n);
    }
}
function $17ad0981586945ee$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.indexId - t.indexId;
    return 0 !== n ? n : (n = $17ad0981586945ee$var$__PRIVATE_compareByteArrays(e.arrayValue, t.arrayValue), 0 !== n ? n : (n = $17ad0981586945ee$var$__PRIVATE_compareByteArrays(e.directionalValue, t.directionalValue), 0 !== n ? n : $17ad0981586945ee$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey)));
}
function $17ad0981586945ee$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $17ad0981586945ee$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.Yt = e.orderBy, this.Zt = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.Xt = e : this.Zt.push(e);
        }
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ en(e) {
        $17ad0981586945ee$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId);
        // If there is an array element, find a matching filter.
        const t = $17ad0981586945ee$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.tn(t)) return !1;
        const n = $17ad0981586945ee$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.tn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (void 0 !== this.Xt) {
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(this.Xt.field.canonicalString())) {
                const e = n[i];
                if (!this.nn(this.Xt, e) || !this.rn(this.Yt[s++], e)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.Yt.length || !this.rn(this.Yt[s++], e)) return !1;
        }
        return !0;
    }
    tn(e) {
        for (const t of this.Zt)if (this.nn(t, e)) return !0;
        return !1;
    }
    nn(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    rn(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $17ad0981586945ee$var$__PRIVATE_computeInExpansion(e) {
    var t, n;
    if ($17ad0981586945ee$var$__PRIVATE_hardAssert(e instanceof $17ad0981586945ee$var$FieldFilter || e instanceof $17ad0981586945ee$var$CompositeFilter), e instanceof $17ad0981586945ee$var$FieldFilter) {
        if (e instanceof $17ad0981586945ee$var$__PRIVATE_InFilter) {
            const r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map((t)=>$17ad0981586945ee$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t))) || [];
            return $17ad0981586945ee$var$CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const r = e.filters.map((e)=>$17ad0981586945ee$var$__PRIVATE_computeInExpansion(e));
    return $17ad0981586945ee$var$CompositeFilter.create(r, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $17ad0981586945ee$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $17ad0981586945ee$var$__PRIVATE_computeDistributedNormalForm($17ad0981586945ee$var$__PRIVATE_computeInExpansion(e));
    return $17ad0981586945ee$var$__PRIVATE_hardAssert($17ad0981586945ee$var$__PRIVATE_isDisjunctiveNormalForm(t)), $17ad0981586945ee$var$__PRIVATE_isSingleFieldFilter(t) || $17ad0981586945ee$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $17ad0981586945ee$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $17ad0981586945ee$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $17ad0981586945ee$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $17ad0981586945ee$var$CompositeFilter && $17ad0981586945ee$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $17ad0981586945ee$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $17ad0981586945ee$var$__PRIVATE_isSingleFieldFilter(e) || $17ad0981586945ee$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $17ad0981586945ee$var$CompositeFilter && $17ad0981586945ee$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$17ad0981586945ee$var$__PRIVATE_isSingleFieldFilter(t) && !$17ad0981586945ee$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $17ad0981586945ee$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($17ad0981586945ee$var$__PRIVATE_hardAssert(e instanceof $17ad0981586945ee$var$FieldFilter || e instanceof $17ad0981586945ee$var$CompositeFilter), e instanceof $17ad0981586945ee$var$FieldFilter) return e;
    if (1 === e.filters.length) return $17ad0981586945ee$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$17ad0981586945ee$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $17ad0981586945ee$var$CompositeFilter.create(t, e.op);
    return n = $17ad0981586945ee$var$__PRIVATE_applyAssociation(n), $17ad0981586945ee$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($17ad0981586945ee$var$__PRIVATE_hardAssert(n instanceof $17ad0981586945ee$var$CompositeFilter), $17ad0981586945ee$var$__PRIVATE_hardAssert($17ad0981586945ee$var$__PRIVATE_compositeFilterIsConjunction(n)), $17ad0981586945ee$var$__PRIVATE_hardAssert(n.filters.length > 1), n.filters.reduce((e, t)=>$17ad0981586945ee$var$__PRIVATE_applyDistribution(e, t)));
}
function $17ad0981586945ee$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $17ad0981586945ee$var$__PRIVATE_hardAssert(e instanceof $17ad0981586945ee$var$FieldFilter || e instanceof $17ad0981586945ee$var$CompositeFilter), $17ad0981586945ee$var$__PRIVATE_hardAssert(t instanceof $17ad0981586945ee$var$FieldFilter || t instanceof $17ad0981586945ee$var$CompositeFilter), // FieldFilter FieldFilter
    n = e instanceof $17ad0981586945ee$var$FieldFilter ? t instanceof $17ad0981586945ee$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $17ad0981586945ee$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $17ad0981586945ee$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $17ad0981586945ee$var$FieldFilter ? $17ad0981586945ee$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($17ad0981586945ee$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0), $17ad0981586945ee$var$__PRIVATE_compositeFilterIsConjunction(e) && $17ad0981586945ee$var$__PRIVATE_compositeFilterIsConjunction(t)) return $17ad0981586945ee$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $17ad0981586945ee$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $17ad0981586945ee$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$17ad0981586945ee$var$__PRIVATE_applyDistribution(e, r));
        return $17ad0981586945ee$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $17ad0981586945ee$var$__PRIVATE_applyAssociation(n);
}
function $17ad0981586945ee$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($17ad0981586945ee$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $17ad0981586945ee$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$17ad0981586945ee$var$__PRIVATE_applyDistribution(e, t));
        return $17ad0981586945ee$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $17ad0981586945ee$var$__PRIVATE_applyAssociation(e) {
    if ($17ad0981586945ee$var$__PRIVATE_hardAssert(e instanceof $17ad0981586945ee$var$FieldFilter || e instanceof $17ad0981586945ee$var$CompositeFilter), e instanceof $17ad0981586945ee$var$FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $17ad0981586945ee$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($17ad0981586945ee$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$17ad0981586945ee$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $17ad0981586945ee$var$FieldFilter ? r.push(t) : t instanceof $17ad0981586945ee$var$CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $17ad0981586945ee$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.sn = new $17ad0981586945ee$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.sn.add(t), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.sn.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $17ad0981586945ee$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $17ad0981586945ee$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $17ad0981586945ee$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $17ad0981586945ee$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.resolve($17ad0981586945ee$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.resolve($17ad0981586945ee$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $17ad0981586945ee$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$Ee = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.user = e, this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.on = new $17ad0981586945ee$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this._n = new $17ad0981586945ee$var$ObjectMap((e)=>$17ad0981586945ee$var$__PRIVATE_canonifyTarget(e), (e, t)=>$17ad0981586945ee$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.on.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.on.add(t);
            });
            const i = {
                collectionId: n,
                parent: $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(r)
            };
            return $17ad0981586945ee$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $17ad0981586945ee$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $17ad0981586945ee$var$__PRIVATE_collectionParentsStore(e).G(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($17ad0981586945ee$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $17ad0981586945ee$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $17ad0981586945ee$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($17ad0981586945ee$var$__PRIVATE_toDbIndexState(e, this.user, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_indexConfigurationStore(e), r = $17ad0981586945ee$var$__PRIVATE_indexStateStore(e), i = $17ad0981586945ee$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $17ad0981586945ee$var$PersistencePromise.forEach(this.an(t), (t)=>this.un(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
                const r = [];
                return $17ad0981586945ee$var$PersistencePromise.forEach(i, (i, s)=>{
                    $17ad0981586945ee$var$__PRIVATE_logDebug("IndexedDbIndexManager", `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$17ad0981586945ee$var$__PRIVATE_canonifyTarget(t)}`);
                    const o = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $17ad0981586945ee$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $17ad0981586945ee$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $17ad0981586945ee$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $17ad0981586945ee$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $17ad0981586945ee$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $17ad0981586945ee$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $17ad0981586945ee$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $17ad0981586945ee$var$Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $17ad0981586945ee$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $17ad0981586945ee$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $17ad0981586945ee$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $17ad0981586945ee$var$Bound(n, r);
                    }(s, i), c = this.cn(i, s, a), l = this.cn(i, s, u), h = this.ln(i, s, _), P = this.hn(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                    return $17ad0981586945ee$var$PersistencePromise.forEach(P, (i)=>n.H(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $17ad0981586945ee$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $17ad0981586945ee$var$PersistencePromise.resolve(null);
        });
    }
    an(e) {
        let t = this._n.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $17ad0981586945ee$var$__PRIVATE_getDnfTerms($17ad0981586945ee$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$17ad0981586945ee$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this._n.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ hn(e, t, n, r, i, s, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < _; ++c){
            const _ = t ? this.Pn(t[c / a]) : $17ad0981586945ee$var$Ee, l = this.In(e, _, n[c % a], r), h = this.Tn(e, _, i[c % a], s), P = o.map((t)=>this.In(e, _, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, h, P));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ In(e, t, n, r) {
        const i = new $17ad0981586945ee$var$__PRIVATE_IndexEntry(e, $17ad0981586945ee$export$afc2e57c475b7810.empty(), t, n);
        return r ? i : i.Jt();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ Tn(e, t, n, r) {
        const i = new $17ad0981586945ee$var$__PRIVATE_IndexEntry(e, $17ad0981586945ee$export$afc2e57c475b7810.empty(), t, n);
        return r ? i.Jt() : i;
    }
    un(e, t) {
        const n = new $17ad0981586945ee$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.en(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.an(t);
        return $17ad0981586945ee$var$PersistencePromise.forEach(r, (t)=>this.un(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$export$b7871852b967eaf1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ En(e, t) {
        const n = new $17ad0981586945ee$var$__PRIVATE_IndexByteEncoder;
        for (const r of $17ad0981586945ee$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Ht(r.kind);
            $17ad0981586945ee$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, i);
        }
        return n.Wt();
    }
    /** Encodes a single value to the ascending index format. */ Pn(e) {
        const t = new $17ad0981586945ee$var$__PRIVATE_IndexByteEncoder;
        return $17ad0981586945ee$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, t.Ht(0 /* IndexKind.ASCENDING */ )), t.Wt();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ dn(e, t) {
        const n = new $17ad0981586945ee$var$__PRIVATE_IndexByteEncoder;
        return $17ad0981586945ee$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt($17ad0981586945ee$var$__PRIVATE_refValue(this.databaseId, t), n.Ht(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $17ad0981586945ee$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.Wt();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ ln(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $17ad0981586945ee$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $17ad0981586945ee$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.An(t, s.fieldPath) && $17ad0981586945ee$var$isArray(e)) r = this.Rn(r, s, e);
            else {
                const t = n.Ht(s.kind);
                $17ad0981586945ee$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, t);
            }
        }
        return this.Vn(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ cn(e, t, n) {
        return this.ln(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ Vn(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].Wt();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Rn(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $17ad0981586945ee$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.Wt()), $17ad0981586945ee$var$__PRIVATE_FirestoreIndexValueWriter.bt.Pt(e, r.Ht(t.kind)), i.push(r);
        }
        return i;
    }
    An(e, t) {
        return !!e.filters.find((e)=>e instanceof $17ad0981586945ee$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_indexConfigurationStore(e), r = $17ad0981586945ee$var$__PRIVATE_indexStateStore(e);
        return (t ? n.G("collectionGroupIndex", IDBKeyRange.bound(t, t)) : n.G()).next((e)=>{
            const t = [];
            return $17ad0981586945ee$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $17ad0981586945ee$var$IndexState(t.sequenceNumber, new $17ad0981586945ee$var$IndexOffset($17ad0981586945ee$var$__PRIVATE_fromDbTimestamp(t.readTime), new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $17ad0981586945ee$var$IndexState.empty(), r = e.fields.map(([e, t])=>new $17ad0981586945ee$var$IndexSegment($17ad0981586945ee$export$b7871852b967eaf1.fromServerFormat(e), t));
                        return new $17ad0981586945ee$var$FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_indexConfigurationStore(e), i = $17ad0981586945ee$var$__PRIVATE_indexStateStore(e);
        return this.mn(e).next((e)=>r.G("collectionGroupIndex", IDBKeyRange.bound(t, t)).next((t)=>$17ad0981586945ee$var$PersistencePromise.forEach(t, (t)=>i.put($17ad0981586945ee$var$__PRIVATE_toDbIndexState(t.indexId, this.user, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $17ad0981586945ee$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $17ad0981586945ee$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $17ad0981586945ee$var$PersistencePromise.forEach(i, (n)=>this.fn(e, t, n).next((t)=>{
                        const i = this.gn(r, n);
                        return t.isEqual(i) ? $17ad0981586945ee$var$PersistencePromise.resolve() : this.pn(e, r, n, t, i);
                    }))));
        });
    }
    yn(e, t, n, r) {
        return $17ad0981586945ee$var$__PRIVATE_indexEntriesStore(e).put({
            indexId: r.indexId,
            uid: this.uid,
            arrayValue: r.arrayValue,
            directionalValue: r.directionalValue,
            orderedDocumentKey: this.dn(n, t.key),
            documentKey: t.key.path.toArray()
        });
    }
    wn(e, t, n, r) {
        return $17ad0981586945ee$var$__PRIVATE_indexEntriesStore(e).delete([
            r.indexId,
            this.uid,
            r.arrayValue,
            r.directionalValue,
            this.dn(n, t.key),
            t.key.path.toArray()
        ]);
    }
    fn(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_indexEntriesStore(e);
        let i = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_indexEntryComparator);
        return r.Z({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.dn(n, t)
            ])
        }, (e, r)=>{
            i = i.add(new $17ad0981586945ee$var$__PRIVATE_IndexEntry(n.indexId, t, r.arrayValue, r.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ gn(e, t) {
        let n = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_indexEntryComparator);
        const r = this.En(t, e);
        if (null == r) return n;
        const i = $17ad0981586945ee$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($17ad0981586945ee$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $17ad0981586945ee$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Pn(i), r));
        } else n = n.add(new $17ad0981586945ee$var$__PRIVATE_IndexEntry(t.indexId, e.key, $17ad0981586945ee$var$Ee, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ pn(e, t, n, r, i) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("IndexedDbIndexManager", "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), o = t.getIterator();
            let _ = $17ad0981586945ee$var$__PRIVATE_advanceIterator(s), a = $17ad0981586945ee$var$__PRIVATE_advanceIterator(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; _ || a;){
                let e = !1, t = !1;
                if (_ && a) {
                    const r = n(_, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != _ ? t = !0 : e = !0;
                e ? (r(a), a = $17ad0981586945ee$var$__PRIVATE_advanceIterator(o)) : t ? (i(_), _ = $17ad0981586945ee$var$__PRIVATE_advanceIterator(s)) : (_ = $17ad0981586945ee$var$__PRIVATE_advanceIterator(s), a = $17ad0981586945ee$var$__PRIVATE_advanceIterator(o));
            }
        }(r, i, $17ad0981586945ee$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.yn(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.wn(e, t, n, r));
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(s);
    }
    mn(e) {
        let t = 1;
        return $17ad0981586945ee$var$__PRIVATE_indexStateStore(e).Z({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$17ad0981586945ee$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $17ad0981586945ee$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $17ad0981586945ee$var$__PRIVATE_indexEntryComparator(i, e), s = $17ad0981586945ee$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.Jt();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.Jt());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.Sn(r[e], r[e + 1])) return [];
            const t = [
                r[e].indexId,
                this.uid,
                r[e].arrayValue,
                r[e].directionalValue,
                $17ad0981586945ee$var$Ee,
                []
            ], n = [
                r[e + 1].indexId,
                this.uid,
                r[e + 1].arrayValue,
                r[e + 1].directionalValue,
                $17ad0981586945ee$var$Ee,
                []
            ];
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    Sn(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $17ad0981586945ee$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($17ad0981586945ee$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.mapArray(this.an(t), (t)=>this.un(e, t).next((e)=>e || $17ad0981586945ee$var$fail())).next($17ad0981586945ee$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $17ad0981586945ee$var$__PRIVATE_collectionParentsStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $17ad0981586945ee$var$__PRIVATE_indexEntriesStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $17ad0981586945ee$var$__PRIVATE_indexConfigurationStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $17ad0981586945ee$var$__PRIVATE_indexStateStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "indexState");
}
function $17ad0981586945ee$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $17ad0981586945ee$var$__PRIVATE_hardAssert(0 !== e.length);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $17ad0981586945ee$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $17ad0981586945ee$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$de = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
class $17ad0981586945ee$var$LruParams {
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
    static withCacheSize(e) {
        return new $17ad0981586945ee$var$LruParams(e, $17ad0981586945ee$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $17ad0981586945ee$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $17ad0981586945ee$var$removeMutationBatch(e, t, n) {
    const r = e.store("mutations"), i = e.store("documentMutations"), s = [], o = IDBKeyRange.only(n.batchId);
    let _ = 0;
    const a = r.Z({
        range: o
    }, (e, t, n)=>(_++, n.delete()));
    s.push(a.next(()=>{
        $17ad0981586945ee$var$__PRIVATE_hardAssert(1 === _);
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $17ad0981586945ee$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $17ad0981586945ee$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $17ad0981586945ee$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $17ad0981586945ee$var$fail();
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $17ad0981586945ee$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $17ad0981586945ee$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $17ad0981586945ee$var$LruParams.DEFAULT = new $17ad0981586945ee$var$LruParams(41943040, $17ad0981586945ee$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $17ad0981586945ee$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $17ad0981586945ee$var$LruParams.DISABLED = new $17ad0981586945ee$var$LruParams(-1, 0, 0);
class $17ad0981586945ee$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.bn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static lt(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $17ad0981586945ee$var$__PRIVATE_hardAssert("" !== e.uid);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $17ad0981586945ee$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $17ad0981586945ee$var$__PRIVATE_mutationsStore(e).Z({
            index: "userMutationsIndex",
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $17ad0981586945ee$var$__PRIVATE_documentMutationsStore(e), s = $17ad0981586945ee$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((o)=>{
            $17ad0981586945ee$var$__PRIVATE_hardAssert("number" == typeof o);
            const _ = new $17ad0981586945ee$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$17ad0981586945ee$var$toMutation(e.ct, t)), i = n.mutations.map((t)=>$17ad0981586945ee$var$toMutation(e.ct, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, _), u = [];
            let c = new $17ad0981586945ee$var$SortedSet((e, t)=>$17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $17ad0981586945ee$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, o);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $17ad0981586945ee$var$O));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.bn[o] = _.keys();
            }), $17ad0981586945ee$var$PersistencePromise.waitFor(u).next(()=>_);
        });
    }
    lookupMutationBatch(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($17ad0981586945ee$var$__PRIVATE_hardAssert(e.userId === this.userId), $17ad0981586945ee$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Dn(e, t) {
        return this.bn[t] ? $17ad0981586945ee$var$PersistencePromise.resolve(this.bn[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.bn[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $17ad0981586945ee$var$__PRIVATE_mutationsStore(e).Z({
            index: "userMutationsIndex",
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($17ad0981586945ee$var$__PRIVATE_hardAssert(t.batchId >= n), i = $17ad0981586945ee$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = -1;
        return $17ad0981586945ee$var$__PRIVATE_mutationsStore(e).Z({
            index: "userMutationsIndex",
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $17ad0981586945ee$var$__PRIVATE_mutationsStore(e).G("userMutationsIndex", t).next((e)=>e.map((e)=>$17ad0981586945ee$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $17ad0981586945ee$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $17ad0981586945ee$var$__PRIVATE_documentMutationsStore(e).Z({
            range: r
        }, (n, r, s)=>{
            const [o, _, a] = n, u = $17ad0981586945ee$var$__PRIVATE_decodeResourcePath(_);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $17ad0981586945ee$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $17ad0981586945ee$var$fail();
                $17ad0981586945ee$var$__PRIVATE_hardAssert(e.userId === this.userId), i.push($17ad0981586945ee$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $17ad0981586945ee$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $17ad0981586945ee$var$__PRIVATE_documentMutationsStore(e).Z({
                range: s
            }, (e, r, i)=>{
                const [s, o, _] = e, a = $17ad0981586945ee$var$__PRIVATE_decodeResourcePath(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
            });
            r.push(o);
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(r).next(()=>this.vn(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $17ad0981586945ee$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_primitiveComparator);
        return $17ad0981586945ee$var$__PRIVATE_documentMutationsStore(e).Z({
            range: s
        }, (e, t, i)=>{
            const [s, _, a] = e, u = $17ad0981586945ee$var$__PRIVATE_decodeResourcePath(_);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (o = o.add(a)) : i.done();
        }).next(()=>this.vn(e, o));
    }
    vn(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($17ad0981586945ee$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $17ad0981586945ee$var$fail();
                $17ad0981586945ee$var$__PRIVATE_hardAssert(e.userId === this.userId), n.push($17ad0981586945ee$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $17ad0981586945ee$var$removeMutationBatch(e.ue, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.Cn(t.batchId);
            }), $17ad0981586945ee$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    Cn(e) {
        delete this.bn[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $17ad0981586945ee$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $17ad0981586945ee$var$__PRIVATE_documentMutationsStore(e).Z({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $17ad0981586945ee$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $17ad0981586945ee$var$__PRIVATE_hardAssert(0 === r.length);
            });
        });
    }
    containsKey(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Fn(e) {
        return $17ad0981586945ee$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: -1,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $17ad0981586945ee$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let o = !1;
    return $17ad0981586945ee$var$__PRIVATE_documentMutationsStore(e).Z({
        range: s,
        Y: !0
    }, (e, n, r)=>{
        const [s, _, /*batchID*/ a] = e;
        s === t && _ === i && (o = !0), r.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $17ad0981586945ee$var$__PRIVATE_mutationsStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $17ad0981586945ee$var$__PRIVATE_documentMutationsStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $17ad0981586945ee$var$__PRIVATE_mutationQueuesStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $17ad0981586945ee$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.Mn = e;
    }
    next() {
        return this.Mn += 2, this.Mn;
    }
    static xn() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $17ad0981586945ee$var$__PRIVATE_TargetIdGenerator(0);
    }
    static On() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $17ad0981586945ee$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.Nn(e).next((t)=>{
            const n = new $17ad0981586945ee$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.Bn(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.Nn(e).next((e)=>$17ad0981586945ee$var$SnapshotVersion.fromTimestamp(new $17ad0981586945ee$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.Nn(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.Nn(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.Bn(e, r)));
    }
    addTargetData(e, t) {
        return this.Ln(e, t).next(()=>this.Nn(e).next((n)=>(n.targetCount += 1, this.kn(t, n), this.Bn(e, n))));
    }
    updateTargetData(e, t) {
        return this.Ln(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$17ad0981586945ee$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.Nn(e)).next((t)=>($17ad0981586945ee$var$__PRIVATE_hardAssert(t.targetCount > 0), t.targetCount -= 1, this.Bn(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $17ad0981586945ee$var$__PRIVATE_targetsStore(e).Z((s, o)=>{
            const _ = $17ad0981586945ee$var$__PRIVATE_fromDbTarget(o);
            _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(this.removeTargetData(e, _)));
        }).next(()=>$17ad0981586945ee$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_targetsStore(e).Z((e, n)=>{
            const r = $17ad0981586945ee$var$__PRIVATE_fromDbTarget(n);
            t(r);
        });
    }
    Nn(e) {
        return $17ad0981586945ee$var$__PRIVATE_globalTargetStore(e).get("targetGlobalKey").next((e)=>($17ad0981586945ee$var$__PRIVATE_hardAssert(null !== e), e));
    }
    Bn(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_globalTargetStore(e).put("targetGlobalKey", t);
    }
    Ln(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_targetsStore(e).put($17ad0981586945ee$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ kn(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.Nn(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $17ad0981586945ee$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $17ad0981586945ee$var$__PRIVATE_targetsStore(e).Z({
            range: r,
            index: "queryTargetsIndex"
        }, (e, n, r)=>{
            const s = $17ad0981586945ee$var$__PRIVATE_fromDbTarget(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $17ad0981586945ee$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e);
        return $17ad0981586945ee$var$PersistencePromise.forEach(t, (t)=>{
            const i = $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(t.path);
            return $17ad0981586945ee$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e);
        let i = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        return r.Z({
            range: n,
            Y: !0
        }, (e, t, n)=>{
            const r = $17ad0981586945ee$var$__PRIVATE_decodeResourcePath(e[1]), s = new $17ad0981586945ee$export$afc2e57c475b7810(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $17ad0981586945ee$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e).Z({
            index: "documentTargetsIndex",
            Y: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    ut(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $17ad0981586945ee$var$__PRIVATE_fromDbTarget(e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $17ad0981586945ee$var$__PRIVATE_targetsStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $17ad0981586945ee$var$__PRIVATE_globalTargetStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $17ad0981586945ee$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $17ad0981586945ee$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $17ad0981586945ee$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.qn = e, this.buffer = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_bufferEntryComparator), this.Qn = 0;
    }
    Kn() {
        return ++this.Qn;
    }
    $n(e) {
        const t = [
            e,
            this.Kn()
        ];
        if (this.buffer.size < this.qn) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $17ad0981586945ee$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $17ad0981586945ee$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.Un = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Wn(6e4);
    }
    stop() {
        this.Un && (this.Un.cancel(), this.Un = null);
    }
    get started() {
        return null !== this.Un;
    }
    Wn(e) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection scheduled in ${e}ms`), this.Un = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.Un = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(e) ? $17ad0981586945ee$var$__PRIVATE_logDebug("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e) : await $17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.Wn(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $17ad0981586945ee$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.Gn = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.Gn.zn(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $17ad0981586945ee$var$PersistencePromise.resolve($17ad0981586945ee$var$__PRIVATE_ListenSequence.ae);
        const n = new $17ad0981586945ee$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.Gn.forEachTarget(e, (e)=>n.$n(e.sequenceNumber)).next(()=>this.Gn.jn(e, (e)=>n.$n(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.Gn.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.Gn.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($17ad0981586945ee$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $17ad0981586945ee$var$PersistencePromise.resolve($17ad0981586945ee$var$de)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($17ad0981586945ee$var$__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $17ad0981586945ee$var$de) : this.Hn(e, t));
    }
    getCacheSize(e) {
        return this.Gn.getCacheSize(e);
    }
    Hn(e, t) {
        let n, r, i, s, o, a, u;
        const c = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($17ad0981586945ee$var$__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, o = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, a = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (u = Date.now(), $17ad0981586945ee$var$__PRIVATE_getLogLevel() <= (0, $kZfxc.LogLevel).DEBUG) $17ad0981586945ee$var$__PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - c}ms\n\tDetermined least recently used ${r} in ` + (o - s) + "ms\n" + `\tRemoved ${i} targets in ` + (a - o) + "ms\n" + `\tRemoved ${e} documents in ` + (u - a) + "ms\n" + `Total Duration: ${u - c}ms`);
            return $17ad0981586945ee$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $17ad0981586945ee$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $17ad0981586945ee$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $17ad0981586945ee$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    zn(e) {
        const t = this.Jn(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    Jn(e) {
        let t = 0;
        return this.jn(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    jn(e, t) {
        return this.Yn(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $17ad0981586945ee$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $17ad0981586945ee$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Zn(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $17ad0981586945ee$var$__PRIVATE_mutationQueuesStore(e).X((r)=>$17ad0981586945ee$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $17ad0981586945ee$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.Yn(e, (s, o)=>{
            if (o <= t) {
                const t = this.Zn(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $17ad0981586945ee$var$SnapshotVersion.min()), $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$17ad0981586945ee$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Yn(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e);
        let r, i = $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae;
        return n.Z({
            index: "documentTargetsIndex"
        }, ([e, n], { path: s, sequenceNumber: o })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae && t(new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae && t(new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $17ad0981586945ee$var$__PRIVATE_writeSentinelKey(e, t) {
    return $17ad0981586945ee$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $17ad0981586945ee$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $17ad0981586945ee$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $17ad0981586945ee$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $17ad0981586945ee$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $17ad0981586945ee$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $17ad0981586945ee$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $17ad0981586945ee$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.Xn(e, n)));
    }
    getEntry(e, t) {
        let n = $17ad0981586945ee$var$MutableDocument.newInvalidDocument(t);
        return $17ad0981586945ee$var$__PRIVATE_remoteDocumentsStore(e).Z({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($17ad0981586945ee$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.er(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ tr(e, t) {
        let n = {
            size: 0,
            document: $17ad0981586945ee$var$MutableDocument.newInvalidDocument(t)
        };
        return $17ad0981586945ee$var$__PRIVATE_remoteDocumentsStore(e).Z({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($17ad0981586945ee$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.er(t, r),
                size: $17ad0981586945ee$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap();
        return this.nr(e, t, (e, t)=>{
            const r = this.er(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ rr(e, t) {
        let n = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap(), r = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
        return this.nr(e, t, (e, t)=>{
            const i = this.er(e, t);
            n = n.insert(e, i), r = r.insert(e, $17ad0981586945ee$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                ir: r
            }));
    }
    nr(e, t, n) {
        if (t.isEmpty()) return $17ad0981586945ee$var$PersistencePromise.resolve();
        let r = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($17ad0981586945ee$var$__PRIVATE_dbKey(r.first()), $17ad0981586945ee$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let o = s.getNext();
        return $17ad0981586945ee$var$__PRIVATE_remoteDocumentsStore(e).Z({
            index: "documentKeyIndex",
            range: i
        }, (e, t, r)=>{
            const i = $17ad0981586945ee$export$afc2e57c475b7810.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $17ad0981586945ee$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            o ? r.W($17ad0981586945ee$var$__PRIVATE_dbKey(o)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        const i = t.path, s = [
            i.popLast().toArray(),
            i.lastSegment(),
            $17ad0981586945ee$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], o = [
            i.popLast().toArray(),
            i.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $17ad0981586945ee$var$__PRIVATE_remoteDocumentsStore(e).G(IDBKeyRange.bound(s, o, !0)).next((e)=>{
            let n = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.er($17ad0981586945ee$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($17ad0981586945ee$var$__PRIVATE_queryMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap();
        const s = $17ad0981586945ee$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $17ad0981586945ee$var$__PRIVATE_dbCollectionGroupKey(t, $17ad0981586945ee$var$IndexOffset.max());
        return $17ad0981586945ee$var$__PRIVATE_remoteDocumentsStore(e).Z({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(s, o, !0)
        }, (e, t, n)=>{
            const s = this.er($17ad0981586945ee$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $17ad0981586945ee$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $17ad0981586945ee$var$__PRIVATE_documentGlobalStore(e).get("remoteDocumentGlobalKey").next((e)=>($17ad0981586945ee$var$__PRIVATE_hardAssert(!!e), e));
    }
    Xn(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_documentGlobalStore(e).put("remoteDocumentGlobalKey", t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ er(e, t) {
        if (t) {
            const e = $17ad0981586945ee$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($17ad0981586945ee$var$SnapshotVersion.min()))) return e;
        }
        return $17ad0981586945ee$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $17ad0981586945ee$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $17ad0981586945ee$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $17ad0981586945ee$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.sr = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this._r = new $17ad0981586945ee$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $17ad0981586945ee$var$SortedSet((e, t)=>$17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const o = this._r.get(i);
            if (t.push(this.sr.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                const _ = $17ad0981586945ee$var$__PRIVATE_toDbRemoteDocument(this.sr.serializer, s);
                r = r.add(i.path.popLast());
                const a = $17ad0981586945ee$var$__PRIVATE_dbDocumentSize(_);
                n += a - o.size, t.push(this.sr.addEntry(e, i, _));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $17ad0981586945ee$var$__PRIVATE_toDbRemoteDocument(this.sr.serializer, s.convertToNoDocument($17ad0981586945ee$var$SnapshotVersion.min()));
                t.push(this.sr.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.sr.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.sr.updateMetadata(e, n)), $17ad0981586945ee$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.sr.tr(e, t).next((e)=>(this._r.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.sr.rr(e, t).next(({ documents: e, ir: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this._r.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $17ad0981586945ee$var$__PRIVATE_documentGlobalStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $17ad0981586945ee$var$__PRIVATE_remoteDocumentsStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $17ad0981586945ee$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $17ad0981586945ee$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $17ad0981586945ee$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $17ad0981586945ee$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $17ad0981586945ee$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $17ad0981586945ee$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $17ad0981586945ee$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $17ad0981586945ee$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $17ad0981586945ee$var$FieldMask.empty(), $17ad0981586945ee$export$d9bcbd5e1ff81430.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $17ad0981586945ee$var$__PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $17ad0981586945ee$var$__PRIVATE_documentKeySet()) {
        const r = $17ad0981586945ee$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $17ad0981586945ee$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $17ad0981586945ee$var$__PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap();
        const s = $17ad0981586945ee$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
            return $17ad0981586945ee$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const o = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === o || o.mutation instanceof $17ad0981586945ee$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $17ad0981586945ee$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $17ad0981586945ee$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $17ad0981586945ee$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>{
                var n;
                return o.set(e, new $17ad0981586945ee$var$OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $17ad0981586945ee$var$SortedMap((e, t)=>e - t), i = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let o = n.get(e) || $17ad0981586945ee$var$FieldMask.empty();
                o = i.applyToLocalView(s, o), n.set(e, o);
                const _ = (r.get(i.batchId) || $17ad0981586945ee$var$__PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, _);
            });
        }).next(()=>{
            const s = [], o = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const r = o.getNext(), _ = r.key, a = r.value, u = $17ad0981586945ee$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $17ad0981586945ee$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, _, u));
            }
            return $17ad0981586945ee$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     */ getDocumentsMatchingQuery(e, t, n) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
            return $17ad0981586945ee$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
        }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $17ad0981586945ee$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n) : this.getDocumentsMatchingCollectionQuery(e, t, n);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $17ad0981586945ee$var$PersistencePromise.resolve($17ad0981586945ee$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = -1, _ = i;
            return s.next((t)=>$17ad0981586945ee$var$PersistencePromise.forEach(t, (t, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $17ad0981586945ee$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        _ = _.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, _, t, $17ad0981586945ee$var$__PRIVATE_documentKeySet())).next((e)=>({
                        batchId: o,
                        changes: $17ad0981586945ee$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $17ad0981586945ee$export$afc2e57c475b7810(t)).next((e)=>{
            let t = $17ad0981586945ee$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n) {
        const r = t.collectionGroup;
        let i = $17ad0981586945ee$var$documentMap();
        return this.indexManager.getCollectionParents(e, r).next((s)=>$17ad0981586945ee$var$PersistencePromise.forEach(s, (s)=>{
                const o = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $17ad0981586945ee$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, s.child(r));
                return this.getDocumentsMatchingCollectionQuery(e, o, n).next((e)=>{
                    e.forEach((e, t)=>{
                        i = i.insert(e, t);
                    });
                });
            }).next(()=>i));
    }
    getDocumentsMatchingCollectionQuery(e, t, n) {
        // Query the remote documents and overlay mutations.
        let r;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((i)=>(r = i, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, r))).next((e)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            r.forEach((t, n)=>{
                const r = n.getKey();
                null === e.get(r) && (e = e.insert(r, $17ad0981586945ee$var$MutableDocument.newInvalidDocument(r)));
            });
            // Apply the overlays and match against the query.
            let n = $17ad0981586945ee$var$documentMap();
            return e.forEach((e, i)=>{
                const s = r.get(e);
                void 0 !== s && $17ad0981586945ee$var$__PRIVATE_mutationApplyToLocalView(s.mutation, i, $17ad0981586945ee$var$FieldMask.empty(), $17ad0981586945ee$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $17ad0981586945ee$var$__PRIVATE_queryMatches(t, i) && (n = n.insert(e, i));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.ar = new Map, this.ur = new Map;
    }
    getBundleMetadata(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.ar.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.ar.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $17ad0981586945ee$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.ur.get(t));
    }
    saveNamedQuery(e, t) {
        return this.ur.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $17ad0981586945ee$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: $17ad0981586945ee$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator), this.cr = new Map;
    }
    getOverlay(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_newOverlayMap();
        return $17ad0981586945ee$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.ht(e, t, r);
        }), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.cr.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.cr.delete(n)), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $17ad0981586945ee$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
        for(; o.hasNext();){
            const e = o.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $17ad0981586945ee$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $17ad0981586945ee$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $17ad0981586945ee$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const o = $17ad0981586945ee$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
        for(; _.hasNext();){
            if (_.getNext().value.forEach((e, t)=>o.set(e, t)), o.size() >= r) break;
        }
        return $17ad0981586945ee$var$PersistencePromise.resolve(o);
    }
    ht(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.cr.get(r.largestBatchId).delete(n.key);
            this.cr.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $17ad0981586945ee$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.cr.get(t);
        void 0 === i && (i = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), this.cr.set(t, i)), this.cr.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $17ad0981586945ee$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.lr = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_DocReference.hr), // A set of outstanding references to a document sorted by target id.
        this.Pr = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_DocReference.Ir);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.lr.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $17ad0981586945ee$var$__PRIVATE_DocReference(e, t);
        this.lr = this.lr.add(n), this.Pr = this.Pr.add(n);
    }
    /** Add references to the given document keys for the given ID. */ Tr(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.Er(new $17ad0981586945ee$var$__PRIVATE_DocReference(e, t));
    }
    dr(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ Ar(e) {
        const t = new $17ad0981586945ee$export$afc2e57c475b7810(new $17ad0981586945ee$var$ResourcePath([])), n = new $17ad0981586945ee$var$__PRIVATE_DocReference(t, e), r = new $17ad0981586945ee$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.Pr.forEachInRange([
            n,
            r
        ], (e)=>{
            this.Er(e), i.push(e.key);
        }), i;
    }
    Rr() {
        this.lr.forEach((e)=>this.Er(e));
    }
    Er(e) {
        this.lr = this.lr.delete(e), this.Pr = this.Pr.delete(e);
    }
    Vr(e) {
        const t = new $17ad0981586945ee$export$afc2e57c475b7810(new $17ad0981586945ee$var$ResourcePath([])), n = new $17ad0981586945ee$var$__PRIVATE_DocReference(t, e), r = new $17ad0981586945ee$var$__PRIVATE_DocReference(t, e + 1);
        let i = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        return this.Pr.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $17ad0981586945ee$var$__PRIVATE_DocReference(e, 0), n = this.lr.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $17ad0981586945ee$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.mr = t;
    }
    /** Compare by key then by ID */ static hr(e, t) {
        return $17ad0981586945ee$export$afc2e57c475b7810.comparator(e.key, t.key) || $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.mr, t.mr);
    }
    /** Compare by ID then by key */ static Ir(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(e.mr, t.mr) || $17ad0981586945ee$export$afc2e57c475b7810.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.gr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.pr = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_DocReference.hr);
    }
    checkEmpty(e) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.gr;
        this.gr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $17ad0981586945ee$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.pr = this.pr.add(new $17ad0981586945ee$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $17ad0981586945ee$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.yr(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.wr(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $17ad0981586945ee$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? -1 : this.gr - 1);
    }
    getAllMutationBatches(e) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $17ad0981586945ee$var$__PRIVATE_DocReference(t, 0), r = new $17ad0981586945ee$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.pr.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.yr(e.mr);
            i.push(t);
        }), $17ad0981586945ee$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $17ad0981586945ee$var$__PRIVATE_DocReference(e, 0), r = new $17ad0981586945ee$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.pr.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.mr);
            });
        }), $17ad0981586945ee$var$PersistencePromise.resolve(this.Sr(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $17ad0981586945ee$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const s = new $17ad0981586945ee$var$__PRIVATE_DocReference(new $17ad0981586945ee$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_primitiveComparator);
        return this.pr.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (o = o.add(e.mr)), !0);
        }, s), $17ad0981586945ee$var$PersistencePromise.resolve(this.Sr(o));
    }
    Sr(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.yr(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $17ad0981586945ee$var$__PRIVATE_hardAssert(0 === this.br(t.batchId, "removed")), this.mutationQueue.shift();
        let n = this.pr;
        return $17ad0981586945ee$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $17ad0981586945ee$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.pr = n;
        });
    }
    Cn(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $17ad0981586945ee$var$__PRIVATE_DocReference(t, 0), r = this.pr.firstAfterOrEqual(n);
        return $17ad0981586945ee$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ br(e, t) {
        return this.wr(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ wr(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ yr(e) {
        const t = this.wr(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.Dr = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.Dr(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $17ad0981586945ee$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $17ad0981586945ee$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $17ad0981586945ee$var$MutableDocument.newInvalidDocument(e));
        }), $17ad0981586945ee$var$PersistencePromise.resolve(n);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        let i = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const s = t.path, o = new $17ad0981586945ee$export$afc2e57c475b7810(s.child("")), _ = this.docs.getIteratorFrom(o);
        for(; _.hasNext();){
            const { key: e, value: { document: o } } = _.getNext();
            if (!s.isPrefixOf(e.path)) break;
            e.path.length > s.length + 1 || $17ad0981586945ee$var$__PRIVATE_indexOffsetComparator($17ad0981586945ee$var$__PRIVATE_newIndexOffsetFromDocument(o), n) <= 0 || (r.has(o.key) || $17ad0981586945ee$var$__PRIVATE_queryMatches(t, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $17ad0981586945ee$var$PersistencePromise.resolve(i);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $17ad0981586945ee$var$fail();
    }
    vr(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $17ad0981586945ee$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $17ad0981586945ee$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.sr = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.sr.addEntry(e, r)) : this.sr.removeEntry(n);
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.sr.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.sr.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.Cr = new $17ad0981586945ee$var$ObjectMap((e)=>$17ad0981586945ee$var$__PRIVATE_canonifyTarget(e), $17ad0981586945ee$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $17ad0981586945ee$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Fr = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.Mr = new $17ad0981586945ee$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.Or = $17ad0981586945ee$var$__PRIVATE_TargetIdGenerator.xn();
    }
    forEachTarget(e, t) {
        return this.Cr.forEach((e, n)=>t(n)), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.Fr);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.Or.next(), $17ad0981586945ee$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.Fr && (this.Fr = t), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    Ln(e) {
        this.Cr.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.Or = new $17ad0981586945ee$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.Fr && (this.Fr = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.Ln(t), this.targetCount += 1, $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.Ln(t), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.Cr.delete(t.target), this.Mr.Ar(t.targetId), this.targetCount -= 1, $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.Cr.forEach((s, o)=>{
            o.sequenceNumber <= t && null === n.get(o.targetId) && (this.Cr.delete(s), i.push(this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.Cr.get(t) || null;
        return $17ad0981586945ee$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.Mr.Tr(t, n), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.Mr.dr(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $17ad0981586945ee$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.Mr.Ar(t), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.Mr.Vr(t);
        return $17ad0981586945ee$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.resolve(this.Mr.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.Nr = {}, this.overlays = {}, this.Br = new $17ad0981586945ee$var$__PRIVATE_ListenSequence(0), this.Lr = !1, this.Lr = !0, this.referenceDelegate = e(this), this.kr = new $17ad0981586945ee$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $17ad0981586945ee$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $17ad0981586945ee$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.qr(e)), this.serializer = new $17ad0981586945ee$var$__PRIVATE_LocalSerializer(t), this.Qr = new $17ad0981586945ee$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.Lr = !1, Promise.resolve();
    }
    get started() {
        return this.Lr;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $17ad0981586945ee$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.Nr[e.toKey()];
        return n || (n = new $17ad0981586945ee$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.Nr[e.toKey()] = n), n;
    }
    getTargetCache() {
        return this.kr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.Qr;
    }
    runTransaction(e, t, n) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new $17ad0981586945ee$var$__PRIVATE_MemoryTransaction(this.Br.next());
        return this.referenceDelegate.Kr(), n(r).next((e)=>this.referenceDelegate.$r(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    Ur(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.or(Object.values(this.Nr).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $17ad0981586945ee$var$__PRIVATE_MemoryTransaction extends $17ad0981586945ee$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $17ad0981586945ee$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.Wr = new $17ad0981586945ee$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Gr = null;
    }
    static zr(e) {
        return new $17ad0981586945ee$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get jr() {
        if (this.Gr) return this.Gr;
        throw $17ad0981586945ee$var$fail();
    }
    addReference(e, t, n) {
        return this.Wr.addReference(n, t), this.jr.delete(n.toString()), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Wr.removeReference(n, t), this.jr.add(n.toString()), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.jr.add(t.toString()), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.Wr.Ar(t.targetId).forEach((e)=>this.jr.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.jr.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    Kr() {
        this.Gr = new Set;
    }
    $r(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $17ad0981586945ee$var$PersistencePromise.forEach(this.jr, (n)=>{
            const r = $17ad0981586945ee$export$afc2e57c475b7810.fromPath(n);
            return this.Hr(e, r).next((e)=>{
                e || t.removeEntry(r, $17ad0981586945ee$var$SnapshotVersion.min());
            });
        }).next(()=>(this.Gr = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.Hr(e, t).next((e)=>{
            e ? this.jr.delete(t.toString()) : this.jr.add(t.toString());
        });
    }
    qr(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    Hr(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.or([
            ()=>$17ad0981586945ee$var$PersistencePromise.resolve(this.Wr.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.Ur(e, t)
        ]);
    }
}
class $17ad0981586945ee$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.Jr = new $17ad0981586945ee$var$ObjectMap((e)=>$17ad0981586945ee$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $17ad0981586945ee$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static zr(e, t) {
        return new $17ad0981586945ee$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Kr() {}
    $r(e) {
        return $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    zn(e) {
        const t = this.Jn(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    Jn(e) {
        let t = 0;
        return this.jn(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    jn(e, t) {
        return $17ad0981586945ee$var$PersistencePromise.forEach(this.Jr, (n, r)=>this.Zn(e, n, r).next((e)=>e ? $17ad0981586945ee$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.vr(e, (r)=>this.Zn(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $17ad0981586945ee$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.Jr.set(t, e.currentSequenceNumber), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.Jr.set(n, e.currentSequenceNumber), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.Jr.set(n, e.currentSequenceNumber), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.Jr.set(t, e.currentSequenceNumber), $17ad0981586945ee$var$PersistencePromise.resolve();
    }
    qr(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $17ad0981586945ee$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    Zn(e, t, n) {
        return $17ad0981586945ee$var$PersistencePromise.or([
            ()=>this.persistence.Ur(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.Jr.get(t);
                return $17ad0981586945ee$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $17ad0981586945ee$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ B(e, t, n, r) {
        const i = new $17ad0981586945ee$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore("owner");
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            e.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", $17ad0981586945ee$var$x, {
                unique: !0
            }), e.createObjectStore("documentMutations");
        }(e), $17ad0981586945ee$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore("remoteDocuments");
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $17ad0981586945ee$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore("targetDocuments"), e.deleteObjectStore("targets"), e.deleteObjectStore("targetGlobal");
        }(e), $17ad0981586945ee$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store("targetGlobal"), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $17ad0981586945ee$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put("targetGlobalKey", n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                return t.store("mutations").G().next((n)=>{
                    e.deleteObjectStore("mutations");
                    e.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $17ad0981586945ee$var$x, {
                        unique: !0
                    });
                    const r = t.store("mutations"), i = n.map((e)=>r.put(e));
                    return $17ad0981586945ee$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.Yr(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore("remoteDocumentGlobal");
            })(e), this.Zr(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.Xr(i))), n < 8 && r >= 8 && (s = s.next(()=>this.ei(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.ti(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore("documentOverlays", {
                    keyPath: $17ad0981586945ee$var$z
                });
                t.createIndex("collectionPathOverlayIndex", $17ad0981586945ee$var$j, {
                    unique: !1
                }), t.createIndex("collectionGroupOverlayIndex", $17ad0981586945ee$var$H, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore("remoteDocumentsV14", {
                    keyPath: $17ad0981586945ee$var$N
                });
                t.createIndex("documentKeyIndex", $17ad0981586945ee$var$B), t.createIndex("collectionGroupIndex", $17ad0981586945ee$var$L);
            })(e)).next(()=>this.ni(e, i)).next(()=>e.deleteObjectStore("remoteDocuments"))), n < 14 && r >= 14 && (s = s.next(()=>this.ri(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                e.createObjectStore("indexConfiguration", {
                    keyPath: "indexId",
                    autoIncrement: !0
                }).createIndex("collectionGroupIndex", "collectionGroup", {
                    unique: !1
                });
                e.createObjectStore("indexState", {
                    keyPath: $17ad0981586945ee$var$$
                }).createIndex("sequenceNumberIndex", $17ad0981586945ee$var$U, {
                    unique: !1
                });
                e.createObjectStore("indexEntries", {
                    keyPath: $17ad0981586945ee$var$W
                }).createIndex("documentKeyIndex", $17ad0981586945ee$var$G, {
                    unique: !1
                });
            })(e))), s;
    }
    Zr(e) {
        let t = 0;
        return e.store("remoteDocuments").Z((e, n)=>{
            t += $17ad0981586945ee$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        });
    }
    Yr(e) {
        const t = e.store("mutationQueues"), n = e.store("mutations");
        return t.G().next((t)=>$17ad0981586945ee$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    -1
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.G("userMutationsIndex", r).next((n)=>$17ad0981586945ee$var$PersistencePromise.forEach(n, (n)=>{
                        $17ad0981586945ee$var$__PRIVATE_hardAssert(n.userId === t.userId);
                        const r = $17ad0981586945ee$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $17ad0981586945ee$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ Xr(e) {
        const t = e.store("targetDocuments"), n = e.store("remoteDocuments");
        return e.store("targetGlobal").get("targetGlobalKey").next((e)=>{
            const r = [];
            return n.Z((n, i)=>{
                const s = new $17ad0981586945ee$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(o).next((n)=>n ? $17ad0981586945ee$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$17ad0981586945ee$var$PersistencePromise.waitFor(r));
        });
    }
    ei(e, t) {
        // Create the index.
        e.createObjectStore("collectionParents", {
            keyPath: $17ad0981586945ee$var$K
        });
        const n = t.store("collectionParents"), r = new $17ad0981586945ee$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $17ad0981586945ee$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store("remoteDocuments").Z({
            Y: !0
        }, (e, t)=>{
            const n = new $17ad0981586945ee$var$ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store("documentMutations").Z({
                Y: !0
            }, ([e, t, n], r)=>{
                const i = $17ad0981586945ee$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    ti(e) {
        const t = e.store("targets");
        return t.Z((e, n)=>{
            const r = $17ad0981586945ee$var$__PRIVATE_fromDbTarget(n), i = $17ad0981586945ee$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    ni(e, t) {
        const n = t.store("remoteDocuments"), r = [];
        return n.Z((e, n)=>{
            const i = t.store("remoteDocumentsV14"), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $17ad0981586945ee$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $17ad0981586945ee$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $17ad0981586945ee$var$fail();
            })(n).path.toArray(), o = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(o));
        }).next(()=>$17ad0981586945ee$var$PersistencePromise.waitFor(r));
    }
    ri(e, t) {
        const n = t.store("mutations"), r = $17ad0981586945ee$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $17ad0981586945ee$var$__PRIVATE_MemoryPersistence($17ad0981586945ee$var$__PRIVATE_MemoryEagerDelegate.zr, this.serializer.ct);
        return n.G().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                var t;
                let r = null !== (t = n.get(e.userId)) && void 0 !== t ? t : $17ad0981586945ee$var$__PRIVATE_documentKeySet();
                $17ad0981586945ee$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>r = r.add(e)), n.set(e.userId, r);
            }), $17ad0981586945ee$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $17ad0981586945ee$var$User(n), o = $17ad0981586945ee$var$__PRIVATE_IndexedDbDocumentOverlayCache.lt(this.serializer, s), _ = i.getIndexManager(s), a = $17ad0981586945ee$var$__PRIVATE_IndexedDbMutationQueue.lt(s, this.serializer, _, i.referenceDelegate);
                return new $17ad0981586945ee$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $17ad0981586945ee$var$__PRIVATE_IndexedDbTransaction(t, $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae), e).next();
            });
        });
    }
}
function $17ad0981586945ee$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore("targetDocuments", {
        keyPath: $17ad0981586945ee$var$q
    }).createIndex("documentTargetsIndex", $17ad0981586945ee$var$Q, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $17ad0981586945ee$var$k, {
        unique: !0
    }), e.createObjectStore("targetGlobal");
}
const $17ad0981586945ee$var$Ae = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 15){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.ii = i, this.window = s, this.document = o, this.si = a, this.oi = u, this._i = c, this.Br = null, this.Lr = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.ai = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.ui = null, /** The client metadata refresh task. */ this.ci = null, /** The last time we garbage collected the client metadata object store. */ this.li = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.hi = (e)=>Promise.resolve(), !$17ad0981586945ee$var$__PRIVATE_IndexedDbPersistence.v()) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $17ad0981586945ee$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Pi = t + "main", this.serializer = new $17ad0981586945ee$var$__PRIVATE_LocalSerializer(_), this.Ii = new $17ad0981586945ee$var$__PRIVATE_SimpleDb(this.Pi, this._i, new $17ad0981586945ee$var$__PRIVATE_SchemaConverter(this.serializer)), this.kr = new $17ad0981586945ee$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $17ad0981586945ee$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Qr = new $17ad0981586945ee$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Ti = this.window.localStorage : (this.Ti = null, !1 === u && $17ad0981586945ee$var$__PRIVATE_logError("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.Ei().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, $17ad0981586945ee$var$Ae);
            return this.di(), this.Ai(), this.Ri(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.kr.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.Br = new $17ad0981586945ee$var$__PRIVATE_ListenSequence(e, this.si);
        }).then(()=>{
            this.Lr = !0;
        }).catch((e)=>(this.Ii && this.Ii.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Vi(e) {
        return this.hi = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.Ii.k(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.ii.enqueueAndForget(async ()=>{
            this.started && await this.Ei();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ Ei() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$17ad0981586945ee$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.mi(e).next((e)=>{
                    e || (this.isPrimary = !1, this.ii.enqueueRetryable(()=>this.hi(!1)));
                });
            }).next(()=>this.fi(e)).next((t)=>this.isPrimary && !t ? this.gi(e).next(()=>!1) : !!t && this.pi(e).next(()=>!0))).catch((e)=>{
            if ($17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $17ad0981586945ee$var$__PRIVATE_logDebug("IndexedDbPersistence", "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $17ad0981586945ee$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.ii.enqueueRetryable(()=>this.hi(e)), this.isPrimary = e;
        });
    }
    mi(e) {
        return $17ad0981586945ee$var$__PRIVATE_primaryClientStore(e).get("owner").next((e)=>$17ad0981586945ee$var$PersistencePromise.resolve(this.yi(e)));
    }
    wi(e) {
        return $17ad0981586945ee$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async Si() {
        if (this.isPrimary && !this.bi(this.li, 18e5)) {
            this.li = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $17ad0981586945ee$var$__PRIVATE_getStore(e, "clientMetadata");
                return t.G().next((e)=>{
                    const n = this.Di(e, 18e5), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $17ad0981586945ee$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.Ti) for (const t of e)this.Ti.removeItem(this.vi(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ Ri() {
        this.ci = this.ii.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.Ei().then(()=>this.Si()).then(()=>this.Ri()));
    }
    /** Checks whether `client` is the local client. */ yi(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ fi(e) {
        if (this.oi) return $17ad0981586945ee$var$PersistencePromise.resolve(!0);
        return $17ad0981586945ee$var$__PRIVATE_primaryClientStore(e).get("owner").next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.bi(t.leaseTimestampMs, 5e3) && !this.Ci(t.ownerId)) {
                if (this.yi(t) && this.networkEnabled) return !0;
                if (!this.yi(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, $17ad0981586945ee$var$Ae);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $17ad0981586945ee$var$__PRIVATE_clientMetadataStore(e).G().next((e)=>void 0 === this.Di(e, 5e3).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $17ad0981586945ee$var$__PRIVATE_logDebug("IndexedDbPersistence", `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.Lr = !1, this.Fi(), this.ci && (this.ci.cancel(), this.ci = null), this.Mi(), this.xi(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.Ii.runTransaction("shutdown", "readwrite", [
            "owner",
            "clientMetadata"
        ], (e)=>{
            const t = new $17ad0981586945ee$var$__PRIVATE_IndexedDbTransaction(e, $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae);
            return this.gi(t).next(()=>this.wi(t));
        }), this.Ii.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Oi();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ Di(e, t) {
        return e.filter((e)=>this.bi(e.updateTimeMs, t) && !this.Ci(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ni() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$17ad0981586945ee$var$__PRIVATE_clientMetadataStore(e).G().next((e)=>this.Di(e, 18e5).map((e)=>e.clientId)));
    }
    get started() {
        return this.Lr;
    }
    getMutationQueue(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_IndexedDbMutationQueue.lt(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.kr;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $17ad0981586945ee$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.ct.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $17ad0981586945ee$var$__PRIVATE_IndexedDbDocumentOverlayCache.lt(this.serializer, e);
    }
    getBundleCache() {
        return this.Qr;
    }
    runTransaction(e, t, n) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("IndexedDbPersistence", "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 15 === e ? $17ad0981586945ee$var$ee : 14 === e ? $17ad0981586945ee$var$X : 13 === e ? $17ad0981586945ee$var$Z : 12 === e ? $17ad0981586945ee$var$Y : 11 === e ? $17ad0981586945ee$var$J : void $17ad0981586945ee$var$fail();
        }(this._i);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.Ii.runTransaction(e, r, i, (r)=>(s = new $17ad0981586945ee$var$__PRIVATE_IndexedDbTransaction(r, this.Br ? this.Br.next() : $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae), "readwrite-primary" === t ? this.mi(s).next((e)=>!!e || this.fi(s)).next((t)=>{
                if (!t) throw $17ad0981586945ee$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.ii.enqueueRetryable(()=>this.hi(!1)), new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, $17ad0981586945ee$var$F);
                return n(s);
            }).next((e)=>this.pi(s).next(()=>e)) : this.Bi(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Bi(e) {
        return $17ad0981586945ee$var$__PRIVATE_primaryClientStore(e).get("owner").next((e)=>{
            if (null !== e && this.bi(e.leaseTimestampMs, 5e3) && !this.Ci(e.ownerId) && !this.yi(e) && !(this.oi || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, $17ad0981586945ee$var$Ae);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ pi(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $17ad0981586945ee$var$__PRIVATE_primaryClientStore(e).put("owner", t);
    }
    static v() {
        return $17ad0981586945ee$var$__PRIVATE_SimpleDb.v();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ gi(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_primaryClientStore(e);
        return t.get("owner").next((e)=>this.yi(e) ? ($17ad0981586945ee$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing primary lease."), t.delete("owner")) : $17ad0981586945ee$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ bi(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($17ad0981586945ee$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    di() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.ui = ()=>{
            this.ii.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.Ei()));
        }, this.document.addEventListener("visibilitychange", this.ui), this.inForeground = "visible" === this.document.visibilityState);
    }
    Mi() {
        this.ui && (this.document.removeEventListener("visibilitychange", this.ui), this.ui = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ Ai() {
        var e;
        "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.ai = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.Fi();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $2xDiJ.isSafari)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.ii.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.ii.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.ai));
    }
    xi() {
        this.ai && (this.window.removeEventListener("pagehide", this.ai), this.ai = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ Ci(e) {
        var t;
        try {
            const n = null !== (null === (t = this.Ti) || void 0 === t ? void 0 : t.getItem(this.vi(e)));
            return $17ad0981586945ee$var$__PRIVATE_logDebug("IndexedDbPersistence", `Client '${e}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $17ad0981586945ee$var$__PRIVATE_logError("IndexedDbPersistence", "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ Fi() {
        if (this.Ti) try {
            this.Ti.setItem(this.vi(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $17ad0981586945ee$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ Oi() {
        if (this.Ti) try {
            this.Ti.removeItem(this.vi(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    vi(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $17ad0981586945ee$var$__PRIVATE_primaryClientStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $17ad0981586945ee$var$__PRIVATE_clientMetadataStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_getStore(e, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $17ad0981586945ee$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $17ad0981586945ee$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.Li = n, this.ki = r;
    }
    static qi(e, t) {
        let n = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), r = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $17ad0981586945ee$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $17ad0981586945ee$var$__PRIVATE_QueryEngine {
    constructor(){
        this.Qi = !1;
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.Ki = e, this.indexManager = t, this.Qi = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        return this.$i(e, t).next((i)=>i || this.Ui(e, t, r, n)).next((n)=>n || this.Wi(e, t));
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ $i(e, t) {
        if ($17ad0981586945ee$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $17ad0981586945ee$var$PersistencePromise.resolve(null);
        let n = $17ad0981586945ee$var$__PRIVATE_queryToTarget(t);
        return this.indexManager.getIndexType(e, n).next((r)=>0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (t = $17ad0981586945ee$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $17ad0981586945ee$var$__PRIVATE_queryToTarget(t)), this.indexManager.getDocumentsMatchingTarget(e, n).next((r)=>{
                const i = $17ad0981586945ee$var$__PRIVATE_documentKeySet(...r);
                return this.Ki.getDocuments(e, i).next((r)=>this.indexManager.getMinOffset(e, n).next((n)=>{
                        const s = this.Gi(t, r);
                        return this.zi(t, s, i, n.readTime) ? this.$i(e, $17ad0981586945ee$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : this.ji(e, s, t, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ Ui(e, t, n, r) {
        return $17ad0981586945ee$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($17ad0981586945ee$var$SnapshotVersion.min()) ? this.Wi(e, t) : this.Ki.getDocuments(e, n).next((i)=>{
            const s = this.Gi(t, i);
            return this.zi(t, s, n, r) ? this.Wi(e, t) : ($17ad0981586945ee$var$__PRIVATE_getLogLevel() <= (0, $kZfxc.LogLevel).DEBUG && $17ad0981586945ee$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $17ad0981586945ee$var$__PRIVATE_stringifyQuery(t)), this.ji(e, s, t, $17ad0981586945ee$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1)));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ Gi(e, t) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $17ad0981586945ee$var$SortedSet($17ad0981586945ee$var$__PRIVATE_newQueryComparator(e));
        return t.forEach((t, r)=>{
            $17ad0981586945ee$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ zi(e, t, n, r) {
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    Wi(e, t) {
        return $17ad0981586945ee$var$__PRIVATE_getLogLevel() <= (0, $kZfxc.LogLevel).DEBUG && $17ad0981586945ee$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $17ad0981586945ee$var$__PRIVATE_stringifyQuery(t)), this.Ki.getDocumentsMatchingQuery(e, t, $17ad0981586945ee$var$IndexOffset.min());
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ ji(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Ki.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $17ad0981586945ee$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.Hi = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.Ji = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Yi = new $17ad0981586945ee$var$ObjectMap((e)=>$17ad0981586945ee$var$__PRIVATE_canonifyTarget(e), $17ad0981586945ee$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Zi = new Map, this.Xi = e.getRemoteDocumentCache(), this.kr = e.getTargetCache(), this.Qr = e.getBundleCache(), this.es(n);
    }
    es(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $17ad0981586945ee$var$LocalDocumentsView(this.Xi, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Xi.setIndexManager(this.indexManager), this.Hi.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.Ji));
    }
}
function $17ad0981586945ee$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $17ad0981586945ee$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $17ad0981586945ee$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.es(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let o = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)o = o.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, o).next((e)=>({
                    ts: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $17ad0981586945ee$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.Xi.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let o = $17ad0981586945ee$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                o = o.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $17ad0981586945ee$var$__PRIVATE_hardAssert(null !== s), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $17ad0981586945ee$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.kr.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $17ad0981586945ee$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.Ji;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.Xi.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.Ji;
        const o = [];
        t.targetChanges.forEach((s, _)=>{
            const a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.kr.removeMatchingKeys(e, s.removedDocuments, _).next(()=>n.kr.addMatchingKeys(e, s.addedDocuments, _)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($17ad0981586945ee$export$67460cdabfa21253.EMPTY_BYTE_STRING, $17ad0981586945ee$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($17ad0981586945ee$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(a, u, s) && o.push(n.kr.updateTargetData(e, u));
        });
        let _ = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap(), a = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($17ad0981586945ee$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            _ = e.ns, a = e.rs;
        })), !r.isEqual($17ad0981586945ee$var$SnapshotVersion.min())) {
            const t = n.kr.getLastRemoteSnapshotVersion(e).next((t)=>n.kr.setTargetsMetadata(e, e.currentSequenceNumber, r));
            o.push(t);
        }
        return $17ad0981586945ee$var$PersistencePromise.waitFor(o).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, _, a)).next(()=>_);
    }).then((e)=>(n.Ji = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $17ad0981586945ee$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), i = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($17ad0981586945ee$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $17ad0981586945ee$var$__PRIVATE_logDebug("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            ns: r,
            rs: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $17ad0981586945ee$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $17ad0981586945ee$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.kr.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $17ad0981586945ee$var$PersistencePromise.resolve(r)) : n.kr.allocateTargetId(e).next((i)=>(r = new $17ad0981586945ee$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.kr.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.Ji.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.Ji = n.Ji.insert(e.targetId, e), n.Yi.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $17ad0981586945ee$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e), i = r.Ji.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $17ad0981586945ee$var$__PRIVATE_logDebug("LocalStore", `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.Ji = r.Ji.remove(t), r.Yi.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $17ad0981586945ee$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    let i = $17ad0981586945ee$var$SnapshotVersion.min(), s = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readonly", (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e), i = r.Yi.get(n);
            return void 0 !== i ? $17ad0981586945ee$var$PersistencePromise.resolve(r.Ji.get(i)) : r.kr.getTargetData(t, n);
        })(r, e, $17ad0981586945ee$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.kr.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.Hi.getDocumentsMatchingQuery(e, t, n ? i : $17ad0981586945ee$var$SnapshotVersion.min(), n ? s : $17ad0981586945ee$var$__PRIVATE_documentKeySet())).next((e)=>($17ad0981586945ee$var$__PRIVATE_setMaxReadTime(r, $17ad0981586945ee$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                ss: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $17ad0981586945ee$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = $17ad0981586945ee$var$__PRIVATE_debugCast(n.kr), i = n.Ji.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.ut(e, t).next((e)=>e ? e.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $17ad0981586945ee$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = n.Zi.get(t) || $17ad0981586945ee$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.Xi.getAllFromCollectionGroup(e, t, $17ad0981586945ee$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($17ad0981586945ee$var$__PRIVATE_setMaxReadTime(n, t, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $17ad0981586945ee$var$__PRIVATE_setMaxReadTime(e, t, n) {
    let r = e.Zi.get(t) || $17ad0981586945ee$var$SnapshotVersion.min();
    n.forEach((e, t)=>{
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.Zi.set(t, r);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $17ad0981586945ee$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    let s = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), o = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.os(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t._s(e);
        r.setReadTime(t.us(e.metadata.readTime)), o = o.insert(n, r);
    }
    const _ = i.Xi.newChangeBuffer({
        trackRemovals: !0
    }), a = await $17ad0981586945ee$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $17ad0981586945ee$var$__PRIVATE_queryToTarget($17ad0981586945ee$var$__PRIVATE_newQueryForPath($17ad0981586945ee$var$ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$17ad0981586945ee$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next((t)=>(_.apply(e), t)).next((t)=>i.kr.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.kr.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.ns, t.rs)).next(()=>t.ns)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $17ad0981586945ee$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $17ad0981586945ee$var$__PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $17ad0981586945ee$var$__PRIVATE_localStoreAllocateTarget(e, $17ad0981586945ee$var$__PRIVATE_queryToTarget($17ad0981586945ee$var$__PRIVATE_fromBundledQuery(t.bundledQuery))), i = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $17ad0981586945ee$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.Qr.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const o = r.withResumeToken($17ad0981586945ee$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
        return i.Ji = i.Ji.insert(o.targetId, o), i.kr.updateTargetData(e, o).next(()=>i.kr.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.kr.addMatchingKeys(e, n, r.targetId)).next(()=>i.Qr.saveNamedQuery(e, t));
    });
}
/** Assembles the key for a client state in WebStorage */ function $17ad0981586945ee$var$createWebStorageClientStateKey(e, t) {
    return `firestore_clients_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $17ad0981586945ee$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `firestore_mutations_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $17ad0981586945ee$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `firestore_targets_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $17ad0981586945ee$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static cs(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $17ad0981586945ee$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new $17ad0981586945ee$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($17ad0981586945ee$var$__PRIVATE_logError("SharedClientState", `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    ls() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $17ad0981586945ee$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static cs(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $17ad0981586945ee$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $17ad0981586945ee$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($17ad0981586945ee$var$__PRIVATE_logError("SharedClientState", `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    ls() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $17ad0981586945ee$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static cs(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $17ad0981586945ee$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $17ad0981586945ee$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $17ad0981586945ee$var$__PRIVATE_RemoteClientState(e, i) : ($17ad0981586945ee$var$__PRIVATE_logError("SharedClientState", `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $17ad0981586945ee$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static cs(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $17ad0981586945ee$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($17ad0981586945ee$var$__PRIVATE_logError("SharedClientState", `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $17ad0981586945ee$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $17ad0981586945ee$var$__PRIVATE_targetIdSet();
    }
    hs(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    Ps(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ ls() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $17ad0981586945ee$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.ii = t, this.persistenceKey = n, this.Is = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.Ts = this.Es.bind(this), this.ds = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.As = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Rs = $17ad0981586945ee$var$createWebStorageClientStateKey(this.persistenceKey, this.Is), this.Vs = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.ds = this.ds.insert(this.Is, new $17ad0981586945ee$var$__PRIVATE_LocalClientState), this.fs = new RegExp(`^firestore_clients_${s}_([^_]*)$`), this.gs = new RegExp(`^firestore_mutations_${s}_(\\d+)(?:_(.*))?$`), this.ps = new RegExp(`^firestore_targets_${s}_(\\d+)$`), this.ys = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.ws = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.Ts);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static v(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.Ni();
        for (const t of e){
            if (t === this.Is) continue;
            const e = this.getItem($17ad0981586945ee$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $17ad0981586945ee$var$__PRIVATE_RemoteClientState.cs(t, e);
                n && (this.ds = this.ds.insert(n.clientId, n));
            }
        }
        this.Ss();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.ys);
        if (t) {
            const e = this.bs(t);
            e && this.Ds(e);
        }
        for (const e of this.As)this.Es(e);
        this.As = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.Vs, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.vs(this.ds);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.ds.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.Cs(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.Cs(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.Fs(e);
    }
    addLocalQueryTarget(e) {
        let t = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const n = this.storage.getItem($17ad0981586945ee$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (n) {
                const r = $17ad0981586945ee$var$__PRIVATE_QueryTargetMetadata.cs(e, n);
                r && (t = r.state);
            }
        }
        return this.Ms.hs(e), this.Ss(), t;
    }
    removeLocalQueryTarget(e) {
        this.Ms.Ps(e), this.Ss();
    }
    isLocalQueryTarget(e) {
        return this.Ms.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($17ad0981586945ee$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.xs(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.Fs(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.Os(e);
    }
    notifyBundleLoaded(e) {
        this.Ns(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.Ts), this.removeItem(this.Rs), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $17ad0981586945ee$var$__PRIVATE_logDebug("SharedClientState", "READ", e, t), t;
    }
    setItem(e, t) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("SharedClientState", "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("SharedClientState", "REMOVE", e), this.storage.removeItem(e);
    }
    Es(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($17ad0981586945ee$var$__PRIVATE_logDebug("SharedClientState", "EVENT", t.key, t.newValue), t.key === this.Rs) return void $17ad0981586945ee$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.ii.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.fs.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.Bs(t.key);
                                return this.Ls(e, null);
                            }
                            {
                                const e = this.ks(t.key, t.newValue);
                                if (e) return this.Ls(e.clientId, e);
                            }
                        } else if (this.gs.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.qs(t.key, t.newValue);
                                if (e) return this.Qs(e);
                            }
                        } else if (this.ps.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Ks(t.key, t.newValue);
                                if (e) return this.$s(e);
                            }
                        } else if (t.key === this.ys) {
                            if (null !== t.newValue) {
                                const e = this.bs(t.newValue);
                                if (e) return this.Ds(e);
                            }
                        } else if (t.key === this.Vs) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $17ad0981586945ee$var$__PRIVATE_hardAssert("number" == typeof n), t = n;
                                } catch (e) {
                                    $17ad0981586945ee$var$__PRIVATE_logError("SharedClientState", "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae && this.sequenceNumberHandler(e);
                        } else if (t.key === this.ws) {
                            const e = this.Us(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.Ws(e)));
                        }
                    }
                } else this.As.push(t);
            });
        }
    }
    get Ms() {
        return this.ds.get(this.Is);
    }
    Ss() {
        this.setItem(this.Rs, this.Ms.ls());
    }
    Cs(e, t, n) {
        const r = new $17ad0981586945ee$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $17ad0981586945ee$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.ls());
    }
    Fs(e) {
        const t = $17ad0981586945ee$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    Os(e) {
        const t = {
            clientId: this.Is,
            onlineState: e
        };
        this.storage.setItem(this.ys, JSON.stringify(t));
    }
    xs(e, t, n) {
        const r = $17ad0981586945ee$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $17ad0981586945ee$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.ls());
    }
    Ns(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.ws, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Bs(e) {
        const t = this.fs.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ ks(e, t) {
        const n = this.Bs(e);
        return $17ad0981586945ee$var$__PRIVATE_RemoteClientState.cs(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ qs(e, t) {
        const n = this.gs.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $17ad0981586945ee$var$__PRIVATE_MutationMetadata.cs(new $17ad0981586945ee$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ks(e, t) {
        const n = this.ps.exec(e), r = Number(n[1]);
        return $17ad0981586945ee$var$__PRIVATE_QueryTargetMetadata.cs(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ bs(e) {
        return $17ad0981586945ee$var$__PRIVATE_SharedOnlineState.cs(e);
    }
    Us(e) {
        return JSON.parse(e);
    }
    async Qs(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.Gs(e.batchId, e.state, e.error);
        $17ad0981586945ee$var$__PRIVATE_logDebug("SharedClientState", `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    $s(e) {
        return this.syncEngine.zs(e.targetId, e.state, e.error);
    }
    Ls(e, t) {
        const n = t ? this.ds.insert(e, t) : this.ds.remove(e), r = this.vs(this.ds), i = this.vs(n), s = [], o = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || o.push(e);
        }), this.syncEngine.js(s, o).then(()=>{
            this.ds = n;
        });
    }
    Ds(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.ds.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    vs(e) {
        let t = $17ad0981586945ee$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $17ad0981586945ee$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.Hs = new $17ad0981586945ee$var$__PRIVATE_LocalClientState, this.Js = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e) {
        return this.Hs.hs(e), this.Js[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.Js[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.Hs.Ps(e);
    }
    isLocalQueryTarget(e) {
        return this.Hs.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.Js[e];
    }
    getAllActiveQueryTargets() {
        return this.Hs.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.Hs.activeTargetIds.has(e);
    }
    start() {
        return this.Hs = new $17ad0981586945ee$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_NoopConnectivityMonitor {
    Ys(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ class $17ad0981586945ee$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.Zs = ()=>this.Xs(), this.eo = ()=>this.no(), this.ro = [], this.io();
    }
    Ys(e) {
        this.ro.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.Zs), window.removeEventListener("offline", this.eo);
    }
    io() {
        window.addEventListener("online", this.Zs), window.addEventListener("offline", this.eo);
    }
    Xs() {
        $17ad0981586945ee$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const e of this.ro)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    no() {
        $17ad0981586945ee$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const e of this.ro)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static v() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $17ad0981586945ee$var$Re = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $17ad0981586945ee$var$__PRIVATE_generateUniqueDebugId() {
    return null === $17ad0981586945ee$var$Re ? $17ad0981586945ee$var$Re = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $17ad0981586945ee$var$Re++, "0x" + $17ad0981586945ee$var$Re.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$Ve = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $17ad0981586945ee$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.so = e.so, this.oo = e.oo;
    }
    _o(e) {
        this.ao = e;
    }
    uo(e) {
        this.co = e;
    }
    onMessage(e) {
        this.lo = e;
    }
    close() {
        this.oo();
    }
    send(e) {
        this.so(e);
    }
    ho() {
        this.ao();
    }
    Po(e) {
        this.co(e);
    }
    Io(e) {
        this.lo(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$me = "WebChannelConnection";
class $17ad0981586945ee$var$__PRIVATE_WebChannelConnection extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class __PRIVATE_RestConnection {
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.To = t + "://" + e.host, this.Eo = `projects/${n}/databases/${r}`, this.Ao = "(default)" === this.databaseId.database ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    get Ro() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    Vo(e, t, n, r, i) {
        const s = $17ad0981586945ee$var$__PRIVATE_generateUniqueDebugId(), o = this.mo(e, t);
        $17ad0981586945ee$var$__PRIVATE_logDebug("RestConnection", `Sending RPC '${e}' ${s}:`, o, n);
        const _ = {
            "google-cloud-resource-prefix": this.Eo,
            "x-goog-request-params": this.Ao
        };
        return this.fo(_, r, i), this.po(e, o, _, n).then((t)=>($17ad0981586945ee$var$__PRIVATE_logDebug("RestConnection", `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $17ad0981586945ee$export$86cd73f49cc6e0bb("RestConnection", `RPC '${e}' ${s} failed with error: `, t, "url: ", o, "request:", n), t;
        });
    }
    yo(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Vo(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ fo(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $17ad0981586945ee$var$b;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    mo(e, t) {
        const n = $17ad0981586945ee$var$Ve[e];
        return `${this.To}/v1/${t}:${n}`;
    }
} {
    constructor(e){
        super(e), this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    po(e, t, n, r) {
        const i = $17ad0981586945ee$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((s, o)=>{
            const _ = new (0, $aSES4.XhrIo);
            _.setWithCredentials(!0), _.listenOnce((0, $aSES4.EventType).COMPLETE, ()=>{
                try {
                    switch(_.getLastErrorCode()){
                        case (0, $aSES4.ErrorCode).NO_ERROR:
                            const t = _.getResponseJson();
                            $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `XHR for RPC '${e}' ${i} received:`, JSON.stringify(t)), s(t);
                            break;
                        case (0, $aSES4.ErrorCode).TIMEOUT:
                            $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' ${i} timed out`), o(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $aSES4.ErrorCode).HTTP_ERROR:
                            const n = _.getStatus();
                            if ($17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' ${i} failed with status:`, n, "response text:", _.getResponseText()), n > 0) {
                                let e = _.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = null == e ? void 0 : e.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($17ad0981586945ee$var$v).indexOf(t) >= 0 ? t : $17ad0981586945ee$var$v.UNKNOWN;
                                    }(t.status);
                                    o(new $17ad0981586945ee$export$8fada0bf726bf278(e, t.message));
                                } else o(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNKNOWN, "Server responded with status " + _.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $17ad0981586945ee$var$fail();
                    }
                } finally{
                    $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' ${i} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' ${i} sending request:`, r), _.send(t, "POST", a, n, 15);
        });
    }
    wo(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.To,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = (0, $aSES4.createWebChannelTransport)(), o = (0, $aSES4.getStatEventTarget)(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, a = this.longPollingOptions.timeoutSeconds;
        void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.xmlHttpFactory = new (0, $aSES4.FetchXmlHttpFactory)({})), this.fo(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const u = i.join("");
        $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `Creating RPC '${e}' stream ${r}: ${u}`, _);
        const c = s.createWebChannel(u, _);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, h = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const P = new $17ad0981586945ee$var$__PRIVATE_StreamBridge({
            so: (t)=>{
                h ? $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (l || ($17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `Opening RPC '${e}' stream ${r} transport.`), c.open(), l = !0), $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' stream ${r} sending:`, t), c.send(t));
            },
            oo: ()=>c.close()
        }), __PRIVATE_unguardedEventListen = (e, t, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            e.listen(t, (e)=>{
                try {
                    n(e);
                } catch (e) {
                    setTimeout(()=>{
                        throw e;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return __PRIVATE_unguardedEventListen(c, (0, $aSES4.WebChannel).EventType.OPEN, ()=>{
            h || $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' stream ${r} transport opened.`);
        }), __PRIVATE_unguardedEventListen(c, (0, $aSES4.WebChannel).EventType.CLOSE, ()=>{
            h || (h = !0, $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' stream ${r} transport closed`), P.Po());
        }), __PRIVATE_unguardedEventListen(c, (0, $aSES4.WebChannel).EventType.ERROR, (t)=>{
            h || (h = !0, $17ad0981586945ee$export$86cd73f49cc6e0bb($17ad0981586945ee$var$me, `RPC '${e}' stream ${r} transport errored:`, t), P.Po(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(c, (0, $aSES4.WebChannel).EventType.MESSAGE, (t)=>{
            var n;
            if (!h) {
                const i = t.data[0];
                $17ad0981586945ee$var$__PRIVATE_hardAssert(!!i);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const s = i, o = s.error || (null === (n = s[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' stream ${r} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $17ad0981586945ee$var$ue[e];
                        if (void 0 !== t) return $17ad0981586945ee$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = o.message;
                    void 0 === n && (n = $17ad0981586945ee$var$v.INTERNAL, i = "Unknown error status: " + t + " with message " + o.message), // Mark closed so no further events are propagated
                    h = !0, P.Po(new $17ad0981586945ee$export$8fada0bf726bf278(n, i)), c.close();
                } else $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' stream ${r} received:`, i), P.Io(i);
            }
        }), __PRIVATE_unguardedEventListen(o, (0, $aSES4.Event).STAT_EVENT, (t)=>{
            t.stat === (0, $aSES4.Stat).PROXY ? $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' stream ${r} detected buffering proxy`) : t.stat === (0, $aSES4.Stat).NOPROXY && $17ad0981586945ee$var$__PRIVATE_logDebug($17ad0981586945ee$var$me, `RPC '${e}' stream ${r} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            P.ho();
        }, 0), P;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $17ad0981586945ee$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $17ad0981586945ee$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $17ad0981586945ee$var$__PRIVATE_newSerializer(e) {
    return new $17ad0981586945ee$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $17ad0981586945ee$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.ii = e, this.timerId = t, this.So = n, this.bo = r, this.Do = i, this.vo = 0, this.Co = null, /** The last backoff attempt, as epoch milliseconds. */ this.Fo = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.vo = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ Mo() {
        this.vo = this.Do;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ xo(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.vo + this.Oo()), n = Math.max(0, Date.now() - this.Fo), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $17ad0981586945ee$var$__PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.vo} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.Co = this.ii.enqueueAfterDelay(this.timerId, r, ()=>(this.Fo = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.vo *= this.bo, this.vo < this.So && (this.vo = this.So), this.vo > this.Do && (this.vo = this.Do);
    }
    No() {
        null !== this.Co && (this.Co.skipDelay(), this.Co = null);
    }
    cancel() {
        null !== this.Co && (this.Co.cancel(), this.Co = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ Oo() {
        return (Math.random() - .5) * this.vo;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $17ad0981586945ee$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, o, _){
        this.ii = e, this.Bo = n, this.Lo = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.ko = 0, this.qo = null, this.Qo = null, this.stream = null, this.Ko = new $17ad0981586945ee$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ $o() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Uo();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Uo() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.Wo();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.$o() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ Go() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.Ko.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ zo() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Uo() && null === this.qo && (this.qo = this.ii.enqueueAfterDelay(this.Bo, 6e4, ()=>this.jo()));
    }
    /** Sends a message to the underlying stream. */ Ho(e) {
        this.Jo(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async jo() {
        if (this.Uo()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ Jo() {
        this.qo && (this.qo.cancel(), this.qo = null);
    }
    /** Cancels the health check delayed operation. */ Yo() {
        this.Qo && (this.Qo.cancel(), this.Qo = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.Jo(), this.Yo(), this.Ko.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.ko++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.Ko.reset() : t && t.code === $17ad0981586945ee$var$v.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($17ad0981586945ee$var$__PRIVATE_logError(t.toString()), $17ad0981586945ee$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.Ko.Mo()) : t && t.code === $17ad0981586945ee$var$v.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.Zo(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.uo(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ Zo() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.Xo(this.ko), t = this.ko;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.ko === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.e_(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.t_(e);
            });
        });
    }
    e_(e, t) {
        const n = this.Xo(this.ko);
        this.stream = this.n_(e, t), this.stream._o(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.Qo = this.ii.enqueueAfterDelay(this.Lo, 1e4, ()=>(this.Uo() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener._o()));
        }), this.stream.uo((e)=>{
            n(()=>this.t_(e));
        }), this.stream.onMessage((e)=>{
            n(()=>this.onMessage(e));
        });
    }
    Wo() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.Ko.xo(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    t_(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $17ad0981586945ee$var$__PRIVATE_logDebug("PersistentStream", `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ Xo(e) {
        return (t)=>{
            this.ii.enqueueAndForget(()=>this.ko === e ? t() : ($17ad0981586945ee$var$__PRIVATE_logDebug("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $17ad0981586945ee$var$__PRIVATE_PersistentListenStream extends $17ad0981586945ee$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    n_(e, t) {
        return this.connection.wo("Listen", e, t);
    }
    onMessage(e) {
        // A successful response means the stream is healthy
        this.Ko.reset();
        const t = $17ad0981586945ee$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $17ad0981586945ee$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $17ad0981586945ee$var$SnapshotVersion.min() : t.readTime ? $17ad0981586945ee$var$__PRIVATE_fromVersion(t.readTime) : $17ad0981586945ee$var$SnapshotVersion.min();
        }(e);
        return this.listener.r_(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ i_(e) {
        const t = {};
        t.database = $17ad0981586945ee$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $17ad0981586945ee$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $17ad0981586945ee$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $17ad0981586945ee$var$__PRIVATE_toQueryTarget(e, r)
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $17ad0981586945ee$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $17ad0981586945ee$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($17ad0981586945ee$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $17ad0981586945ee$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $17ad0981586945ee$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $17ad0981586945ee$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.Ho(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ s_(e) {
        const t = {};
        t.database = $17ad0981586945ee$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.Ho(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $17ad0981586945ee$var$__PRIVATE_PersistentWriteStream extends $17ad0981586945ee$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i, this.o_ = !1;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get __() {
        return this.o_;
    }
    // Override of PersistentStream.start
    start() {
        this.o_ = !1, this.lastStreamToken = void 0, super.start();
    }
    Zo() {
        this.o_ && this.a_([]);
    }
    n_(e, t) {
        return this.connection.wo("Write", e, t);
    }
    onMessage(e) {
        if (// Always capture the last stream token.
        $17ad0981586945ee$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, this.o_) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.Ko.reset();
            const t = $17ad0981586945ee$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $17ad0981586945ee$var$__PRIVATE_fromVersion(e.commitTime);
            return this.listener.u_(n, t);
        }
        // The first response is always the handshake response
        return $17ad0981586945ee$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length), this.o_ = !0, this.listener.c_();
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ l_() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $17ad0981586945ee$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.Ho(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ a_(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$17ad0981586945ee$var$toMutation(this.serializer, e))
        };
        this.Ho(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $17ad0981586945ee$var$__PRIVATE_DatastoreImpl extends class Datastore {
} {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.h_ = !1;
    }
    P_() {
        if (this.h_) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Vo(e, t, n) {
        return this.P_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([r, i])=>this.connection.Vo(e, t, n, r, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $17ad0981586945ee$var$v.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ yo(e, t, n, r) {
        return this.P_(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.yo(e, t, n, i, s, r)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $17ad0981586945ee$var$v.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.h_ = !0;
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
async function $17ad0981586945ee$var$__PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
    var r;
    const i = $17ad0981586945ee$var$__PRIVATE_debugCast(e), { request: s, I_: o } = function __PRIVATE_toRunAggregationQueryRequest(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_toQueryTarget(e, t), i = {}, s = [];
        let o = 0;
        return n.forEach((e)=>{
            // Map all client-side aliases to a unique short-form
            // alias. This avoids issues with client-side aliases that
            // exceed the 1500-byte string size limit.
            const t = "aggregate_" + o++;
            i[t] = e.alias, "count" === e.Ee ? s.push({
                alias: t,
                count: {}
            }) : "avg" === e.Ee ? s.push({
                alias: t,
                avg: {
                    field: $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e.fieldPath)
                }
            }) : "sum" === e.Ee && s.push({
                alias: t,
                sum: {
                    field: $17ad0981586945ee$var$__PRIVATE_toFieldPathReference(e.fieldPath)
                }
            });
        }), {
            request: {
                structuredAggregationQuery: {
                    aggregations: s,
                    structuredQuery: r.structuredQuery
                },
                parent: r.parent
            },
            I_: i
        };
    }(i.serializer, $17ad0981586945ee$var$__PRIVATE_queryToTarget(t), n), _ = s.parent;
    i.connection.Ro || delete s.parent;
    const a = (await i.yo("RunAggregationQuery", _, s, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
    // Omit RunAggregationQueryResponse that only contain readTimes.
    $17ad0981586945ee$var$__PRIVATE_hardAssert(1 === a.length);
    // Remap the short-form aliases that were sent to the server
    // to the client-side aliases. Users will access the results
    // using the client-side alias.
    const u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
    return Object.keys(u).reduce((e, t)=>(e[o[t]] = u[t], e), {});
}
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $17ad0981586945ee$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.T_ = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.E_ = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.d_ = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ A_() {
        0 === this.T_ && (this.R_("Unknown" /* OnlineState.Unknown */ ), this.E_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.E_ = null, this.V_("Backend didn't respond within 10 seconds."), this.R_("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ m_(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.R_("Unknown" /* OnlineState.Unknown */ ) : (this.T_++, this.T_ >= 1 && (this.f_(), this.V_(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.R_("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.f_(), this.T_ = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.d_ = !1), this.R_(e);
    }
    R_(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    V_(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.d_ ? ($17ad0981586945ee$var$__PRIVATE_logError(t), this.d_ = !1) : $17ad0981586945ee$var$__PRIVATE_logDebug("OnlineStateTracker", t);
    }
    f_() {
        null !== this.E_ && (this.E_.cancel(), this.E_ = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.g_ = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.p_ = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.y_ = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.w_ = [], this.S_ = i, this.S_.Ys((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $17ad0981586945ee$var$__PRIVATE_canUseNetwork(this) && ($17ad0981586945ee$var$__PRIVATE_logDebug("RemoteStore", "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
                    t.y_.add(4 /* OfflineCause.ConnectivityChange */ ), await $17ad0981586945ee$var$__PRIVATE_disableNetworkInternal(t), t.b_.set("Unknown" /* OnlineState.Unknown */ ), t.y_.delete(4 /* OfflineCause.ConnectivityChange */ ), await $17ad0981586945ee$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.b_ = new $17ad0981586945ee$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $17ad0981586945ee$var$__PRIVATE_enableNetworkInternal(e) {
    if ($17ad0981586945ee$var$__PRIVATE_canUseNetwork(e)) for (const t of e.w_)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $17ad0981586945ee$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.w_)await t(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $17ad0981586945ee$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    n.p_.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.p_.set(t.targetId, t), $17ad0981586945ee$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $17ad0981586945ee$var$__PRIVATE_startWatchStream(n) : $17ad0981586945ee$var$__PRIVATE_ensureWatchStream(n).Uo() && $17ad0981586945ee$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $17ad0981586945ee$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = $17ad0981586945ee$var$__PRIVATE_ensureWatchStream(n);
    n.p_.delete(t), r.Uo() && $17ad0981586945ee$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.p_.size && (r.Uo() ? r.zo() : $17ad0981586945ee$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.b_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $17ad0981586945ee$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.D_.Be(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($17ad0981586945ee$var$SnapshotVersion.min()) > 0) {
        const n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $17ad0981586945ee$var$__PRIVATE_ensureWatchStream(e).i_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $17ad0981586945ee$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.D_.Be(t), $17ad0981586945ee$var$__PRIVATE_ensureWatchStream(e).s_(t);
}
function $17ad0981586945ee$var$__PRIVATE_startWatchStream(e) {
    e.D_ = new $17ad0981586945ee$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>e.remoteSyncer.getRemoteKeysForTarget(t),
        ut: (t)=>e.p_.get(t) || null,
        rt: ()=>e.datastore.serializer.databaseId
    }), $17ad0981586945ee$var$__PRIVATE_ensureWatchStream(e).start(), e.b_.A_();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $17ad0981586945ee$var$__PRIVATE_shouldStartWatchStream(e) {
    return $17ad0981586945ee$var$__PRIVATE_canUseNetwork(e) && !$17ad0981586945ee$var$__PRIVATE_ensureWatchStream(e).$o() && e.p_.size > 0;
}
function $17ad0981586945ee$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $17ad0981586945ee$var$__PRIVATE_debugCast(e).y_.size;
}
function $17ad0981586945ee$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.D_ = void 0;
}
async function $17ad0981586945ee$var$__PRIVATE_onWatchStreamOpen(e) {
    e.p_.forEach((t, n)=>{
        $17ad0981586945ee$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $17ad0981586945ee$var$__PRIVATE_onWatchStreamClose(e, t) {
    $17ad0981586945ee$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $17ad0981586945ee$var$__PRIVATE_shouldStartWatchStream(e) ? (e.b_.m_(t), $17ad0981586945ee$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.b_.set("Unknown" /* OnlineState.Unknown */ );
}
async function $17ad0981586945ee$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.b_.set("Online" /* OnlineState.Online */ ), t instanceof $17ad0981586945ee$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await /** Handles an error on a target */ async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds)// A watched target might have been removed already.
            e.p_.has(r) && (await e.remoteSyncer.rejectListen(r, n), e.p_.delete(r), e.D_.removeTarget(r));
        }(e, t);
    } catch (n) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $17ad0981586945ee$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $17ad0981586945ee$var$__PRIVATE_DocumentWatchChange ? e.D_.We(t) : t instanceof $17ad0981586945ee$var$__PRIVATE_ExistenceFilterChange ? e.D_.Ze(t) : e.D_.je(t), !n.isEqual($17ad0981586945ee$var$SnapshotVersion.min())) try {
        const t = await $17ad0981586945ee$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.D_.st(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.p_.get(r);
                    // A watched target might have been removed already.
                    i && e.p_.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((t, n)=>{
                const r = e.p_.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.p_.set(t, r.withResumeToken($17ad0981586945ee$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $17ad0981586945ee$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $17ad0981586945ee$var$TargetData(r.target, t, n, r.sequenceNumber);
                $17ad0981586945ee$var$__PRIVATE_sendWatchRequest(e, i);
            }), e.remoteSyncer.applyRemoteEvent(n);
        }(e, n);
    } catch (t) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("RemoteStore", "Failed to raise snapshot:", t), await $17ad0981586945ee$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $17ad0981586945ee$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.y_.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $17ad0981586945ee$var$__PRIVATE_disableNetworkInternal(e), e.b_.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$17ad0981586945ee$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $17ad0981586945ee$var$__PRIVATE_logDebug("RemoteStore", "Retrying IndexedDB access"), await n(), e.y_.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $17ad0981586945ee$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $17ad0981586945ee$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$17ad0981586945ee$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $17ad0981586945ee$var$__PRIVATE_fillWritePipeline(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e), n = $17ad0981586945ee$var$__PRIVATE_ensureWriteStream(t);
    let r = t.g_.length > 0 ? t.g_[t.g_.length - 1].batchId : -1;
    for(; $17ad0981586945ee$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $17ad0981586945ee$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.g_.length && n.zo();
            break;
        }
        r = e.batchId, $17ad0981586945ee$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $17ad0981586945ee$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $17ad0981586945ee$var$__PRIVATE_shouldStartWriteStream(t) && $17ad0981586945ee$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $17ad0981586945ee$var$__PRIVATE_canAddToWritePipeline(e) {
    return $17ad0981586945ee$var$__PRIVATE_canUseNetwork(e) && e.g_.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $17ad0981586945ee$var$__PRIVATE_addToWritePipeline(e, t) {
    e.g_.push(t);
    const n = $17ad0981586945ee$var$__PRIVATE_ensureWriteStream(e);
    n.Uo() && n.__ && n.a_(t.mutations);
}
function $17ad0981586945ee$var$__PRIVATE_shouldStartWriteStream(e) {
    return $17ad0981586945ee$var$__PRIVATE_canUseNetwork(e) && !$17ad0981586945ee$var$__PRIVATE_ensureWriteStream(e).$o() && e.g_.length > 0;
}
function $17ad0981586945ee$var$__PRIVATE_startWriteStream(e) {
    $17ad0981586945ee$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $17ad0981586945ee$var$__PRIVATE_onWriteStreamOpen(e) {
    $17ad0981586945ee$var$__PRIVATE_ensureWriteStream(e).l_();
}
async function $17ad0981586945ee$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.g_)t.a_(n.mutations);
}
async function $17ad0981586945ee$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.g_.shift(), i = $17ad0981586945ee$var$MutationBatchResult.from(r, t, n);
    await $17ad0981586945ee$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $17ad0981586945ee$var$__PRIVATE_fillWritePipeline(e);
}
async function $17ad0981586945ee$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $17ad0981586945ee$var$__PRIVATE_ensureWriteStream(e).__ && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $17ad0981586945ee$var$__PRIVATE_isPermanentError(e) && e !== $17ad0981586945ee$var$v.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.g_.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $17ad0981586945ee$var$__PRIVATE_ensureWriteStream(e).Go(), await $17ad0981586945ee$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $17ad0981586945ee$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $17ad0981586945ee$var$__PRIVATE_shouldStartWriteStream(e) && $17ad0981586945ee$var$__PRIVATE_startWriteStream(e);
}
async function $17ad0981586945ee$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $17ad0981586945ee$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore received new credentials");
    const r = $17ad0981586945ee$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.y_.add(3 /* OfflineCause.CredentialChange */ ), await $17ad0981586945ee$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.b_.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.y_.delete(3 /* OfflineCause.CredentialChange */ ), await $17ad0981586945ee$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $17ad0981586945ee$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    t ? (n.y_.delete(2 /* OfflineCause.IsSecondary */ ), await $17ad0981586945ee$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.y_.add(2 /* OfflineCause.IsSecondary */ ), await $17ad0981586945ee$var$__PRIVATE_disableNetworkInternal(n), n.b_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $17ad0981586945ee$var$__PRIVATE_ensureWatchStream(e) {
    return e.v_ || // Create stream (but note that it is not started yet).
    (e.v_ = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
        return r.P_(), new $17ad0981586945ee$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        _o: $17ad0981586945ee$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        uo: $17ad0981586945ee$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        r_: $17ad0981586945ee$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.w_.push(async (t)=>{
        t ? (e.v_.Go(), $17ad0981586945ee$var$__PRIVATE_shouldStartWatchStream(e) ? $17ad0981586945ee$var$__PRIVATE_startWatchStream(e) : e.b_.set("Unknown" /* OnlineState.Unknown */ )) : (await e.v_.stop(), $17ad0981586945ee$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e.v_;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $17ad0981586945ee$var$__PRIVATE_ensureWriteStream(e) {
    return e.C_ || // Create stream (but note that it is not started yet).
    (e.C_ = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
        return r.P_(), new $17ad0981586945ee$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        _o: $17ad0981586945ee$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        uo: $17ad0981586945ee$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        c_: $17ad0981586945ee$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        u_: $17ad0981586945ee$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.w_.push(async (t)=>{
        t ? (e.C_.Go(), // This will start the write stream if necessary.
        await $17ad0981586945ee$var$__PRIVATE_fillWritePipeline(e)) : (await e.C_.stop(), e.g_.length > 0 && ($17ad0981586945ee$var$__PRIVATE_logDebug("RemoteStore", `Stopping write stream with ${e.g_.length} pending writes`), e.g_ = []));
    })), e.C_;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $17ad0981586945ee$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $17ad0981586945ee$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, o = new $17ad0981586945ee$var$DelayedOperation(e, t, s, r, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $17ad0981586945ee$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($17ad0981586945ee$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $17ad0981586945ee$var$DocumentSet {
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $17ad0981586945ee$export$afc2e57c475b7810.comparator(t.key, n.key) : (e, t)=>$17ad0981586945ee$export$afc2e57c475b7810.comparator(e.key, t.key), this.keyedMap = $17ad0981586945ee$var$documentMap(), this.sortedSet = new $17ad0981586945ee$var$SortedMap(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $17ad0981586945ee$var$DocumentSet(e.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $17ad0981586945ee$var$DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $17ad0981586945ee$var$DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $17ad0981586945ee$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.F_ = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.F_.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.F_ = this.F_.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.F_ = this.F_.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.F_ = this.F_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.F_ = this.F_.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.F_ = this.F_.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.F_ = this.F_.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.F_ = this.F_.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $17ad0981586945ee$var$fail() : this.F_ = this.F_.insert(t, e);
    }
    M_() {
        const e = [];
        return this.F_.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $17ad0981586945ee$var$ViewSnapshot {
    constructor(e, t, n, r, i, s, o, _, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $17ad0981586945ee$var$ViewSnapshot(e, t, $17ad0981586945ee$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $17ad0981586945ee$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $17ad0981586945ee$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.x_ = void 0, this.listeners = [];
    }
}
class $17ad0981586945ee$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = new $17ad0981586945ee$var$ObjectMap((e)=>$17ad0981586945ee$var$__PRIVATE_canonifyQuery(e), $17ad0981586945ee$var$__PRIVATE_queryEquals), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.O_ = new Set;
    }
}
async function $17ad0981586945ee$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = t.query;
    let i = !1, s = n.queries.get(r);
    if (s || (i = !0, s = new $17ad0981586945ee$var$__PRIVATE_QueryListenersInfo), i) try {
        s.x_ = await n.onListen(r);
    } catch (e) {
        const n = $17ad0981586945ee$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$17ad0981586945ee$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(r, s), s.listeners.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.N_(n.onlineState), s.x_) t.B_(s.x_) && $17ad0981586945ee$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $17ad0981586945ee$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = t.query;
    let i = !1;
    const s = n.queries.get(r);
    if (s) {
        const e = s.listeners.indexOf(t);
        e >= 0 && (s.listeners.splice(e, 1), i = 0 === s.listeners.length);
    }
    if (i) return n.queries.delete(r), n.onUnlisten(r);
}
function $17ad0981586945ee$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.listeners)t.B_(e) && (r = !0);
            i.x_ = e;
        }
    }
    r && $17ad0981586945ee$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $17ad0981586945ee$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.listeners)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
// Call all global snapshot listeners that have been set.
function $17ad0981586945ee$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.O_.forEach((e)=>{
        e.next();
    });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $17ad0981586945ee$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.L_ = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.k_ = !1, this.q_ = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ B_(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $17ad0981586945ee$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.k_ ? this.Q_(e) && (this.L_.next(e), t = !0) : this.K_(e, this.onlineState) && (this.U_(e), t = !0), this.q_ = e, t;
    }
    onError(e) {
        this.L_.error(e);
    }
    /** Returns whether a snapshot was raised. */ N_(e) {
        this.onlineState = e;
        let t = !1;
        return this.q_ && !this.k_ && this.K_(this.q_, e) && (this.U_(this.q_), t = !0), t;
    }
    K_(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.W_ || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Q_(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.q_ && this.q_.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    U_(e) {
        e = $17ad0981586945ee$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.k_ = !0, this.L_.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $17ad0981586945ee$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.G_ = e, this.byteLength = t;
    }
    z_() {
        return "metadata" in this.G_;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $17ad0981586945ee$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    os(e) {
        return $17ad0981586945ee$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ _s(e) {
        return e.metadata.exists ? $17ad0981586945ee$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $17ad0981586945ee$var$MutableDocument.newNoDocument(this.os(e.metadata.name), this.us(e.metadata.readTime));
    }
    us(e) {
        return $17ad0981586945ee$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $17ad0981586945ee$var$__PRIVATE_BundleLoader {
    constructor(e, t, n){
        this.j_ = e, this.localStore = t, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $17ad0981586945ee$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ H_(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.G_.namedQuery) this.queries.push(e.G_.namedQuery);
        else if (e.G_.documentMetadata) {
            this.documents.push({
                metadata: e.G_.documentMetadata
            }), e.G_.documentMetadata.exists || ++t;
            const n = $17ad0981586945ee$var$ResourcePath.fromString(e.G_.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.G_.document && (this.documents[this.documents.length - 1].document = e.G_.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
    }
    J_(e) {
        const t = new Map, n = new $17ad0981586945ee$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.os(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $17ad0981586945ee$var$__PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const e = await $17ad0981586945ee$var$__PRIVATE_localStoreApplyBundledDocuments(this.localStore, new $17ad0981586945ee$var$__PRIVATE_BundleConverterImpl(this.serializer), this.documents, this.j_.id), t = this.J_(this.documents);
        for (const e of this.queries)await $17ad0981586945ee$var$__PRIVATE_localStoreSaveNamedQuery(this.localStore, e, t.get(e.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Y_: this.collectionGroups,
            Z_: e
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $17ad0981586945ee$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $17ad0981586945ee$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $17ad0981586945ee$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.X_ = t, this.ea = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.ta = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), this.na = $17ad0981586945ee$var$__PRIVATE_newQueryComparator(e), this.ra = new $17ad0981586945ee$var$DocumentSet(this.na);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get ia() {
        return this.X_;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ sa(e, t) {
        const n = t ? t.oa : new $17ad0981586945ee$var$__PRIVATE_DocumentChangeSet, r = t ? t.ra : this.ra;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $17ad0981586945ee$var$__PRIVATE_queryMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let P = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), P = !0) : this._a(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), P = !0, (_ && this.na(c, _) > 0 || a && this.na(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), P = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        }), null !== this.query.limit) for(; s.size > this.query.limit;){
            const e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
            s = s.delete(e.key), i = i.delete(e.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: e
            });
        }
        return {
            ra: s,
            oa: n,
            zi: o,
            mutatedKeys: i
        };
    }
    _a(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param updateLimboDocuments - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n) {
        const r = this.ra;
        this.ra = e.ra, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const i = e.oa.M_();
        i.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $17ad0981586945ee$var$fail();
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.na(e.doc, t.doc)), this.aa(n);
        const s = t ? this.ua() : [], o = 0 === this.ta.size && this.current ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , _ = o !== this.ea;
        if (this.ea = o, 0 !== i.length || _) return {
            snapshot: new $17ad0981586945ee$var$ViewSnapshot(this.query, e.ra, r, i, e.mutatedKeys, 0 /* SyncState.Local */  === o, _, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            ca: s
        };
        // no changes
        return {
            ca: s
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ N_(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            ra: this.ra,
            oa: new $17ad0981586945ee$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            zi: !1
        }, /* updateLimboDocuments= */ !1)) : {
            ca: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ la(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.X_.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.ra.has(e) && !this.ra.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ aa(e) {
        e && (e.addedDocuments.forEach((e)=>this.X_ = this.X_.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.X_ = this.X_.delete(e)), this.current = e.current);
    }
    ua() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.ta;
        this.ta = $17ad0981586945ee$var$__PRIVATE_documentKeySet(), this.ra.forEach((e)=>{
            this.la(e.key) && (this.ta = this.ta.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.ta.has(e) || t.push(new $17ad0981586945ee$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.ta.forEach((n)=>{
            e.has(n) || t.push(new $17ad0981586945ee$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    ha(e) {
        this.X_ = e.ss, this.ta = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        const t = this.sa(e.documents);
        return this.applyChanges(t, /*updateLimboDocuments=*/ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Pa() {
        return $17ad0981586945ee$var$ViewSnapshot.fromInitialDocuments(this.query, this.ra, this.mutatedKeys, 0 /* SyncState.Local */  === this.ea, this.hasCachedResults);
    }
}
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $17ad0981586945ee$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $17ad0981586945ee$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Ia = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $17ad0981586945ee$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Ta = {}, this.Ea = new $17ad0981586945ee$var$ObjectMap((e)=>$17ad0981586945ee$var$__PRIVATE_canonifyQuery(e), $17ad0981586945ee$var$__PRIVATE_queryEquals), this.da = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.Aa = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.Ra = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Va = new Map, this.ma = new $17ad0981586945ee$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.fa = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.ga = new Map, this.pa = $17ad0981586945ee$var$__PRIVATE_TargetIdGenerator.On(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.ya = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.ya;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $17ad0981586945ee$var$__PRIVATE_syncEngineListen(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_ensureWatchCallbacks(e);
    let r, i;
    const s = n.Ea.get(t);
    if (s) // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    r = s.targetId, n.sharedClientState.addLocalQueryTarget(r), i = s.view.Pa();
    else {
        const e = await $17ad0981586945ee$var$__PRIVATE_localStoreAllocateTarget(n.localStore, $17ad0981586945ee$var$__PRIVATE_queryToTarget(t)), s = n.sharedClientState.addLocalQueryTarget(e.targetId);
        r = e.targetId, i = await $17ad0981586945ee$var$__PRIVATE_initializeViewAndComputeSnapshot(n, t, r, "current" === s, e.resumeToken), n.isPrimaryClient && $17ad0981586945ee$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    }
    return i;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $17ad0981586945ee$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.wa = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.sa(n);
            i.zi && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $17ad0981586945ee$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.sa(e, i)));
            const s = r && r.targetChanges.get(t.targetId), o = t.view.applyChanges(i, /* updateLimboDocuments= */ e.isPrimaryClient, s);
            return $17ad0981586945ee$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, o.ca), o.snapshot;
        })(e, t, n, r);
    const s = await $17ad0981586945ee$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), o = new $17ad0981586945ee$var$__PRIVATE_View(t, s.ss), _ = o.sa(s.documents), a = $17ad0981586945ee$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* updateLimboDocuments= */ e.isPrimaryClient, a);
    $17ad0981586945ee$var$__PRIVATE_updateTrackedLimbos(e, n, u.ca);
    const c = new $17ad0981586945ee$var$__PRIVATE_QueryView(t, n, o);
    return e.Ea.set(t, c), e.da.has(n) ? e.da.get(n).push(t) : e.da.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $17ad0981586945ee$var$__PRIVATE_syncEngineUnlisten(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = n.Ea.get(t), i = n.da.get(r.targetId);
    if (i.length > 1) return n.da.set(r.targetId, i.filter((e)=>!$17ad0981586945ee$var$__PRIVATE_queryEquals(e, t))), void n.Ea.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (n.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        n.sharedClientState.removeLocalQueryTarget(r.targetId);
        n.sharedClientState.isActiveQueryTarget(r.targetId) || await $17ad0981586945ee$var$__PRIVATE_localStoreReleaseTarget(n.localStore, r.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            n.sharedClientState.clearQueryState(r.targetId), $17ad0981586945ee$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId), $17ad0981586945ee$var$__PRIVATE_removeAndCleanupTarget(n, r.targetId);
        }).catch($17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $17ad0981586945ee$var$__PRIVATE_removeAndCleanupTarget(n, r.targetId), await $17ad0981586945ee$var$__PRIVATE_localStoreReleaseTarget(n.localStore, r.targetId, /*keepPersistedTargetData=*/ !0);
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $17ad0981586945ee$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = $17ad0981586945ee$export$d9bcbd5e1ff81430.now(), i = t.reduce((e, t)=>e.add(t.key), $17ad0981586945ee$var$__PRIVATE_documentKeySet());
            let s, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let _ = $17ad0981586945ee$var$__PRIVATE_mutableDocumentMap(), a = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
                return n.Xi.getEntries(e, i).next((e)=>{
                    _ = e, _.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, _)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const e of t){
                        const t = $17ad0981586945ee$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $17ad0981586945ee$var$__PRIVATE_PatchMutation(e.key, t, $17ad0981586945ee$var$__PRIVATE_extractFieldMask(t.value.mapValue), $17ad0981586945ee$var$Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, o, t);
                }).next((t)=>{
                    o = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $17ad0981586945ee$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.fa[e.currentUser.toKey()];
            r || (r = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.fa[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $17ad0981586945ee$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $17ad0981586945ee$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $17ad0981586945ee$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    try {
        const e = await $17ad0981586945ee$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.Va.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($17ad0981586945ee$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.Ia = !0 : e.modifiedDocuments.size > 0 ? $17ad0981586945ee$var$__PRIVATE_hardAssert(r.Ia) : e.removedDocuments.size > 0 && ($17ad0981586945ee$var$__PRIVATE_hardAssert(r.Ia), r.Ia = !1));
        }), await $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $17ad0981586945ee$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.Ea.forEach((n, r)=>{
            const i = r.view.N_(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.listeners)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.N_(t) && (r = !0);
            }), r && $17ad0981586945ee$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Ta.r_(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $17ad0981586945ee$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.Va.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $17ad0981586945ee$var$MutableDocument.newNoDocument(s, $17ad0981586945ee$var$SnapshotVersion.min()));
        const n = $17ad0981586945ee$var$__PRIVATE_documentKeySet().add(s), i = new $17ad0981586945ee$var$RemoteEvent($17ad0981586945ee$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$var$__PRIVATE_primitiveComparator), e, n);
        await $17ad0981586945ee$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.Ra = r.Ra.remove(s), r.Va.delete(t), $17ad0981586945ee$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $17ad0981586945ee$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$17ad0981586945ee$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $17ad0981586945ee$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $17ad0981586945ee$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $17ad0981586945ee$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $17ad0981586945ee$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $17ad0981586945ee$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($17ad0981586945ee$var$__PRIVATE_hardAssert(null !== t), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $17ad0981586945ee$var$__PRIVATE_processUserCallback(r, t, n), $17ad0981586945ee$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $17ad0981586945ee$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    $17ad0981586945ee$var$__PRIVATE_canUseNetwork(n.remoteStore) || $17ad0981586945ee$var$__PRIVATE_logDebug("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (-1 === e) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.ga.get(e) || [];
        r.push(t), n.ga.set(e, r);
    } catch (e) {
        const n = $17ad0981586945ee$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $17ad0981586945ee$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.ga.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.ga.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $17ad0981586945ee$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    let i = r.fa[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.fa[r.currentUser.toKey()] = i;
    }
}
function $17ad0981586945ee$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.da.get(t))e.Ea.delete(r), n && e.Ta.Sa(r, n);
    if (e.da.delete(t), e.isPrimaryClient) e.ma.Ar(t).forEach((t)=>{
        e.ma.containsKey(t) || // We removed the last reference for this key
        $17ad0981586945ee$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $17ad0981586945ee$var$__PRIVATE_removeLimboTarget(e, t) {
    e.Aa.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.Ra.get(t);
    null !== n && ($17ad0981586945ee$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.Ra = e.Ra.remove(t), e.Va.delete(n), $17ad0981586945ee$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $17ad0981586945ee$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $17ad0981586945ee$var$__PRIVATE_AddedLimboDocument) e.ma.addReference(r.key, t), $17ad0981586945ee$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $17ad0981586945ee$var$__PRIVATE_RemovedLimboDocument) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("SyncEngine", "Document no longer in limbo: " + r.key), e.ma.removeReference(r.key, t);
        e.ma.containsKey(r.key) || // We removed the last reference for this key
        $17ad0981586945ee$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.Ra.get(n) || e.Aa.has(r) || ($17ad0981586945ee$var$__PRIVATE_logDebug("SyncEngine", "New document in limbo: " + n), e.Aa.add(r), $17ad0981586945ee$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $17ad0981586945ee$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.Aa.size > 0 && e.Ra.size < e.maxConcurrentLimboResolutions;){
        const t = e.Aa.values().next().value;
        e.Aa.delete(t);
        const n = new $17ad0981586945ee$export$afc2e57c475b7810($17ad0981586945ee$var$ResourcePath.fromString(t)), r = e.pa.next();
        e.Va.set(r, new $17ad0981586945ee$var$LimboResolution(n)), e.Ra = e.Ra.insert(n, r), $17ad0981586945ee$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $17ad0981586945ee$var$TargetData($17ad0981586945ee$var$__PRIVATE_queryToTarget($17ad0981586945ee$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $17ad0981586945ee$var$__PRIVATE_ListenSequence.ae));
    }
}
async function $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
    r.Ea.isEmpty() || (r.Ea.forEach((e, _)=>{
        o.push(r.wa(_, t, n).then((e)=>{
            // Update views if there are actual changes.
            if (// If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            (e || n) && r.isPrimaryClient && r.sharedClientState.updateQueryState(_.targetId, (null == e ? void 0 : e.fromCache) ? "not-current" : "current"), e) {
                i.push(e);
                const t = $17ad0981586945ee$var$__PRIVATE_LocalViewChanges.qi(_.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(o), r.Ta.r_(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$17ad0981586945ee$var$PersistencePromise.forEach(t, (t)=>$17ad0981586945ee$var$PersistencePromise.forEach(t.Li, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$17ad0981586945ee$var$PersistencePromise.forEach(t.ki, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $17ad0981586945ee$var$__PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.Ji.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.Ji = n.Ji.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $17ad0981586945ee$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $17ad0981586945ee$var$__PRIVATE_logDebug("SyncEngine", "User change. New user:", t.toKey());
        const e = await $17ad0981586945ee$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.ga.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.CANCELLED, t));
                });
            }), e.ga.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.ts);
    }
}
function $17ad0981586945ee$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = n.Va.get(t);
    if (r && r.Ia) return $17ad0981586945ee$var$__PRIVATE_documentKeySet().add(r.key);
    {
        let e = $17ad0981586945ee$var$__PRIVATE_documentKeySet();
        const r = n.da.get(t);
        if (!r) return e;
        for (const t of r){
            const r = n.Ea.get(t);
            e = e.unionWith(r.view.ia);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $17ad0981586945ee$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = await $17ad0981586945ee$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.ha(r);
    return n.isPrimaryClient && $17ad0981586945ee$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.ca), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $17ad0981586945ee$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return $17ad0981586945ee$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $17ad0981586945ee$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $17ad0981586945ee$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = $17ad0981586945ee$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.Dn(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $17ad0981586945ee$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $17ad0981586945ee$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($17ad0981586945ee$var$__PRIVATE_processUserCallback(i, t, r || null), $17ad0981586945ee$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $17ad0981586945ee$var$__PRIVATE_debugCast($17ad0981586945ee$var$__PRIVATE_debugCast(e).mutationQueue).Cn(t);
    }(i.localStore, t)) : $17ad0981586945ee$var$fail(), await $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $17ad0981586945ee$var$__PRIVATE_logDebug("SyncEngine", "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $17ad0981586945ee$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    if ($17ad0981586945ee$var$__PRIVATE_ensureWatchCallbacks(n), $17ad0981586945ee$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.ya) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $17ad0981586945ee$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.ya = !0, await $17ad0981586945ee$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$17ad0981586945ee$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.ya) {
        const e = [];
        let t = Promise.resolve();
        n.da.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($17ad0981586945ee$var$__PRIVATE_removeAndCleanupTarget(n, i), $17ad0981586945ee$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $17ad0981586945ee$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $17ad0981586945ee$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
            t.Va.forEach((e, n)=>{
                $17ad0981586945ee$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t.ma.Rr(), t.Va = new Map, t.Ra = new $17ad0981586945ee$var$SortedMap($17ad0981586945ee$export$afc2e57c475b7810.comparator);
        }(n), n.ya = !1, await $17ad0981586945ee$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $17ad0981586945ee$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.da.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $17ad0981586945ee$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $17ad0981586945ee$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.Ea.get(e), n = await $17ad0981586945ee$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $17ad0981586945ee$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $17ad0981586945ee$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $17ad0981586945ee$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $17ad0981586945ee$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Ta.r_(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $17ad0981586945ee$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $17ad0981586945ee$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $17ad0981586945ee$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $17ad0981586945ee$var$__PRIVATE_debugCast($17ad0981586945ee$var$__PRIVATE_debugCast(e).persistence).Ni();
    }($17ad0981586945ee$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $17ad0981586945ee$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    if (i.ya) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $17ad0981586945ee$var$__PRIVATE_logDebug("SyncEngine", "Ignoring unexpected query state notification.");
    const s = i.da.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const e = await $17ad0981586945ee$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $17ad0981586945ee$var$__PRIVATE_queryCollectionGroup(s[0])), r = $17ad0981586945ee$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $17ad0981586945ee$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                await $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $17ad0981586945ee$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $17ad0981586945ee$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $17ad0981586945ee$var$fail();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $17ad0981586945ee$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.ya) {
        for (const e of t){
            if (r.da.has(e)) {
                // A target might have been added in a previous attempt
                $17ad0981586945ee$var$__PRIVATE_logDebug("SyncEngine", "Adding an already active target " + e);
                continue;
            }
            const t = await $17ad0981586945ee$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $17ad0981586945ee$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $17ad0981586945ee$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $17ad0981586945ee$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $17ad0981586945ee$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.da.has(e) && // Release queries that are still active.
        await $17ad0981586945ee$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $17ad0981586945ee$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $17ad0981586945ee$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($17ad0981586945ee$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $17ad0981586945ee$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $17ad0981586945ee$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $17ad0981586945ee$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $17ad0981586945ee$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Ta.r_ = $17ad0981586945ee$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Ta.Sa = $17ad0981586945ee$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $17ad0981586945ee$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $17ad0981586945ee$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $17ad0981586945ee$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $17ad0981586945ee$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = $17ad0981586945ee$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.Qr.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($17ad0981586945ee$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $17ad0981586945ee$var$__PRIVATE_BundleLoader(r, e.localStore, t.serializer);
            let s = await t.ba();
            for(; s;){
                const e = await i.H_(s);
                e && n._updateProgress(e), s = await t.ba();
            }
            const o = await i.complete();
            return await $17ad0981586945ee$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.Z_, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.Qr.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(o.progress), Promise.resolve(o.Y_);
        } catch (e) {
            return $17ad0981586945ee$export$86cd73f49cc6e0bb("SyncEngine", `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $17ad0981586945ee$var$MemoryOfflineComponentProvider {
    constructor(){
        this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $17ad0981586945ee$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.createSharedClientState(e), this.persistence = this.createPersistence(e), await this.persistence.start(), this.localStore = this.createLocalStore(e), this.gcScheduler = this.createGarbageCollectionScheduler(e, this.localStore), this.indexBackfillerScheduler = this.createIndexBackfillerScheduler(e, this.localStore);
    }
    createGarbageCollectionScheduler(e, t) {
        return null;
    }
    createIndexBackfillerScheduler(e, t) {
        return null;
    }
    createLocalStore(e) {
        return $17ad0981586945ee$var$__PRIVATE_newLocalStore(this.persistence, new $17ad0981586945ee$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    createPersistence(e) {
        return new $17ad0981586945ee$var$__PRIVATE_MemoryPersistence($17ad0981586945ee$var$__PRIVATE_MemoryEagerDelegate.zr, this.serializer);
    }
    createSharedClientState(e) {
        return new $17ad0981586945ee$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        this.gcScheduler && this.gcScheduler.stop(), await this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
class $17ad0981586945ee$var$__PRIVATE_LruGcMemoryOfflineComponentProvider extends $17ad0981586945ee$var$MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    createGarbageCollectionScheduler(e, t) {
        $17ad0981586945ee$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $17ad0981586945ee$var$__PRIVATE_MemoryLruDelegate);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $17ad0981586945ee$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    createPersistence(e) {
        const t = void 0 !== this.cacheSizeBytes ? $17ad0981586945ee$var$LruParams.withCacheSize(this.cacheSizeBytes) : $17ad0981586945ee$var$LruParams.DEFAULT;
        return new $17ad0981586945ee$var$__PRIVATE_MemoryPersistence((e)=>$17ad0981586945ee$var$__PRIVATE_MemoryLruDelegate.zr(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $17ad0981586945ee$var$__PRIVATE_IndexedDbOfflineComponentProvider extends $17ad0981586945ee$var$MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.Da = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.Da.initialize(this, e), // Enqueue writes from a previous session
        await $17ad0981586945ee$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.Da.syncEngine), await $17ad0981586945ee$var$__PRIVATE_fillWritePipeline(this.Da.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Vi(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    createLocalStore(e) {
        return $17ad0981586945ee$var$__PRIVATE_newLocalStore(this.persistence, new $17ad0981586945ee$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    createGarbageCollectionScheduler(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $17ad0981586945ee$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    createIndexBackfillerScheduler(e, t) {
        const n = new $17ad0981586945ee$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $17ad0981586945ee$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    createPersistence(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $17ad0981586945ee$var$LruParams.withCacheSize(this.cacheSizeBytes) : $17ad0981586945ee$var$LruParams.DEFAULT;
        return new $17ad0981586945ee$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $17ad0981586945ee$var$__PRIVATE_getWindow(), $17ad0981586945ee$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    createSharedClientState(e) {
        return new $17ad0981586945ee$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $17ad0981586945ee$var$__PRIVATE_MultiTabOfflineComponentProvider extends $17ad0981586945ee$var$__PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.Da = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.Da.syncEngine;
        this.sharedClientState instanceof $17ad0981586945ee$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            Gs: $17ad0981586945ee$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            zs: $17ad0981586945ee$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            js: $17ad0981586945ee$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            Ni: $17ad0981586945ee$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            Ws: $17ad0981586945ee$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Vi(async (e)=>{
            await $17ad0981586945ee$var$__PRIVATE_syncEngineApplyPrimaryState(this.Da.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    createSharedClientState(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_getWindow();
        if (!$17ad0981586945ee$var$__PRIVATE_WebStorageSharedClientState.v(t)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $17ad0981586945ee$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $17ad0981586945ee$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $17ad0981586945ee$var$OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$17ad0981586945ee$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $17ad0981586945ee$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $17ad0981586945ee$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $17ad0981586945ee$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
            return new $17ad0981586945ee$var$__PRIVATE_WebChannelConnection(e);
        }(e.databaseInfo);
        return function __PRIVATE_newDatastore(e, t, n, r) {
            return new $17ad0981586945ee$var$__PRIVATE_DatastoreImpl(e, t, n, r);
        }(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $17ad0981586945ee$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$17ad0981586945ee$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $17ad0981586945ee$var$__PRIVATE_BrowserConnectivityMonitor.v() ? new $17ad0981586945ee$var$__PRIVATE_BrowserConnectivityMonitor : new $17ad0981586945ee$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, o) {
            const _ = new $17ad0981586945ee$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return o && (_.ya = !0), _;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    terminate() {
        return async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
            $17ad0981586945ee$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore shutting down."), t.y_.add(5 /* OfflineCause.Shutdown */ ), await $17ad0981586945ee$var$__PRIVATE_disableNetworkInternal(t), t.S_.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.b_.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $17ad0981586945ee$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $17ad0981586945ee$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.observer.next && this.va(this.observer.next, e);
    }
    error(e) {
        this.observer.error ? this.va(this.observer.error, e) : $17ad0981586945ee$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString());
    }
    Ca() {
        this.muted = !0;
    }
    va(e, t) {
        this.muted || setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $17ad0981586945ee$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.Fa = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $17ad0981586945ee$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.Ma = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.xa().then((e)=>{
            e && e.z_() ? this.metadata.resolve(e.G_.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == e ? void 0 : e.G_)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.Fa.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async ba() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.xa();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async xa() {
        const e = await this.Oa();
        if (null === e) return null;
        const t = this.Ma.decode(e), n = Number(t);
        isNaN(n) && this.Na(`length string (${t}) is not valid number`);
        const r = await this.Ba(n);
        return new $17ad0981586945ee$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ La() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async Oa() {
        for(; this.La() < 0;){
            if (await this.ka()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.La();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.Na("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Ba(e) {
        for(; this.buffer.length < e;)await this.ka() && this.Na("Reached the end of bundle when more is expected.");
        const t = this.Ma.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    Na(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Fa.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async ka() {
        const e = await this.Fa.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $17ad0981586945ee$var$Transaction$2 {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastWriteError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = $17ad0981586945ee$var$__PRIVATE_getEncodedDatabaseId(n.serializer) + "/documents", i = {
                documents: t.map((e)=>$17ad0981586945ee$var$__PRIVATE_toName(n.serializer, e))
            }, s = await n.yo("BatchGetDocuments", r, i, t.length), o = new Map;
            s.forEach((e)=>{
                const t = $17ad0981586945ee$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                o.set(t.key.toString(), t);
            });
            const _ = [];
            return t.forEach((e)=>{
                const t = o.get(e.toString());
                $17ad0981586945ee$var$__PRIVATE_hardAssert(!!t), _.push(t);
            }), _;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastWriteError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $17ad0981586945ee$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastWriteError) throw this.lastWriteError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $17ad0981586945ee$export$afc2e57c475b7810.fromPath(t);
            this.mutations.push(new $17ad0981586945ee$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = $17ad0981586945ee$var$__PRIVATE_getEncodedDatabaseId(n.serializer) + "/documents", i = {
                writes: t.map((e)=>$17ad0981586945ee$var$toMutation(n.serializer, e))
            };
            await n.Vo("Commit", r, i);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $17ad0981586945ee$var$fail();
            // Represent a deleted doc using SnapshotVersion.min().
            t = $17ad0981586945ee$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($17ad0981586945ee$var$SnapshotVersion.min()) ? $17ad0981586945ee$var$Precondition.exists(!1) : $17ad0981586945ee$var$Precondition.updateTime(t) : $17ad0981586945ee$var$Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($17ad0981586945ee$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $17ad0981586945ee$var$Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $17ad0981586945ee$var$Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $17ad0981586945ee$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.qa = n.maxAttempts, this.Ko = new $17ad0981586945ee$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ run() {
        this.qa -= 1, this.Qa();
    }
    Qa() {
        this.Ko.xo(async ()=>{
            const e = new $17ad0981586945ee$var$Transaction$2(this.datastore), t = this.Ka(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.$a(e);
                    }));
            }).catch((e)=>{
                this.$a(e);
            });
        });
    }
    Ka(e) {
        try {
            const t = this.updateFunction(e);
            return !$17ad0981586945ee$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    $a(e) {
        this.qa > 0 && this.Ua(e) ? (this.qa -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Qa(), Promise.resolve()))) : this.deferred.reject(e);
    }
    Ua(e) {
        if ("FirebaseError" === e.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$17ad0981586945ee$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $17ad0981586945ee$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $17ad0981586945ee$var$User.UNAUTHENTICATED, this.clientId = $17ad0981586945ee$var$__PRIVATE_AutoId.V(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this.authCredentials.start(n, async (e)=>{
            $17ad0981586945ee$var$__PRIVATE_logDebug("FirestoreClient", "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($17ad0981586945ee$var$__PRIVATE_logDebug("FirestoreClient", "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    async getConfiguration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    /**
     * Checks that the client has not been terminated. Ensures that other methods on //
     * this class cannot be called after the client is terminated. //
     */ verifyNotTerminated() {
        if (this.asyncQueue.isShuttingDown) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $17ad0981586945ee$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $17ad0981586945ee$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $17ad0981586945ee$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $17ad0981586945ee$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = await e.getConfiguration();
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $17ad0981586945ee$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $17ad0981586945ee$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $17ad0981586945ee$var$__PRIVATE_ensureOfflineComponents(e);
    $17ad0981586945ee$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OnlineComponentProvider");
    const r = await e.getConfiguration();
    await t.initialize(n, r), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$17ad0981586945ee$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$17ad0981586945ee$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function $17ad0981586945ee$var$__PRIVATE_canFallbackFromIndexedDbError(e) {
    return "FirebaseError" === e.name ? e.code === $17ad0981586945ee$var$v.FAILED_PRECONDITION || e.code === $17ad0981586945ee$var$v.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
    // or an aborted error depending on whether the error happened during
    // schema migration.
    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
    // INVALID_STATE for any usage.
    11 === e.code;
}
async function $17ad0981586945ee$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $17ad0981586945ee$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OfflineComponentProvider");
            try {
                await $17ad0981586945ee$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!$17ad0981586945ee$var$__PRIVATE_canFallbackFromIndexedDbError(n)) throw n;
                $17ad0981586945ee$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $17ad0981586945ee$var$__PRIVATE_setOfflineComponentProvider(e, new $17ad0981586945ee$var$MemoryOfflineComponentProvider);
            }
        } else $17ad0981586945ee$var$__PRIVATE_logDebug("FirestoreClient", "Using default OfflineComponentProvider"), await $17ad0981586945ee$var$__PRIVATE_setOfflineComponentProvider(e, new $17ad0981586945ee$var$MemoryOfflineComponentProvider);
    }
    return e._offlineComponents;
}
async function $17ad0981586945ee$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($17ad0981586945ee$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OnlineComponentProvider"), await $17ad0981586945ee$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($17ad0981586945ee$var$__PRIVATE_logDebug("FirestoreClient", "Using default OnlineComponentProvider"), await $17ad0981586945ee$var$__PRIVATE_setOnlineComponentProvider(e, new $17ad0981586945ee$var$OnlineComponentProvider))), e._onlineComponents;
}
function $17ad0981586945ee$var$__PRIVATE_getPersistence(e) {
    return $17ad0981586945ee$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $17ad0981586945ee$var$__PRIVATE_getLocalStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $17ad0981586945ee$var$__PRIVATE_getRemoteStore(e) {
    return $17ad0981586945ee$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $17ad0981586945ee$var$__PRIVATE_getSyncEngine(e) {
    return $17ad0981586945ee$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $17ad0981586945ee$var$__PRIVATE_getDatastore(e) {
    return $17ad0981586945ee$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $17ad0981586945ee$var$__PRIVATE_getEventManager(e) {
    const t = await $17ad0981586945ee$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $17ad0981586945ee$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $17ad0981586945ee$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $17ad0981586945ee$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $17ad0981586945ee$var$__PRIVATE_getPersistence(e), n = await $17ad0981586945ee$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
            return t.y_.delete(0 /* OfflineCause.UserDisabled */ ), $17ad0981586945ee$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $17ad0981586945ee$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $17ad0981586945ee$var$__PRIVATE_getPersistence(e), n = await $17ad0981586945ee$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
            t.y_.add(0 /* OfflineCause.UserDisabled */ ), await $17ad0981586945ee$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.b_.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new $17ad0981586945ee$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $17ad0981586945ee$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $17ad0981586945ee$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new $17ad0981586945ee$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $17ad0981586945ee$var$__PRIVATE_AsyncObserver({
                next: (s)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    t.enqueueAndForget(()=>$17ad0981586945ee$var$__PRIVATE_eventManagerUnlisten(e, o));
                    const _ = s.docs.has(n);
                    !_ && s.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNAVAILABLE, "Failed to get document because the client is offline.")) : _ && s.fromCache && r && "server" === r.source ? i.reject(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(s);
                },
                error: (e)=>i.reject(e)
            }), o = new $17ad0981586945ee$var$__PRIVATE_QueryListener($17ad0981586945ee$var$__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                W_: !0
            });
            return $17ad0981586945ee$var$__PRIVATE_eventManagerListen(e, o);
        })(await $17ad0981586945ee$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new $17ad0981586945ee$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $17ad0981586945ee$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $17ad0981586945ee$var$__PRIVATE_View(t, r.ss), s = i.sa(r.documents), o = i.applyChanges(s, /* updateLimboDocuments= */ !1);
                n.resolve(o.snapshot);
            } catch (e) {
                const r = $17ad0981586945ee$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $17ad0981586945ee$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new $17ad0981586945ee$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $17ad0981586945ee$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    t.enqueueAndForget(()=>$17ad0981586945ee$var$__PRIVATE_eventManagerUnlisten(e, o)), n.fromCache && "server" === r.source ? i.reject(new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), o = new $17ad0981586945ee$var$__PRIVATE_QueryListener(n, s, {
                includeMetadataChanges: !0,
                W_: !0
            });
            return $17ad0981586945ee$var$__PRIVATE_eventManagerListen(e, o);
        })(await $17ad0981586945ee$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $17ad0981586945ee$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new $17ad0981586945ee$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $17ad0981586945ee$var$__PRIVATE_debugCast(e).O_.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $17ad0981586945ee$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.Ca(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $17ad0981586945ee$var$__PRIVATE_debugCast(e).O_.delete(t);
            })(await $17ad0981586945ee$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $17ad0981586945ee$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $17ad0981586945ee$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $17ad0981586945ee$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $17ad0981586945ee$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $17ad0981586945ee$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $17ad0981586945ee$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $17ad0981586945ee$var$__PRIVATE_syncEngineLoadBundle(await $17ad0981586945ee$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $17ad0981586945ee$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.Qr.getNamedQuery(e, t));
        })(await $17ad0981586945ee$var$__PRIVATE_getLocalStore(e), t));
}
function $17ad0981586945ee$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $17ad0981586945ee$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, o = t.length;
                        let _ = 0, a = 0;
                        for(; _ < o && a < s;){
                            const s = n(e[a], t[_]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[_++]) : (_++, a++);
                        }
                        for(; _ < o;)r(t[_++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $17ad0981586945ee$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$17ad0981586945ee$var$PersistencePromise.waitFor(i)));
        })(await $17ad0981586945ee$var$__PRIVATE_getLocalStore(e), t));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $17ad0981586945ee$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$fe = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $17ad0981586945ee$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $17ad0981586945ee$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $17ad0981586945ee$var$__PRIVATE_validateDocumentPath(e) {
    if (!$17ad0981586945ee$export$afc2e57c475b7810.isDocumentKey(e)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $17ad0981586945ee$var$__PRIVATE_validateCollectionPath(e) {
    if ($17ad0981586945ee$export$afc2e57c475b7810.isDocumentKey(e)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $17ad0981586945ee$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $17ad0981586945ee$var$fail();
}
function $17ad0981586945ee$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $17ad0981586945ee$var$__PRIVATE_valueDescription(e);
            throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $17ad0981586945ee$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $17ad0981586945ee$var$FirestoreSettingsImpl {
    constructor(e){
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = e.host, this.ssl = null === (t = e.ssl) || void 0 === t || t;
        if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $17ad0981586945ee$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $17ad0981586945ee$var$__PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $17ad0981586945ee$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $17ad0981586945ee$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1;
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return void 0 !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $17ad0981586945ee$var$FirestoreSettingsImpl(e), void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $17ad0981586945ee$export$65ffa50b6039c992;
            switch(e.type){
                case "firstParty":
                    return new $17ad0981586945ee$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $17ad0981586945ee$var$fe.get(e);
            t && ($17ad0981586945ee$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $17ad0981586945ee$var$fe.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $17ad0981586945ee$export$966a03d25297d115(e, t, n, r = {}) {
    var i;
    const s = (e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$var$Firestore$1))._getSettings(), o = `${t}:${n}`;
    if ("firestore.googleapis.com" !== s.host && s.host !== o && $17ad0981586945ee$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, s), {
        host: o,
        ssl: !1
    })), r.mockUserToken) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $17ad0981586945ee$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $2xDiJ.createMockUserToken)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            const s = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $17ad0981586945ee$var$User(s);
        }
        e._authCredentials = new $17ad0981586945ee$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $17ad0981586945ee$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $17ad0981586945ee$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $17ad0981586945ee$export$62297b13309008b2(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $17ad0981586945ee$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $17ad0981586945ee$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $17ad0981586945ee$export$6be62b059fb12175(this.firestore, e, this._key);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $17ad0981586945ee$export$ab5a1a47940a200e extends $17ad0981586945ee$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $17ad0981586945ee$var$__PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $17ad0981586945ee$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $17ad0981586945ee$export$afc2e57c475b7810(e));
    }
    withConverter(e) {
        return new $17ad0981586945ee$export$ab5a1a47940a200e(this.firestore, e, this._path);
    }
}
function $17ad0981586945ee$export$bf5175b0c24981cd(e, t, ...n) {
    if (e = (0, $2xDiJ.getModularInstance)(e), $17ad0981586945ee$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $17ad0981586945ee$var$Firestore$1) {
        const r = $17ad0981586945ee$var$ResourcePath.fromString(t, ...n);
        return $17ad0981586945ee$var$__PRIVATE_validateCollectionPath(r), new $17ad0981586945ee$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $17ad0981586945ee$export$6be62b059fb12175 || e instanceof $17ad0981586945ee$export$ab5a1a47940a200e)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($17ad0981586945ee$var$ResourcePath.fromString(t, ...n));
        return $17ad0981586945ee$var$__PRIVATE_validateCollectionPath(r), new $17ad0981586945ee$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $17ad0981586945ee$export$473d82a73f88c107(e, t) {
    if (e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$var$Firestore$1), $17ad0981586945ee$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $17ad0981586945ee$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $17ad0981586945ee$var$__PRIVATE_QueryImpl($17ad0981586945ee$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $17ad0981586945ee$export$2a111da947c407d2(e, t, ...n) {
    if (e = (0, $2xDiJ.getModularInstance)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $17ad0981586945ee$var$__PRIVATE_AutoId.V()), $17ad0981586945ee$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $17ad0981586945ee$var$Firestore$1) {
        const r = $17ad0981586945ee$var$ResourcePath.fromString(t, ...n);
        return $17ad0981586945ee$var$__PRIVATE_validateDocumentPath(r), new $17ad0981586945ee$export$6be62b059fb12175(e, /* converter= */ null, new $17ad0981586945ee$export$afc2e57c475b7810(r));
    }
    {
        if (!(e instanceof $17ad0981586945ee$export$6be62b059fb12175 || e instanceof $17ad0981586945ee$export$ab5a1a47940a200e)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($17ad0981586945ee$var$ResourcePath.fromString(t, ...n));
        return $17ad0981586945ee$var$__PRIVATE_validateDocumentPath(r), new $17ad0981586945ee$export$6be62b059fb12175(e.firestore, e instanceof $17ad0981586945ee$export$ab5a1a47940a200e ? e.converter : null, new $17ad0981586945ee$export$afc2e57c475b7810(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $17ad0981586945ee$export$62a32f2da6187d11(e, t) {
    return e = (0, $2xDiJ.getModularInstance)(e), t = (0, $2xDiJ.getModularInstance)(t), (e instanceof $17ad0981586945ee$export$6be62b059fb12175 || e instanceof $17ad0981586945ee$export$ab5a1a47940a200e) && (t instanceof $17ad0981586945ee$export$6be62b059fb12175 || t instanceof $17ad0981586945ee$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $17ad0981586945ee$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $2xDiJ.getModularInstance)(e), t = (0, $2xDiJ.getModularInstance)(t), e instanceof $17ad0981586945ee$export$62297b13309008b2 && t instanceof $17ad0981586945ee$export$62297b13309008b2 && e.firestore === t.firestore && $17ad0981586945ee$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $17ad0981586945ee$var$__PRIVATE_AsyncQueueImpl {
    constructor(){
        // The last promise in the queue.
        this.Wa = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Ga = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.za = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.ja = [], // visible for testing
        this.Ha = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Ja = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Ya = !1, // List of TimerIds to fast-forward delays for.
        this.Za = [], // Backoff timer used to schedule retries for retryable operations
        this.Ko = new $17ad0981586945ee$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Xa = ()=>{
            const e = $17ad0981586945ee$var$getDocument();
            e && $17ad0981586945ee$var$__PRIVATE_logDebug("AsyncQueue", "Visibility state changed to " + e.visibilityState), this.Ko.No();
        };
        const e = $17ad0981586945ee$var$getDocument();
        e && "function" == typeof e.addEventListener && e.addEventListener("visibilitychange", this.Xa);
    }
    get isShuttingDown() {
        return this.za;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.eu(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.tu(e);
    }
    enterRestrictedMode(e) {
        if (!this.za) {
            this.za = !0, this.Ya = e || !1;
            const t = $17ad0981586945ee$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.Xa);
        }
    }
    enqueue(e) {
        if (this.eu(), this.za) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $17ad0981586945ee$var$__PRIVATE_Deferred;
        return this.tu(()=>this.za && this.Ya ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.Ga.push(e), this.nu()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async nu() {
        if (0 !== this.Ga.length) {
            try {
                await this.Ga[0](), this.Ga.shift(), this.Ko.reset();
            } catch (e) {
                if (!$17ad0981586945ee$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $17ad0981586945ee$var$__PRIVATE_logDebug("AsyncQueue", "Operation failed with retryable error: " + e);
            }
            this.Ga.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.Ko.xo(()=>this.nu());
        }
    }
    tu(e) {
        const t = this.Wa.then(()=>(this.Ja = !0, e().catch((e)=>{
                this.Ha = e, this.Ja = !1;
                const t = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
                    let t = e.message || "";
                    e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack);
                    return t;
                }(e);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $17ad0981586945ee$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t), e;
            }).then((e)=>(this.Ja = !1, e))));
        return this.Wa = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.eu(), // Fast-forward delays for timerIds that have been overriden.
        this.Za.indexOf(e) > -1 && (t = 0);
        const r = $17ad0981586945ee$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.ru(e));
        return this.ja.push(r), r;
    }
    eu() {
        this.Ha && $17ad0981586945ee$var$fail();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async iu() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.Wa, await e;
        while (e !== this.Wa);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ su(e) {
        for (const t of this.ja)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ ou(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.iu().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            this.ja.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.ja)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.iu();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ _u(e) {
        this.Za.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ ru(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.ja.indexOf(e);
        this.ja.splice(t, 1);
    }
}
function $17ad0981586945ee$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        const n = e;
        for (const e of t)if (e in n && "function" == typeof n[e]) return !0;
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
class $17ad0981586945ee$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $17ad0981586945ee$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $17ad0981586945ee$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $17ad0981586945ee$export$d0e2b3272814ce82 extends $17ad0981586945ee$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = function __PRIVATE_newAsyncQueue() {
            return new $17ad0981586945ee$var$__PRIVATE_AsyncQueueImpl;
        }(), this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
    }
    _terminate() {
        return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
        // usage throws an exception.
        $17ad0981586945ee$var$__PRIVATE_configureFirestore(this), this._firestoreClient.terminate();
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $17ad0981586945ee$export$9061557f3e3b42f9(e, t, n) {
    n || (n = "(default)");
    const r = (0, $MjY8E._getProvider)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $2xDiJ.deepEqual)(i, t)) return e;
        throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $17ad0981586945ee$export$f06a05d14c3a6678(t, n) {
    const r = "object" == typeof t ? t : (0, $MjY8E.getApp)(), i = "string" == typeof t ? t : n || "(default)", s = (0, $MjY8E._getProvider)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $2xDiJ.getDefaultEmulatorHostnameAndPort)("firestore");
        e && $17ad0981586945ee$export$966a03d25297d115(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $17ad0981586945ee$export$8da5fbea04405656(e) {
    return e._firestoreClient || $17ad0981586945ee$var$__PRIVATE_configureFirestore(e), e._firestoreClient.verifyNotTerminated(), e._firestoreClient;
}
function $17ad0981586945ee$var$__PRIVATE_configureFirestore(e) {
    var t, n, r;
    const i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $17ad0981586945ee$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $17ad0981586945ee$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._firestoreClient = new $17ad0981586945ee$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s), (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._firestoreClient._uninitializedComponentsProvider = {
        _offlineKind: i.localCache.kind,
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    });
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * Must be called before any other functions (other than
 * {@link initializeFirestore}, {@link (getFirestore:1)} or
 * {@link clearIndexedDbPersistence}.
 *
 * If this fails, `enableIndexedDbPersistence()` will reject the promise it
 * returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * Persistence cannot be used in a Node.js environment.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on IndexedDb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function $17ad0981586945ee$export$cebe3b626a79c5f3(e, t) {
    $17ad0981586945ee$var$__PRIVATE_verifyNotInitialized(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82));
    const n = $17ad0981586945ee$export$8da5fbea04405656(e);
    if (n._uninitializedComponentsProvider) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "SDK cache is already specified.");
    $17ad0981586945ee$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const r = e._freezeSettings(), i = new $17ad0981586945ee$var$OnlineComponentProvider;
    return $17ad0981586945ee$var$__PRIVATE_setPersistenceProviders(n, i, new $17ad0981586945ee$var$__PRIVATE_IndexedDbOfflineComponentProvider(i, r.cacheSizeBytes, null == t ? void 0 : t.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * If this fails, `enableMultiTabIndexedDbPersistence()` will reject the promise
 * it returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function $17ad0981586945ee$export$6d4c055e91302ab9(e) {
    $17ad0981586945ee$var$__PRIVATE_verifyNotInitialized(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82));
    const t = $17ad0981586945ee$export$8da5fbea04405656(e);
    if (t._uninitializedComponentsProvider) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "SDK cache is already specified.");
    $17ad0981586945ee$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings(), r = new $17ad0981586945ee$var$OnlineComponentProvider;
    return $17ad0981586945ee$var$__PRIVATE_setPersistenceProviders(t, r, new $17ad0981586945ee$var$__PRIVATE_MultiTabOfflineComponentProvider(r, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $17ad0981586945ee$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    const r = new $17ad0981586945ee$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueue(async ()=>{
        try {
            await $17ad0981586945ee$var$__PRIVATE_setOfflineComponentProvider(e, n), await $17ad0981586945ee$var$__PRIVATE_setOnlineComponentProvider(e, t), r.resolve();
        } catch (e) {
            const t = e;
            if (!$17ad0981586945ee$var$__PRIVATE_canFallbackFromIndexedDbError(t)) throw t;
            $17ad0981586945ee$export$86cd73f49cc6e0bb("Error enabling indexeddb cache. Falling back to memory cache: " + t), r.reject(t);
        }
    }).then(()=>r.promise);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $17ad0981586945ee$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $17ad0981586945ee$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$17ad0981586945ee$var$__PRIVATE_SimpleDb.v()) return Promise.resolve();
                const t = e + "main";
                await $17ad0981586945ee$var$__PRIVATE_SimpleDb.delete(t);
            }($17ad0981586945ee$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $17ad0981586945ee$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $17ad0981586945ee$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$17ad0981586945ee$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $17ad0981586945ee$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($17ad0981586945ee$export$8da5fbea04405656(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $17ad0981586945ee$export$ee6bdee8287ecc5f(e) {
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientEnableNetwork($17ad0981586945ee$export$8da5fbea04405656(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $17ad0981586945ee$export$f35b708ad73d52eb(e) {
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientDisableNetwork($17ad0981586945ee$export$8da5fbea04405656(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $17ad0981586945ee$export$9aff22d1ec357a14(e) {
    return (0, $MjY8E._removeServiceInstance)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $17ad0981586945ee$export$4b8b93c690c9810b(e, t) {
    const n = $17ad0981586945ee$export$8da5fbea04405656(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82)), r = new $17ad0981586945ee$export$6cac12425252ec14;
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $17ad0981586945ee$export$169d2c6fe0f7f4ea(e, t) {
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientGetNamedQuery($17ad0981586945ee$export$8da5fbea04405656(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82)), t).then((t)=>t ? new $17ad0981586945ee$export$62297b13309008b2(e, null, t.query) : null);
}
function $17ad0981586945ee$var$__PRIVATE_verifyNotInitialized(e) {
    if (e._initialized || e._terminated) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $17ad0981586945ee$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param _aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(// TODO (sum/avg) make aggregateType public when the feature is supported
    e = "count", t){
        this._aggregateType = e, this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField";
    }
}
/**
 * The results of executing an aggregation query.
 */ class $17ad0981586945ee$export$40257fef64be808b {
    /** @hideconstructor */ constructor(e, t, n){
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $17ad0981586945ee$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $17ad0981586945ee$export$9f55f2e2bf8c2fc1($17ad0981586945ee$export$67460cdabfa21253.fromBase64String(e));
        } catch (e) {
            throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $17ad0981586945ee$export$9f55f2e2bf8c2fc1($17ad0981586945ee$export$67460cdabfa21253.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $17ad0981586945ee$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $17ad0981586945ee$export$b7871852b967eaf1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $17ad0981586945ee$export$bf6e62266977b8eb() {
    return new $17ad0981586945ee$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $17ad0981586945ee$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $17ad0981586945ee$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $17ad0981586945ee$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $17ad0981586945ee$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$pe = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $17ad0981586945ee$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $17ad0981586945ee$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $17ad0981586945ee$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $17ad0981586945ee$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $17ad0981586945ee$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $17ad0981586945ee$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $17ad0981586945ee$var$fail();
    }
}
/** A "context" object passed around while parsing user data. */ class $17ad0981586945ee$var$__PRIVATE_ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.au(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get uu() {
        return this.settings.uu;
    }
    /** Returns a new context with the specified settings overwritten. */ cu(e) {
        return new $17ad0981586945ee$var$__PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    lu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.cu({
            path: n,
            hu: !1
        });
        return r.Pu(e), r;
    }
    Iu(e) {
        var t;
        const n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.cu({
            path: n,
            hu: !1
        });
        return r.au(), r;
    }
    Tu(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.cu({
            path: void 0,
            hu: !0
        });
    }
    Eu(e) {
        return $17ad0981586945ee$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.du || !1, this.path, this.settings.Au);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    au() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.Pu(this.path.get(e));
    }
    Pu(e) {
        if (0 === e.length) throw this.Eu("Document fields must not be empty");
        if ($17ad0981586945ee$var$__PRIVATE_isWrite(this.uu) && $17ad0981586945ee$var$pe.test(e)) throw this.Eu('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $17ad0981586945ee$var$__PRIVATE_UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $17ad0981586945ee$var$__PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ Ru(e, t, n, r = !1) {
        return new $17ad0981586945ee$var$__PRIVATE_ParseContextImpl({
            uu: e,
            methodName: t,
            Au: n,
            path: $17ad0981586945ee$export$b7871852b967eaf1.emptyPath(),
            hu: !1,
            du: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $17ad0981586945ee$var$__PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = $17ad0981586945ee$var$__PRIVATE_newSerializer(e._databaseId);
    return new $17ad0981586945ee$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $17ad0981586945ee$var$__PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const o = e.Ru(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $17ad0981586945ee$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    const _ = $17ad0981586945ee$var$__PRIVATE_parseObject(r, o);
    let a, u;
    if (s.merge) a = new $17ad0981586945ee$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument$1(t, r, n);
            if (!o.contains(i)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $17ad0981586945ee$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $17ad0981586945ee$var$FieldMask(e), u = o.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = o.fieldTransforms;
    return new $17ad0981586945ee$var$ParsedSetData(new $17ad0981586945ee$var$ObjectValue(_), a, u);
}
class $17ad0981586945ee$var$__PRIVATE_DeleteFieldValueImpl extends $17ad0981586945ee$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.uu) throw 1 /* UserDataSource.Update */  === e.uu ? e.Eu(`${this._methodName}() can only appear at the top level of your update data`) : e.Eu(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $17ad0981586945ee$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $17ad0981586945ee$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $17ad0981586945ee$var$__PRIVATE_ParseContextImpl({
        uu: 3 /* UserDataSource.Argument */ ,
        Au: t.settings.Au,
        methodName: e._methodName,
        hu: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $17ad0981586945ee$var$__PRIVATE_ServerTimestampFieldValueImpl extends $17ad0981586945ee$export$c58bc8ee7ecc248d {
    _toFieldTransform(e) {
        return new $17ad0981586945ee$var$FieldTransform(e.path, new $17ad0981586945ee$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $17ad0981586945ee$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $17ad0981586945ee$var$__PRIVATE_ArrayUnionFieldValueImpl extends $17ad0981586945ee$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Vu = t;
    }
    _toFieldTransform(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Vu.map((e)=>$17ad0981586945ee$var$__PRIVATE_parseData(e, t)), r = new $17ad0981586945ee$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $17ad0981586945ee$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        // TODO(mrschmidt): Implement isEquals
        return this === e;
    }
}
class $17ad0981586945ee$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $17ad0981586945ee$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.Vu = t;
    }
    _toFieldTransform(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Vu.map((e)=>$17ad0981586945ee$var$__PRIVATE_parseData(e, t)), r = new $17ad0981586945ee$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $17ad0981586945ee$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        // TODO(mrschmidt): Implement isEquals
        return this === e;
    }
}
class $17ad0981586945ee$var$__PRIVATE_NumericIncrementFieldValueImpl extends $17ad0981586945ee$export$c58bc8ee7ecc248d {
    constructor(e, t){
        super(e), this.mu = t;
    }
    _toFieldTransform(e) {
        const t = new $17ad0981586945ee$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $17ad0981586945ee$var$toNumber(e.serializer, this.mu));
        return new $17ad0981586945ee$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        // TODO(mrschmidt): Implement isEquals
        return this === e;
    }
}
/** Parse update data from an update() call. */ function $17ad0981586945ee$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.Ru(1 /* UserDataSource.Update */ , t, n);
    $17ad0981586945ee$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], o = $17ad0981586945ee$var$ObjectValue.empty();
    $17ad0981586945ee$var$forEach(r, (e, r)=>{
        const _ = $17ad0981586945ee$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $2xDiJ.getModularInstance)(r);
        const a = i.Iu(_);
        if (r instanceof $17ad0981586945ee$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            const e = $17ad0981586945ee$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(_), o.set(_, e));
        }
    });
    const _ = new $17ad0981586945ee$var$FieldMask(s);
    return new $17ad0981586945ee$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $17ad0981586945ee$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const o = e.Ru(1 /* UserDataSource.Update */ , t, n), _ = [
        $17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)_.push($17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument$1(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $17ad0981586945ee$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = _.length - 1; e >= 0; --e)if (!$17ad0981586945ee$var$__PRIVATE_fieldMaskContains(u, _[e])) {
        const t = _[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $2xDiJ.getModularInstance)(n);
        const r = o.Iu(t);
        if (n instanceof $17ad0981586945ee$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $17ad0981586945ee$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const l = new $17ad0981586945ee$var$FieldMask(u);
    return new $17ad0981586945ee$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $17ad0981586945ee$var$__PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return $17ad0981586945ee$var$__PRIVATE_parseData(n, e.Ru(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $17ad0981586945ee$var$__PRIVATE_parseData(e, t) {
    if ($17ad0981586945ee$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $2xDiJ.getModularInstance)(e))) return $17ad0981586945ee$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $17ad0981586945ee$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $17ad0981586945ee$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$17ad0981586945ee$var$__PRIVATE_isWrite(t.uu)) throw t.Eu(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.Eu(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.hu && 4 /* UserDataSource.ArrayArgument */  !== t.uu) throw t.Eu("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $17ad0981586945ee$var$__PRIVATE_parseData(i, t.Tu(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $2xDiJ.getModularInstance)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $17ad0981586945ee$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $17ad0981586945ee$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $17ad0981586945ee$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $17ad0981586945ee$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $17ad0981586945ee$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $17ad0981586945ee$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $17ad0981586945ee$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $17ad0981586945ee$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $17ad0981586945ee$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $17ad0981586945ee$export$6be62b059fb12175) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.Eu(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $17ad0981586945ee$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        throw t.Eu(`Unsupported field value: ${$17ad0981586945ee$var$__PRIVATE_valueDescription(e)}`);
    }(e, t);
}
function $17ad0981586945ee$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $17ad0981586945ee$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $17ad0981586945ee$var$forEach(e, (e, r)=>{
        const i = $17ad0981586945ee$var$__PRIVATE_parseData(r, t.lu(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $17ad0981586945ee$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $17ad0981586945ee$export$d9bcbd5e1ff81430 || e instanceof $17ad0981586945ee$export$f9f719d1b6419c4 || e instanceof $17ad0981586945ee$export$9f55f2e2bf8c2fc1 || e instanceof $17ad0981586945ee$export$6be62b059fb12175 || e instanceof $17ad0981586945ee$export$c58bc8ee7ecc248d);
}
function $17ad0981586945ee$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$17ad0981586945ee$var$__PRIVATE_looksLikeJsonObject(n) || !function __PRIVATE_isPlainObject(e) {
        return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }(n)) {
        const r = $17ad0981586945ee$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.Eu(e + " a custom object") : t.Eu(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (t = (0, $2xDiJ.getModularInstance)(t)) instanceof $17ad0981586945ee$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $17ad0981586945ee$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $17ad0981586945ee$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $17ad0981586945ee$var$ye = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $17ad0981586945ee$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($17ad0981586945ee$var$ye) >= 0) throw $17ad0981586945ee$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $17ad0981586945ee$export$a1a8fea822d17659(...t.split("."))._internalPath;
    } catch (r) {
        throw $17ad0981586945ee$var$__PRIVATE_createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $17ad0981586945ee$var$__PRIVATE_createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), o = void 0 !== i;
    let _ = `Function ${t}() called with invalid data`;
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    let a = "";
    return (s || o) && (a += " (found", s && (a += ` in field ${r}`), o && (a += ` in document ${i}`), a += ")"), new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $17ad0981586945ee$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $17ad0981586945ee$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(e, t, n, r, i){
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $17ad0981586945ee$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $17ad0981586945ee$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(e);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e) {
        if (this._document) {
            const t = this._document.data.field($17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== t) return this._userDataWriter.convertValue(t);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $17ad0981586945ee$var$QueryDocumentSnapshot$1 extends $17ad0981586945ee$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $17ad0981586945ee$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $17ad0981586945ee$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $17ad0981586945ee$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $17ad0981586945ee$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $17ad0981586945ee$export$b0e86f2c7431df4e extends $17ad0981586945ee$var$AppliableConstraint {
}
function $17ad0981586945ee$export$2fa187e846a241c4(e, t, ...n) {
    let r = [];
    t instanceof $17ad0981586945ee$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        const t = e.filter((e)=>e instanceof $17ad0981586945ee$export$6bbc7aef0717f3d2).length, n = e.filter((e)=>e instanceof $17ad0981586945ee$export$f765fc5789dfd439).length;
        if (t > 1 || t > 0 && n > 0) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const t of r)e = t._apply(e);
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $17ad0981586945ee$export$f765fc5789dfd439 extends $17ad0981586945ee$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t, n){
        super(), this._field = e, this._op = t, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(e, t, n) {
        return new $17ad0981586945ee$export$f765fc5789dfd439(e, t, n);
    }
    _apply(e) {
        const t = this._parse(e);
        return $17ad0981586945ee$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $17ad0981586945ee$export$62297b13309008b2(e.firestore, e.converter, $17ad0981586945ee$var$__PRIVATE_queryWithAddedFilter(e._query, t));
    }
    _parse(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
            let _;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid Query. You can't perform '${s}' queries on documentId().`);
                if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                    $17ad0981586945ee$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                    const t = [];
                    for (const n of o)t.push($17ad0981586945ee$var$__PRIVATE_parseDocumentIdValue(r, e, n));
                    _ = {
                        arrayValue: {
                            values: t
                        }
                    };
                } else _ = $17ad0981586945ee$var$__PRIVATE_parseDocumentIdValue(r, e, o);
            } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $17ad0981586945ee$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $17ad0981586945ee$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
            return $17ad0981586945ee$var$FieldFilter.create(i, s, _);
        }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $17ad0981586945ee$export$9c59b80dda569a6e(e, t, n) {
    const r = t, i = $17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $17ad0981586945ee$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $17ad0981586945ee$export$6bbc7aef0717f3d2 extends $17ad0981586945ee$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t){
        super(), this.type = e, this._queryConstraints = t;
    }
    static _create(e, t) {
        return new $17ad0981586945ee$export$6bbc7aef0717f3d2(e, t);
    }
    _parse(e) {
        const t = this._queryConstraints.map((t)=>t._parse(e)).filter((e)=>e.getFilters().length > 0);
        return 1 === t.length ? t[0] : $17ad0981586945ee$var$CompositeFilter.create(t, this._getOperator());
    }
    _apply(e) {
        const t = this._parse(e);
        return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
            let n = e;
            const r = t.getFlattenedFilters();
            for (const e of r)$17ad0981586945ee$var$__PRIVATE_validateNewFieldFilter(n, e), n = $17ad0981586945ee$var$__PRIVATE_queryWithAddedFilter(n, e);
        }(e._query, t), new $17ad0981586945ee$export$62297b13309008b2(e.firestore, e.converter, $17ad0981586945ee$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $17ad0981586945ee$export$252bb8b3bbdf6749(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$17ad0981586945ee$var$__PRIVATE_validateQueryFilterConstraint("or", e)), $17ad0981586945ee$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $17ad0981586945ee$export$21c0ac7fe1cef1b8(...e) {
    // Only support QueryFilterConstraints
    return e.forEach((e)=>$17ad0981586945ee$var$__PRIVATE_validateQueryFilterConstraint("and", e)), $17ad0981586945ee$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $17ad0981586945ee$export$65a9ba8bbd6ed9e3 extends $17ad0981586945ee$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(e, t){
        super(), this._field = e, this._direction = t, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(e, t) {
        return new $17ad0981586945ee$export$65a9ba8bbd6ed9e3(e, t);
    }
    _apply(e) {
        const t = function __PRIVATE_newQueryOrderBy(e, t, n) {
            if (null !== e.startAt) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== e.endAt) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new $17ad0981586945ee$var$OrderBy(t, n);
            return function __PRIVATE_validateNewOrderBy(e, t) {
                if (null === $17ad0981586945ee$var$__PRIVATE_getFirstOrderByField(e)) {
                    // This is the first order by. It must match any inequality.
                    const n = $17ad0981586945ee$var$__PRIVATE_getInequalityFilterField(e);
                    null !== n && $17ad0981586945ee$var$__PRIVATE_validateOrderByAndInequalityMatch(e, n, t.field);
                }
            }(e, r), r;
        }(e._query, this._field, this._direction);
        return new $17ad0981586945ee$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = e.explicitOrderBy.concat([
                t
            ]);
            return new $17ad0981586945ee$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
        }(e._query, t));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $17ad0981586945ee$export$f18af21d6f4dafd8(e, t = "asc") {
    const n = t, r = $17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $17ad0981586945ee$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $17ad0981586945ee$export$49bb5356ca788047 extends $17ad0981586945ee$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._limit = t, this._limitType = n;
    }
    static _create(e, t, n) {
        return new $17ad0981586945ee$export$49bb5356ca788047(e, t, n);
    }
    _apply(e) {
        return new $17ad0981586945ee$export$62297b13309008b2(e.firestore, e.converter, $17ad0981586945ee$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $17ad0981586945ee$export$ee37e834aaad6f7e(e) {
    return $17ad0981586945ee$var$__PRIVATE_validatePositiveNumber("limit", e), $17ad0981586945ee$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $17ad0981586945ee$export$f823b3589f69d3b8(e) {
    return $17ad0981586945ee$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $17ad0981586945ee$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $17ad0981586945ee$export$d92e2830aca1d816 extends $17ad0981586945ee$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $17ad0981586945ee$export$d92e2830aca1d816(e, t, n);
    }
    _apply(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $17ad0981586945ee$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
            return new $17ad0981586945ee$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
        }(e._query, t));
    }
}
function $17ad0981586945ee$export$859941c5fc8eba6b(...e) {
    return $17ad0981586945ee$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $17ad0981586945ee$export$dd8dee5f7b804673(...e) {
    return $17ad0981586945ee$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $17ad0981586945ee$export$fd1782fd870d1e06 extends $17ad0981586945ee$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ e, t, n){
        super(), this.type = e, this._docOrFields = t, this._inclusive = n;
    }
    static _create(e, t, n) {
        return new $17ad0981586945ee$export$fd1782fd870d1e06(e, t, n);
    }
    _apply(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
        return new $17ad0981586945ee$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
            return new $17ad0981586945ee$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
        }(e._query, t));
    }
}
function $17ad0981586945ee$export$57203950645b8b11(...e) {
    return $17ad0981586945ee$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $17ad0981586945ee$export$28ec54a8428bdb3f(...e) {
    return $17ad0981586945ee$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $17ad0981586945ee$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $2xDiJ.getModularInstance)(n[0]), n[0] instanceof $17ad0981586945ee$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const s = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $17ad0981586945ee$var$__PRIVATE_queryOrderBy(e))if (n.field.isKeyField()) s.push($17ad0981586945ee$var$__PRIVATE_refValue(t, r.key));
        else {
            const e = r.data.field(n.field);
            if ($17ad0981586945ee$var$__PRIVATE_isServerTimestamp(e)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === e) {
                const e = n.field.canonicalString();
                throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${e}' (used as the orderBy) does not exist.`);
            }
            s.push(e);
        }
        return new $17ad0981586945ee$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        const i = $17ad0981586945ee$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            const o = e.explicitOrderBy;
            if (i.length > o.length) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const _ = [];
            for(let s = 0; s < i.length; s++){
                const a = i[s];
                if (o[s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof a}`);
                    if (!$17ad0981586945ee$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${a}' contains a slash.`);
                    const n = e.path.child($17ad0981586945ee$var$ResourcePath.fromString(a));
                    if (!$17ad0981586945ee$export$afc2e57c475b7810.isDocumentKey(n)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $17ad0981586945ee$export$afc2e57c475b7810(n);
                    _.push($17ad0981586945ee$var$__PRIVATE_refValue(t, i));
                } else {
                    const e = $17ad0981586945ee$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(e);
                }
            }
            return new $17ad0981586945ee$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $17ad0981586945ee$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $2xDiJ.getModularInstance)(n))) {
        if ("" === n) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$17ad0981586945ee$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = t.path.child($17ad0981586945ee$var$ResourcePath.fromString(n));
        if (!$17ad0981586945ee$export$afc2e57c475b7810.isDocumentKey(r)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return $17ad0981586945ee$var$__PRIVATE_refValue(e, new $17ad0981586945ee$export$afc2e57c475b7810(r));
    }
    if (n instanceof $17ad0981586945ee$export$6be62b059fb12175) return $17ad0981586945ee$var$__PRIVATE_refValue(e, n._key);
    throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$17ad0981586945ee$var$__PRIVATE_valueDescription(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $17ad0981586945ee$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${t.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $17ad0981586945ee$var$__PRIVATE_validateNewFieldFilter(e, t) {
    if (t.isInequality()) {
        const n = $17ad0981586945ee$var$__PRIVATE_getInequalityFilterField(e), r = t.field;
        if (null !== n && !n.isEqual(r)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. All where filters with an inequality (<, <=, !=, not-in, >, or >=) must be on the same field. But you have inequality filters on '${n.toString()}' and '${r.toString()}'`);
        const i = $17ad0981586945ee$var$__PRIVATE_getFirstOrderByField(e);
        null !== i && $17ad0981586945ee$var$__PRIVATE_validateOrderByAndInequalityMatch(e, r, i);
    }
    const n = function __PRIVATE_findOpInsideFilters(e, t) {
        for (const n of e)for (const e of n.getFlattenedFilters())if (t.indexOf(e.op) >= 0) return e.op;
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === t.op ? new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${t.op.toString()}' filter.`) : new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. You cannot use '${t.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $17ad0981586945ee$var$__PRIVATE_validateOrderByAndInequalityMatch(e, t, n) {
    if (!n.isEqual(t)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Invalid query. You have a where filter with an inequality (<, <=, !=, not-in, >, or >=) on field '${t.toString()}' and so you must also use '${t.toString()}' as your first argument to orderBy(), but your first orderBy() is on field '${n.toString()}' instead.`);
}
function $17ad0981586945ee$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $17ad0981586945ee$export$f765fc5789dfd439 || t instanceof $17ad0981586945ee$export$6bbc7aef0717f3d2)) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, `Function ${e}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $17ad0981586945ee$export$2cd31cfe6f6866e9 {
    convertValue(e, t = "none") {
        switch($17ad0981586945ee$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($17ad0981586945ee$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 10 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            default:
                throw $17ad0981586945ee$var$fail();
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $17ad0981586945ee$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    convertGeoPoint(e) {
        return new $17ad0981586945ee$export$f9f719d1b6419c4($17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.latitude), $17ad0981586945ee$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $17ad0981586945ee$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($17ad0981586945ee$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_normalizeTimestamp(e);
        return new $17ad0981586945ee$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $17ad0981586945ee$var$ResourcePath.fromString(e);
        $17ad0981586945ee$var$__PRIVATE_hardAssert($17ad0981586945ee$var$__PRIVATE_isValidResourceName(n));
        const r = new $17ad0981586945ee$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $17ad0981586945ee$export$afc2e57c475b7810(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $17ad0981586945ee$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $17ad0981586945ee$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
class $17ad0981586945ee$var$__PRIVATE_LiteUserDataWriter extends $17ad0981586945ee$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $17ad0981586945ee$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $17ad0981586945ee$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 * @internal TODO (sum/avg) remove when public
 */ function $17ad0981586945ee$export$8a63f25cc62965f1(e) {
    return new $17ad0981586945ee$export$fada2345be8928cf("sum", $17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 * @internal TODO (sum/avg) remove when public
 */ function $17ad0981586945ee$export$cc6710ee5f037d57(e) {
    return new $17ad0981586945ee$export$fada2345be8928cf("avg", $17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 * @internal TODO (sum/avg) remove when public
 */ function $17ad0981586945ee$export$85b9a36db797e02b() {
    return new $17ad0981586945ee$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 * @internal TODO (sum/avg) remove when public
 */ function $17ad0981586945ee$export$31fa8ec66e0239ad(e, t) {
    var n, r;
    return e instanceof $17ad0981586945ee$export$fada2345be8928cf && t instanceof $17ad0981586945ee$export$fada2345be8928cf && e._aggregateType === t._aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $17ad0981586945ee$export$104f59389a332076(e, t) {
    return $17ad0981586945ee$export$49b1d0de6ba30f41(e.query, t.query) && (0, $2xDiJ.deepEqual)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $17ad0981586945ee$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(e, t){
        this.hasPendingWrites = e, this.fromCache = t;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(e) {
        return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $17ad0981586945ee$export$acab0e6ef25eb301 extends $17ad0981586945ee$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(e, t, n, r, i, s){
        super(e, t, n, r, s), this._firestore = e, this._firestoreImpl = e, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(e = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $17ad0981586945ee$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(t, e);
            }
            return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(e, t = {}) {
        if (this._document) {
            const n = this._document.data.field($17ad0981586945ee$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
            if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $17ad0981586945ee$export$6d4d04e42af6b03c extends $17ad0981586945ee$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(e = {}) {
        return super.data(e);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $17ad0981586945ee$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $17ad0981586945ee$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const e = [];
        return this.forEach((t)=>e.push(t)), e;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(e, t) {
        this._snapshot.docs.forEach((n)=>{
            e.call(t, new $17ad0981586945ee$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $17ad0981586945ee$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(e = {}) {
        const t = !!e.includeMetadataChanges;
        if (t && this._snapshot.excludesMetadataChanges) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
            if (e._snapshot.oldDocs.isEmpty()) {
                let t = 0;
                return e._snapshot.docChanges.map((n)=>{
                    const r = new $17ad0981586945ee$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $17ad0981586945ee$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: t++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = e._snapshot.oldDocs;
                return e._snapshot.docChanges.filter((e)=>t || 3 /* ChangeType.Metadata */  !== e.type).map((t)=>{
                    const r = new $17ad0981586945ee$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $17ad0981586945ee$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                    let i = -1, s = -1;
                    return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                        type: $17ad0981586945ee$var$__PRIVATE_resultChangeType(t.type),
                        doc: r,
                        oldIndex: i,
                        newIndex: s
                    };
                });
            }
        }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
    }
}
function $17ad0981586945ee$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $17ad0981586945ee$var$fail();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $17ad0981586945ee$export$f243a5d948512846(e, t) {
    return e instanceof $17ad0981586945ee$export$acab0e6ef25eb301 && t instanceof $17ad0981586945ee$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $17ad0981586945ee$export$8f21149d8133945c && t instanceof $17ad0981586945ee$export$8f21149d8133945c && e._firestore === t._firestore && $17ad0981586945ee$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $17ad0981586945ee$export$11eb3b5ef9574821(e) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$6be62b059fb12175);
    const t = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82);
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($17ad0981586945ee$export$8da5fbea04405656(t), e._key).then((n)=>$17ad0981586945ee$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
class $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter extends $17ad0981586945ee$export$2cd31cfe6f6866e9 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $17ad0981586945ee$export$9f55f2e2bf8c2fc1(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $17ad0981586945ee$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $17ad0981586945ee$export$a58bd92642f7fb58(e) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$6be62b059fb12175);
    const t = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), n = $17ad0981586945ee$export$8da5fbea04405656(t), r = new $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter(t);
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then((n)=>new $17ad0981586945ee$export$acab0e6ef25eb301(t, r, e._key, n, new $17ad0981586945ee$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $17ad0981586945ee$export$35dd759aed9686b4(e) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$6be62b059fb12175);
    const t = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82);
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($17ad0981586945ee$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then((n)=>$17ad0981586945ee$var$__PRIVATE_convertToDocSnapshot(t, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $17ad0981586945ee$export$81d3477bd73c86ef(e) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$62297b13309008b2);
    const t = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), n = $17ad0981586945ee$export$8da5fbea04405656(t), r = new $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter(t);
    return $17ad0981586945ee$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then((n)=>new $17ad0981586945ee$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $17ad0981586945ee$export$3fd010f18eac1dd(e) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$62297b13309008b2);
    const t = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), n = $17ad0981586945ee$export$8da5fbea04405656(t), r = new $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter(t);
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then((n)=>new $17ad0981586945ee$export$8f21149d8133945c(t, r, e, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $17ad0981586945ee$export$ec7d9e44f349c77b(e) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$62297b13309008b2);
    const t = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), n = $17ad0981586945ee$export$8da5fbea04405656(t), r = new $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter(t);
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then((n)=>new $17ad0981586945ee$export$8f21149d8133945c(t, r, e, n));
}
function $17ad0981586945ee$export$5ff77ddaff3c9e12(e, t, n) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$6be62b059fb12175);
    const r = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), i = $17ad0981586945ee$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $17ad0981586945ee$export$1945f8fec9dda613(r, [
        $17ad0981586945ee$var$__PRIVATE_parseSetData($17ad0981586945ee$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $17ad0981586945ee$var$Precondition.none())
    ]);
}
function $17ad0981586945ee$export$22d1fdd1e73faff2(e, t, n, ...r) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$6be62b059fb12175);
    const i = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), s = $17ad0981586945ee$var$__PRIVATE_newUserDataReader(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $2xDiJ.getModularInstance)(t)) || t instanceof $17ad0981586945ee$export$a1a8fea822d17659 ? $17ad0981586945ee$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $17ad0981586945ee$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $17ad0981586945ee$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $17ad0981586945ee$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $17ad0981586945ee$export$a4f20481fae8f78b(e) {
    return $17ad0981586945ee$export$1945f8fec9dda613($17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), [
        new $17ad0981586945ee$var$__PRIVATE_DeleteMutation(e._key, $17ad0981586945ee$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $17ad0981586945ee$export$a13890143fb1c2dd(e, t) {
    const n = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), r = $17ad0981586945ee$export$2a111da947c407d2(e), i = $17ad0981586945ee$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $17ad0981586945ee$export$1945f8fec9dda613(n, [
        $17ad0981586945ee$var$__PRIVATE_parseSetData($17ad0981586945ee$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $17ad0981586945ee$var$Precondition.exists(!1))
    ]).then(()=>r);
}
function $17ad0981586945ee$export$d36370812fb26935(e, ...t) {
    var n, r, i;
    e = (0, $2xDiJ.getModularInstance)(e);
    let s = {
        includeMetadataChanges: !1
    }, o = 0;
    "object" != typeof t[o] || $17ad0981586945ee$var$__PRIVATE_isPartialObserver(t[o]) || (s = t[o], o++);
    const _ = {
        includeMetadataChanges: s.includeMetadataChanges
    };
    if ($17ad0981586945ee$var$__PRIVATE_isPartialObserver(t[o])) {
        const e = t[o];
        t[o] = null === (n = e.next) || void 0 === n ? void 0 : n.bind(e), t[o + 1] = null === (r = e.error) || void 0 === r ? void 0 : r.bind(e), t[o + 2] = null === (i = e.complete) || void 0 === i ? void 0 : i.bind(e);
    }
    let a, u, c;
    if (e instanceof $17ad0981586945ee$export$6be62b059fb12175) u = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), c = $17ad0981586945ee$var$__PRIVATE_newQueryForPath(e._key.path), a = {
        next: (n)=>{
            t[o] && t[o]($17ad0981586945ee$var$__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        const n = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$62297b13309008b2);
        u = $17ad0981586945ee$export$572106fb5803752c(n.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), c = n._query;
        const r = new $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter(u);
        a = {
            next: (e)=>{
                t[o] && t[o](new $17ad0981586945ee$export$8f21149d8133945c(u, r, n, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, $17ad0981586945ee$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        const i = new $17ad0981586945ee$var$__PRIVATE_AsyncObserver(r), s = new $17ad0981586945ee$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(async ()=>$17ad0981586945ee$var$__PRIVATE_eventManagerListen(await $17ad0981586945ee$var$__PRIVATE_getEventManager(e), s)), ()=>{
            i.Ca(), e.asyncQueue.enqueueAndForget(async ()=>$17ad0981586945ee$var$__PRIVATE_eventManagerUnlisten(await $17ad0981586945ee$var$__PRIVATE_getEventManager(e), s));
        };
    }($17ad0981586945ee$export$8da5fbea04405656(u), c, _, a);
}
function $17ad0981586945ee$export$9dff4f5aba83e348(e, t) {
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($17ad0981586945ee$export$8da5fbea04405656(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82)), $17ad0981586945ee$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $17ad0981586945ee$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        const n = new $17ad0981586945ee$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$17ad0981586945ee$var$__PRIVATE_syncEngineWrite(await $17ad0981586945ee$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
    }($17ad0981586945ee$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $17ad0981586945ee$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    const r = n.docs.get(t._key), i = new $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter(e);
    return new $17ad0981586945ee$export$acab0e6ef25eb301(e, i, t._key, r, new $17ad0981586945ee$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query,
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can even
 * count the documents if the result set would be prohibitively large to
 * download entirely (e.g. thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used: every request using this source necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size to calculate.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $17ad0981586945ee$export$b1de1b12889d0afb(e) {
    return $17ad0981586945ee$export$a51511de2fae49b3(e, {
        count: $17ad0981586945ee$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query, without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, is downloaded. This
 * function can even perform aggregations of the documents if the result set
 * would be prohibitively large to download entirely (e.g. thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used: every request using this source necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set to aggregate over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 * @internal TODO (sum/avg) remove when public
 */ function $17ad0981586945ee$export$a51511de2fae49b3(e, t) {
    const n = $17ad0981586945ee$export$572106fb5803752c(e.firestore, $17ad0981586945ee$export$d0e2b3272814ce82), r = $17ad0981586945ee$export$8da5fbea04405656(n), i = function __PRIVATE_mapToArray(e, t) {
        const n = [];
        for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
        return n;
    }(t, (e, t)=>new $17ad0981586945ee$var$__PRIVATE_AggregateImpl(t, e._aggregateType, e._internalFieldPath));
    // Run the aggregation and convert the results
    return (function __PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
        const r = new $17ad0981586945ee$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            // TODO (sum/avg) should we update this to use the event manager?
            // Implement and call executeAggregateQueryViaSnapshotListener, similar
            // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
            // above
            try {
                // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
                const i = await $17ad0981586945ee$var$__PRIVATE_getDatastore(e);
                r.resolve($17ad0981586945ee$var$__PRIVATE_invokeRunAggregationQueryRpc(i, t, n));
            } catch (e) {
                r.reject(e);
            }
        }), r.promise;
    })(r, e._query, i).then((t)=>/**
 * Converts the core aggregration result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            const r = new $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter(e);
            return new $17ad0981586945ee$export$40257fef64be808b(t, r, n);
        })(n, e, t));
}
class $17ad0981586945ee$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(e){
        this.kind = "memory", this._onlineComponentProvider = new $17ad0981586945ee$var$OnlineComponentProvider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = new $17ad0981586945ee$var$MemoryOfflineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $17ad0981586945ee$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(e){
        let t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $17ad0981586945ee$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $17ad0981586945ee$var$__PRIVATE_MemoryEagerGabageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = new $17ad0981586945ee$var$MemoryOfflineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $17ad0981586945ee$var$__PRIVATE_MemoryLruGabageCollectorImpl {
    constructor(e){
        this.kind = "memoryLru", this._offlineComponentProvider = new $17ad0981586945ee$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e);
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $17ad0981586945ee$export$574728f3be606189() {
    return new $17ad0981586945ee$var$__PRIVATE_MemoryEagerGabageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $17ad0981586945ee$export$2340f88905cc0c23(e) {
    return new $17ad0981586945ee$var$__PRIVATE_MemoryLruGabageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $17ad0981586945ee$export$72ef71adb739a32c(e) {
    return new $17ad0981586945ee$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $17ad0981586945ee$export$51b321e43d5331d5(e) {
    return new $17ad0981586945ee$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
class $17ad0981586945ee$var$__PRIVATE_SingleTabManagerImpl {
    constructor(e){
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = new $17ad0981586945ee$var$OnlineComponentProvider, this._offlineComponentProvider = new $17ad0981586945ee$var$__PRIVATE_IndexedDbOfflineComponentProvider(this._onlineComponentProvider, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership);
    }
}
class $17ad0981586945ee$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(e) {
        this._onlineComponentProvider = new $17ad0981586945ee$var$OnlineComponentProvider, this._offlineComponentProvider = new $17ad0981586945ee$var$__PRIVATE_MultiTabOfflineComponentProvider(this._onlineComponentProvider, null == e ? void 0 : e.cacheSizeBytes);
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $17ad0981586945ee$export$d5f96a3c009e86ac(e) {
    return new $17ad0981586945ee$var$__PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $17ad0981586945ee$export$57e9d290b0b4dc04() {
    return new $17ad0981586945ee$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $17ad0981586945ee$var$we = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $17ad0981586945ee$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $17ad0981586945ee$var$__PRIVATE_newUserDataReader(e);
    }
    set(e, t, n) {
        this._verifyNotCommitted();
        const r = $17ad0981586945ee$var$__PRIVATE_validateReference(e, this._firestore), i = $17ad0981586945ee$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $17ad0981586945ee$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
        return this._mutations.push(s.toMutation(r._key, $17ad0981586945ee$var$Precondition.none())), this;
    }
    update(e, t, n, ...r) {
        this._verifyNotCommitted();
        const i = $17ad0981586945ee$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $2xDiJ.getModularInstance)(t)) || t instanceof $17ad0981586945ee$export$a1a8fea822d17659 ? $17ad0981586945ee$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $17ad0981586945ee$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $17ad0981586945ee$var$Precondition.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(e) {
        this._verifyNotCommitted();
        const t = $17ad0981586945ee$var$__PRIVATE_validateReference(e, this._firestore);
        return this._mutations = this._mutations.concat(new $17ad0981586945ee$var$__PRIVATE_DeleteMutation(t._key, $17ad0981586945ee$var$Precondition.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $17ad0981586945ee$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $2xDiJ.getModularInstance)(e)).firestore !== t) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $17ad0981586945ee$export$febc5573c75cefb0 extends class Transaction$1 {
    /** @hideconstructor */ constructor(e, t){
        this._firestore = e, this._transaction = t, this._dataReader = $17ad0981586945ee$var$__PRIVATE_newUserDataReader(e);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_validateReference(e, this._firestore), n = new $17ad0981586945ee$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            t._key
        ]).then((e)=>{
            if (!e || 1 !== e.length) return $17ad0981586945ee$var$fail();
            const r = e[0];
            if (r.isFoundDocument()) return new $17ad0981586945ee$var$DocumentSnapshot$1(this._firestore, n, r.key, r, t.converter);
            if (r.isNoDocument()) return new $17ad0981586945ee$var$DocumentSnapshot$1(this._firestore, n, t._key, null, t.converter);
            throw $17ad0981586945ee$var$fail();
        });
    }
    set(e, t, n) {
        const r = $17ad0981586945ee$var$__PRIVATE_validateReference(e, this._firestore), i = $17ad0981586945ee$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $17ad0981586945ee$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
        return this._transaction.set(r._key, s), this;
    }
    update(e, t, n, ...r) {
        const i = $17ad0981586945ee$var$__PRIVATE_validateReference(e, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let s;
        return s = "string" == typeof (t = (0, $2xDiJ.getModularInstance)(t)) || t instanceof $17ad0981586945ee$export$a1a8fea822d17659 ? $17ad0981586945ee$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $17ad0981586945ee$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_validateReference(e, this._firestore);
        return this._transaction.delete(t._key), this;
    }
} {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(e, t){
        super(e, t), this._firestore = e;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(e) {
        const t = $17ad0981586945ee$var$__PRIVATE_validateReference(e, this._firestore), n = new $17ad0981586945ee$var$__PRIVATE_ExpUserDataWriter(this._firestore);
        return super.get(e).then((e)=>new $17ad0981586945ee$export$acab0e6ef25eb301(this._firestore, n, t._key, e._document, new $17ad0981586945ee$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $17ad0981586945ee$export$3c54e006bf9c93b7(e, t, n) {
    e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82);
    const r = Object.assign(Object.assign({}, $17ad0981586945ee$var$we), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        const r = new $17ad0981586945ee$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $17ad0981586945ee$var$__PRIVATE_getDatastore(e);
            new $17ad0981586945ee$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).run();
        }), r.promise;
    }($17ad0981586945ee$export$8da5fbea04405656(e), (n)=>t(new $17ad0981586945ee$export$febc5573c75cefb0(e, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $17ad0981586945ee$export$2bbad96c62fdba3e() {
    return new $17ad0981586945ee$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $17ad0981586945ee$export$3ff8e7e00c3264b7() {
    return new $17ad0981586945ee$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $17ad0981586945ee$export$f62af892fd92610c(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $17ad0981586945ee$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $17ad0981586945ee$export$30a014203d0d7e4f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $17ad0981586945ee$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $17ad0981586945ee$export$a2647aa13413c947(e) {
    return new $17ad0981586945ee$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $17ad0981586945ee$export$44cd1c9d57edd9b1(e) {
    return $17ad0981586945ee$export$8da5fbea04405656(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82)), new $17ad0981586945ee$export$d94ed661b1cfd435(e, (t)=>$17ad0981586945ee$export$1945f8fec9dda613(e, t));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $17ad0981586945ee$export$ff1663c0c1304f1a(e, t) {
    var n;
    const r = $17ad0981586945ee$export$8da5fbea04405656(e = $17ad0981586945ee$export$572106fb5803752c(e, $17ad0981586945ee$export$d0e2b3272814ce82));
    if (!r._uninitializedComponentsProvider || "memory" === (null === (n = r._uninitializedComponentsProvider) || void 0 === n ? void 0 : n._offlineKind)) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $17ad0981586945ee$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const i = function __PRIVATE_parseIndexes(e) {
        const t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        if (Array.isArray(t.indexes)) for (const e of t.indexes){
            const t = $17ad0981586945ee$var$__PRIVATE_tryGetString(e, "collectionGroup"), r = [];
            if (Array.isArray(e.fields)) for (const t of e.fields){
                const e = $17ad0981586945ee$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $17ad0981586945ee$var$__PRIVATE_tryGetString(t, "fieldPath"));
                "CONTAINS" === t.arrayConfig ? r.push(new $17ad0981586945ee$var$IndexSegment(e, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === t.order ? r.push(new $17ad0981586945ee$var$IndexSegment(e, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === t.order && r.push(new $17ad0981586945ee$var$IndexSegment(e, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $17ad0981586945ee$var$FieldIndex($17ad0981586945ee$var$FieldIndex.UNKNOWN_ID, t, r, $17ad0981586945ee$var$IndexState.empty()));
        }
        return n;
    }(t);
    return $17ad0981586945ee$var$__PRIVATE_firestoreClientSetIndexConfiguration(r, i);
}
function $17ad0981586945ee$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e, t = !0) {
    !function __PRIVATE_setSDKVersion(e) {
        $17ad0981586945ee$var$b = e;
    }((0, $MjY8E.SDK_VERSION)), (0, $MjY8E._registerComponent)(new (0, $6ExWU.Component)("firestore", (e, { instanceIdentifier: n, options: r })=>{
        const i = e.getProvider("app").getImmediate(), s = new $17ad0981586945ee$export$d0e2b3272814ce82(new $17ad0981586945ee$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $17ad0981586945ee$var$__PRIVATE_FirebaseAppCheckTokenProvider(e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $17ad0981586945ee$export$8fada0bf726bf278($17ad0981586945ee$var$v.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $17ad0981586945ee$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $MjY8E.registerVersion)($17ad0981586945ee$var$S, "4.1.0", e), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $MjY8E.registerVersion)($17ad0981586945ee$var$S, "4.1.0", "esm2017");
}();

});
parcelRequire.register("aSES4", function(module, exports) {

$parcel$export(module.exports, "createWebChannelTransport", function () { return $7ebea6b2d35970b2$export$66869136fc133c3a; });
$parcel$export(module.exports, "getStatEventTarget", function () { return $7ebea6b2d35970b2$export$888d0d9ab79d08fc; });
$parcel$export(module.exports, "ErrorCode", function () { return $7ebea6b2d35970b2$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "EventType", function () { return $7ebea6b2d35970b2$export$3d7865934588d77e; });
$parcel$export(module.exports, "Event", function () { return $7ebea6b2d35970b2$export$d61e24a684f9e51; });
$parcel$export(module.exports, "Stat", function () { return $7ebea6b2d35970b2$export$cbbc350c1dfc80cb; });
$parcel$export(module.exports, "FetchXmlHttpFactory", function () { return $7ebea6b2d35970b2$export$ddb1030448106742; });
$parcel$export(module.exports, "WebChannel", function () { return $7ebea6b2d35970b2$export$aa726fb96ad3e039; });
$parcel$export(module.exports, "XhrIo", function () { return $7ebea6b2d35970b2$export$26404658cda3ee02; });
$parcel$export(module.exports, "Md5", function () { return $7ebea6b2d35970b2$export$9f5a3dfc7a9f5dd; });
$parcel$export(module.exports, "Integer", function () { return $7ebea6b2d35970b2$export$70ffa26850098d01; });
var $7ebea6b2d35970b2$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $7ebea6b2d35970b2$export$2e2bcd8739ae039 = {};
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $7ebea6b2d35970b2$var$k, $7ebea6b2d35970b2$var$goog = $7ebea6b2d35970b2$var$goog || {}, $7ebea6b2d35970b2$var$l = $7ebea6b2d35970b2$var$commonjsGlobal || self;
function $7ebea6b2d35970b2$var$aa(a) {
    var b = typeof a;
    b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $7ebea6b2d35970b2$var$p(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $7ebea6b2d35970b2$var$ba(a) {
    return Object.prototype.hasOwnProperty.call(a, $7ebea6b2d35970b2$var$ca) && a[$7ebea6b2d35970b2$var$ca] || (a[$7ebea6b2d35970b2$var$ca] = ++$7ebea6b2d35970b2$var$da);
}
var $7ebea6b2d35970b2$var$ca = "closure_uid_" + (1E9 * Math.random() >>> 0), $7ebea6b2d35970b2$var$da = 0;
function $7ebea6b2d35970b2$var$ea(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $7ebea6b2d35970b2$var$fa(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $7ebea6b2d35970b2$var$q(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $7ebea6b2d35970b2$var$q = $7ebea6b2d35970b2$var$ea : $7ebea6b2d35970b2$var$q = $7ebea6b2d35970b2$var$fa;
    return $7ebea6b2d35970b2$var$q.apply(null, arguments);
}
function $7ebea6b2d35970b2$var$ha(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
function $7ebea6b2d35970b2$var$r(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.$ = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.ac = function(d, e, f) {
        for(var h = Array(arguments.length - 2), n = 2; n < arguments.length; n++)h[n - 2] = arguments[n];
        return b.prototype[e].apply(d, h);
    };
}
function $7ebea6b2d35970b2$var$v() {
    this.s = this.s;
    this.o = this.o;
}
var $7ebea6b2d35970b2$var$ia = 0;
$7ebea6b2d35970b2$var$v.prototype.s = !1;
$7ebea6b2d35970b2$var$v.prototype.sa = function() {
    if (!this.s && (this.s = !0, this.N(), 0 != $7ebea6b2d35970b2$var$ia)) $7ebea6b2d35970b2$var$ba(this);
};
$7ebea6b2d35970b2$var$v.prototype.N = function() {
    if (this.o) for(; this.o.length;)this.o.shift()();
};
const $7ebea6b2d35970b2$var$ka = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(let c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
};
function $7ebea6b2d35970b2$var$ma(a) {
    const b = a.length;
    if (0 < b) {
        const c = Array(b);
        for(let d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $7ebea6b2d35970b2$var$na(a, b) {
    for(let c = 1; c < arguments.length; c++){
        const d = arguments[c];
        if ($7ebea6b2d35970b2$var$aa(d)) {
            const e = a.length || 0, f = d.length || 0;
            a.length = e + f;
            for(let h = 0; h < f; h++)a[e + h] = d[h];
        } else a.push(d);
    }
}
function $7ebea6b2d35970b2$var$w(a, b) {
    this.type = a;
    this.g = this.target = b;
    this.defaultPrevented = !1;
}
$7ebea6b2d35970b2$var$w.prototype.h = function() {
    this.defaultPrevented = !0;
};
var $7ebea6b2d35970b2$var$oa = function() {
    if (!$7ebea6b2d35970b2$var$l.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $7ebea6b2d35970b2$var$l.addEventListener("test", ()=>{}, b), $7ebea6b2d35970b2$var$l.removeEventListener("test", ()=>{}, b);
    } catch (c) {}
    return a;
}();
function $7ebea6b2d35970b2$var$x(a) {
    return /^[\s\xa0]*$/.test(a);
}
function $7ebea6b2d35970b2$var$pa() {
    var a = $7ebea6b2d35970b2$var$l.navigator;
    return a && (a = a.userAgent) ? a : "";
}
function $7ebea6b2d35970b2$var$y(a) {
    return -1 != $7ebea6b2d35970b2$var$pa().indexOf(a);
}
function $7ebea6b2d35970b2$var$qa(a) {
    $7ebea6b2d35970b2$var$qa[" "](a);
    return a;
}
$7ebea6b2d35970b2$var$qa[" "] = function() {};
function $7ebea6b2d35970b2$var$ra(a, b) {
    var c = $7ebea6b2d35970b2$var$sa;
    return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
}
var $7ebea6b2d35970b2$var$ta = $7ebea6b2d35970b2$var$y("Opera"), $7ebea6b2d35970b2$var$z = $7ebea6b2d35970b2$var$y("Trident") || $7ebea6b2d35970b2$var$y("MSIE"), $7ebea6b2d35970b2$var$ua = $7ebea6b2d35970b2$var$y("Edge"), $7ebea6b2d35970b2$var$va = $7ebea6b2d35970b2$var$ua || $7ebea6b2d35970b2$var$z, $7ebea6b2d35970b2$var$wa = $7ebea6b2d35970b2$var$y("Gecko") && !(-1 != $7ebea6b2d35970b2$var$pa().toLowerCase().indexOf("webkit") && !$7ebea6b2d35970b2$var$y("Edge")) && !($7ebea6b2d35970b2$var$y("Trident") || $7ebea6b2d35970b2$var$y("MSIE")) && !$7ebea6b2d35970b2$var$y("Edge"), $7ebea6b2d35970b2$var$xa = -1 != $7ebea6b2d35970b2$var$pa().toLowerCase().indexOf("webkit") && !$7ebea6b2d35970b2$var$y("Edge");
function $7ebea6b2d35970b2$var$ya() {
    var a = $7ebea6b2d35970b2$var$l.document;
    return a ? a.documentMode : void 0;
}
var $7ebea6b2d35970b2$var$za;
a: {
    var $7ebea6b2d35970b2$var$Aa = "", $7ebea6b2d35970b2$var$Ba = function() {
        var a = $7ebea6b2d35970b2$var$pa();
        if ($7ebea6b2d35970b2$var$wa) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($7ebea6b2d35970b2$var$ua) return /Edge\/([\d\.]+)/.exec(a);
        if ($7ebea6b2d35970b2$var$z) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($7ebea6b2d35970b2$var$xa) return /WebKit\/(\S+)/.exec(a);
        if ($7ebea6b2d35970b2$var$ta) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $7ebea6b2d35970b2$var$Ba && ($7ebea6b2d35970b2$var$Aa = $7ebea6b2d35970b2$var$Ba ? $7ebea6b2d35970b2$var$Ba[1] : "");
    if ($7ebea6b2d35970b2$var$z) {
        var $7ebea6b2d35970b2$var$Ca = $7ebea6b2d35970b2$var$ya();
        if (null != $7ebea6b2d35970b2$var$Ca && $7ebea6b2d35970b2$var$Ca > parseFloat($7ebea6b2d35970b2$var$Aa)) {
            $7ebea6b2d35970b2$var$za = String($7ebea6b2d35970b2$var$Ca);
            break a;
        }
    }
    $7ebea6b2d35970b2$var$za = $7ebea6b2d35970b2$var$Aa;
}
var $7ebea6b2d35970b2$var$Da;
if ($7ebea6b2d35970b2$var$l.document && $7ebea6b2d35970b2$var$z) {
    var $7ebea6b2d35970b2$var$Ea = $7ebea6b2d35970b2$var$ya();
    $7ebea6b2d35970b2$var$Da = $7ebea6b2d35970b2$var$Ea ? $7ebea6b2d35970b2$var$Ea : parseInt($7ebea6b2d35970b2$var$za, 10) || void 0;
} else $7ebea6b2d35970b2$var$Da = void 0;
var $7ebea6b2d35970b2$var$Fa = $7ebea6b2d35970b2$var$Da;
function $7ebea6b2d35970b2$var$A(a, b) {
    $7ebea6b2d35970b2$var$w.call(this, a ? a.type : "");
    this.relatedTarget = this.g = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.state = null;
    this.pointerId = 0;
    this.pointerType = "";
    this.i = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        if (b = a.relatedTarget) {
            if ($7ebea6b2d35970b2$var$wa) {
                a: {
                    try {
                        $7ebea6b2d35970b2$var$qa(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $7ebea6b2d35970b2$var$Ga[a.pointerType] || "";
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && $7ebea6b2d35970b2$var$A.$.h.call(this);
    }
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$A, $7ebea6b2d35970b2$var$w);
var $7ebea6b2d35970b2$var$Ga = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$7ebea6b2d35970b2$var$A.prototype.h = function() {
    $7ebea6b2d35970b2$var$A.$.h.call(this);
    var a = this.i;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var $7ebea6b2d35970b2$var$Ha = "closure_listenable_" + (1E6 * Math.random() | 0);
var $7ebea6b2d35970b2$var$Ia = 0;
function $7ebea6b2d35970b2$var$Ja(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.la = e;
    this.key = ++$7ebea6b2d35970b2$var$Ia;
    this.fa = this.ia = !1;
}
function $7ebea6b2d35970b2$var$Ka(a) {
    a.fa = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.la = null;
}
function $7ebea6b2d35970b2$var$Na(a, b, c) {
    for(const d in a)b.call(c, a[d], d, a);
}
function $7ebea6b2d35970b2$var$Oa(a, b) {
    for(const c in a)b.call(void 0, a[c], c, a);
}
function $7ebea6b2d35970b2$var$Pa(a) {
    const b = {};
    for(const c in a)b[c] = a[c];
    return b;
}
const $7ebea6b2d35970b2$var$Qa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $7ebea6b2d35970b2$var$Ra(a, b) {
    let c, d;
    for(let e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(let f = 0; f < $7ebea6b2d35970b2$var$Qa.length; f++)c = $7ebea6b2d35970b2$var$Qa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $7ebea6b2d35970b2$var$Sa(a) {
    this.src = a;
    this.g = {};
    this.h = 0;
}
$7ebea6b2d35970b2$var$Sa.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.g[f];
    a || (a = this.g[f] = [], this.h++);
    var h = $7ebea6b2d35970b2$var$Ta(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.ia = !1)) : (b = new $7ebea6b2d35970b2$var$Ja(b, this.src, f, !!d, e), b.ia = c, a.push(b));
    return b;
};
function $7ebea6b2d35970b2$var$Ua(a, b) {
    var c = b.type;
    if (c in a.g) {
        var d = a.g[c], e = $7ebea6b2d35970b2$var$ka(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($7ebea6b2d35970b2$var$Ka(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
    }
}
function $7ebea6b2d35970b2$var$Ta(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.fa && f.listener == b && f.capture == !!c && f.la == d) return e;
    }
    return -1;
}
var $7ebea6b2d35970b2$var$Va = "closure_lm_" + (1E6 * Math.random() | 0), $7ebea6b2d35970b2$var$Wa = {};
function $7ebea6b2d35970b2$var$Ya(a, b, c, d, e) {
    if (d && d.once) return $7ebea6b2d35970b2$var$Za(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$7ebea6b2d35970b2$var$Ya(a, b[f], c, d, e);
        return null;
    }
    c = $7ebea6b2d35970b2$var$$a(c);
    return a && a[$7ebea6b2d35970b2$var$Ha] ? a.O(b, c, $7ebea6b2d35970b2$var$p(d) ? !!d.capture : !!d, e) : $7ebea6b2d35970b2$var$ab(a, b, c, !1, d, e);
}
function $7ebea6b2d35970b2$var$ab(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $7ebea6b2d35970b2$var$p(e) ? !!e.capture : !!e, n = $7ebea6b2d35970b2$var$bb(a);
    n || (a[$7ebea6b2d35970b2$var$Va] = n = new $7ebea6b2d35970b2$var$Sa(a));
    c = n.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $7ebea6b2d35970b2$var$cb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $7ebea6b2d35970b2$var$oa || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($7ebea6b2d35970b2$var$db(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $7ebea6b2d35970b2$var$cb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    const b = $7ebea6b2d35970b2$var$eb;
    return a;
}
function $7ebea6b2d35970b2$var$Za(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$7ebea6b2d35970b2$var$Za(a, b[f], c, d, e);
        return null;
    }
    c = $7ebea6b2d35970b2$var$$a(c);
    return a && a[$7ebea6b2d35970b2$var$Ha] ? a.P(b, c, $7ebea6b2d35970b2$var$p(d) ? !!d.capture : !!d, e) : $7ebea6b2d35970b2$var$ab(a, b, c, !0, d, e);
}
function $7ebea6b2d35970b2$var$fb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$7ebea6b2d35970b2$var$fb(a, b[f], c, d, e);
    else (d = $7ebea6b2d35970b2$var$p(d) ? !!d.capture : !!d, c = $7ebea6b2d35970b2$var$$a(c), a && a[$7ebea6b2d35970b2$var$Ha]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = $7ebea6b2d35970b2$var$Ta(f, c, d, e), -1 < c && ($7ebea6b2d35970b2$var$Ka(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = $7ebea6b2d35970b2$var$bb(a)) && (b = a.g[b.toString()], a = -1, b && (a = $7ebea6b2d35970b2$var$Ta(b, c, d, e)), (c = -1 < a ? b[a] : null) && $7ebea6b2d35970b2$var$gb(c));
}
function $7ebea6b2d35970b2$var$gb(a) {
    if ("number" !== typeof a && a && !a.fa) {
        var b = a.src;
        if (b && b[$7ebea6b2d35970b2$var$Ha]) $7ebea6b2d35970b2$var$Ua(b.i, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($7ebea6b2d35970b2$var$db(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $7ebea6b2d35970b2$var$bb(b)) ? ($7ebea6b2d35970b2$var$Ua(c, a), 0 == c.h && (c.src = null, b[$7ebea6b2d35970b2$var$Va] = null)) : $7ebea6b2d35970b2$var$Ka(a);
        }
    }
}
function $7ebea6b2d35970b2$var$db(a) {
    return a in $7ebea6b2d35970b2$var$Wa ? $7ebea6b2d35970b2$var$Wa[a] : $7ebea6b2d35970b2$var$Wa[a] = "on" + a;
}
function $7ebea6b2d35970b2$var$eb(a, b) {
    if (a.fa) a = !0;
    else {
        b = new $7ebea6b2d35970b2$var$A(b, this);
        var c = a.listener, d = a.la || a.src;
        a.ia && $7ebea6b2d35970b2$var$gb(a);
        a = c.call(d, b);
    }
    return a;
}
function $7ebea6b2d35970b2$var$bb(a) {
    a = a[$7ebea6b2d35970b2$var$Va];
    return a instanceof $7ebea6b2d35970b2$var$Sa ? a : null;
}
var $7ebea6b2d35970b2$var$hb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $7ebea6b2d35970b2$var$$a(a) {
    if ("function" === typeof a) return a;
    a[$7ebea6b2d35970b2$var$hb] || (a[$7ebea6b2d35970b2$var$hb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$7ebea6b2d35970b2$var$hb];
}
function $7ebea6b2d35970b2$var$B() {
    $7ebea6b2d35970b2$var$v.call(this);
    this.i = new $7ebea6b2d35970b2$var$Sa(this);
    this.S = this;
    this.J = null;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$B, $7ebea6b2d35970b2$var$v);
$7ebea6b2d35970b2$var$B.prototype[$7ebea6b2d35970b2$var$Ha] = !0;
$7ebea6b2d35970b2$var$B.prototype.removeEventListener = function(a, b, c, d) {
    $7ebea6b2d35970b2$var$fb(this, a, b, c, d);
};
function $7ebea6b2d35970b2$var$C(a, b) {
    var c, d = a.J;
    if (d) for(c = []; d; d = d.J)c.push(d);
    a = a.S;
    d = b.type || b;
    if ("string" === typeof b) b = new $7ebea6b2d35970b2$var$w(b, a);
    else if (b instanceof $7ebea6b2d35970b2$var$w) b.target = b.target || a;
    else {
        var e = b;
        b = new $7ebea6b2d35970b2$var$w(d, a);
        $7ebea6b2d35970b2$var$Ra(b, e);
    }
    e = !0;
    if (c) for(var f = c.length - 1; 0 <= f; f--){
        var h = b.g = c[f];
        e = $7ebea6b2d35970b2$var$ib(h, d, !0, b) && e;
    }
    h = b.g = a;
    e = $7ebea6b2d35970b2$var$ib(h, d, !0, b) && e;
    e = $7ebea6b2d35970b2$var$ib(h, d, !1, b) && e;
    if (c) for(f = 0; f < c.length; f++)h = b.g = c[f], e = $7ebea6b2d35970b2$var$ib(h, d, !1, b) && e;
}
$7ebea6b2d35970b2$var$B.prototype.N = function() {
    $7ebea6b2d35970b2$var$B.$.N.call(this);
    if (this.i) {
        var a = this.i, c;
        for(c in a.g){
            for(var d = a.g[c], e = 0; e < d.length; e++)$7ebea6b2d35970b2$var$Ka(d[e]);
            delete a.g[c];
            a.h--;
        }
    }
    this.J = null;
};
$7ebea6b2d35970b2$var$B.prototype.O = function(a, b, c, d) {
    return this.i.add(String(a), b, !1, c, d);
};
$7ebea6b2d35970b2$var$B.prototype.P = function(a, b, c, d) {
    return this.i.add(String(a), b, !0, c, d);
};
function $7ebea6b2d35970b2$var$ib(a, b, c, d) {
    b = a.i.g[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.fa && h.capture == c) {
            var n = h.listener, t = h.la || h.src;
            h.ia && $7ebea6b2d35970b2$var$Ua(a.i, h);
            e = !1 !== n.call(t, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $7ebea6b2d35970b2$var$jb = $7ebea6b2d35970b2$var$l.JSON.stringify;
class $7ebea6b2d35970b2$var$kb {
    constructor(a, b){
        this.i = a;
        this.j = b;
        this.h = 0;
        this.g = null;
    }
    get() {
        let a;
        0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
        return a;
    }
}
function $7ebea6b2d35970b2$var$lb() {
    var a = $7ebea6b2d35970b2$var$mb;
    let b = null;
    a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
    return b;
}
class $7ebea6b2d35970b2$var$nb {
    constructor(){
        this.h = this.g = null;
    }
    add(a, b) {
        const c = $7ebea6b2d35970b2$var$ob.get();
        c.set(a, b);
        this.h ? this.h.next = c : this.g = c;
        this.h = c;
    }
}
var $7ebea6b2d35970b2$var$ob = new $7ebea6b2d35970b2$var$kb(()=>new $7ebea6b2d35970b2$var$pb, (a)=>a.reset());
class $7ebea6b2d35970b2$var$pb {
    constructor(){
        this.next = this.g = this.h = null;
    }
    set(a, b) {
        this.h = a;
        this.g = b;
        this.next = null;
    }
    reset() {
        this.next = this.g = this.h = null;
    }
}
function $7ebea6b2d35970b2$var$qb(a) {
    var b = 1;
    a = a.split(":");
    const c = [];
    for(; 0 < b && a.length;)c.push(a.shift()), b--;
    a.length && c.push(a.join(":"));
    return c;
}
function $7ebea6b2d35970b2$var$rb(a) {
    $7ebea6b2d35970b2$var$l.setTimeout(()=>{
        throw a;
    }, 0);
}
let $7ebea6b2d35970b2$var$sb, $7ebea6b2d35970b2$var$tb = !1, $7ebea6b2d35970b2$var$mb = new $7ebea6b2d35970b2$var$nb, $7ebea6b2d35970b2$var$vb = ()=>{
    const a = $7ebea6b2d35970b2$var$l.Promise.resolve(void 0);
    $7ebea6b2d35970b2$var$sb = ()=>{
        a.then($7ebea6b2d35970b2$var$ub);
    };
};
var $7ebea6b2d35970b2$var$ub = ()=>{
    for(var a; a = $7ebea6b2d35970b2$var$lb();){
        try {
            a.h.call(a.g);
        } catch (c) {
            $7ebea6b2d35970b2$var$rb(c);
        }
        var b = $7ebea6b2d35970b2$var$ob;
        b.j(a);
        100 > b.h && (b.h++, a.next = b.g, b.g = a);
    }
    $7ebea6b2d35970b2$var$tb = !1;
};
function $7ebea6b2d35970b2$var$wb(a, b) {
    $7ebea6b2d35970b2$var$B.call(this);
    this.h = a || 1;
    this.g = b || $7ebea6b2d35970b2$var$l;
    this.j = $7ebea6b2d35970b2$var$q(this.qb, this);
    this.l = Date.now();
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$wb, $7ebea6b2d35970b2$var$B);
$7ebea6b2d35970b2$var$k = $7ebea6b2d35970b2$var$wb.prototype;
$7ebea6b2d35970b2$var$k.ga = !1;
$7ebea6b2d35970b2$var$k.T = null;
$7ebea6b2d35970b2$var$k.qb = function() {
    if (this.ga) {
        var a = Date.now() - this.l;
        0 < a && a < .8 * this.h ? this.T = this.g.setTimeout(this.j, this.h - a) : (this.T && (this.g.clearTimeout(this.T), this.T = null), $7ebea6b2d35970b2$var$C(this, "tick"), this.ga && ($7ebea6b2d35970b2$var$xb(this), this.start()));
    }
};
$7ebea6b2d35970b2$var$k.start = function() {
    this.ga = !0;
    this.T || (this.T = this.g.setTimeout(this.j, this.h), this.l = Date.now());
};
function $7ebea6b2d35970b2$var$xb(a) {
    a.ga = !1;
    a.T && (a.g.clearTimeout(a.T), a.T = null);
}
$7ebea6b2d35970b2$var$k.N = function() {
    $7ebea6b2d35970b2$var$wb.$.N.call(this);
    $7ebea6b2d35970b2$var$xb(this);
    delete this.g;
};
function $7ebea6b2d35970b2$var$yb(a, b, c) {
    if ("function" === typeof a) c && (a = $7ebea6b2d35970b2$var$q(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $7ebea6b2d35970b2$var$q(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $7ebea6b2d35970b2$var$l.setTimeout(a, b || 0);
}
function $7ebea6b2d35970b2$var$zb(a) {
    a.g = $7ebea6b2d35970b2$var$yb(()=>{
        a.g = null;
        a.i && (a.i = !1, $7ebea6b2d35970b2$var$zb(a));
    }, a.j);
    const b = a.h;
    a.h = null;
    a.m.apply(null, b);
}
class $7ebea6b2d35970b2$var$Ab extends $7ebea6b2d35970b2$var$v {
    constructor(a, b){
        super();
        this.m = a;
        this.j = b;
        this.h = null;
        this.i = !1;
        this.g = null;
    }
    l(a) {
        this.h = arguments;
        this.g ? this.i = !0 : $7ebea6b2d35970b2$var$zb(this);
    }
    N() {
        super.N();
        this.g && ($7ebea6b2d35970b2$var$l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
    }
}
function $7ebea6b2d35970b2$var$Bb(a) {
    $7ebea6b2d35970b2$var$v.call(this);
    this.h = a;
    this.g = {};
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Bb, $7ebea6b2d35970b2$var$v);
var $7ebea6b2d35970b2$var$Cb = [];
function $7ebea6b2d35970b2$var$Db(a, b, c, d) {
    Array.isArray(c) || (c && ($7ebea6b2d35970b2$var$Cb[0] = c.toString()), c = $7ebea6b2d35970b2$var$Cb);
    for(var e = 0; e < c.length; e++){
        var f = $7ebea6b2d35970b2$var$Ya(b, c[e], d || a.handleEvent, !1, a.h || a);
        if (!f) break;
        a.g[f.key] = f;
    }
}
function $7ebea6b2d35970b2$var$Fb(a) {
    $7ebea6b2d35970b2$var$Na(a.g, function(b, c) {
        this.g.hasOwnProperty(c) && $7ebea6b2d35970b2$var$gb(b);
    }, a);
    a.g = {};
}
$7ebea6b2d35970b2$var$Bb.prototype.N = function() {
    $7ebea6b2d35970b2$var$Bb.$.N.call(this);
    $7ebea6b2d35970b2$var$Fb(this);
};
$7ebea6b2d35970b2$var$Bb.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $7ebea6b2d35970b2$var$Gb() {
    this.g = !0;
}
$7ebea6b2d35970b2$var$Gb.prototype.Ea = function() {
    this.g = !1;
};
function $7ebea6b2d35970b2$var$Hb(a, b, c, d, e, f) {
    a.info(function() {
        if (a.g) {
            if (f) {
                var h = "";
                for(var n = f.split("&"), t = 0; t < n.length; t++){
                    var m = n[t].split("=");
                    if (1 < m.length) {
                        var u = m[0];
                        m = m[1];
                        var L = u.split("_");
                        h = 2 <= L.length && "type" == L[1] ? h + (u + "=" + m + "&") : h + (u + "=redacted&");
                    }
                }
            } else h = null;
        } else h = f;
        return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
}
function $7ebea6b2d35970b2$var$Ib(a, b, c, d, e, f, h) {
    a.info(function() {
        return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
}
function $7ebea6b2d35970b2$var$D(a, b, c, d) {
    a.info(function() {
        return "XMLHTTP TEXT (" + b + "): " + $7ebea6b2d35970b2$var$Jb(a, c) + (d ? " " + d : "");
    });
}
function $7ebea6b2d35970b2$var$Kb(a, b) {
    a.info(function() {
        return "TIMEOUT: " + b;
    });
}
$7ebea6b2d35970b2$var$Gb.prototype.info = function() {};
function $7ebea6b2d35970b2$var$Jb(a, b) {
    if (!a.g) return b;
    if (!b) return null;
    try {
        var c = JSON.parse(b);
        if (c) {
            for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                var d = c[a];
                if (!(2 > d.length)) {
                    var e = d[1];
                    if (Array.isArray(e) && !(1 > e.length)) {
                        var f = e[0];
                        if ("noop" != f && "stop" != f && "close" != f) for(var h = 1; h < e.length; h++)e[h] = "";
                    }
                }
            }
        }
        return $7ebea6b2d35970b2$var$jb(c);
    } catch (n) {
        return b;
    }
}
var $7ebea6b2d35970b2$var$E = {}, $7ebea6b2d35970b2$var$Lb = null;
function $7ebea6b2d35970b2$var$Mb() {
    return $7ebea6b2d35970b2$var$Lb = $7ebea6b2d35970b2$var$Lb || new $7ebea6b2d35970b2$var$B;
}
$7ebea6b2d35970b2$var$E.Ta = "serverreachability";
function $7ebea6b2d35970b2$var$Nb(a) {
    $7ebea6b2d35970b2$var$w.call(this, $7ebea6b2d35970b2$var$E.Ta, a);
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Nb, $7ebea6b2d35970b2$var$w);
function $7ebea6b2d35970b2$var$Ob(a) {
    const b = $7ebea6b2d35970b2$var$Mb();
    $7ebea6b2d35970b2$var$C(b, new $7ebea6b2d35970b2$var$Nb(b));
}
$7ebea6b2d35970b2$var$E.STAT_EVENT = "statevent";
function $7ebea6b2d35970b2$var$Pb(a, b) {
    $7ebea6b2d35970b2$var$w.call(this, $7ebea6b2d35970b2$var$E.STAT_EVENT, a);
    this.stat = b;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Pb, $7ebea6b2d35970b2$var$w);
function $7ebea6b2d35970b2$var$F(a) {
    const b = $7ebea6b2d35970b2$var$Mb();
    $7ebea6b2d35970b2$var$C(b, new $7ebea6b2d35970b2$var$Pb(b, a));
}
$7ebea6b2d35970b2$var$E.Ua = "timingevent";
function $7ebea6b2d35970b2$var$Qb(a, b) {
    $7ebea6b2d35970b2$var$w.call(this, $7ebea6b2d35970b2$var$E.Ua, a);
    this.size = b;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Qb, $7ebea6b2d35970b2$var$w);
function $7ebea6b2d35970b2$var$Rb(a, b) {
    if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
    return $7ebea6b2d35970b2$var$l.setTimeout(function() {
        a();
    }, b);
}
var $7ebea6b2d35970b2$var$Sb = {
    NO_ERROR: 0,
    rb: 1,
    Eb: 2,
    Db: 3,
    yb: 4,
    Cb: 5,
    Fb: 6,
    Qa: 7,
    TIMEOUT: 8,
    Ib: 9
};
var $7ebea6b2d35970b2$var$Tb = {
    wb: "complete",
    Sb: "success",
    Ra: "error",
    Qa: "abort",
    Kb: "ready",
    Lb: "readystatechange",
    TIMEOUT: "timeout",
    Gb: "incrementaldata",
    Jb: "progress",
    zb: "downloadprogress",
    $b: "uploadprogress"
};
function $7ebea6b2d35970b2$var$Ub() {}
$7ebea6b2d35970b2$var$Ub.prototype.h = null;
function $7ebea6b2d35970b2$var$Vb(a) {
    return a.h || (a.h = a.i());
}
function $7ebea6b2d35970b2$var$Wb() {}
var $7ebea6b2d35970b2$var$Xb = {
    OPEN: "a",
    vb: "b",
    Ra: "c",
    Hb: "d"
};
function $7ebea6b2d35970b2$var$Yb() {
    $7ebea6b2d35970b2$var$w.call(this, "d");
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Yb, $7ebea6b2d35970b2$var$w);
function $7ebea6b2d35970b2$var$Zb() {
    $7ebea6b2d35970b2$var$w.call(this, "c");
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Zb, $7ebea6b2d35970b2$var$w);
var $7ebea6b2d35970b2$var$$b;
function $7ebea6b2d35970b2$var$ac() {}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$ac, $7ebea6b2d35970b2$var$Ub);
$7ebea6b2d35970b2$var$ac.prototype.g = function() {
    return new XMLHttpRequest;
};
$7ebea6b2d35970b2$var$ac.prototype.i = function() {
    return {};
};
$7ebea6b2d35970b2$var$$b = new $7ebea6b2d35970b2$var$ac;
function $7ebea6b2d35970b2$var$bc(a, b, c, d) {
    this.l = a;
    this.j = b;
    this.m = c;
    this.W = d || 1;
    this.U = new $7ebea6b2d35970b2$var$Bb(this);
    this.P = $7ebea6b2d35970b2$var$cc;
    a = $7ebea6b2d35970b2$var$va ? 125 : void 0;
    this.V = new $7ebea6b2d35970b2$var$wb(a);
    this.I = null;
    this.i = !1;
    this.s = this.A = this.v = this.L = this.G = this.Y = this.B = null;
    this.F = [];
    this.g = null;
    this.C = 0;
    this.o = this.u = null;
    this.ca = -1;
    this.J = !1;
    this.O = 0;
    this.M = null;
    this.ba = this.K = this.aa = this.S = !1;
    this.h = new $7ebea6b2d35970b2$var$dc;
}
function $7ebea6b2d35970b2$var$dc() {
    this.i = null;
    this.g = "";
    this.h = !1;
}
var $7ebea6b2d35970b2$var$cc = 45E3, $7ebea6b2d35970b2$var$ec = {}, $7ebea6b2d35970b2$var$fc = {};
$7ebea6b2d35970b2$var$k = $7ebea6b2d35970b2$var$bc.prototype;
$7ebea6b2d35970b2$var$k.setTimeout = function(a) {
    this.P = a;
};
function $7ebea6b2d35970b2$var$gc(a, b, c) {
    a.L = 1;
    a.v = $7ebea6b2d35970b2$var$hc($7ebea6b2d35970b2$var$G(b));
    a.s = c;
    a.S = !0;
    $7ebea6b2d35970b2$var$ic(a, null);
}
function $7ebea6b2d35970b2$var$ic(a, b) {
    a.G = Date.now();
    $7ebea6b2d35970b2$var$jc(a);
    a.A = $7ebea6b2d35970b2$var$G(a.v);
    var c = a.A, d = a.W;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $7ebea6b2d35970b2$var$kc(c.i, "t", d);
    a.C = 0;
    c = a.l.J;
    a.h = new $7ebea6b2d35970b2$var$dc;
    a.g = $7ebea6b2d35970b2$var$lc(a.l, c ? b : null, !a.s);
    0 < a.O && (a.M = new $7ebea6b2d35970b2$var$Ab($7ebea6b2d35970b2$var$q(a.Pa, a, a.g), a.O));
    $7ebea6b2d35970b2$var$Db(a.U, a.g, "readystatechange", a.nb);
    b = a.I ? $7ebea6b2d35970b2$var$Pa(a.I) : {};
    a.s ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ha(a.A, a.u, a.s, b)) : (a.u = "GET", a.g.ha(a.A, a.u, null, b));
    $7ebea6b2d35970b2$var$Ob();
    $7ebea6b2d35970b2$var$Hb(a.j, a.u, a.A, a.m, a.W, a.s);
}
$7ebea6b2d35970b2$var$k.nb = function(a) {
    a = a.target;
    const b = this.M;
    b && 3 == $7ebea6b2d35970b2$var$H(a) ? b.l() : this.Pa(a);
};
$7ebea6b2d35970b2$var$k.Pa = function(a) {
    try {
        if (a == this.g) a: {
            const u = $7ebea6b2d35970b2$var$H(this.g);
            var b = this.g.Ia();
            const L = this.g.da();
            if (!(3 > u) && (3 != u || $7ebea6b2d35970b2$var$va || this.g && (this.h.h || this.g.ja() || $7ebea6b2d35970b2$var$mc(this.g)))) {
                this.J || 4 != u || 7 == b || (8 == b || 0 >= L ? $7ebea6b2d35970b2$var$Ob(3) : $7ebea6b2d35970b2$var$Ob(2));
                $7ebea6b2d35970b2$var$nc(this);
                var c = this.g.da();
                this.ca = c;
                b: if ($7ebea6b2d35970b2$var$oc(this)) {
                    var d = $7ebea6b2d35970b2$var$mc(this.g);
                    a = "";
                    var e = d.length, f = 4 == $7ebea6b2d35970b2$var$H(this.g);
                    if (!this.h.i) {
                        if ("undefined" === typeof TextDecoder) {
                            $7ebea6b2d35970b2$var$I(this);
                            $7ebea6b2d35970b2$var$pc(this);
                            var h = "";
                            break b;
                        }
                        this.h.i = new $7ebea6b2d35970b2$var$l.TextDecoder;
                    }
                    for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                        stream: f && b == e - 1
                    });
                    d.splice(0, e);
                    this.h.g += a;
                    this.C = 0;
                    h = this.h.g;
                } else h = this.g.ja();
                this.i = 200 == c;
                $7ebea6b2d35970b2$var$Ib(this.j, this.u, this.A, this.m, this.W, u, c);
                if (this.i) {
                    if (this.aa && !this.K) {
                        b: {
                            if (this.g) {
                                var n, t = this.g;
                                if ((n = t.g ? t.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !$7ebea6b2d35970b2$var$x(n)) {
                                    var m = n;
                                    break b;
                                }
                            }
                            m = null;
                        }
                        if (c = m) $7ebea6b2d35970b2$var$D(this.j, this.m, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, $7ebea6b2d35970b2$var$qc(this, c);
                        else {
                            this.i = !1;
                            this.o = 3;
                            $7ebea6b2d35970b2$var$F(12);
                            $7ebea6b2d35970b2$var$I(this);
                            $7ebea6b2d35970b2$var$pc(this);
                            break a;
                        }
                    }
                    this.S ? ($7ebea6b2d35970b2$var$rc(this, u, h), $7ebea6b2d35970b2$var$va && this.i && 3 == u && ($7ebea6b2d35970b2$var$Db(this.U, this.V, "tick", this.mb), this.V.start())) : ($7ebea6b2d35970b2$var$D(this.j, this.m, h, null), $7ebea6b2d35970b2$var$qc(this, h));
                    4 == u && $7ebea6b2d35970b2$var$I(this);
                    this.i && !this.J && (4 == u ? $7ebea6b2d35970b2$var$sc(this.l, this) : (this.i = !1, $7ebea6b2d35970b2$var$jc(this)));
                } else $7ebea6b2d35970b2$var$tc(this.g), 400 == c && 0 < h.indexOf("Unknown SID") ? (this.o = 3, $7ebea6b2d35970b2$var$F(12)) : (this.o = 0, $7ebea6b2d35970b2$var$F(13)), $7ebea6b2d35970b2$var$I(this), $7ebea6b2d35970b2$var$pc(this);
            }
        }
    } catch (u) {} finally{}
};
function $7ebea6b2d35970b2$var$oc(a) {
    return a.g ? "GET" == a.u && 2 != a.L && a.l.Ha : !1;
}
function $7ebea6b2d35970b2$var$rc(a, b, c) {
    let d = !0, e;
    for(; !a.J && a.C < c.length;)if (e = $7ebea6b2d35970b2$var$uc(a, c), e == $7ebea6b2d35970b2$var$fc) {
        4 == b && (a.o = 4, $7ebea6b2d35970b2$var$F(14), d = !1);
        $7ebea6b2d35970b2$var$D(a.j, a.m, null, "[Incomplete Response]");
        break;
    } else if (e == $7ebea6b2d35970b2$var$ec) {
        a.o = 4;
        $7ebea6b2d35970b2$var$F(15);
        $7ebea6b2d35970b2$var$D(a.j, a.m, c, "[Invalid Chunk]");
        d = !1;
        break;
    } else $7ebea6b2d35970b2$var$D(a.j, a.m, e, null), $7ebea6b2d35970b2$var$qc(a, e);
    $7ebea6b2d35970b2$var$oc(a) && e != $7ebea6b2d35970b2$var$fc && e != $7ebea6b2d35970b2$var$ec && (a.h.g = "", a.C = 0);
    4 != b || 0 != c.length || a.h.h || (a.o = 1, $7ebea6b2d35970b2$var$F(16), d = !1);
    a.i = a.i && d;
    d ? 0 < c.length && !a.ba && (a.ba = !0, b = a.l, b.g == a && b.ca && !b.M && (b.l.info("Great, no buffering proxy detected. Bytes received: " + c.length), $7ebea6b2d35970b2$var$vc(b), b.M = !0, $7ebea6b2d35970b2$var$F(11))) : ($7ebea6b2d35970b2$var$D(a.j, a.m, c, "[Invalid Chunked Response]"), $7ebea6b2d35970b2$var$I(a), $7ebea6b2d35970b2$var$pc(a));
}
$7ebea6b2d35970b2$var$k.mb = function() {
    if (this.g) {
        var a = $7ebea6b2d35970b2$var$H(this.g), b = this.g.ja();
        this.C < b.length && ($7ebea6b2d35970b2$var$nc(this), $7ebea6b2d35970b2$var$rc(this, a, b), this.i && 4 != a && $7ebea6b2d35970b2$var$jc(this));
    }
};
function $7ebea6b2d35970b2$var$uc(a, b) {
    var c = a.C, d = b.indexOf("\n", c);
    if (-1 == d) return $7ebea6b2d35970b2$var$fc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $7ebea6b2d35970b2$var$ec;
    d += 1;
    if (d + c > b.length) return $7ebea6b2d35970b2$var$fc;
    b = b.slice(d, d + c);
    a.C = d + c;
    return b;
}
$7ebea6b2d35970b2$var$k.cancel = function() {
    this.J = !0;
    $7ebea6b2d35970b2$var$I(this);
};
function $7ebea6b2d35970b2$var$jc(a) {
    a.Y = Date.now() + a.P;
    $7ebea6b2d35970b2$var$wc(a, a.P);
}
function $7ebea6b2d35970b2$var$wc(a, b) {
    if (null != a.B) throw Error("WatchDog timer not null");
    a.B = $7ebea6b2d35970b2$var$Rb($7ebea6b2d35970b2$var$q(a.lb, a), b);
}
function $7ebea6b2d35970b2$var$nc(a) {
    a.B && ($7ebea6b2d35970b2$var$l.clearTimeout(a.B), a.B = null);
}
$7ebea6b2d35970b2$var$k.lb = function() {
    this.B = null;
    const a = Date.now();
    0 <= a - this.Y ? ($7ebea6b2d35970b2$var$Kb(this.j, this.A), 2 != this.L && ($7ebea6b2d35970b2$var$Ob(), $7ebea6b2d35970b2$var$F(17)), $7ebea6b2d35970b2$var$I(this), this.o = 2, $7ebea6b2d35970b2$var$pc(this)) : $7ebea6b2d35970b2$var$wc(this, this.Y - a);
};
function $7ebea6b2d35970b2$var$pc(a) {
    0 == a.l.H || a.J || $7ebea6b2d35970b2$var$sc(a.l, a);
}
function $7ebea6b2d35970b2$var$I(a) {
    $7ebea6b2d35970b2$var$nc(a);
    var b = a.M;
    b && "function" == typeof b.sa && b.sa();
    a.M = null;
    $7ebea6b2d35970b2$var$xb(a.V);
    $7ebea6b2d35970b2$var$Fb(a.U);
    a.g && (b = a.g, a.g = null, b.abort(), b.sa());
}
function $7ebea6b2d35970b2$var$qc(a, b) {
    try {
        var c = a.l;
        if (0 != c.H && (c.g == a || $7ebea6b2d35970b2$var$xc(c.i, a))) {
            if (!a.K && $7ebea6b2d35970b2$var$xc(c.i, a) && 3 == c.H) {
                try {
                    var d = c.Ja.g.parse(b);
                } catch (m) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.u) {
                            if (c.g) {
                                if (c.g.G + 3E3 < a.G) $7ebea6b2d35970b2$var$yc(c), $7ebea6b2d35970b2$var$zc(c);
                                else break a;
                            }
                            $7ebea6b2d35970b2$var$Ac(c);
                            $7ebea6b2d35970b2$var$F(18);
                        }
                    } else c.Fa = e[1], 0 < c.Fa - c.V && 37500 > e[2] && c.G && 0 == c.A && !c.v && (c.v = $7ebea6b2d35970b2$var$Rb($7ebea6b2d35970b2$var$q(c.ib, c), 6E3));
                    if (1 >= $7ebea6b2d35970b2$var$Bc(c.i) && c.oa) {
                        try {
                            c.oa();
                        } catch (m) {}
                        c.oa = void 0;
                    }
                } else $7ebea6b2d35970b2$var$J(c, 11);
            } else if ((a.K || c.g == a) && $7ebea6b2d35970b2$var$yc(c), !$7ebea6b2d35970b2$var$x(b)) for(e = c.Ja.g.parse(b), b = 0; b < e.length; b++){
                let m = e[b];
                c.V = m[0];
                m = m[1];
                if (2 == c.H) {
                    if ("c" == m[0]) {
                        c.K = m[1];
                        c.pa = m[2];
                        const u = m[3];
                        null != u && (c.ra = u, c.l.info("VER=" + c.ra));
                        const L = m[4];
                        null != L && (c.Ga = L, c.l.info("SVER=" + c.Ga));
                        const La = m[5];
                        null != La && "number" === typeof La && 0 < La && (d = 1.5 * La, c.L = d, c.l.info("backChannelRequestTimeoutMs_=" + d));
                        d = c;
                        const la = a.g;
                        if (la) {
                            const Ma = la.g ? la.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                            if (Ma) {
                                var f = d.i;
                                f.g || -1 == Ma.indexOf("spdy") && -1 == Ma.indexOf("quic") && -1 == Ma.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && ($7ebea6b2d35970b2$var$Cc(f, f.h), f.h = null));
                            }
                            if (d.F) {
                                const Eb = la.g ? la.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                Eb && (d.Da = Eb, $7ebea6b2d35970b2$var$K(d.I, d.F, Eb));
                            }
                        }
                        c.H = 3;
                        c.h && c.h.Ba();
                        c.ca && (c.S = Date.now() - a.G, c.l.info("Handshake RTT: " + c.S + "ms"));
                        d = c;
                        var h = a;
                        d.wa = $7ebea6b2d35970b2$var$Dc(d, d.J ? d.pa : null, d.Y);
                        if (h.K) {
                            $7ebea6b2d35970b2$var$Ec(d.i, h);
                            var n = h, t = d.L;
                            t && n.setTimeout(t);
                            n.B && ($7ebea6b2d35970b2$var$nc(n), $7ebea6b2d35970b2$var$jc(n));
                            d.g = h;
                        } else $7ebea6b2d35970b2$var$Fc(d);
                        0 < c.j.length && $7ebea6b2d35970b2$var$Gc(c);
                    } else "stop" != m[0] && "close" != m[0] || $7ebea6b2d35970b2$var$J(c, 7);
                } else 3 == c.H && ("stop" == m[0] || "close" == m[0] ? "stop" == m[0] ? $7ebea6b2d35970b2$var$J(c, 7) : $7ebea6b2d35970b2$var$Hc(c) : "noop" != m[0] && c.h && c.h.Aa(m), c.A = 0);
            }
        }
        $7ebea6b2d35970b2$var$Ob(4);
    } catch (m) {}
}
function $7ebea6b2d35970b2$var$Ic(a) {
    if (a.Z && "function" == typeof a.Z) return a.Z();
    if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
    if ("string" === typeof a) return a.split("");
    if ($7ebea6b2d35970b2$var$aa(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return b;
}
function $7ebea6b2d35970b2$var$Jc(a) {
    if (a.ta && "function" == typeof a.ta) return a.ta();
    if (!a.Z || "function" != typeof a.Z) {
        if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
        if (!("undefined" !== typeof Set && a instanceof Set)) {
            if ($7ebea6b2d35970b2$var$aa(a) || "string" === typeof a) {
                var b = [];
                a = a.length;
                for(var c = 0; c < a; c++)b.push(c);
                return b;
            }
            b = [];
            c = 0;
            for(const d in a)b[c++] = d;
            return b;
        }
    }
}
function $7ebea6b2d35970b2$var$Kc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($7ebea6b2d35970b2$var$aa(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
    else for(var c = $7ebea6b2d35970b2$var$Jc(a), d = $7ebea6b2d35970b2$var$Ic(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
}
var $7ebea6b2d35970b2$var$Lc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
function $7ebea6b2d35970b2$var$Mc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $7ebea6b2d35970b2$var$M(a) {
    this.g = this.s = this.j = "";
    this.m = null;
    this.o = this.l = "";
    this.h = !1;
    if (a instanceof $7ebea6b2d35970b2$var$M) {
        this.h = a.h;
        $7ebea6b2d35970b2$var$Nc(this, a.j);
        this.s = a.s;
        this.g = a.g;
        $7ebea6b2d35970b2$var$Oc(this, a.m);
        this.l = a.l;
        var b = a.i;
        var c = new $7ebea6b2d35970b2$var$Pc;
        c.i = b.i;
        b.g && (c.g = new Map(b.g), c.h = b.h);
        $7ebea6b2d35970b2$var$Qc(this, c);
        this.o = a.o;
    } else a && (b = String(a).match($7ebea6b2d35970b2$var$Lc)) ? (this.h = !1, $7ebea6b2d35970b2$var$Nc(this, b[1] || "", !0), this.s = $7ebea6b2d35970b2$var$Rc(b[2] || ""), this.g = $7ebea6b2d35970b2$var$Rc(b[3] || "", !0), $7ebea6b2d35970b2$var$Oc(this, b[4]), this.l = $7ebea6b2d35970b2$var$Rc(b[5] || "", !0), $7ebea6b2d35970b2$var$Qc(this, b[6] || "", !0), this.o = $7ebea6b2d35970b2$var$Rc(b[7] || "")) : (this.h = !1, this.i = new $7ebea6b2d35970b2$var$Pc(null, this.h));
}
$7ebea6b2d35970b2$var$M.prototype.toString = function() {
    var a = [], b = this.j;
    b && a.push($7ebea6b2d35970b2$var$Sc(b, $7ebea6b2d35970b2$var$Tc, !0), ":");
    var c = this.g;
    if (c || "file" == b) a.push("//"), (b = this.s) && a.push($7ebea6b2d35970b2$var$Sc(b, $7ebea6b2d35970b2$var$Tc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.m, null != c && a.push(":", String(c));
    if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push($7ebea6b2d35970b2$var$Sc(c, "/" == c.charAt(0) ? $7ebea6b2d35970b2$var$Uc : $7ebea6b2d35970b2$var$Vc, !0));
    (c = this.i.toString()) && a.push("?", c);
    (c = this.o) && a.push("#", $7ebea6b2d35970b2$var$Sc(c, $7ebea6b2d35970b2$var$Wc));
    return a.join("");
};
function $7ebea6b2d35970b2$var$G(a) {
    return new $7ebea6b2d35970b2$var$M(a);
}
function $7ebea6b2d35970b2$var$Nc(a, b, c) {
    a.j = c ? $7ebea6b2d35970b2$var$Rc(b, !0) : b;
    a.j && (a.j = a.j.replace(/:$/, ""));
}
function $7ebea6b2d35970b2$var$Oc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.m = b;
    } else a.m = null;
}
function $7ebea6b2d35970b2$var$Qc(a, b, c) {
    b instanceof $7ebea6b2d35970b2$var$Pc ? (a.i = b, $7ebea6b2d35970b2$var$Xc(a.i, a.h)) : (c || (b = $7ebea6b2d35970b2$var$Sc(b, $7ebea6b2d35970b2$var$Yc)), a.i = new $7ebea6b2d35970b2$var$Pc(b, a.h));
}
function $7ebea6b2d35970b2$var$K(a, b, c) {
    a.i.set(b, c);
}
function $7ebea6b2d35970b2$var$hc(a) {
    $7ebea6b2d35970b2$var$K(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
    return a;
}
function $7ebea6b2d35970b2$var$Rc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $7ebea6b2d35970b2$var$Sc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $7ebea6b2d35970b2$var$Zc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $7ebea6b2d35970b2$var$Zc(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $7ebea6b2d35970b2$var$Tc = /[#\/\?@]/g, $7ebea6b2d35970b2$var$Vc = /[#\?:]/g, $7ebea6b2d35970b2$var$Uc = /[#\?]/g, $7ebea6b2d35970b2$var$Yc = /[#\?@]/g, $7ebea6b2d35970b2$var$Wc = /#/g;
function $7ebea6b2d35970b2$var$Pc(a, b) {
    this.h = this.g = null;
    this.i = a || null;
    this.j = !!b;
}
function $7ebea6b2d35970b2$var$N(a) {
    a.g || (a.g = new Map, a.h = 0, a.i && $7ebea6b2d35970b2$var$Mc(a.i, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$7ebea6b2d35970b2$var$k = $7ebea6b2d35970b2$var$Pc.prototype;
$7ebea6b2d35970b2$var$k.add = function(a, b) {
    $7ebea6b2d35970b2$var$N(this);
    this.i = null;
    a = $7ebea6b2d35970b2$var$O(this, a);
    var c = this.g.get(a);
    c || this.g.set(a, c = []);
    c.push(b);
    this.h += 1;
    return this;
};
function $7ebea6b2d35970b2$var$$c(a, b) {
    $7ebea6b2d35970b2$var$N(a);
    b = $7ebea6b2d35970b2$var$O(a, b);
    a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
}
function $7ebea6b2d35970b2$var$ad(a, b) {
    $7ebea6b2d35970b2$var$N(a);
    b = $7ebea6b2d35970b2$var$O(a, b);
    return a.g.has(b);
}
$7ebea6b2d35970b2$var$k.forEach = function(a, b) {
    $7ebea6b2d35970b2$var$N(this);
    this.g.forEach(function(c, d) {
        c.forEach(function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$7ebea6b2d35970b2$var$k.ta = function() {
    $7ebea6b2d35970b2$var$N(this);
    const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
    for(let d = 0; d < b.length; d++){
        const e = a[d];
        for(let f = 0; f < e.length; f++)c.push(b[d]);
    }
    return c;
};
$7ebea6b2d35970b2$var$k.Z = function(a) {
    $7ebea6b2d35970b2$var$N(this);
    let b = [];
    if ("string" === typeof a) $7ebea6b2d35970b2$var$ad(this, a) && (b = b.concat(this.g.get($7ebea6b2d35970b2$var$O(this, a))));
    else {
        a = Array.from(this.g.values());
        for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
    }
    return b;
};
$7ebea6b2d35970b2$var$k.set = function(a, b) {
    $7ebea6b2d35970b2$var$N(this);
    this.i = null;
    a = $7ebea6b2d35970b2$var$O(this, a);
    $7ebea6b2d35970b2$var$ad(this, a) && (this.h -= this.g.get(a).length);
    this.g.set(a, [
        b
    ]);
    this.h += 1;
    return this;
};
$7ebea6b2d35970b2$var$k.get = function(a, b) {
    if (!a) return b;
    a = this.Z(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $7ebea6b2d35970b2$var$kc(a, b, c) {
    $7ebea6b2d35970b2$var$$c(a, b);
    0 < c.length && (a.i = null, a.g.set($7ebea6b2d35970b2$var$O(a, b), $7ebea6b2d35970b2$var$ma(c)), a.h += c.length);
}
$7ebea6b2d35970b2$var$k.toString = function() {
    if (this.i) return this.i;
    if (!this.g) return "";
    const a = [], b = Array.from(this.g.keys());
    for(var c = 0; c < b.length; c++){
        var d = b[c];
        const f = encodeURIComponent(String(d)), h = this.Z(d);
        for(d = 0; d < h.length; d++){
            var e = f;
            "" !== h[d] && (e += "=" + encodeURIComponent(String(h[d])));
            a.push(e);
        }
    }
    return this.i = a.join("&");
};
function $7ebea6b2d35970b2$var$O(a, b) {
    b = String(b);
    a.j && (b = b.toLowerCase());
    return b;
}
function $7ebea6b2d35970b2$var$Xc(a, b) {
    b && !a.j && ($7ebea6b2d35970b2$var$N(a), a.i = null, a.g.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($7ebea6b2d35970b2$var$$c(this, d), $7ebea6b2d35970b2$var$kc(this, e, c));
    }, a));
    a.j = b;
}
var $7ebea6b2d35970b2$var$bd = class {
    constructor(a, b){
        this.g = a;
        this.map = b;
    }
};
function $7ebea6b2d35970b2$var$cd(a) {
    this.l = a || $7ebea6b2d35970b2$var$dd;
    $7ebea6b2d35970b2$var$l.PerformanceNavigationTiming ? (a = $7ebea6b2d35970b2$var$l.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($7ebea6b2d35970b2$var$l.g && $7ebea6b2d35970b2$var$l.g.Ka && $7ebea6b2d35970b2$var$l.g.Ka() && $7ebea6b2d35970b2$var$l.g.Ka().ec);
    this.j = a ? this.l : 1;
    this.g = null;
    1 < this.j && (this.g = new Set);
    this.h = null;
    this.i = [];
}
var $7ebea6b2d35970b2$var$dd = 10;
function $7ebea6b2d35970b2$var$ed(a) {
    return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
}
function $7ebea6b2d35970b2$var$Bc(a) {
    return a.h ? 1 : a.g ? a.g.size : 0;
}
function $7ebea6b2d35970b2$var$xc(a, b) {
    return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
}
function $7ebea6b2d35970b2$var$Cc(a, b) {
    a.g ? a.g.add(b) : a.h = b;
}
function $7ebea6b2d35970b2$var$Ec(a, b) {
    a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
}
$7ebea6b2d35970b2$var$cd.prototype.cancel = function() {
    this.i = $7ebea6b2d35970b2$var$fd(this);
    if (this.h) this.h.cancel(), this.h = null;
    else if (this.g && 0 !== this.g.size) {
        for (const a of this.g.values())a.cancel();
        this.g.clear();
    }
};
function $7ebea6b2d35970b2$var$fd(a) {
    if (null != a.h) return a.i.concat(a.h.F);
    if (null != a.g && 0 !== a.g.size) {
        let b = a.i;
        for (const c of a.g.values())b = b.concat(c.F);
        return b;
    }
    return $7ebea6b2d35970b2$var$ma(a.i);
}
var $7ebea6b2d35970b2$var$gd = class {
    stringify(a) {
        return $7ebea6b2d35970b2$var$l.JSON.stringify(a, void 0);
    }
    parse(a) {
        return $7ebea6b2d35970b2$var$l.JSON.parse(a, void 0);
    }
};
function $7ebea6b2d35970b2$var$hd() {
    this.g = new $7ebea6b2d35970b2$var$gd;
}
function $7ebea6b2d35970b2$var$id(a, b, c) {
    const d = c || "";
    try {
        $7ebea6b2d35970b2$var$Kc(a, function(e, f) {
            let h = e;
            $7ebea6b2d35970b2$var$p(e) && (h = $7ebea6b2d35970b2$var$jb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $7ebea6b2d35970b2$var$jd(a, b) {
    const c = new $7ebea6b2d35970b2$var$Gb;
    if ($7ebea6b2d35970b2$var$l.Image) {
        const d = new Image;
        d.onload = $7ebea6b2d35970b2$var$ha($7ebea6b2d35970b2$var$kd, c, d, "TestLoadImage: loaded", !0, b);
        d.onerror = $7ebea6b2d35970b2$var$ha($7ebea6b2d35970b2$var$kd, c, d, "TestLoadImage: error", !1, b);
        d.onabort = $7ebea6b2d35970b2$var$ha($7ebea6b2d35970b2$var$kd, c, d, "TestLoadImage: abort", !1, b);
        d.ontimeout = $7ebea6b2d35970b2$var$ha($7ebea6b2d35970b2$var$kd, c, d, "TestLoadImage: timeout", !1, b);
        $7ebea6b2d35970b2$var$l.setTimeout(function() {
            if (d.ontimeout) d.ontimeout();
        }, 1E4);
        d.src = a;
    } else b(!1);
}
function $7ebea6b2d35970b2$var$kd(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
function $7ebea6b2d35970b2$var$ld(a) {
    this.l = a.fc || null;
    this.j = a.ob || !1;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$ld, $7ebea6b2d35970b2$var$Ub);
$7ebea6b2d35970b2$var$ld.prototype.g = function() {
    return new $7ebea6b2d35970b2$var$md(this.l, this.j);
};
$7ebea6b2d35970b2$var$ld.prototype.i = function(a) {
    return function() {
        return a;
    };
}({});
function $7ebea6b2d35970b2$var$md(a, b) {
    $7ebea6b2d35970b2$var$B.call(this);
    this.F = a;
    this.u = b;
    this.m = void 0;
    this.readyState = $7ebea6b2d35970b2$var$nd;
    this.status = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.v = new Headers;
    this.h = null;
    this.C = "GET";
    this.B = "";
    this.g = !1;
    this.A = this.j = this.l = null;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$md, $7ebea6b2d35970b2$var$B);
var $7ebea6b2d35970b2$var$nd = 0;
$7ebea6b2d35970b2$var$k = $7ebea6b2d35970b2$var$md.prototype;
$7ebea6b2d35970b2$var$k.open = function(a, b) {
    if (this.readyState != $7ebea6b2d35970b2$var$nd) throw this.abort(), Error("Error reopening a connection");
    this.C = a;
    this.B = b;
    this.readyState = 1;
    $7ebea6b2d35970b2$var$od(this);
};
$7ebea6b2d35970b2$var$k.send = function(a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    const b = {
        headers: this.v,
        method: this.C,
        credentials: this.m,
        cache: void 0
    };
    a && (b.body = a);
    (this.F || $7ebea6b2d35970b2$var$l).fetch(new Request(this.B, b)).then(this.$a.bind(this), this.ka.bind(this));
};
$7ebea6b2d35970b2$var$k.abort = function() {
    this.response = this.responseText = "";
    this.v = new Headers;
    this.status = 0;
    this.j && this.j.cancel("Request was aborted.").catch(()=>{});
    1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, $7ebea6b2d35970b2$var$pd(this));
    this.readyState = $7ebea6b2d35970b2$var$nd;
};
$7ebea6b2d35970b2$var$k.$a = function(a) {
    if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, $7ebea6b2d35970b2$var$od(this)), this.g && (this.readyState = 3, $7ebea6b2d35970b2$var$od(this), this.g))) {
        if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Ya.bind(this), this.ka.bind(this));
        else if ("undefined" !== typeof $7ebea6b2d35970b2$var$l.ReadableStream && "body" in a) {
            this.j = a.body.getReader();
            if (this.u) {
                if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                this.response = [];
            } else this.response = this.responseText = "", this.A = new TextDecoder;
            $7ebea6b2d35970b2$var$qd(this);
        } else a.text().then(this.Za.bind(this), this.ka.bind(this));
    }
};
function $7ebea6b2d35970b2$var$qd(a) {
    a.j.read().then(a.Xa.bind(a)).catch(a.ka.bind(a));
}
$7ebea6b2d35970b2$var$k.Xa = function(a) {
    if (this.g) {
        if (this.u && a.value) this.response.push(a.value);
        else if (!this.u) {
            var b = a.value ? a.value : new Uint8Array(0);
            if (b = this.A.decode(b, {
                stream: !a.done
            })) this.response = this.responseText += b;
        }
        a.done ? $7ebea6b2d35970b2$var$pd(this) : $7ebea6b2d35970b2$var$od(this);
        3 == this.readyState && $7ebea6b2d35970b2$var$qd(this);
    }
};
$7ebea6b2d35970b2$var$k.Za = function(a) {
    this.g && (this.response = this.responseText = a, $7ebea6b2d35970b2$var$pd(this));
};
$7ebea6b2d35970b2$var$k.Ya = function(a) {
    this.g && (this.response = a, $7ebea6b2d35970b2$var$pd(this));
};
$7ebea6b2d35970b2$var$k.ka = function() {
    this.g && $7ebea6b2d35970b2$var$pd(this);
};
function $7ebea6b2d35970b2$var$pd(a) {
    a.readyState = 4;
    a.l = null;
    a.j = null;
    a.A = null;
    $7ebea6b2d35970b2$var$od(a);
}
$7ebea6b2d35970b2$var$k.setRequestHeader = function(a, b) {
    this.v.append(a, b);
};
$7ebea6b2d35970b2$var$k.getResponseHeader = function(a) {
    return this.h ? this.h.get(a.toLowerCase()) || "" : "";
};
$7ebea6b2d35970b2$var$k.getAllResponseHeaders = function() {
    if (!this.h) return "";
    const a = [], b = this.h.entries();
    for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    return a.join("\r\n");
};
function $7ebea6b2d35970b2$var$od(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
}
Object.defineProperty($7ebea6b2d35970b2$var$md.prototype, "withCredentials", {
    get: function() {
        return "include" === this.m;
    },
    set: function(a) {
        this.m = a ? "include" : "same-origin";
    }
});
var $7ebea6b2d35970b2$var$rd = $7ebea6b2d35970b2$var$l.JSON.parse;
function $7ebea6b2d35970b2$var$P(a) {
    $7ebea6b2d35970b2$var$B.call(this);
    this.headers = new Map;
    this.u = a || null;
    this.h = !1;
    this.C = this.g = null;
    this.I = "";
    this.m = 0;
    this.j = "";
    this.l = this.G = this.v = this.F = !1;
    this.B = 0;
    this.A = null;
    this.K = $7ebea6b2d35970b2$var$sd;
    this.L = this.M = !1;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$P, $7ebea6b2d35970b2$var$B);
var $7ebea6b2d35970b2$var$sd = "", $7ebea6b2d35970b2$var$td = /^https?$/i, $7ebea6b2d35970b2$var$ud = [
    "POST",
    "PUT"
];
$7ebea6b2d35970b2$var$k = $7ebea6b2d35970b2$var$P.prototype;
$7ebea6b2d35970b2$var$k.Oa = function(a) {
    this.M = a;
};
$7ebea6b2d35970b2$var$k.ha = function(a, b, c, d) {
    if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.I + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.I = a;
    this.j = "";
    this.m = 0;
    this.F = !1;
    this.h = !0;
    this.g = this.u ? this.u.g() : $7ebea6b2d35970b2$var$$b.g();
    this.C = this.u ? $7ebea6b2d35970b2$var$Vb(this.u) : $7ebea6b2d35970b2$var$Vb($7ebea6b2d35970b2$var$$b);
    this.g.onreadystatechange = $7ebea6b2d35970b2$var$q(this.La, this);
    try {
        this.G = !0, this.g.open(b, String(a), !0), this.G = !1;
    } catch (f) {
        $7ebea6b2d35970b2$var$vd(this, f);
        return;
    }
    a = c || "";
    c = new Map(this.headers);
    if (d) {
        if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
        else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
        else throw Error("Unknown input type for opt_headers: " + String(d));
    }
    d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
    e = $7ebea6b2d35970b2$var$l.FormData && a instanceof $7ebea6b2d35970b2$var$l.FormData;
    !(0 <= $7ebea6b2d35970b2$var$ka($7ebea6b2d35970b2$var$ud, b)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    for (const [f, h] of c)this.g.setRequestHeader(f, h);
    this.K && (this.g.responseType = this.K);
    "withCredentials" in this.g && this.g.withCredentials !== this.M && (this.g.withCredentials = this.M);
    try {
        $7ebea6b2d35970b2$var$wd(this), 0 < this.B && ((this.L = $7ebea6b2d35970b2$var$xd(this.g)) ? (this.g.timeout = this.B, this.g.ontimeout = $7ebea6b2d35970b2$var$q(this.ua, this)) : this.A = $7ebea6b2d35970b2$var$yb(this.ua, this.B, this)), this.v = !0, this.g.send(a), this.v = !1;
    } catch (f) {
        $7ebea6b2d35970b2$var$vd(this, f);
    }
};
function $7ebea6b2d35970b2$var$xd(a) {
    return $7ebea6b2d35970b2$var$z && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
$7ebea6b2d35970b2$var$k.ua = function() {
    "undefined" != typeof $7ebea6b2d35970b2$var$goog && this.g && (this.j = "Timed out after " + this.B + "ms, aborting", this.m = 8, $7ebea6b2d35970b2$var$C(this, "timeout"), this.abort(8));
};
function $7ebea6b2d35970b2$var$vd(a, b) {
    a.h = !1;
    a.g && (a.l = !0, a.g.abort(), a.l = !1);
    a.j = b;
    a.m = 5;
    $7ebea6b2d35970b2$var$yd(a);
    $7ebea6b2d35970b2$var$zd(a);
}
function $7ebea6b2d35970b2$var$yd(a) {
    a.F || (a.F = !0, $7ebea6b2d35970b2$var$C(a, "complete"), $7ebea6b2d35970b2$var$C(a, "error"));
}
$7ebea6b2d35970b2$var$k.abort = function(a) {
    this.g && this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1, this.m = a || 7, $7ebea6b2d35970b2$var$C(this, "complete"), $7ebea6b2d35970b2$var$C(this, "abort"), $7ebea6b2d35970b2$var$zd(this));
};
$7ebea6b2d35970b2$var$k.N = function() {
    this.g && (this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1), $7ebea6b2d35970b2$var$zd(this, !0));
    $7ebea6b2d35970b2$var$P.$.N.call(this);
};
$7ebea6b2d35970b2$var$k.La = function() {
    this.s || (this.G || this.v || this.l ? $7ebea6b2d35970b2$var$Ad(this) : this.kb());
};
$7ebea6b2d35970b2$var$k.kb = function() {
    $7ebea6b2d35970b2$var$Ad(this);
};
function $7ebea6b2d35970b2$var$Ad(a) {
    if (a.h && "undefined" != typeof $7ebea6b2d35970b2$var$goog && (!a.C[1] || 4 != $7ebea6b2d35970b2$var$H(a) || 2 != a.da())) {
        if (a.v && 4 == $7ebea6b2d35970b2$var$H(a)) $7ebea6b2d35970b2$var$yb(a.La, 0, a);
        else if ($7ebea6b2d35970b2$var$C(a, "readystatechange"), 4 == $7ebea6b2d35970b2$var$H(a)) {
            a.h = !1;
            try {
                const h = a.da();
                a: switch(h){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var b = !0;
                        break a;
                    default:
                        b = !1;
                }
                var c;
                if (!(c = b)) {
                    var d;
                    if (d = 0 === h) {
                        var e = String(a.I).match($7ebea6b2d35970b2$var$Lc)[1] || null;
                        !e && $7ebea6b2d35970b2$var$l.self && $7ebea6b2d35970b2$var$l.self.location && (e = $7ebea6b2d35970b2$var$l.self.location.protocol.slice(0, -1));
                        d = !$7ebea6b2d35970b2$var$td.test(e ? e.toLowerCase() : "");
                    }
                    c = d;
                }
                if (c) $7ebea6b2d35970b2$var$C(a, "complete"), $7ebea6b2d35970b2$var$C(a, "success");
                else {
                    a.m = 6;
                    try {
                        var f = 2 < $7ebea6b2d35970b2$var$H(a) ? a.g.statusText : "";
                    } catch (n) {
                        f = "";
                    }
                    a.j = f + " [" + a.da() + "]";
                    $7ebea6b2d35970b2$var$yd(a);
                }
            } finally{
                $7ebea6b2d35970b2$var$zd(a);
            }
        }
    }
}
function $7ebea6b2d35970b2$var$zd(a, b) {
    if (a.g) {
        $7ebea6b2d35970b2$var$wd(a);
        const c = a.g, d = a.C[0] ? ()=>{} : null;
        a.g = null;
        a.C = null;
        b || $7ebea6b2d35970b2$var$C(a, "ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $7ebea6b2d35970b2$var$wd(a) {
    a.g && a.L && (a.g.ontimeout = null);
    a.A && ($7ebea6b2d35970b2$var$l.clearTimeout(a.A), a.A = null);
}
$7ebea6b2d35970b2$var$k.isActive = function() {
    return !!this.g;
};
function $7ebea6b2d35970b2$var$H(a) {
    return a.g ? a.g.readyState : 0;
}
$7ebea6b2d35970b2$var$k.da = function() {
    try {
        return 2 < $7ebea6b2d35970b2$var$H(this) ? this.g.status : -1;
    } catch (a) {
        return -1;
    }
};
$7ebea6b2d35970b2$var$k.ja = function() {
    try {
        return this.g ? this.g.responseText : "";
    } catch (a) {
        return "";
    }
};
$7ebea6b2d35970b2$var$k.Wa = function(a) {
    if (this.g) {
        var b = this.g.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $7ebea6b2d35970b2$var$rd(b);
    }
};
function $7ebea6b2d35970b2$var$mc(a) {
    try {
        if (!a.g) return null;
        if ("response" in a.g) return a.g.response;
        switch(a.K){
            case $7ebea6b2d35970b2$var$sd:
            case "text":
                return a.g.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
        }
        return null;
    } catch (b) {
        return null;
    }
}
function $7ebea6b2d35970b2$var$tc(a) {
    const b = {};
    a = (a.g && 2 <= $7ebea6b2d35970b2$var$H(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
    for(let d = 0; d < a.length; d++){
        if ($7ebea6b2d35970b2$var$x(a[d])) continue;
        var c = $7ebea6b2d35970b2$var$qb(a[d]);
        const e = c[0];
        c = c[1];
        if ("string" !== typeof c) continue;
        c = c.trim();
        const f = b[e] || [];
        b[e] = f;
        f.push(c);
    }
    $7ebea6b2d35970b2$var$Oa(b, function(d) {
        return d.join(", ");
    });
}
$7ebea6b2d35970b2$var$k.Ia = function() {
    return this.m;
};
$7ebea6b2d35970b2$var$k.Sa = function() {
    return "string" === typeof this.j ? this.j : String(this.j);
};
function $7ebea6b2d35970b2$var$Bd(a) {
    let b = "";
    $7ebea6b2d35970b2$var$Na(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $7ebea6b2d35970b2$var$Cd(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $7ebea6b2d35970b2$var$Bd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $7ebea6b2d35970b2$var$K(a, b, c));
}
function $7ebea6b2d35970b2$var$Dd(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $7ebea6b2d35970b2$var$Ed(a) {
    this.Ga = 0;
    this.j = [];
    this.l = new $7ebea6b2d35970b2$var$Gb;
    this.pa = this.wa = this.I = this.Y = this.g = this.Da = this.F = this.na = this.o = this.U = this.s = null;
    this.fb = this.W = 0;
    this.cb = $7ebea6b2d35970b2$var$Dd("failFast", !1, a);
    this.G = this.v = this.u = this.m = this.h = null;
    this.aa = !0;
    this.Fa = this.V = -1;
    this.ba = this.A = this.C = 0;
    this.ab = $7ebea6b2d35970b2$var$Dd("baseRetryDelayMs", 5E3, a);
    this.hb = $7ebea6b2d35970b2$var$Dd("retryDelaySeedMs", 1E4, a);
    this.eb = $7ebea6b2d35970b2$var$Dd("forwardChannelMaxRetries", 2, a);
    this.xa = $7ebea6b2d35970b2$var$Dd("forwardChannelRequestTimeoutMs", 2E4, a);
    this.va = a && a.xmlHttpFactory || void 0;
    this.Ha = a && a.dc || !1;
    this.L = void 0;
    this.J = a && a.supportsCrossDomainXhr || !1;
    this.K = "";
    this.i = new $7ebea6b2d35970b2$var$cd(a && a.concurrentRequestLimit);
    this.Ja = new $7ebea6b2d35970b2$var$hd;
    this.P = a && a.fastHandshake || !1;
    this.O = a && a.encodeInitMessageHeaders || !1;
    this.P && this.O && (this.O = !1);
    this.bb = a && a.bc || !1;
    a && a.Ea && this.l.Ea();
    a && a.forceLongPolling && (this.aa = !1);
    this.ca = !this.P && this.aa && a && a.detectBufferingProxy || !1;
    this.qa = void 0;
    a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.qa = a.longPollingTimeout);
    this.oa = void 0;
    this.S = 0;
    this.M = !1;
    this.ma = this.B = null;
}
$7ebea6b2d35970b2$var$k = $7ebea6b2d35970b2$var$Ed.prototype;
$7ebea6b2d35970b2$var$k.ra = 8;
$7ebea6b2d35970b2$var$k.H = 1;
function $7ebea6b2d35970b2$var$Hc(a) {
    $7ebea6b2d35970b2$var$Fd(a);
    if (3 == a.H) {
        var b = a.W++, c = $7ebea6b2d35970b2$var$G(a.I);
        $7ebea6b2d35970b2$var$K(c, "SID", a.K);
        $7ebea6b2d35970b2$var$K(c, "RID", b);
        $7ebea6b2d35970b2$var$K(c, "TYPE", "terminate");
        $7ebea6b2d35970b2$var$Gd(a, c);
        b = new $7ebea6b2d35970b2$var$bc(a, a.l, b);
        b.L = 2;
        b.v = $7ebea6b2d35970b2$var$hc($7ebea6b2d35970b2$var$G(c));
        c = !1;
        if ($7ebea6b2d35970b2$var$l.navigator && $7ebea6b2d35970b2$var$l.navigator.sendBeacon) try {
            c = $7ebea6b2d35970b2$var$l.navigator.sendBeacon(b.v.toString(), "");
        } catch (d) {}
        !c && $7ebea6b2d35970b2$var$l.Image && ((new Image).src = b.v, c = !0);
        c || (b.g = $7ebea6b2d35970b2$var$lc(b.l, null), b.g.ha(b.v));
        b.G = Date.now();
        $7ebea6b2d35970b2$var$jc(b);
    }
    $7ebea6b2d35970b2$var$Hd(a);
}
function $7ebea6b2d35970b2$var$zc(a) {
    a.g && ($7ebea6b2d35970b2$var$vc(a), a.g.cancel(), a.g = null);
}
function $7ebea6b2d35970b2$var$Fd(a) {
    $7ebea6b2d35970b2$var$zc(a);
    a.u && ($7ebea6b2d35970b2$var$l.clearTimeout(a.u), a.u = null);
    $7ebea6b2d35970b2$var$yc(a);
    a.i.cancel();
    a.m && ("number" === typeof a.m && $7ebea6b2d35970b2$var$l.clearTimeout(a.m), a.m = null);
}
function $7ebea6b2d35970b2$var$Gc(a) {
    if (!$7ebea6b2d35970b2$var$ed(a.i) && !a.m) {
        a.m = !0;
        var b = a.Na;
        $7ebea6b2d35970b2$var$sb || $7ebea6b2d35970b2$var$vb();
        $7ebea6b2d35970b2$var$tb || ($7ebea6b2d35970b2$var$sb(), $7ebea6b2d35970b2$var$tb = !0);
        $7ebea6b2d35970b2$var$mb.add(b, a);
        a.C = 0;
    }
}
function $7ebea6b2d35970b2$var$Id(a, b) {
    if ($7ebea6b2d35970b2$var$Bc(a.i) >= a.i.j - (a.m ? 1 : 0)) return !1;
    if (a.m) return a.j = b.F.concat(a.j), !0;
    if (1 == a.H || 2 == a.H || a.C >= (a.cb ? 0 : a.eb)) return !1;
    a.m = $7ebea6b2d35970b2$var$Rb($7ebea6b2d35970b2$var$q(a.Na, a, b), $7ebea6b2d35970b2$var$Jd(a, a.C));
    a.C++;
    return !0;
}
$7ebea6b2d35970b2$var$k.Na = function(a) {
    if (this.m) {
        if (this.m = null, 1 == this.H) {
            if (!a) {
                this.W = Math.floor(1E5 * Math.random());
                a = this.W++;
                const e = new $7ebea6b2d35970b2$var$bc(this, this.l, a);
                let f = this.s;
                this.U && (f ? (f = $7ebea6b2d35970b2$var$Pa(f), $7ebea6b2d35970b2$var$Ra(f, this.U)) : f = this.U);
                null !== this.o || this.O || (e.I = f, f = null);
                if (this.P) a: {
                    var b = 0;
                    for(var c = 0; c < this.j.length; c++){
                        b: {
                            var d = this.j[c];
                            if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                d = d.length;
                                break b;
                            }
                            d = void 0;
                        }
                        if (void 0 === d) break;
                        b += d;
                        if (4096 < b) {
                            b = c;
                            break a;
                        }
                        if (4096 === b || c === this.j.length - 1) {
                            b = c + 1;
                            break a;
                        }
                    }
                    b = 1E3;
                }
                else b = 1E3;
                b = $7ebea6b2d35970b2$var$Kd(this, e, b);
                c = $7ebea6b2d35970b2$var$G(this.I);
                $7ebea6b2d35970b2$var$K(c, "RID", a);
                $7ebea6b2d35970b2$var$K(c, "CVER", 22);
                this.F && $7ebea6b2d35970b2$var$K(c, "X-HTTP-Session-Id", this.F);
                $7ebea6b2d35970b2$var$Gd(this, c);
                f && (this.O ? b = "headers=" + encodeURIComponent(String($7ebea6b2d35970b2$var$Bd(f))) + "&" + b : this.o && $7ebea6b2d35970b2$var$Cd(c, this.o, f));
                $7ebea6b2d35970b2$var$Cc(this.i, e);
                this.bb && $7ebea6b2d35970b2$var$K(c, "TYPE", "init");
                this.P ? ($7ebea6b2d35970b2$var$K(c, "$req", b), $7ebea6b2d35970b2$var$K(c, "SID", "null"), e.aa = !0, $7ebea6b2d35970b2$var$gc(e, c, null)) : $7ebea6b2d35970b2$var$gc(e, c, b);
                this.H = 2;
            }
        } else 3 == this.H && (a ? $7ebea6b2d35970b2$var$Ld(this, a) : 0 == this.j.length || $7ebea6b2d35970b2$var$ed(this.i) || $7ebea6b2d35970b2$var$Ld(this));
    }
};
function $7ebea6b2d35970b2$var$Ld(a, b) {
    var c;
    b ? c = b.m : c = a.W++;
    const d = $7ebea6b2d35970b2$var$G(a.I);
    $7ebea6b2d35970b2$var$K(d, "SID", a.K);
    $7ebea6b2d35970b2$var$K(d, "RID", c);
    $7ebea6b2d35970b2$var$K(d, "AID", a.V);
    $7ebea6b2d35970b2$var$Gd(a, d);
    a.o && a.s && $7ebea6b2d35970b2$var$Cd(d, a.o, a.s);
    c = new $7ebea6b2d35970b2$var$bc(a, a.l, c, a.C + 1);
    null === a.o && (c.I = a.s);
    b && (a.j = b.F.concat(a.j));
    b = $7ebea6b2d35970b2$var$Kd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.xa) + Math.round(.5 * a.xa * Math.random()));
    $7ebea6b2d35970b2$var$Cc(a.i, c);
    $7ebea6b2d35970b2$var$gc(c, d, b);
}
function $7ebea6b2d35970b2$var$Gd(a, b) {
    a.na && $7ebea6b2d35970b2$var$Na(a.na, function(c, d) {
        $7ebea6b2d35970b2$var$K(b, d, c);
    });
    a.h && $7ebea6b2d35970b2$var$Kc({}, function(c, d) {
        $7ebea6b2d35970b2$var$K(b, d, c);
    });
}
function $7ebea6b2d35970b2$var$Kd(a, b, c) {
    c = Math.min(a.j.length, c);
    var d = a.h ? $7ebea6b2d35970b2$var$q(a.h.Va, a.h, a) : null;
    a: {
        var e = a.j;
        let f = -1;
        for(;;){
            const h = [
                "count=" + c
            ];
            -1 == f ? 0 < c ? (f = e[0].g, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
            let n = !0;
            for(let t = 0; t < c; t++){
                let m = e[t].g;
                const u = e[t].map;
                m -= f;
                if (0 > m) f = Math.max(0, e[t].g - 100), n = !1;
                else try {
                    $7ebea6b2d35970b2$var$id(u, h, "req" + m + "_");
                } catch (L) {
                    d && d(u);
                }
            }
            if (n) {
                d = h.join("&");
                break a;
            }
        }
    }
    a = a.j.splice(0, c);
    b.F = a;
    return d;
}
function $7ebea6b2d35970b2$var$Fc(a) {
    if (!a.g && !a.u) {
        a.ba = 1;
        var b = a.Ma;
        $7ebea6b2d35970b2$var$sb || $7ebea6b2d35970b2$var$vb();
        $7ebea6b2d35970b2$var$tb || ($7ebea6b2d35970b2$var$sb(), $7ebea6b2d35970b2$var$tb = !0);
        $7ebea6b2d35970b2$var$mb.add(b, a);
        a.A = 0;
    }
}
function $7ebea6b2d35970b2$var$Ac(a) {
    if (a.g || a.u || 3 <= a.A) return !1;
    a.ba++;
    a.u = $7ebea6b2d35970b2$var$Rb($7ebea6b2d35970b2$var$q(a.Ma, a), $7ebea6b2d35970b2$var$Jd(a, a.A));
    a.A++;
    return !0;
}
$7ebea6b2d35970b2$var$k.Ma = function() {
    this.u = null;
    $7ebea6b2d35970b2$var$Md(this);
    if (this.ca && !(this.M || null == this.g || 0 >= this.S)) {
        var a = 2 * this.S;
        this.l.info("BP detection timer enabled: " + a);
        this.B = $7ebea6b2d35970b2$var$Rb($7ebea6b2d35970b2$var$q(this.jb, this), a);
    }
};
$7ebea6b2d35970b2$var$k.jb = function() {
    this.B && (this.B = null, this.l.info("BP detection timeout reached."), this.l.info("Buffering proxy detected and switch to long-polling!"), this.G = !1, this.M = !0, $7ebea6b2d35970b2$var$F(10), $7ebea6b2d35970b2$var$zc(this), $7ebea6b2d35970b2$var$Md(this));
};
function $7ebea6b2d35970b2$var$vc(a) {
    null != a.B && ($7ebea6b2d35970b2$var$l.clearTimeout(a.B), a.B = null);
}
function $7ebea6b2d35970b2$var$Md(a) {
    a.g = new $7ebea6b2d35970b2$var$bc(a, a.l, "rpc", a.ba);
    null === a.o && (a.g.I = a.s);
    a.g.O = 0;
    var b = $7ebea6b2d35970b2$var$G(a.wa);
    $7ebea6b2d35970b2$var$K(b, "RID", "rpc");
    $7ebea6b2d35970b2$var$K(b, "SID", a.K);
    $7ebea6b2d35970b2$var$K(b, "AID", a.V);
    $7ebea6b2d35970b2$var$K(b, "CI", a.G ? "0" : "1");
    !a.G && a.qa && $7ebea6b2d35970b2$var$K(b, "TO", a.qa);
    $7ebea6b2d35970b2$var$K(b, "TYPE", "xmlhttp");
    $7ebea6b2d35970b2$var$Gd(a, b);
    a.o && a.s && $7ebea6b2d35970b2$var$Cd(b, a.o, a.s);
    a.L && a.g.setTimeout(a.L);
    var c = a.g;
    a = a.pa;
    c.L = 1;
    c.v = $7ebea6b2d35970b2$var$hc($7ebea6b2d35970b2$var$G(b));
    c.s = null;
    c.S = !0;
    $7ebea6b2d35970b2$var$ic(c, a);
}
$7ebea6b2d35970b2$var$k.ib = function() {
    null != this.v && (this.v = null, $7ebea6b2d35970b2$var$zc(this), $7ebea6b2d35970b2$var$Ac(this), $7ebea6b2d35970b2$var$F(19));
};
function $7ebea6b2d35970b2$var$yc(a) {
    null != a.v && ($7ebea6b2d35970b2$var$l.clearTimeout(a.v), a.v = null);
}
function $7ebea6b2d35970b2$var$sc(a, b) {
    var c = null;
    if (a.g == b) {
        $7ebea6b2d35970b2$var$yc(a);
        $7ebea6b2d35970b2$var$vc(a);
        a.g = null;
        var d = 2;
    } else if ($7ebea6b2d35970b2$var$xc(a.i, b)) c = b.F, $7ebea6b2d35970b2$var$Ec(a.i, b), d = 1;
    else return;
    if (0 != a.H) {
        if (b.i) {
            if (1 == d) {
                c = b.s ? b.s.length : 0;
                b = Date.now() - b.G;
                var e = a.C;
                d = $7ebea6b2d35970b2$var$Mb();
                $7ebea6b2d35970b2$var$C(d, new $7ebea6b2d35970b2$var$Qb(d, c));
                $7ebea6b2d35970b2$var$Gc(a);
            } else $7ebea6b2d35970b2$var$Fc(a);
        } else if (e = b.o, 3 == e || 0 == e && 0 < b.ca || !(1 == d && $7ebea6b2d35970b2$var$Id(a, b) || 2 == d && $7ebea6b2d35970b2$var$Ac(a))) switch(c && 0 < c.length && (b = a.i, b.i = b.i.concat(c)), e){
            case 1:
                $7ebea6b2d35970b2$var$J(a, 5);
                break;
            case 4:
                $7ebea6b2d35970b2$var$J(a, 10);
                break;
            case 3:
                $7ebea6b2d35970b2$var$J(a, 6);
                break;
            default:
                $7ebea6b2d35970b2$var$J(a, 2);
        }
    }
}
function $7ebea6b2d35970b2$var$Jd(a, b) {
    let c = a.ab + Math.floor(Math.random() * a.hb);
    a.isActive() || (c *= 2);
    return c * b;
}
function $7ebea6b2d35970b2$var$J(a, b) {
    a.l.info("Error code " + b);
    if (2 == b) {
        var c = null;
        a.h && (c = null);
        var d = $7ebea6b2d35970b2$var$q(a.pb, a);
        c || (c = new $7ebea6b2d35970b2$var$M("//www.google.com/images/cleardot.gif"), $7ebea6b2d35970b2$var$l.location && "http" == $7ebea6b2d35970b2$var$l.location.protocol || $7ebea6b2d35970b2$var$Nc(c, "https"), $7ebea6b2d35970b2$var$hc(c));
        $7ebea6b2d35970b2$var$jd(c.toString(), d);
    } else $7ebea6b2d35970b2$var$F(2);
    a.H = 0;
    a.h && a.h.za(b);
    $7ebea6b2d35970b2$var$Hd(a);
    $7ebea6b2d35970b2$var$Fd(a);
}
$7ebea6b2d35970b2$var$k.pb = function(a) {
    a ? (this.l.info("Successfully pinged google.com"), $7ebea6b2d35970b2$var$F(2)) : (this.l.info("Failed to ping google.com"), $7ebea6b2d35970b2$var$F(1));
};
function $7ebea6b2d35970b2$var$Hd(a) {
    a.H = 0;
    a.ma = [];
    if (a.h) {
        const b = $7ebea6b2d35970b2$var$fd(a.i);
        if (0 != b.length || 0 != a.j.length) $7ebea6b2d35970b2$var$na(a.ma, b), $7ebea6b2d35970b2$var$na(a.ma, a.j), a.i.i.length = 0, $7ebea6b2d35970b2$var$ma(a.j), a.j.length = 0;
        a.h.ya();
    }
}
function $7ebea6b2d35970b2$var$Dc(a, b, c) {
    var d = c instanceof $7ebea6b2d35970b2$var$M ? $7ebea6b2d35970b2$var$G(c) : new $7ebea6b2d35970b2$var$M(c);
    if ("" != d.g) b && (d.g = b + "." + d.g), $7ebea6b2d35970b2$var$Oc(d, d.m);
    else {
        var e = $7ebea6b2d35970b2$var$l.location;
        d = e.protocol;
        b = b ? b + "." + e.hostname : e.hostname;
        e = +e.port;
        var f = new $7ebea6b2d35970b2$var$M(null);
        d && $7ebea6b2d35970b2$var$Nc(f, d);
        b && (f.g = b);
        e && $7ebea6b2d35970b2$var$Oc(f, e);
        c && (f.l = c);
        d = f;
    }
    c = a.F;
    b = a.Da;
    c && b && $7ebea6b2d35970b2$var$K(d, c, b);
    $7ebea6b2d35970b2$var$K(d, "VER", a.ra);
    $7ebea6b2d35970b2$var$Gd(a, d);
    return d;
}
function $7ebea6b2d35970b2$var$lc(a, b, c) {
    if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
    b = c && a.Ha && !a.va ? new $7ebea6b2d35970b2$var$P(new $7ebea6b2d35970b2$var$ld({
        ob: !0
    })) : new $7ebea6b2d35970b2$var$P(a.va);
    b.Oa(a.J);
    return b;
}
$7ebea6b2d35970b2$var$k.isActive = function() {
    return !!this.h && this.h.isActive(this);
};
function $7ebea6b2d35970b2$var$Nd() {}
$7ebea6b2d35970b2$var$k = $7ebea6b2d35970b2$var$Nd.prototype;
$7ebea6b2d35970b2$var$k.Ba = function() {};
$7ebea6b2d35970b2$var$k.Aa = function() {};
$7ebea6b2d35970b2$var$k.za = function() {};
$7ebea6b2d35970b2$var$k.ya = function() {};
$7ebea6b2d35970b2$var$k.isActive = function() {
    return !0;
};
$7ebea6b2d35970b2$var$k.Va = function() {};
function $7ebea6b2d35970b2$var$Od() {
    if ($7ebea6b2d35970b2$var$z && !(10 <= Number($7ebea6b2d35970b2$var$Fa))) throw Error("Environmental error: no available transport.");
}
$7ebea6b2d35970b2$var$Od.prototype.g = function(a, b) {
    return new $7ebea6b2d35970b2$var$Q(a, b);
};
function $7ebea6b2d35970b2$var$Q(a, b) {
    $7ebea6b2d35970b2$var$B.call(this);
    this.g = new $7ebea6b2d35970b2$var$Ed(b);
    this.l = a;
    this.h = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.g.s = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.Ca && (a ? a["X-WebChannel-Client-Profile"] = b.Ca : a = {
        "X-WebChannel-Client-Profile": b.Ca
    });
    this.g.U = a;
    (a = b && b.cc) && !$7ebea6b2d35970b2$var$x(a) && (this.g.o = a);
    this.A = b && b.supportsCrossDomainXhr || !1;
    this.v = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$7ebea6b2d35970b2$var$x(b) && (this.g.F = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
    this.j = new $7ebea6b2d35970b2$var$R(this);
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Q, $7ebea6b2d35970b2$var$B);
$7ebea6b2d35970b2$var$Q.prototype.m = function() {
    this.g.h = this.j;
    this.A && (this.g.J = !0);
    var a = this.g, b = this.l, c = this.h || void 0;
    $7ebea6b2d35970b2$var$F(0);
    a.Y = b;
    a.na = c || {};
    a.G = a.aa;
    a.I = $7ebea6b2d35970b2$var$Dc(a, null, a.Y);
    $7ebea6b2d35970b2$var$Gc(a);
};
$7ebea6b2d35970b2$var$Q.prototype.close = function() {
    $7ebea6b2d35970b2$var$Hc(this.g);
};
$7ebea6b2d35970b2$var$Q.prototype.u = function(a) {
    var b = this.g;
    if ("string" === typeof a) {
        var c = {};
        c.__data__ = a;
        a = c;
    } else this.v && (c = {}, c.__data__ = $7ebea6b2d35970b2$var$jb(a), a = c);
    b.j.push(new $7ebea6b2d35970b2$var$bd(b.fb++, a));
    3 == b.H && $7ebea6b2d35970b2$var$Gc(b);
};
$7ebea6b2d35970b2$var$Q.prototype.N = function() {
    this.g.h = null;
    delete this.j;
    $7ebea6b2d35970b2$var$Hc(this.g);
    delete this.g;
    $7ebea6b2d35970b2$var$Q.$.N.call(this);
};
function $7ebea6b2d35970b2$var$Pd(a) {
    $7ebea6b2d35970b2$var$Yb.call(this);
    a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
    var b = a.__sm__;
    if (b) {
        a: {
            for(const c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
        this.data = b;
    } else this.data = a;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Pd, $7ebea6b2d35970b2$var$Yb);
function $7ebea6b2d35970b2$var$Qd() {
    $7ebea6b2d35970b2$var$Zb.call(this);
    this.status = 1;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$Qd, $7ebea6b2d35970b2$var$Zb);
function $7ebea6b2d35970b2$var$R(a) {
    this.g = a;
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$R, $7ebea6b2d35970b2$var$Nd);
$7ebea6b2d35970b2$var$R.prototype.Ba = function() {
    $7ebea6b2d35970b2$var$C(this.g, "a");
};
$7ebea6b2d35970b2$var$R.prototype.Aa = function(a) {
    $7ebea6b2d35970b2$var$C(this.g, new $7ebea6b2d35970b2$var$Pd(a));
};
$7ebea6b2d35970b2$var$R.prototype.za = function(a) {
    $7ebea6b2d35970b2$var$C(this.g, new $7ebea6b2d35970b2$var$Qd());
};
$7ebea6b2d35970b2$var$R.prototype.ya = function() {
    $7ebea6b2d35970b2$var$C(this.g, "b");
};
function $7ebea6b2d35970b2$var$Rd() {
    this.blockSize = -1;
}
function $7ebea6b2d35970b2$var$S() {
    this.blockSize = -1;
    this.blockSize = 64;
    this.g = Array(4);
    this.m = Array(this.blockSize);
    this.i = this.h = 0;
    this.reset();
}
$7ebea6b2d35970b2$var$r($7ebea6b2d35970b2$var$S, $7ebea6b2d35970b2$var$Rd);
$7ebea6b2d35970b2$var$S.prototype.reset = function() {
    this.g[0] = 1732584193;
    this.g[1] = 4023233417;
    this.g[2] = 2562383102;
    this.g[3] = 271733878;
    this.i = this.h = 0;
};
function $7ebea6b2d35970b2$var$Sd(a, b, c) {
    c || (c = 0);
    var d = Array(16);
    if ("string" === typeof b) for(var e = 0; 16 > e; ++e)d[e] = b.charCodeAt(c++) | b.charCodeAt(c++) << 8 | b.charCodeAt(c++) << 16 | b.charCodeAt(c++) << 24;
    else for(e = 0; 16 > e; ++e)d[e] = b[c++] | b[c++] << 8 | b[c++] << 16 | b[c++] << 24;
    b = a.g[0];
    c = a.g[1];
    e = a.g[2];
    var f = a.g[3];
    var h = b + (f ^ c & (e ^ f)) + d[0] + 3614090360 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[1] + 3905402710 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[2] + 606105819 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[3] + 3250441966 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[4] + 4118548399 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[5] + 1200080426 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[6] + 2821735955 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[7] + 4249261313 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[8] + 1770035416 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[9] + 2336552879 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[10] + 4294925233 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[11] + 2304563134 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[12] + 1804603682 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[13] + 4254626195 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[14] + 2792965006 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[15] + 1236535329 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (e ^ f & (c ^ e)) + d[1] + 4129170786 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[6] + 3225465664 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[11] + 643717713 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[0] + 3921069994 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[5] + 3593408605 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[10] + 38016083 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[15] + 3634488961 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[4] + 3889429448 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[9] + 568446438 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[14] + 3275163606 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[3] + 4107603335 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[8] + 1163531501 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[13] + 2850285829 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[2] + 4243563512 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[7] + 1735328473 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[12] + 2368359562 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (c ^ e ^ f) + d[5] + 4294588738 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[8] + 2272392833 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[11] + 1839030562 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[14] + 4259657740 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[1] + 2763975236 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[4] + 1272893353 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[7] + 4139469664 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[10] + 3200236656 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[13] + 681279174 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[0] + 3936430074 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[3] + 3572445317 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[6] + 76029189 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[9] + 3654602809 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[12] + 3873151461 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[15] + 530742520 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[2] + 3299628645 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (e ^ (c | ~f)) + d[0] + 4096336452 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[7] + 1126891415 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[14] + 2878612391 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[5] + 4237533241 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[12] + 1700485571 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[3] + 2399980690 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[10] + 4293915773 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[1] + 2240044497 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[8] + 1873313359 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[15] + 4264355552 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[6] + 2734768916 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[13] + 1309151649 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[4] + 4149444226 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[11] + 3174756917 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[2] + 718787259 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[9] + 3951481745 & 4294967295;
    a.g[0] = a.g[0] + b & 4294967295;
    a.g[1] = a.g[1] + (e + (h << 21 & 4294967295 | h >>> 11)) & 4294967295;
    a.g[2] = a.g[2] + e & 4294967295;
    a.g[3] = a.g[3] + f & 4294967295;
}
$7ebea6b2d35970b2$var$S.prototype.j = function(a, b) {
    void 0 === b && (b = a.length);
    for(var c = b - this.blockSize, d = this.m, e = this.h, f = 0; f < b;){
        if (0 == e) for(; f <= c;)$7ebea6b2d35970b2$var$Sd(this, a, f), f += this.blockSize;
        if ("string" === typeof a) {
            for(; f < b;)if (d[e++] = a.charCodeAt(f++), e == this.blockSize) {
                $7ebea6b2d35970b2$var$Sd(this, d);
                e = 0;
                break;
            }
        } else for(; f < b;)if (d[e++] = a[f++], e == this.blockSize) {
            $7ebea6b2d35970b2$var$Sd(this, d);
            e = 0;
            break;
        }
    }
    this.h = e;
    this.i += b;
};
$7ebea6b2d35970b2$var$S.prototype.l = function() {
    var a = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
    a[0] = 128;
    for(var b = 1; b < a.length - 8; ++b)a[b] = 0;
    var c = 8 * this.i;
    for(b = a.length - 8; b < a.length; ++b)a[b] = c & 255, c /= 256;
    this.j(a);
    a = Array(16);
    for(b = c = 0; 4 > b; ++b)for(var d = 0; 32 > d; d += 8)a[c++] = this.g[b] >>> d & 255;
    return a;
};
function $7ebea6b2d35970b2$var$T(a, b) {
    this.h = b;
    for(var c = [], d = !0, e = a.length - 1; 0 <= e; e--){
        var f = a[e] | 0;
        d && f == b || (c[e] = f, d = !1);
    }
    this.g = c;
}
var $7ebea6b2d35970b2$var$sa = {};
function $7ebea6b2d35970b2$var$Td(a) {
    return -128 <= a && 128 > a ? $7ebea6b2d35970b2$var$ra(a, function(b) {
        return new $7ebea6b2d35970b2$var$T([
            b | 0
        ], 0 > b ? -1 : 0);
    }) : new $7ebea6b2d35970b2$var$T([
        a | 0
    ], 0 > a ? -1 : 0);
}
function $7ebea6b2d35970b2$var$U(a) {
    if (isNaN(a) || !isFinite(a)) return $7ebea6b2d35970b2$var$V;
    if (0 > a) return $7ebea6b2d35970b2$var$W($7ebea6b2d35970b2$var$U(-a));
    for(var b = [], c = 1, d = 0; a >= c; d++)b[d] = a / c | 0, c *= $7ebea6b2d35970b2$var$Ud;
    return new $7ebea6b2d35970b2$var$T(b, 0);
}
function $7ebea6b2d35970b2$var$Vd(a, b) {
    if (0 == a.length) throw Error("number format error: empty string");
    b = b || 10;
    if (2 > b || 36 < b) throw Error("radix out of range: " + b);
    if ("-" == a.charAt(0)) return $7ebea6b2d35970b2$var$W($7ebea6b2d35970b2$var$Vd(a.substring(1), b));
    if (0 <= a.indexOf("-")) throw Error('number format error: interior "-" character');
    for(var c = $7ebea6b2d35970b2$var$U(Math.pow(b, 8)), d = $7ebea6b2d35970b2$var$V, e = 0; e < a.length; e += 8){
        var f = Math.min(8, a.length - e), h = parseInt(a.substring(e, e + f), b);
        8 > f ? (f = $7ebea6b2d35970b2$var$U(Math.pow(b, f)), d = d.R(f).add($7ebea6b2d35970b2$var$U(h))) : (d = d.R(c), d = d.add($7ebea6b2d35970b2$var$U(h)));
    }
    return d;
}
var $7ebea6b2d35970b2$var$Ud = 4294967296, $7ebea6b2d35970b2$var$V = $7ebea6b2d35970b2$var$Td(0), $7ebea6b2d35970b2$var$Wd = $7ebea6b2d35970b2$var$Td(1), $7ebea6b2d35970b2$var$Xd = $7ebea6b2d35970b2$var$Td(16777216);
$7ebea6b2d35970b2$var$k = $7ebea6b2d35970b2$var$T.prototype;
$7ebea6b2d35970b2$var$k.ea = function() {
    if ($7ebea6b2d35970b2$var$X(this)) return -$7ebea6b2d35970b2$var$W(this).ea();
    for(var a = 0, b = 1, c = 0; c < this.g.length; c++){
        var d = this.D(c);
        a += (0 <= d ? d : $7ebea6b2d35970b2$var$Ud + d) * b;
        b *= $7ebea6b2d35970b2$var$Ud;
    }
    return a;
};
$7ebea6b2d35970b2$var$k.toString = function(a) {
    a = a || 10;
    if (2 > a || 36 < a) throw Error("radix out of range: " + a);
    if ($7ebea6b2d35970b2$var$Y(this)) return "0";
    if ($7ebea6b2d35970b2$var$X(this)) return "-" + $7ebea6b2d35970b2$var$W(this).toString(a);
    for(var b = $7ebea6b2d35970b2$var$U(Math.pow(a, 6)), c = this, d = "";;){
        var e = $7ebea6b2d35970b2$var$Yd(c, b).g;
        c = $7ebea6b2d35970b2$var$Zd(c, e.R(b));
        var f = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(a);
        c = e;
        if ($7ebea6b2d35970b2$var$Y(c)) return f + d;
        for(; 6 > f.length;)f = "0" + f;
        d = f + d;
    }
};
$7ebea6b2d35970b2$var$k.D = function(a) {
    return 0 > a ? 0 : a < this.g.length ? this.g[a] : this.h;
};
function $7ebea6b2d35970b2$var$Y(a) {
    if (0 != a.h) return !1;
    for(var b = 0; b < a.g.length; b++)if (0 != a.g[b]) return !1;
    return !0;
}
function $7ebea6b2d35970b2$var$X(a) {
    return -1 == a.h;
}
$7ebea6b2d35970b2$var$k.X = function(a) {
    a = $7ebea6b2d35970b2$var$Zd(this, a);
    return $7ebea6b2d35970b2$var$X(a) ? -1 : $7ebea6b2d35970b2$var$Y(a) ? 0 : 1;
};
function $7ebea6b2d35970b2$var$W(a) {
    for(var b = a.g.length, c = [], d = 0; d < b; d++)c[d] = ~a.g[d];
    return new $7ebea6b2d35970b2$var$T(c, ~a.h).add($7ebea6b2d35970b2$var$Wd);
}
$7ebea6b2d35970b2$var$k.abs = function() {
    return $7ebea6b2d35970b2$var$X(this) ? $7ebea6b2d35970b2$var$W(this) : this;
};
$7ebea6b2d35970b2$var$k.add = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0, e = 0; e <= b; e++){
        var f = d + (this.D(e) & 65535) + (a.D(e) & 65535), h = (f >>> 16) + (this.D(e) >>> 16) + (a.D(e) >>> 16);
        d = h >>> 16;
        f &= 65535;
        h &= 65535;
        c[e] = h << 16 | f;
    }
    return new $7ebea6b2d35970b2$var$T(c, c[c.length - 1] & -2147483648 ? -1 : 0);
};
function $7ebea6b2d35970b2$var$Zd(a, b) {
    return a.add($7ebea6b2d35970b2$var$W(b));
}
$7ebea6b2d35970b2$var$k.R = function(a) {
    if ($7ebea6b2d35970b2$var$Y(this) || $7ebea6b2d35970b2$var$Y(a)) return $7ebea6b2d35970b2$var$V;
    if ($7ebea6b2d35970b2$var$X(this)) return $7ebea6b2d35970b2$var$X(a) ? $7ebea6b2d35970b2$var$W(this).R($7ebea6b2d35970b2$var$W(a)) : $7ebea6b2d35970b2$var$W($7ebea6b2d35970b2$var$W(this).R(a));
    if ($7ebea6b2d35970b2$var$X(a)) return $7ebea6b2d35970b2$var$W(this.R($7ebea6b2d35970b2$var$W(a)));
    if (0 > this.X($7ebea6b2d35970b2$var$Xd) && 0 > a.X($7ebea6b2d35970b2$var$Xd)) return $7ebea6b2d35970b2$var$U(this.ea() * a.ea());
    for(var b = this.g.length + a.g.length, c = [], d = 0; d < 2 * b; d++)c[d] = 0;
    for(d = 0; d < this.g.length; d++)for(var e = 0; e < a.g.length; e++){
        var f = this.D(d) >>> 16, h = this.D(d) & 65535, n = a.D(e) >>> 16, t = a.D(e) & 65535;
        c[2 * d + 2 * e] += h * t;
        $7ebea6b2d35970b2$var$$d(c, 2 * d + 2 * e);
        c[2 * d + 2 * e + 1] += f * t;
        $7ebea6b2d35970b2$var$$d(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 1] += h * n;
        $7ebea6b2d35970b2$var$$d(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 2] += f * n;
        $7ebea6b2d35970b2$var$$d(c, 2 * d + 2 * e + 2);
    }
    for(d = 0; d < b; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
    for(d = b; d < 2 * b; d++)c[d] = 0;
    return new $7ebea6b2d35970b2$var$T(c, 0);
};
function $7ebea6b2d35970b2$var$$d(a, b) {
    for(; (a[b] & 65535) != a[b];)a[b + 1] += a[b] >>> 16, a[b] &= 65535, b++;
}
function $7ebea6b2d35970b2$var$ae(a, b) {
    this.g = a;
    this.h = b;
}
function $7ebea6b2d35970b2$var$Yd(a, b) {
    if ($7ebea6b2d35970b2$var$Y(b)) throw Error("division by zero");
    if ($7ebea6b2d35970b2$var$Y(a)) return new $7ebea6b2d35970b2$var$ae($7ebea6b2d35970b2$var$V, $7ebea6b2d35970b2$var$V);
    if ($7ebea6b2d35970b2$var$X(a)) return b = $7ebea6b2d35970b2$var$Yd($7ebea6b2d35970b2$var$W(a), b), new $7ebea6b2d35970b2$var$ae($7ebea6b2d35970b2$var$W(b.g), $7ebea6b2d35970b2$var$W(b.h));
    if ($7ebea6b2d35970b2$var$X(b)) return b = $7ebea6b2d35970b2$var$Yd(a, $7ebea6b2d35970b2$var$W(b)), new $7ebea6b2d35970b2$var$ae($7ebea6b2d35970b2$var$W(b.g), b.h);
    if (30 < a.g.length) {
        if ($7ebea6b2d35970b2$var$X(a) || $7ebea6b2d35970b2$var$X(b)) throw Error("slowDivide_ only works with positive integers.");
        for(var c = $7ebea6b2d35970b2$var$Wd, d = b; 0 >= d.X(a);)c = $7ebea6b2d35970b2$var$be(c), d = $7ebea6b2d35970b2$var$be(d);
        var e = $7ebea6b2d35970b2$var$Z(c, 1), f = $7ebea6b2d35970b2$var$Z(d, 1);
        d = $7ebea6b2d35970b2$var$Z(d, 2);
        for(c = $7ebea6b2d35970b2$var$Z(c, 2); !$7ebea6b2d35970b2$var$Y(d);){
            var h = f.add(d);
            0 >= h.X(a) && (e = e.add(c), f = h);
            d = $7ebea6b2d35970b2$var$Z(d, 1);
            c = $7ebea6b2d35970b2$var$Z(c, 1);
        }
        b = $7ebea6b2d35970b2$var$Zd(a, e.R(b));
        return new $7ebea6b2d35970b2$var$ae(e, b);
    }
    for(e = $7ebea6b2d35970b2$var$V; 0 <= a.X(b);){
        c = Math.max(1, Math.floor(a.ea() / b.ea()));
        d = Math.ceil(Math.log(c) / Math.LN2);
        d = 48 >= d ? 1 : Math.pow(2, d - 48);
        f = $7ebea6b2d35970b2$var$U(c);
        for(h = f.R(b); $7ebea6b2d35970b2$var$X(h) || 0 < h.X(a);)c -= d, f = $7ebea6b2d35970b2$var$U(c), h = f.R(b);
        $7ebea6b2d35970b2$var$Y(f) && (f = $7ebea6b2d35970b2$var$Wd);
        e = e.add(f);
        a = $7ebea6b2d35970b2$var$Zd(a, h);
    }
    return new $7ebea6b2d35970b2$var$ae(e, a);
}
$7ebea6b2d35970b2$var$k.gb = function(a) {
    return $7ebea6b2d35970b2$var$Yd(this, a).h;
};
$7ebea6b2d35970b2$var$k.and = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) & a.D(d);
    return new $7ebea6b2d35970b2$var$T(c, this.h & a.h);
};
$7ebea6b2d35970b2$var$k.or = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) | a.D(d);
    return new $7ebea6b2d35970b2$var$T(c, this.h | a.h);
};
$7ebea6b2d35970b2$var$k.xor = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) ^ a.D(d);
    return new $7ebea6b2d35970b2$var$T(c, this.h ^ a.h);
};
function $7ebea6b2d35970b2$var$be(a) {
    for(var b = a.g.length + 1, c = [], d = 0; d < b; d++)c[d] = a.D(d) << 1 | a.D(d - 1) >>> 31;
    return new $7ebea6b2d35970b2$var$T(c, a.h);
}
function $7ebea6b2d35970b2$var$Z(a, b) {
    var c = b >> 5;
    b %= 32;
    for(var d = a.g.length - c, e = [], f = 0; f < d; f++)e[f] = 0 < b ? a.D(f + c) >>> b | a.D(f + c + 1) << 32 - b : a.D(f + c);
    return new $7ebea6b2d35970b2$var$T(e, a.h);
}
$7ebea6b2d35970b2$var$Od.prototype.createWebChannel = $7ebea6b2d35970b2$var$Od.prototype.g;
$7ebea6b2d35970b2$var$Q.prototype.send = $7ebea6b2d35970b2$var$Q.prototype.u;
$7ebea6b2d35970b2$var$Q.prototype.open = $7ebea6b2d35970b2$var$Q.prototype.m;
$7ebea6b2d35970b2$var$Q.prototype.close = $7ebea6b2d35970b2$var$Q.prototype.close;
$7ebea6b2d35970b2$var$Sb.NO_ERROR = 0;
$7ebea6b2d35970b2$var$Sb.TIMEOUT = 8;
$7ebea6b2d35970b2$var$Sb.HTTP_ERROR = 6;
$7ebea6b2d35970b2$var$Tb.COMPLETE = "complete";
$7ebea6b2d35970b2$var$Wb.EventType = $7ebea6b2d35970b2$var$Xb;
$7ebea6b2d35970b2$var$Xb.OPEN = "a";
$7ebea6b2d35970b2$var$Xb.CLOSE = "b";
$7ebea6b2d35970b2$var$Xb.ERROR = "c";
$7ebea6b2d35970b2$var$Xb.MESSAGE = "d";
$7ebea6b2d35970b2$var$B.prototype.listen = $7ebea6b2d35970b2$var$B.prototype.O;
$7ebea6b2d35970b2$var$P.prototype.listenOnce = $7ebea6b2d35970b2$var$P.prototype.P;
$7ebea6b2d35970b2$var$P.prototype.getLastError = $7ebea6b2d35970b2$var$P.prototype.Sa;
$7ebea6b2d35970b2$var$P.prototype.getLastErrorCode = $7ebea6b2d35970b2$var$P.prototype.Ia;
$7ebea6b2d35970b2$var$P.prototype.getStatus = $7ebea6b2d35970b2$var$P.prototype.da;
$7ebea6b2d35970b2$var$P.prototype.getResponseJson = $7ebea6b2d35970b2$var$P.prototype.Wa;
$7ebea6b2d35970b2$var$P.prototype.getResponseText = $7ebea6b2d35970b2$var$P.prototype.ja;
$7ebea6b2d35970b2$var$P.prototype.send = $7ebea6b2d35970b2$var$P.prototype.ha;
$7ebea6b2d35970b2$var$P.prototype.setWithCredentials = $7ebea6b2d35970b2$var$P.prototype.Oa;
$7ebea6b2d35970b2$var$S.prototype.digest = $7ebea6b2d35970b2$var$S.prototype.l;
$7ebea6b2d35970b2$var$S.prototype.reset = $7ebea6b2d35970b2$var$S.prototype.reset;
$7ebea6b2d35970b2$var$S.prototype.update = $7ebea6b2d35970b2$var$S.prototype.j;
$7ebea6b2d35970b2$var$T.prototype.add = $7ebea6b2d35970b2$var$T.prototype.add;
$7ebea6b2d35970b2$var$T.prototype.multiply = $7ebea6b2d35970b2$var$T.prototype.R;
$7ebea6b2d35970b2$var$T.prototype.modulo = $7ebea6b2d35970b2$var$T.prototype.gb;
$7ebea6b2d35970b2$var$T.prototype.compare = $7ebea6b2d35970b2$var$T.prototype.X;
$7ebea6b2d35970b2$var$T.prototype.toNumber = $7ebea6b2d35970b2$var$T.prototype.ea;
$7ebea6b2d35970b2$var$T.prototype.toString = $7ebea6b2d35970b2$var$T.prototype.toString;
$7ebea6b2d35970b2$var$T.prototype.getBits = $7ebea6b2d35970b2$var$T.prototype.D;
$7ebea6b2d35970b2$var$T.fromNumber = $7ebea6b2d35970b2$var$U;
$7ebea6b2d35970b2$var$T.fromString = $7ebea6b2d35970b2$var$Vd;
var $7ebea6b2d35970b2$export$66869136fc133c3a = $7ebea6b2d35970b2$export$2e2bcd8739ae039.createWebChannelTransport = function() {
    return new $7ebea6b2d35970b2$var$Od;
};
var $7ebea6b2d35970b2$export$888d0d9ab79d08fc = $7ebea6b2d35970b2$export$2e2bcd8739ae039.getStatEventTarget = function() {
    return $7ebea6b2d35970b2$var$Mb();
};
var $7ebea6b2d35970b2$export$d4e71bc0b80dc0fb = $7ebea6b2d35970b2$export$2e2bcd8739ae039.ErrorCode = $7ebea6b2d35970b2$var$Sb;
var $7ebea6b2d35970b2$export$3d7865934588d77e = $7ebea6b2d35970b2$export$2e2bcd8739ae039.EventType = $7ebea6b2d35970b2$var$Tb;
var $7ebea6b2d35970b2$export$d61e24a684f9e51 = $7ebea6b2d35970b2$export$2e2bcd8739ae039.Event = $7ebea6b2d35970b2$var$E;
var $7ebea6b2d35970b2$export$cbbc350c1dfc80cb = $7ebea6b2d35970b2$export$2e2bcd8739ae039.Stat = {
    xb: 0,
    Ab: 1,
    Bb: 2,
    Ub: 3,
    Zb: 4,
    Wb: 5,
    Xb: 6,
    Vb: 7,
    Tb: 8,
    Yb: 9,
    PROXY: 10,
    NOPROXY: 11,
    Rb: 12,
    Nb: 13,
    Ob: 14,
    Mb: 15,
    Pb: 16,
    Qb: 17,
    tb: 18,
    sb: 19,
    ub: 20
};
var $7ebea6b2d35970b2$export$ddb1030448106742 = $7ebea6b2d35970b2$export$2e2bcd8739ae039.FetchXmlHttpFactory = $7ebea6b2d35970b2$var$ld;
var $7ebea6b2d35970b2$export$aa726fb96ad3e039 = $7ebea6b2d35970b2$export$2e2bcd8739ae039.WebChannel = $7ebea6b2d35970b2$var$Wb;
var $7ebea6b2d35970b2$export$26404658cda3ee02 = $7ebea6b2d35970b2$export$2e2bcd8739ae039.XhrIo = $7ebea6b2d35970b2$var$P;
var $7ebea6b2d35970b2$export$9f5a3dfc7a9f5dd = $7ebea6b2d35970b2$export$2e2bcd8739ae039.Md5 = $7ebea6b2d35970b2$var$S;
var $7ebea6b2d35970b2$export$70ffa26850098d01 = $7ebea6b2d35970b2$export$2e2bcd8739ae039.Integer = $7ebea6b2d35970b2$var$T;

});



parcelRequire.register("fivgP", function(module, exports) {
/*
* Notiflix Report AIO (https://notiflix.github.io)
* Description: This file has been created automatically that using "notiflix.js", and "notiflix.css" files.
* Version: 3.2.6
* Author: Furkan (https://github.com/furcan)
* Copyright 2019 - 2023 Notiflix, MIT Licence (https://opensource.org/licenses/MIT)
*/ /* global define */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define([], function() {
        return factory(root);
    });
    else if (typeof module.exports === "object") module.exports = factory(root);
    else root.Notiflix = factory(root);
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : module.exports, function(window1) {
    "use strict";
    // COMMON: SSR check: begin
    if (typeof window1 === "undefined" && typeof window1.document === "undefined") return false;
    // COMMON: SSR check: end
    // COMMON: Variables: begin
    var notiflixNamespace = "Notiflix";
    var notiflixConsoleDocs = "\n\nVisit documentation page to learn more: https://notiflix.github.io/documentation";
    var defaultFontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif';
    // COMMON: Variables: end
    // REPORT: Default Settings: begin
    var typesReport = {
        Success: "Success",
        Failure: "Failure",
        Warning: "Warning",
        Info: "Info"
    };
    var newReportSettings;
    var reportSettings = {
        ID: "NotiflixReportWrap",
        className: "notiflix-report",
        width: "320px",
        backgroundColor: "#f8f8f8",
        borderRadius: "25px",
        rtl: false,
        zindex: 4002,
        backOverlay: true,
        backOverlayColor: "rgba(0,0,0,0.5)",
        backOverlayClickToClose: false,
        fontFamily: "Quicksand",
        svgSize: "110px",
        plainText: true,
        titleFontSize: "16px",
        titleMaxLength: 34,
        messageFontSize: "13px",
        messageMaxLength: 400,
        buttonFontSize: "14px",
        buttonMaxLength: 34,
        cssAnimation: true,
        cssAnimationDuration: 360,
        cssAnimationStyle: "fade",
        success: {
            svgColor: "#32c682",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#32c682",
            buttonColor: "#fff",
            backOverlayColor: "rgba(50,198,130,0.2)"
        },
        failure: {
            svgColor: "#ff5549",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#ff5549",
            buttonColor: "#fff",
            backOverlayColor: "rgba(255,85,73,0.2)"
        },
        warning: {
            svgColor: "#eebf31",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#eebf31",
            buttonColor: "#fff",
            backOverlayColor: "rgba(238,191,49,0.2)"
        },
        info: {
            svgColor: "#26c0d3",
            titleColor: "#1e1e1e",
            messageColor: "#242424",
            buttonBackground: "#26c0d3",
            buttonColor: "#fff",
            backOverlayColor: "rgba(38,192,211,0.2)"
        }
    };
    // REPORT: Default Settings: end
    // COMMON: Console Error: begin
    var commonConsoleError = function(message) {
        return console.error("%c " + notiflixNamespace + " Error ", "padding:2px;border-radius:20px;color:#fff;background:#ff5549", "\n" + message + notiflixConsoleDocs);
    };
    // COMMON: Console Error: end
    // COMMON: Check Head or Body: begin
    var commonCheckHeadOrBody = function(element) {
        if (!element) element = "head";
        if (window1.document[element] === null) {
            commonConsoleError('\nNotiflix needs to be appended to the "<' + element + '>" element, but you called it before the "<' + element + '>" element has been created.');
            return false;
        }
        return true;
    };
    // COMMON: Check Head or Body: end
    // COMMON: Set Internal CSS Codes: begin
    var commonSetInternalCSSCodes = function(getInternalCSSCodes, styleElementId) {
        // check doc head
        if (!commonCheckHeadOrBody("head")) return false;
        // internal css
        if (getInternalCSSCodes() !== null && !window1.document.getElementById(styleElementId)) {
            var internalCSS = window1.document.createElement("style");
            internalCSS.id = styleElementId;
            internalCSS.innerHTML = getInternalCSSCodes();
            window1.document.head.appendChild(internalCSS);
        }
    };
    // COMMON: Set Internal CSS Codes: end
    // COMMON: Extend Options: begin
    var commonExtendOptions = function() {
        // variables
        var extended = {};
        var deep = false;
        var i = 0;
        // check if a deep merge
        if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]") {
            deep = arguments[0];
            i++;
        }
        // merge the object into the extended object
        var merge = function(obj) {
            for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                // if property is an object, merge properties
                if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") extended[prop] = commonExtendOptions(extended[prop], obj[prop]);
                else extended[prop] = obj[prop];
            }
        };
        // loop through each object and conduct a merge
        for(; i < arguments.length; i++)merge(arguments[i]);
        return extended;
    };
    // COMMON: Extend Options: end
    // COMMON: Get Plaintext: begin
    var commonGetPlaintext = function(html) {
        var htmlPool = window1.document.createElement("div");
        htmlPool.innerHTML = html;
        return htmlPool.textContent || htmlPool.innerText || "";
    };
    // COMMON: Get Plaintext: end
    // REPORT: SVG Icon Success: begin
    var reportSvgIconSuccess = function(width, color) {
        if (!width) width = "110px";
        if (!color) color = "#32c682";
        var reportSvgSuccess = '<svg xmlns="http://www.w3.org/2000/svg" id="NXReportSuccess" width="' + width + '" height="' + width + '" fill="' + color + '" viewBox="0 0 120 120"><style>@-webkit-keyframes NXReportSuccess1-animation{0%{-webkit-transform:translate(60px,57.7px) scale(.5,.5) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(.5,.5) translate(-60px,-57.7px)}50%,to{-webkit-transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px)}60%{-webkit-transform:translate(60px,57.7px) scale(.95,.95) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(.95,.95) translate(-60px,-57.7px)}}@keyframes NXReportSuccess1-animation{0%{-webkit-transform:translate(60px,57.7px) scale(.5,.5) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(.5,.5) translate(-60px,-57.7px)}50%,to{-webkit-transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px)}60%{-webkit-transform:translate(60px,57.7px) scale(.95,.95) translate(-60px,-57.7px);transform:translate(60px,57.7px) scale(.95,.95) translate(-60px,-57.7px)}}@-webkit-keyframes NXReportSuccess4-animation{0%{opacity:0}50%,to{opacity:1}}@keyframes NXReportSuccess4-animation{0%{opacity:0}50%,to{opacity:1}}@-webkit-keyframes NXReportSuccess3-animation{0%{opacity:0}40%,to{opacity:1}}@keyframes NXReportSuccess3-animation{0%{opacity:0}40%,to{opacity:1}}@-webkit-keyframes NXReportSuccess2-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportSuccess2-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}#NXReportSuccess *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g style="-webkit-animation-name:NXReportSuccess2-animation;animation-name:NXReportSuccess2-animation;-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)"><path d="M60 115.38C29.46 115.38 4.62 90.54 4.62 60 4.62 29.46 29.46 4.62 60 4.62c30.54 0 55.38 24.84 55.38 55.38 0 30.54-24.84 55.38-55.38 55.38zM60 0C26.92 0 0 26.92 0 60s26.92 60 60 60 60-26.92 60-60S93.08 0 60 0z" style="-webkit-animation-name:NXReportSuccess3-animation;animation-name:NXReportSuccess3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g><g style="-webkit-animation-name:NXReportSuccess1-animation;animation-name:NXReportSuccess1-animation;-webkit-transform:translate(60px,57.7px) scale(1,1) translate(-60px,-57.7px);-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)"><path d="M88.27 35.39L52.8 75.29 31.43 58.2c-.98-.81-2.44-.63-3.24.36-.79.99-.63 2.44.36 3.24l23.08 18.46c.43.34.93.51 1.44.51.64 0 1.27-.26 1.74-.78l36.91-41.53a2.3 2.3 0 0 0-.19-3.26c-.95-.86-2.41-.77-3.26.19z" style="-webkit-animation-name:NXReportSuccess4-animation;animation-name:NXReportSuccess4-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g></svg>';
        return reportSvgSuccess;
    };
    // REPORT: SVG Icon Success: end
    // REPORT: SVG Icon Failure: begin
    var reportSvgIconFailure = function(width, color) {
        if (!width) width = "110px";
        if (!color) color = "#ff5549";
        var reportSvgFailure = '<svg xmlns="http://www.w3.org/2000/svg" id="NXReportFailure" width="' + width + '" height="' + width + '" fill="' + color + '" viewBox="0 0 120 120"><style>@-webkit-keyframes NXReportFailure2-animation{0%{opacity:0}40%,to{opacity:1}}@keyframes NXReportFailure2-animation{0%{opacity:0}40%,to{opacity:1}}@-webkit-keyframes NXReportFailure1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportFailure1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@-webkit-keyframes NXReportFailure3-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}50%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportFailure3-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}50%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@-webkit-keyframes NXReportFailure4-animation{0%{opacity:0}50%,to{opacity:1}}@keyframes NXReportFailure4-animation{0%{opacity:0}50%,to{opacity:1}}#NXReportFailure *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g style="-webkit-animation-name:NXReportFailure1-animation;animation-name:NXReportFailure1-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M4.35 34.95c0-16.82 13.78-30.6 30.6-30.6h50.1c16.82 0 30.6 13.78 30.6 30.6v50.1c0 16.82-13.78 30.6-30.6 30.6h-50.1c-16.82 0-30.6-13.78-30.6-30.6v-50.1zM34.95 120h50.1c19.22 0 34.95-15.73 34.95-34.95v-50.1C120 15.73 104.27 0 85.05 0h-50.1C15.73 0 0 15.73 0 34.95v50.1C0 104.27 15.73 120 34.95 120z" style="-webkit-animation-name:NXReportFailure2-animation;animation-name:NXReportFailure2-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g><g style="-webkit-animation-name:NXReportFailure3-animation;animation-name:NXReportFailure3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M82.4 37.6c-.9-.9-2.37-.9-3.27 0L60 56.73 40.86 37.6a2.306 2.306 0 0 0-3.26 3.26L56.73 60 37.6 79.13c-.9.9-.9 2.37 0 3.27.45.45 1.04.68 1.63.68.59 0 1.18-.23 1.63-.68L60 63.26 79.13 82.4c.45.45 1.05.68 1.64.68.58 0 1.18-.23 1.63-.68.9-.9.9-2.37 0-3.27L63.26 60 82.4 40.86c.9-.91.9-2.36 0-3.26z" style="-webkit-animation-name:NXReportFailure4-animation;animation-name:NXReportFailure4-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g></svg>';
        return reportSvgFailure;
    };
    // REPORT: SVG Icon Failure: end
    // REPORT: SVG Icon Warning: begin
    var reportSvgIconWarning = function(width, color) {
        if (!width) width = "110px";
        if (!color) color = "#eebf31";
        var reportSvgWarning = '<svg xmlns="http://www.w3.org/2000/svg" id="NXReportWarning" width="' + width + '" height="' + width + '" fill="' + color + '" viewBox="0 0 120 120"><style>@-webkit-keyframes NXReportWarning2-animation{0%{opacity:0}40%,to{opacity:1}}@keyframes NXReportWarning2-animation{0%{opacity:0}40%,to{opacity:1}}@-webkit-keyframes NXReportWarning1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportWarning1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@-webkit-keyframes NXReportWarning3-animation{0%{-webkit-transform:translate(60px,66.6px) scale(.5,.5) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(.5,.5) translate(-60px,-66.6px)}50%,to{-webkit-transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px)}60%{-webkit-transform:translate(60px,66.6px) scale(.95,.95) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(.95,.95) translate(-60px,-66.6px)}}@keyframes NXReportWarning3-animation{0%{-webkit-transform:translate(60px,66.6px) scale(.5,.5) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(.5,.5) translate(-60px,-66.6px)}50%,to{-webkit-transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px)}60%{-webkit-transform:translate(60px,66.6px) scale(.95,.95) translate(-60px,-66.6px);transform:translate(60px,66.6px) scale(.95,.95) translate(-60px,-66.6px)}}@-webkit-keyframes NXReportWarning4-animation{0%{opacity:0}50%,to{opacity:1}}@keyframes NXReportWarning4-animation{0%{opacity:0}50%,to{opacity:1}}#NXReportWarning *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g style="-webkit-animation-name:NXReportWarning1-animation;animation-name:NXReportWarning1-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M115.46 106.15l-54.04-93.8c-.61-1.06-2.23-1.06-2.84 0l-54.04 93.8c-.62 1.07.21 2.29 1.42 2.29h108.08c1.21 0 2.04-1.22 1.42-2.29zM65.17 10.2l54.04 93.8c2.28 3.96-.65 8.78-5.17 8.78H5.96c-4.52 0-7.45-4.82-5.17-8.78l54.04-93.8c2.28-3.95 8.03-4 10.34 0z" style="-webkit-animation-name:NXReportWarning2-animation;animation-name:NXReportWarning2-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g><g style="-webkit-animation-name:NXReportWarning3-animation;animation-name:NXReportWarning3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,66.6px) scale(1,1) translate(-60px,-66.6px)"><path d="M57.83 94.01c0 1.2.97 2.17 2.17 2.17s2.17-.97 2.17-2.17v-3.2c0-1.2-.97-2.17-2.17-2.17s-2.17.97-2.17 2.17v3.2zm0-14.15c0 1.2.97 2.17 2.17 2.17s2.17-.97 2.17-2.17V39.21c0-1.2-.97-2.17-2.17-2.17s-2.17.97-2.17 2.17v40.65z" style="-webkit-animation-name:NXReportWarning4-animation;animation-name:NXReportWarning4-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g></svg>';
        return reportSvgWarning;
    };
    // REPORT: SVG Icon Warning: end
    // REPORT: SVG Icon Info: begin
    var reportSvgIconInfo = function(width, color) {
        if (!width) width = "110px";
        if (!color) color = "#26c0d3";
        var reportSvgInfo = '<svg xmlns="http://www.w3.org/2000/svg" id="NXReportInfo" width="' + width + '" height="' + width + '" fill="' + color + '" viewBox="0 0 120 120"><style>@-webkit-keyframes NXReportInfo4-animation{0%{opacity:0}50%,to{opacity:1}}@keyframes NXReportInfo4-animation{0%{opacity:0}50%,to{opacity:1}}@-webkit-keyframes NXReportInfo3-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}50%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportInfo3-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}50%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@-webkit-keyframes NXReportInfo2-animation{0%{opacity:0}40%,to{opacity:1}}@keyframes NXReportInfo2-animation{0%{opacity:0}40%,to{opacity:1}}@-webkit-keyframes NXReportInfo1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}@keyframes NXReportInfo1-animation{0%{-webkit-transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px);transform:translate(60px,60px) scale(.5,.5) translate(-60px,-60px)}40%,to{-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px);transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)}60%{-webkit-transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px);transform:translate(60px,60px) scale(.95,.95) translate(-60px,-60px)}}#NXReportInfo *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g style="-webkit-animation-name:NXReportInfo1-animation;animation-name:NXReportInfo1-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M60 115.38C29.46 115.38 4.62 90.54 4.62 60 4.62 29.46 29.46 4.62 60 4.62c30.54 0 55.38 24.84 55.38 55.38 0 30.54-24.84 55.38-55.38 55.38zM60 0C26.92 0 0 26.92 0 60s26.92 60 60 60 60-26.92 60-60S93.08 0 60 0z" style="-webkit-animation-name:NXReportInfo2-animation;animation-name:NXReportInfo2-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g><g style="-webkit-animation-name:NXReportInfo3-animation;animation-name:NXReportInfo3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform:translate(60px,60px) scale(1,1) translate(-60px,-60px)"><path d="M57.75 43.85c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v48.18c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25V43.85zm0-15.88c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v3.32c0 1.25-1.01 2.25-2.25 2.25s-2.25-1-2.25-2.25v-3.32z" style="-webkit-animation-name:NXReportInfo4-animation;animation-name:NXReportInfo4-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1)" fill="inherit" data-animator-group="true" data-animator-type="2"/></g></svg>';
        return reportSvgInfo;
    };
    // REPORT: SVG Icon Info: end
    // REPORT: Get Internal CSS Codes: begin
    var reportGetInternalCSSCodes = function() {
        var reportCSS = '[id^=NotiflixReportWrap]{position:fixed;z-index:4002;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;font-family:"Quicksand",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;left:0;top:0;padding:10px;color:#1e1e1e;border-radius:25px;background:transparent;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}[id^=NotiflixReportWrap] *{-webkit-box-sizing:border-box;box-sizing:border-box}[id^=NotiflixReportWrap]>div[class*="-overlay"]{width:100%;height:100%;left:0;top:0;background:rgba(255,255,255,.5);position:fixed;z-index:0}[id^=NotiflixReportWrap]>div.nx-report-click-to-close{cursor:pointer}[id^=NotiflixReportWrap]>div[class*="-content"]{width:320px;max-width:100%;max-height:96vh;overflow-x:hidden;overflow-y:auto;border-radius:inherit;padding:10px;-webkit-filter:drop-shadow(0 0 5px rgba(0,0,0,0.05));filter:drop-shadow(0 0 5px rgba(0, 0, 0, .05));border:1px solid rgba(0,0,0,.03);background:#f8f8f8;position:relative;z-index:1}[id^=NotiflixReportWrap]>div[class*="-content"]::-webkit-scrollbar{width:0;height:0}[id^=NotiflixReportWrap]>div[class*="-content"]::-webkit-scrollbar-thumb{background:transparent}[id^=NotiflixReportWrap]>div[class*="-content"]::-webkit-scrollbar-track{background:transparent}[id^=NotiflixReportWrap]>div[class*="-content"]>div[class$="-icon"]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:110px;height:110px;display:block;margin:6px auto 12px}[id^=NotiflixReportWrap]>div[class*="-content"]>div[class$="-icon"] svg{min-width:100%;max-width:100%;height:auto}[id^=NotiflixReportWrap]>*>h5{word-break:break-all;word-break:break-word;font-family:inherit!important;font-size:16px;font-weight:500;line-height:1.4;margin:0 0 10px;padding:0 0 10px;border-bottom:1px solid rgba(0,0,0,.1);float:left;width:100%;text-align:center}[id^=NotiflixReportWrap]>*>p{word-break:break-all;word-break:break-word;font-family:inherit!important;font-size:13px;line-height:1.4;font-weight:normal;float:left;width:100%;padding:0 10px;margin:0 0 10px}[id^=NotiflixReportWrap] a#NXReportButton{word-break:break-all;word-break:break-word;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-family:inherit!important;-webkit-transition:all .25s ease-in-out;-o-transition:all .25s ease-in-out;transition:all .25s ease-in-out;cursor:pointer;float:right;padding:7px 17px;background:#32c682;font-size:14px;line-height:1.4;font-weight:500;border-radius:inherit!important;color:#fff}[id^=NotiflixReportWrap] a#NXReportButton:hover{-webkit-box-shadow:inset 0 -60px 5px -5px rgba(0,0,0,.25);box-shadow:inset 0 -60px 5px -5px rgba(0,0,0,.25)}[id^=NotiflixReportWrap].nx-rtl-on a#NXReportButton{float:left}[id^=NotiflixReportWrap]>div[class*="-overlay"].nx-with-animation{-webkit-animation:report-overlay-animation .3s ease-in-out 0s normal;animation:report-overlay-animation .3s ease-in-out 0s normal}@-webkit-keyframes report-overlay-animation{0%{opacity:0}100%{opacity:1}}@keyframes report-overlay-animation{0%{opacity:0}100%{opacity:1}}[id^=NotiflixReportWrap]>div[class*="-content"].nx-with-animation.nx-fade{-webkit-animation:report-animation-fade .3s ease-in-out 0s normal;animation:report-animation-fade .3s ease-in-out 0s normal}@-webkit-keyframes report-animation-fade{0%{opacity:0}100%{opacity:1}}@keyframes report-animation-fade{0%{opacity:0}100%{opacity:1}}[id^=NotiflixReportWrap]>div[class*="-content"].nx-with-animation.nx-zoom{-webkit-animation:report-animation-zoom .3s ease-in-out 0s normal;animation:report-animation-zoom .3s ease-in-out 0s normal}@-webkit-keyframes report-animation-zoom{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}50%{opacity:1;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes report-animation-zoom{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}50%{opacity:1;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}[id^=NotiflixReportWrap].nx-remove>div[class*="-overlay"].nx-with-animation{opacity:0;-webkit-animation:report-overlay-animation-remove .3s ease-in-out 0s normal;animation:report-overlay-animation-remove .3s ease-in-out 0s normal}@-webkit-keyframes report-overlay-animation-remove{0%{opacity:1}100%{opacity:0}}@keyframes report-overlay-animation-remove{0%{opacity:1}100%{opacity:0}}[id^=NotiflixReportWrap].nx-remove>div[class*="-content"].nx-with-animation.nx-fade{opacity:0;-webkit-animation:report-animation-fade-remove .3s ease-in-out 0s normal;animation:report-animation-fade-remove .3s ease-in-out 0s normal}@-webkit-keyframes report-animation-fade-remove{0%{opacity:1}100%{opacity:0}}@keyframes report-animation-fade-remove{0%{opacity:1}100%{opacity:0}}[id^=NotiflixReportWrap].nx-remove>div[class*="-content"].nx-with-animation.nx-zoom{opacity:0;-webkit-animation:report-animation-zoom-remove .3s ease-in-out 0s normal;animation:report-animation-zoom-remove .3s ease-in-out 0s normal}@-webkit-keyframes report-animation-zoom-remove{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.5;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}}@keyframes report-animation-zoom-remove{0%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}50%{opacity:.5;-webkit-transform:scale(1.05);transform:scale(1.05)}100%{opacity:0;-webkit-transform:scale(0);transform:scale(0)}}';
        return reportCSS || null;
    };
    // REPORT: Get Internal CSS Codes: end
    // REPORT: Create: begin
    var reportCreate = function(reportType, title, message, buttonText, callbackOrOptions, options) {
        // check doc body
        if (!commonCheckHeadOrBody("body")) return false;
        // if not initialized pretend like init
        if (!newReportSettings) Notiflix.Report.init({});
        // create a backup for settings
        var newReportSettingsBackup = {};
        // check callbackOrOptions and options: begin
        if (typeof callbackOrOptions === "object" && !Array.isArray(callbackOrOptions) || typeof options === "object" && !Array.isArray(options)) {
            // new options
            var newOptions = {};
            if (typeof callbackOrOptions === "object") newOptions = callbackOrOptions;
            else if (typeof options === "object") newOptions = options;
            // extend the backup settings with new settings
            newReportSettingsBackup = commonExtendOptions(true, newReportSettings, {});
            // extend new settings with the options
            newReportSettings = commonExtendOptions(true, newReportSettings, newOptions);
        }
        // check callbackOrOptions and callback: end
        // report type
        var theType = newReportSettings[reportType.toLocaleLowerCase("en")];
        // check the arguments: begin
        if (typeof title !== "string") title = "Notiflix " + reportType;
        if (typeof message !== "string") {
            if (reportType === typesReport.Success) message = '"Do not try to become a person of success but try to become a person of value." <br><br>- Albert Einstein';
            else if (reportType === typesReport.Failure) message = '"Failure is simply the opportunity to begin again, this time more intelligently." <br><br>- Henry Ford';
            else if (reportType === typesReport.Warning) message = '"The peoples who want to live comfortably without producing and fatigue; they are doomed to lose their dignity, then liberty, and then independence and destiny." <br><br>- Mustafa Kemal Ataturk';
            else if (reportType === typesReport.Info) message = '"Knowledge rests not upon truth alone, but upon error also." <br><br>- Carl Gustav Jung';
        }
        if (typeof buttonText !== "string") buttonText = "Okay";
        // check the arguments: end
        // if plainText is true => HTML tags not allowed: begin
        if (newReportSettings.plainText) {
            title = commonGetPlaintext(title);
            message = commonGetPlaintext(message);
            buttonText = commonGetPlaintext(buttonText);
        }
        // if plainText is true => HTML tags not allowed: end
        // if plainText is false but the contents length more than ${title | message | buttonText}MaxLength => Possible HTML tags error: begin
        if (!newReportSettings.plainText) {
            if (title.length > newReportSettings.titleMaxLength) {
                title = "Possible HTML Tags Error";
                message = 'The "plainText" option is "false" and the title content length is more than the "titleMaxLength" option.';
                buttonText = "Okay";
            }
            if (message.length > newReportSettings.messageMaxLength) {
                title = "Possible HTML Tags Error";
                message = 'The "plainText" option is "false" and the message content length is more than the "messageMaxLength" option.';
                buttonText = "Okay";
            }
            if (buttonText.length > newReportSettings.buttonMaxLength) {
                title = "Possible HTML Tags Error";
                message = 'The "plainText" option is "false" and the button content length is more than the "buttonMaxLength" option.';
                buttonText = "Okay";
            }
        }
        // if plainText is false but the contents length more than ${title | message | buttonText}MaxLength => Possible HTML tags error: end
        // max length: begin
        if (title.length > newReportSettings.titleMaxLength) title = title.substring(0, newReportSettings.titleMaxLength) + "...";
        if (message.length > newReportSettings.messageMaxLength) message = message.substring(0, newReportSettings.messageMaxLength) + "...";
        if (buttonText.length > newReportSettings.buttonMaxLength) buttonText = buttonText.substring(0, newReportSettings.buttonMaxLength) + "...";
        // max length: end
        // if cssAnimaion is false => duration: begin
        if (!newReportSettings.cssAnimation) newReportSettings.cssAnimationDuration = 0;
        // if cssAnimaion is false => duration: end
        // report wrap: begin
        var ntflxReportWrap = window1.document.createElement("div");
        ntflxReportWrap.id = reportSettings.ID;
        ntflxReportWrap.className = newReportSettings.className;
        ntflxReportWrap.style.zIndex = newReportSettings.zindex;
        ntflxReportWrap.style.borderRadius = newReportSettings.borderRadius;
        ntflxReportWrap.style.fontFamily = '"' + newReportSettings.fontFamily + '", ' + defaultFontFamily;
        // rtl: begin
        if (newReportSettings.rtl) {
            ntflxReportWrap.setAttribute("dir", "rtl");
            ntflxReportWrap.classList.add("nx-rtl-on");
        }
        // rtl: end
        // position: begin
        ntflxReportWrap.style.display = "flex";
        ntflxReportWrap.style.flexWrap = "wrap";
        ntflxReportWrap.style.flexDirection = "column";
        ntflxReportWrap.style.alignItems = "center";
        ntflxReportWrap.style.justifyContent = "center";
        // position: end
        // overlay: begin
        var reportOverlay = "";
        var reportOverlayClickToClose = newReportSettings.backOverlayClickToClose === true;
        if (newReportSettings.backOverlay) reportOverlay = '<div class="' + newReportSettings.className + "-overlay" + (newReportSettings.cssAnimation ? " nx-with-animation" : "") + (reportOverlayClickToClose ? " nx-report-click-to-close" : "") + '" style="background:' + (theType.backOverlayColor || newReportSettings.backOverlayColor) + ";animation-duration:" + newReportSettings.cssAnimationDuration + 'ms;"></div>';
        // overlay: end
        // svg icon: begin
        var svgIcon = "";
        if (reportType === typesReport.Success) svgIcon = reportSvgIconSuccess(newReportSettings.svgSize, theType.svgColor);
        else if (reportType === typesReport.Failure) svgIcon = reportSvgIconFailure(newReportSettings.svgSize, theType.svgColor);
        else if (reportType === typesReport.Warning) svgIcon = reportSvgIconWarning(newReportSettings.svgSize, theType.svgColor);
        else if (reportType === typesReport.Info) svgIcon = reportSvgIconInfo(newReportSettings.svgSize, theType.svgColor);
        // svg icon: end
        ntflxReportWrap.innerHTML = reportOverlay + '<div class="' + newReportSettings.className + "-content" + (newReportSettings.cssAnimation ? " nx-with-animation " : "") + " nx-" + newReportSettings.cssAnimationStyle + '" style="width:' + newReportSettings.width + "; background:" + newReportSettings.backgroundColor + "; animation-duration:" + newReportSettings.cssAnimationDuration + 'ms;">' + '<div style="width:' + newReportSettings.svgSize + "; height:" + newReportSettings.svgSize + ';" class="' + newReportSettings.className + '-icon">' + svgIcon + "</div>" + '<h5 class="' + newReportSettings.className + '-title" style="font-weight:500; font-size:' + newReportSettings.titleFontSize + "; color:" + theType.titleColor + ';">' + title + "</h5>" + '<p class="' + newReportSettings.className + '-message" style="font-size:' + newReportSettings.messageFontSize + "; color:" + theType.messageColor + ';">' + message + "</p>" + '<a id="NXReportButton" class="' + newReportSettings.className + '-button" style="font-weight:500; font-size:' + newReportSettings.buttonFontSize + "; background:" + theType.buttonBackground + "; color:" + theType.buttonColor + ';">' + buttonText + "</a>" + "</div>";
        // if there is no report element
        if (!window1.document.getElementById(ntflxReportWrap.id)) {
            // append
            window1.document.body.appendChild(ntflxReportWrap);
            // report remove: begin
            var reportRemove = function() {
                var elementWrapper = window1.document.getElementById(ntflxReportWrap.id);
                elementWrapper.classList.add("nx-remove");
                var timeout = setTimeout(function() {
                    if (elementWrapper.parentNode !== null) elementWrapper.parentNode.removeChild(elementWrapper);
                    clearTimeout(timeout);
                }, newReportSettings.cssAnimationDuration);
            };
            // report remove: end
            // callback: begin
            var elementButton = window1.document.getElementById("NXReportButton");
            elementButton.addEventListener("click", function() {
                // if callback: begin
                if (typeof callbackOrOptions === "function") callbackOrOptions();
                // if callback: end
                // remove report
                reportRemove();
            });
            // callback: end
            // overlay click to close: begin
            if (reportOverlay && reportOverlayClickToClose) {
                var elementOverlay = window1.document.querySelector(".nx-report-click-to-close");
                elementOverlay.addEventListener("click", function() {
                    reportRemove();
                });
            }
        // overlay click to close: end
        }
        // report wrap: end
        // extend new settings with the backup settings
        newReportSettings = commonExtendOptions(true, newReportSettings, newReportSettingsBackup);
    };
    // REPORT: Create: end
    var Notiflix = {
        Report: {
            // Init
            init: function(userReportOptions) {
                // extend options
                newReportSettings = commonExtendOptions(true, reportSettings, userReportOptions);
                // internal css if exist
                commonSetInternalCSSCodes(reportGetInternalCSSCodes, "NotiflixReportInternalCSS");
            },
            // Merge First Init
            merge: function(userReportExtendOptions) {
                // if initialized already
                if (newReportSettings) newReportSettings = commonExtendOptions(true, newReportSettings, userReportExtendOptions);
                else {
                    commonConsoleError("You have to initialize the Report module before call Merge function.");
                    return false;
                }
            },
            // Success
            success: function(title, message, buttonText, callbackOrOptions, options) {
                reportCreate(typesReport.Success, title, message, buttonText, callbackOrOptions, options);
            },
            // Failure
            failure: function(title, message, buttonText, callbackOrOptions, options) {
                reportCreate(typesReport.Failure, title, message, buttonText, callbackOrOptions, options);
            },
            // Warning
            warning: function(title, message, buttonText, callbackOrOptions, options) {
                reportCreate(typesReport.Warning, title, message, buttonText, callbackOrOptions, options);
            },
            // Info
            info: function(title, message, buttonText, callbackOrOptions, options) {
                reportCreate(typesReport.Info, title, message, buttonText, callbackOrOptions, options);
            }
        }
    };
    if (typeof window1.Notiflix === "object") return commonExtendOptions(true, window1.Notiflix, {
        Report: Notiflix.Report
    });
    else return {
        Report: Notiflix.Report
    };
});

});


parcelRequire.register("32ZrB", function(module, exports) {
const $2381388f86a3d3bd$var$themeSwitcher = document.querySelector("#theme-switch");
const $2381388f86a3d3bd$var$savedTheme = localStorage.getItem("theme");
if ($2381388f86a3d3bd$var$savedTheme === "dark") {
    $2381388f86a3d3bd$var$themeSwitcher.checked = true;
    document.body.classList.add("dark-theme");
}
$2381388f86a3d3bd$var$themeSwitcher.addEventListener("click", ()=>{
    const newTheme = $2381388f86a3d3bd$var$savedTheme === "dark" ? "light" : "dark";
    localStorage.setItem("theme", newTheme);
    document.body.classList.toggle("dark-theme");
});

});

parcelRequire.register("7rQOT", function(module, exports) {
/*
* Notiflix Loading AIO (https://notiflix.github.io)
* Description: This file has been created automatically that using "notiflix.js", and "notiflix.css" files.
* Version: 3.2.6
* Author: Furkan (https://github.com/furcan)
* Copyright 2019 - 2023 Notiflix, MIT Licence (https://opensource.org/licenses/MIT)
*/ /* global define */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define([], function() {
        return factory(root);
    });
    else if (typeof module.exports === "object") module.exports = factory(root);
    else root.Notiflix = factory(root);
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : module.exports, function(window1) {
    "use strict";
    // COMMON: SSR check: begin
    if (typeof window1 === "undefined" && typeof window1.document === "undefined") return false;
    // COMMON: SSR check: end
    // COMMON: Variables: begin
    var notiflixNamespace = "Notiflix";
    var notiflixConsoleDocs = "\n\nVisit documentation page to learn more: https://notiflix.github.io/documentation";
    var defaultFontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif';
    // COMMON: Variables: end
    // LOADING: Default Settings: begin
    var typesLoading = {
        Standard: "Standard",
        Hourglass: "Hourglass",
        Circle: "Circle",
        Arrows: "Arrows",
        Dots: "Dots",
        Pulse: "Pulse",
        Custom: "Custom",
        Notiflix: "Notiflix"
    };
    var newLoadingSettings;
    var loadingSettings = {
        ID: "NotiflixLoadingWrap",
        className: "notiflix-loading",
        zindex: 4000,
        backgroundColor: "rgba(0,0,0,0.8)",
        rtl: false,
        fontFamily: "Quicksand",
        cssAnimation: true,
        cssAnimationDuration: 400,
        clickToClose: false,
        customSvgUrl: null,
        customSvgCode: null,
        svgSize: "80px",
        svgColor: "#32c682",
        messageID: "NotiflixLoadingMessage",
        messageFontSize: "15px",
        messageMaxLength: 34,
        messageColor: "#dcdcdc"
    };
    // LOADING: Default Settings: end
    // COMMON: Console Error: begin
    var commonConsoleError = function(message) {
        return console.error("%c " + notiflixNamespace + " Error ", "padding:2px;border-radius:20px;color:#fff;background:#ff5549", "\n" + message + notiflixConsoleDocs);
    };
    // COMMON: Console Error: end
    // COMMON: Check Head or Body: begin
    var commonCheckHeadOrBody = function(element) {
        if (!element) element = "head";
        if (window1.document[element] === null) {
            commonConsoleError('\nNotiflix needs to be appended to the "<' + element + '>" element, but you called it before the "<' + element + '>" element has been created.');
            return false;
        }
        return true;
    };
    // COMMON: Check Head or Body: end
    // COMMON: Set Internal CSS Codes: begin
    var commonSetInternalCSSCodes = function(getInternalCSSCodes, styleElementId) {
        // check doc head
        if (!commonCheckHeadOrBody("head")) return false;
        // internal css
        if (getInternalCSSCodes() !== null && !window1.document.getElementById(styleElementId)) {
            var internalCSS = window1.document.createElement("style");
            internalCSS.id = styleElementId;
            internalCSS.innerHTML = getInternalCSSCodes();
            window1.document.head.appendChild(internalCSS);
        }
    };
    // COMMON: Set Internal CSS Codes: end
    // COMMON: Extend Options: begin
    var commonExtendOptions = function() {
        // variables
        var extended = {};
        var deep = false;
        var i = 0;
        // check if a deep merge
        if (Object.prototype.toString.call(arguments[0]) === "[object Boolean]") {
            deep = arguments[0];
            i++;
        }
        // merge the object into the extended object
        var merge = function(obj) {
            for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                // if property is an object, merge properties
                if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") extended[prop] = commonExtendOptions(extended[prop], obj[prop]);
                else extended[prop] = obj[prop];
            }
        };
        // loop through each object and conduct a merge
        for(; i < arguments.length; i++)merge(arguments[i]);
        return extended;
    };
    // COMMON: Extend Options: end
    // COMMON: Get Plaintext: begin
    var commonGetPlaintext = function(html) {
        var htmlPool = window1.document.createElement("div");
        htmlPool.innerHTML = html;
        return htmlPool.textContent || htmlPool.innerText || "";
    };
    // COMMON: Get Plaintext: end
    // LOADING && BLOCK: SVG Icon Standard: begin
    var loadingAndBlockSvgIconStandard = function(width, color) {
        if (!width) width = "60px";
        if (!color) color = "#32c682";
        var standard = '<svg xmlns="http://www.w3.org/2000/svg" stroke="' + color + '" width="' + width + '" height="' + width + '" transform="scale(.8)" viewBox="0 0 38 38"><g fill="none" fill-rule="evenodd" stroke-width="2" transform="translate(1 1)"><circle cx="18" cy="18" r="18" stroke-opacity=".25"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" dur="1s" from="0 18 18" repeatCount="indefinite" to="360 18 18" type="rotate"/></path></g></svg>';
        return standard;
    };
    // LOADING && BLOCK: SVG Icon Standard: end
    // LOADING && BLOCK: SVG Icon Hourglass: begin
    var loadingAndBlockSvgIconHourglass = function(width, color) {
        if (!width) width = "60px";
        if (!color) color = "#32c682";
        var hourglass = '<svg xmlns="http://www.w3.org/2000/svg" id="NXLoadingHourglass" fill="' + color + '" width="' + width + '" height="' + width + '" viewBox="0 0 200 200"><style>@-webkit-keyframes NXhourglass5-animation{0%{-webkit-transform:scale(1,1);transform:scale(1,1)}16.67%{-webkit-transform:scale(1,.8);transform:scale(1,.8)}33.33%{-webkit-transform:scale(.88,.6);transform:scale(.88,.6)}37.5%{-webkit-transform:scale(.85,.55);transform:scale(.85,.55)}41.67%{-webkit-transform:scale(.8,.5);transform:scale(.8,.5)}45.83%{-webkit-transform:scale(.75,.45);transform:scale(.75,.45)}50%{-webkit-transform:scale(.7,.4);transform:scale(.7,.4)}54.17%{-webkit-transform:scale(.6,.35);transform:scale(.6,.35)}58.33%{-webkit-transform:scale(.5,.3);transform:scale(.5,.3)}83.33%,to{-webkit-transform:scale(.2,0);transform:scale(.2,0)}}@keyframes NXhourglass5-animation{0%{-webkit-transform:scale(1,1);transform:scale(1,1)}16.67%{-webkit-transform:scale(1,.8);transform:scale(1,.8)}33.33%{-webkit-transform:scale(.88,.6);transform:scale(.88,.6)}37.5%{-webkit-transform:scale(.85,.55);transform:scale(.85,.55)}41.67%{-webkit-transform:scale(.8,.5);transform:scale(.8,.5)}45.83%{-webkit-transform:scale(.75,.45);transform:scale(.75,.45)}50%{-webkit-transform:scale(.7,.4);transform:scale(.7,.4)}54.17%{-webkit-transform:scale(.6,.35);transform:scale(.6,.35)}58.33%{-webkit-transform:scale(.5,.3);transform:scale(.5,.3)}83.33%,to{-webkit-transform:scale(.2,0);transform:scale(.2,0)}}@-webkit-keyframes NXhourglass3-animation{0%{-webkit-transform:scale(1,.02);transform:scale(1,.02)}79.17%,to{-webkit-transform:scale(1,1);transform:scale(1,1)}}@keyframes NXhourglass3-animation{0%{-webkit-transform:scale(1,.02);transform:scale(1,.02)}79.17%,to{-webkit-transform:scale(1,1);transform:scale(1,1)}}@-webkit-keyframes NXhourglass1-animation{0%,83.33%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(180deg);transform:rotate(180deg)}}@keyframes NXhourglass1-animation{0%,83.33%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(180deg);transform:rotate(180deg)}}#NXLoadingHourglass *{-webkit-animation-duration:1.2s;animation-duration:1.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:cubic-bezier(0,0,1,1);animation-timing-function:cubic-bezier(0,0,1,1)}</style><g data-animator-group="true" data-animator-type="1" style="-webkit-animation-name:NXhourglass1-animation;animation-name:NXhourglass1-animation;-webkit-transform-origin:50% 50%;transform-origin:50% 50%;transform-box:fill-box"><g id="NXhourglass2" fill="inherit"><g data-animator-group="true" data-animator-type="2" style="-webkit-animation-name:NXhourglass3-animation;animation-name:NXhourglass3-animation;-webkit-animation-timing-function:cubic-bezier(.42,0,.58,1);animation-timing-function:cubic-bezier(.42,0,.58,1);-webkit-transform-origin:50% 100%;transform-origin:50% 100%;transform-box:fill-box" opacity=".4"><path id="NXhourglass4" d="M100 100l-34.38 32.08v31.14h68.76v-31.14z"/></g><g data-animator-group="true" data-animator-type="2" style="-webkit-animation-name:NXhourglass5-animation;animation-name:NXhourglass5-animation;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;transform-box:fill-box" opacity=".4"><path id="NXhourglass6" d="M100 100L65.62 67.92V36.78h68.76v31.14z"/></g><path d="M51.14 38.89h8.33v14.93c0 15.1 8.29 28.99 23.34 39.1 1.88 1.25 3.04 3.97 3.04 7.08s-1.16 5.83-3.04 7.09c-15.05 10.1-23.34 23.99-23.34 39.09v14.93h-8.33a4.859 4.859 0 1 0 0 9.72h97.72a4.859 4.859 0 1 0 0-9.72h-8.33v-14.93c0-15.1-8.29-28.99-23.34-39.09-1.88-1.26-3.04-3.98-3.04-7.09s1.16-5.83 3.04-7.08c15.05-10.11 23.34-24 23.34-39.1V38.89h8.33a4.859 4.859 0 1 0 0-9.72H51.14a4.859 4.859 0 1 0 0 9.72zm79.67 14.93c0 15.87-11.93 26.25-19.04 31.03-4.6 3.08-7.34 8.75-7.34 15.15 0 6.41 2.74 12.07 7.34 15.15 7.11 4.78 19.04 15.16 19.04 31.03v14.93H69.19v-14.93c0-15.87 11.93-26.25 19.04-31.02 4.6-3.09 7.34-8.75 7.34-15.16 0-6.4-2.74-12.07-7.34-15.15-7.11-4.78-19.04-15.16-19.04-31.03V38.89h61.62v14.93z"/></g></g></svg>';
        return hourglass;
    };
    // LOADING && BLOCK: SVG Icon Hourglass: end
    // LOADING && BLOCK: SVG Icon Circle: begin
    var loadingAndBlockSvgIconCircle = function(width, color) {
        if (!width) width = "60px";
        if (!color) color = "#32c682";
        var circle = '<svg xmlns="http://www.w3.org/2000/svg" width="' + width + '" height="' + width + '" viewBox="25 25 50 50" style="-webkit-animation:rotate 2s linear infinite;animation:rotate 2s linear infinite;height:' + width + ";-webkit-transform-origin:center center;-ms-transform-origin:center center;transform-origin:center center;width:" + width + ';position:absolute;top:0;left:0;margin:auto"><style>@-webkit-keyframes rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35}to{stroke-dasharray:89,200;stroke-dashoffset:-124}}@keyframes dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35}to{stroke-dasharray:89,200;stroke-dashoffset:-124}}</style><circle cx="50" cy="50" r="20" fill="none" stroke="' + color + '" stroke-width="2" style="-webkit-animation:dash 1.5s ease-in-out infinite,color 1.5s ease-in-out infinite;animation:dash 1.5s ease-in-out infinite,color 1.5s ease-in-out infinite" stroke-dasharray="150 200" stroke-dashoffset="-10" stroke-linecap="round"/></svg>';
        return circle;
    };
    // LOADING && BLOCK: SVG Icon Circle: end
    // LOADING && BLOCK: SVG Icon Arrows: begin
    var loadingAndBlockSvgIconArrows = function(width, color) {
        if (!width) width = "60px";
        if (!color) color = "#32c682";
        var arrows = '<svg xmlns="http://www.w3.org/2000/svg" fill="' + color + '" width="' + width + '" height="' + width + '" viewBox="0 0 128 128"><g><path fill="inherit" d="M109.25 55.5h-36l12-12a29.54 29.54 0 0 0-49.53 12H18.75A46.04 46.04 0 0 1 96.9 31.84l12.35-12.34v36zm-90.5 17h36l-12 12a29.54 29.54 0 0 0 49.53-12h16.97A46.04 46.04 0 0 1 31.1 96.16L18.74 108.5v-36z"/><animateTransform attributeName="transform" dur="1.5s" from="0 64 64" repeatCount="indefinite" to="360 64 64" type="rotate"/></g></svg>';
        return arrows;
    };
    // LOADING && BLOCK: SVG Icon Arrows: end
    // LOADING && BLOCK: SVG Icon Dots: begin
    var loadingAndBlockSvgIconDots = function(width, color) {
        if (!width) width = "60px";
        if (!color) color = "#32c682";
        var dots = '<svg xmlns="http://www.w3.org/2000/svg" fill="' + color + '" width="' + width + '" height="' + width + '" viewBox="0 0 100 100"><g transform="translate(25 50)"><circle r="9" fill="inherit" transform="scale(.239)"><animateTransform attributeName="transform" begin="-0.266s" calcMode="spline" dur="0.8s" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" keyTimes="0;0.5;1" repeatCount="indefinite" type="scale" values="0;1;0"/></circle></g><g transform="translate(50 50)"><circle r="9" fill="inherit" transform="scale(.00152)"><animateTransform attributeName="transform" begin="-0.133s" calcMode="spline" dur="0.8s" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" keyTimes="0;0.5;1" repeatCount="indefinite" type="scale" values="0;1;0"/></circle></g><g transform="translate(75 50)"><circle r="9" fill="inherit" transform="scale(.299)"><animateTransform attributeName="transform" begin="0s" calcMode="spline" dur="0.8s" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" keyTimes="0;0.5;1" repeatCount="indefinite" type="scale" values="0;1;0"/></circle></g></svg>';
        return dots;
    };
    // LOADING && BLOCK: SVG Icon Dots: end
    // LOADING && BLOCK: SVG Icon Pulse: begin
    var loadingAndBlockSvgIconPulse = function(width, color) {
        if (!width) width = "60px";
        if (!color) color = "#32c682";
        var pulse = '<svg xmlns="http://www.w3.org/2000/svg" stroke="' + color + '" width="' + width + '" height="' + width + '" viewBox="0 0 44 44"><g fill="none" fill-rule="evenodd" stroke-width="2"><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="0s" calcMode="spline" dur="1.8s" keySplines="0.165, 0.84, 0.44, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 20"/><animate attributeName="stroke-opacity" begin="0s" calcMode="spline" dur="1.8s" keySplines="0.3, 0.61, 0.355, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 0"/></circle><circle cx="22" cy="22" r="1"><animate attributeName="r" begin="-0.9s" calcMode="spline" dur="1.8s" keySplines="0.165, 0.84, 0.44, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 20"/><animate attributeName="stroke-opacity" begin="-0.9s" calcMode="spline" dur="1.8s" keySplines="0.3, 0.61, 0.355, 1" keyTimes="0; 1" repeatCount="indefinite" values="1; 0"/></circle></g></svg>';
        return pulse;
    };
    // LOADING && BLOCK: SVG Icon Pulse: end
    // LOADING && BLOCK: SVG Icon Notiflix: begin
    var loadingAndBlockSvgIconNotiflix = function(width, white, green) {
        if (!width) width = "60px";
        if (!white) white = "#f8f8f8";
        if (!green) green = "#32c682";
        var notiflixIcon = '<svg xmlns="http://www.w3.org/2000/svg" id="NXLoadingNotiflixLib" width="' + width + '" height="' + width + '" viewBox="0 0 200 200"><defs><style>@keyframes notiflix-n{0%{stroke-dashoffset:1000}to{stroke-dashoffset:0}}@keyframes notiflix-x{0%{stroke-dashoffset:1000}to{stroke-dashoffset:0}}@keyframes notiflix-dot{0%,to{stroke-width:0}50%{stroke-width:12}}.nx-icon-line{stroke:' + white + ';stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22;fill:none}</style></defs><path d="M47.97 135.05a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13z" style="animation-name:notiflix-dot;animation-timing-function:ease-in-out;animation-duration:1.25s;animation-iteration-count:infinite;animation-direction:normal" fill="' + green + '" stroke="' + green + '" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="22" stroke-width="12"/><path class="nx-icon-line" d="M10.14 144.76V87.55c0-5.68-4.54-41.36 37.83-41.36 42.36 0 37.82 35.68 37.82 41.36v57.21" style="animation-name:notiflix-n;animation-timing-function:linear;animation-duration:2.5s;animation-delay:0s;animation-iteration-count:infinite;animation-direction:normal" stroke-dasharray="500"/><path class="nx-icon-line" d="M115.06 144.49c24.98-32.68 49.96-65.35 74.94-98.03M114.89 46.6c25.09 32.58 50.19 65.17 75.29 97.75" style="animation-name:notiflix-x;animation-timing-function:linear;animation-duration:2.5s;animation-delay:.2s;animation-iteration-count:infinite;animation-direction:normal" stroke-dasharray="500"/></svg>';
        return notiflixIcon;
    };
    // LOADING && BLOCK: SVG Icon Notiflix: end
    // LOADING: Get Internal CSS Codes: begin
    var loadingGetInternalCSSCodes = function() {
        var loadingCSS = '[id^=NotiflixLoadingWrap]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:fixed;z-index:4000;width:100%;height:100%;left:0;top:0;right:0;bottom:0;margin:auto;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:center;-webkit-box-sizing:border-box;box-sizing:border-box;background:rgba(0,0,0,.8);font-family:"Quicksand",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif}[id^=NotiflixLoadingWrap] *{-webkit-box-sizing:border-box;box-sizing:border-box}[id^=NotiflixLoadingWrap].nx-loading-click-to-close{cursor:pointer}[id^=NotiflixLoadingWrap]>div[class*="-icon"]{width:60px;height:60px;position:relative;-webkit-transition:top .2s ease-in-out;-o-transition:top .2s ease-in-out;transition:top .2s ease-in-out;margin:0 auto}[id^=NotiflixLoadingWrap]>div[class*="-icon"] img,[id^=NotiflixLoadingWrap]>div[class*="-icon"] svg{max-width:unset;max-height:unset;width:100%;height:auto;position:absolute;left:0;top:0}[id^=NotiflixLoadingWrap]>p{position:relative;margin:10px auto 0;font-family:inherit!important;font-weight:normal;font-size:15px;line-height:1.4;padding:0 10px;width:100%;text-align:center}[id^=NotiflixLoadingWrap].nx-with-animation{-webkit-animation:loading-animation-fade .3s ease-in-out 0s normal;animation:loading-animation-fade .3s ease-in-out 0s normal}@-webkit-keyframes loading-animation-fade{0%{opacity:0}100%{opacity:1}}@keyframes loading-animation-fade{0%{opacity:0}100%{opacity:1}}[id^=NotiflixLoadingWrap].nx-with-animation.nx-remove{opacity:0;-webkit-animation:loading-animation-fade-remove .3s ease-in-out 0s normal;animation:loading-animation-fade-remove .3s ease-in-out 0s normal}@-webkit-keyframes loading-animation-fade-remove{0%{opacity:1}100%{opacity:0}}@keyframes loading-animation-fade-remove{0%{opacity:1}100%{opacity:0}}[id^=NotiflixLoadingWrap]>p.nx-loading-message-new{-webkit-animation:loading-new-message-fade .3s ease-in-out 0s normal;animation:loading-new-message-fade .3s ease-in-out 0s normal}@-webkit-keyframes loading-new-message-fade{0%{opacity:0}100%{opacity:1}}@keyframes loading-new-message-fade{0%{opacity:0}100%{opacity:1}}';
        return loadingCSS || null;
    };
    // LOADING: Get Internal CSS Codes: end
    // LOADING: Create: begin
    var loadingCreate = function(loadingType, messageOrOptions, options, display, delay) {
        // check doc body
        if (!commonCheckHeadOrBody("body")) return false;
        // if not initialized pretend like init
        if (!newLoadingSettings) Notiflix.Loading.init({});
        // create a backup for new settings
        var newLoadingSettingsBackup = commonExtendOptions(true, newLoadingSettings, {});
        // check "messageOrOptions" and "options": begin
        if (typeof messageOrOptions === "object" && !Array.isArray(messageOrOptions) || typeof options === "object" && !Array.isArray(options)) {
            // new options
            var newOptions = {};
            if (typeof messageOrOptions === "object") newOptions = messageOrOptions;
            else if (typeof options === "object") newOptions = options;
            // extend new settings with the new options
            newLoadingSettings = commonExtendOptions(true, newLoadingSettings, newOptions);
        }
        // check "messageOrOptions" and "options": end
        // check the message
        var message = "";
        if (typeof messageOrOptions === "string" && messageOrOptions.length > 0) message = messageOrOptions;
        // show loading
        if (display) {
            // if message settings: begin
            if (message.length > newLoadingSettings.messageMaxLength) message = commonGetPlaintext(message).toString().substring(0, newLoadingSettings.messageMaxLength) + "...";
            else message = commonGetPlaintext(message).toString();
            var messageHTML = "";
            if (message.length > 0) messageHTML = '<p id="' + newLoadingSettings.messageID + '" class="nx-loading-message" style="color:' + newLoadingSettings.messageColor + ";font-size:" + newLoadingSettings.messageFontSize + ';">' + message + "</p>";
            // if message settings: end
            // if cssAnimaion is false => duration: begin
            if (!newLoadingSettings.cssAnimation) newLoadingSettings.cssAnimationDuration = 0;
            // if cssAnimaion is false => duration: end
            // svgIcon: begin
            var svgIcon = "";
            if (loadingType === typesLoading.Standard) svgIcon = loadingAndBlockSvgIconStandard(newLoadingSettings.svgSize, newLoadingSettings.svgColor);
            else if (loadingType === typesLoading.Hourglass) svgIcon = loadingAndBlockSvgIconHourglass(newLoadingSettings.svgSize, newLoadingSettings.svgColor);
            else if (loadingType === typesLoading.Circle) svgIcon = loadingAndBlockSvgIconCircle(newLoadingSettings.svgSize, newLoadingSettings.svgColor);
            else if (loadingType === typesLoading.Arrows) svgIcon = loadingAndBlockSvgIconArrows(newLoadingSettings.svgSize, newLoadingSettings.svgColor);
            else if (loadingType === typesLoading.Dots) svgIcon = loadingAndBlockSvgIconDots(newLoadingSettings.svgSize, newLoadingSettings.svgColor);
            else if (loadingType === typesLoading.Pulse) svgIcon = loadingAndBlockSvgIconPulse(newLoadingSettings.svgSize, newLoadingSettings.svgColor);
            else if (loadingType === typesLoading.Custom && newLoadingSettings.customSvgCode !== null && newLoadingSettings.customSvgUrl === null) svgIcon = newLoadingSettings.customSvgCode || "";
            else if (loadingType === typesLoading.Custom && newLoadingSettings.customSvgUrl !== null && newLoadingSettings.customSvgCode === null) svgIcon = '<img class="nx-custom-loading-icon" width="' + newLoadingSettings.svgSize + '" height="' + newLoadingSettings.svgSize + '" src="' + newLoadingSettings.customSvgUrl + '" alt="Notiflix">';
            else if (loadingType === typesLoading.Custom && (newLoadingSettings.customSvgUrl === null || newLoadingSettings.customSvgCode === null)) {
                commonConsoleError('You have to set a static SVG url to "customSvgUrl" option to use Loading Custom.');
                return false;
            } else svgIcon = loadingAndBlockSvgIconNotiflix(newLoadingSettings.svgSize, "#f8f8f8", "#32c682");
            var svgSizeAsDigit = parseInt((newLoadingSettings.svgSize || "").replace(/[^0-9]/g, ""));
            var winWidth = window1.innerWidth;
            var maxSvgWidthPx = svgSizeAsDigit >= winWidth ? winWidth - 40 + "px" : svgSizeAsDigit + "px";
            var svgIconHTML = '<div style="width:' + maxSvgWidthPx + "; height:" + maxSvgWidthPx + ';" class="' + newLoadingSettings.className + "-icon" + (message.length > 0 ? " nx-with-message" : "") + '">' + svgIcon + "</div>";
            // svgIcon: end
            // loading wrap: begin
            var ntflxLoadingWrap = window1.document.createElement("div");
            ntflxLoadingWrap.id = loadingSettings.ID;
            ntflxLoadingWrap.className = newLoadingSettings.className + (newLoadingSettings.cssAnimation ? " nx-with-animation" : "") + (newLoadingSettings.clickToClose ? " nx-loading-click-to-close" : "");
            ntflxLoadingWrap.style.zIndex = newLoadingSettings.zindex;
            ntflxLoadingWrap.style.background = newLoadingSettings.backgroundColor;
            ntflxLoadingWrap.style.animationDuration = newLoadingSettings.cssAnimationDuration + "ms";
            ntflxLoadingWrap.style.fontFamily = '"' + newLoadingSettings.fontFamily + '", ' + defaultFontFamily;
            ntflxLoadingWrap.style.display = "flex";
            ntflxLoadingWrap.style.flexWrap = "wrap";
            ntflxLoadingWrap.style.flexDirection = "column";
            ntflxLoadingWrap.style.alignItems = "center";
            ntflxLoadingWrap.style.justifyContent = "center";
            // rtl: begin
            if (newLoadingSettings.rtl) {
                ntflxLoadingWrap.setAttribute("dir", "rtl");
                ntflxLoadingWrap.classList.add("nx-rtl-on");
            }
            // rtl: end
            // append: begin
            ntflxLoadingWrap.innerHTML = svgIconHTML + messageHTML;
            // if there is no loading element
            if (!window1.document.getElementById(ntflxLoadingWrap.id)) {
                // append
                window1.document.body.appendChild(ntflxLoadingWrap);
                // if click to close
                if (newLoadingSettings.clickToClose) {
                    var loadingWrapElm = window1.document.getElementById(ntflxLoadingWrap.id);
                    loadingWrapElm.addEventListener("click", function() {
                        ntflxLoadingWrap.classList.add("nx-remove");
                        var timeout = setTimeout(function() {
                            if (ntflxLoadingWrap.parentNode !== null) {
                                ntflxLoadingWrap.parentNode.removeChild(ntflxLoadingWrap);
                                clearTimeout(timeout);
                            }
                        }, newLoadingSettings.cssAnimationDuration);
                    });
                }
            }
        // append: end
        } else // if there is a loading element
        if (window1.document.getElementById(loadingSettings.ID)) {
            var loadingElm = window1.document.getElementById(loadingSettings.ID);
            var timeout = setTimeout(function() {
                loadingElm.classList.add("nx-remove");
                var timeout2 = setTimeout(function() {
                    if (loadingElm.parentNode !== null) {
                        loadingElm.parentNode.removeChild(loadingElm);
                        clearTimeout(timeout2);
                    }
                }, newLoadingSettings.cssAnimationDuration);
                clearTimeout(timeout);
            }, delay);
        }
        // extend new settings with the backup settings
        newLoadingSettings = commonExtendOptions(true, newLoadingSettings, newLoadingSettingsBackup);
    };
    // LOADING: Create: end
    // LOADING: Change Message: begin
    var loadingChangeMessage = function(newMessage) {
        // check the new message
        if (typeof newMessage !== "string") newMessage = "";
        // if has any loading
        var messageWrap = window1.document.getElementById(loadingSettings.ID);
        if (messageWrap) {
            // if there is a new message
            if (newMessage.length > 0) {
                // max length: begin
                if (newMessage.length > newLoadingSettings.messageMaxLength) newMessage = commonGetPlaintext(newMessage).substring(0, newLoadingSettings.messageMaxLength) + "...";
                else newMessage = commonGetPlaintext(newMessage);
                // max length: end
                // there is a message element
                var oldMessageElm = messageWrap.getElementsByTagName("p")[0];
                if (oldMessageElm) oldMessageElm.innerHTML = newMessage; // change the message
                else {
                    // create a new message element: begin
                    var newMessageHTML = window1.document.createElement("p");
                    newMessageHTML.id = newLoadingSettings.messageID;
                    newMessageHTML.className = "nx-loading-message nx-loading-message-new";
                    newMessageHTML.style.color = newLoadingSettings.messageColor;
                    newMessageHTML.style.fontSize = newLoadingSettings.messageFontSize;
                    newMessageHTML.innerHTML = newMessage;
                    messageWrap.appendChild(newMessageHTML);
                // create a new message element: end
                }
            } else commonConsoleError("Where is the new message?");
        }
    };
    // LOADING: Change Message: end
    var Notiflix = {
        Loading: {
            // Init
            init: function(userLoadingOptions) {
                // extend options
                newLoadingSettings = commonExtendOptions(true, loadingSettings, userLoadingOptions);
                // internal css if exist
                commonSetInternalCSSCodes(loadingGetInternalCSSCodes, "NotiflixLoadingInternalCSS");
            },
            // Merge First Init
            merge: function(userLoadingExtendOptions) {
                // if initialized already
                if (newLoadingSettings) newLoadingSettings = commonExtendOptions(true, newLoadingSettings, userLoadingExtendOptions);
                else {
                    commonConsoleError("You have to initialize the Loading module before call Merge function.");
                    return false;
                }
            },
            // Standard
            standard: function(messageOrOptions, options) {
                loadingCreate(typesLoading.Standard, messageOrOptions, options, true, 0); // true => show && 0 => delay
            },
            // Hourglass
            hourglass: function(messageOrOptions, options) {
                loadingCreate(typesLoading.Hourglass, messageOrOptions, options, true, 0); // true => show && 0 => delay
            },
            // Circle
            circle: function(messageOrOptions, options) {
                loadingCreate(typesLoading.Circle, messageOrOptions, options, true, 0); // true => show && 0 => delay
            },
            // Arrows
            arrows: function(messageOrOptions, options) {
                loadingCreate(typesLoading.Arrows, messageOrOptions, options, true, 0); // true => show && 0 => delay
            },
            // Dots
            dots: function(messageOrOptions, options) {
                loadingCreate(typesLoading.Dots, messageOrOptions, options, true, 0); // true => show && 0 => delay
            },
            // Pulse
            pulse: function(messageOrOptions, options) {
                loadingCreate(typesLoading.Pulse, messageOrOptions, options, true, 0); // true => show && 0 => delay
            },
            // Custom
            custom: function(messageOrOptions, options) {
                loadingCreate(typesLoading.Custom, messageOrOptions, options, true, 0); // true => show && 0 => delay
            },
            // Notiflix
            notiflix: function(messageOrOptions, options) {
                loadingCreate(typesLoading.Notiflix, messageOrOptions, options, true, 0); // true => show && 0 => delay
            },
            // Remove
            remove: function(delay) {
                if (typeof delay !== "number") delay = 0;
                loadingCreate(null, null, null, false, delay); // false => hide/remove
            },
            // Change The Message
            change: function(newMessage) {
                loadingChangeMessage(newMessage);
            }
        }
    };
    if (typeof window1.Notiflix === "object") return commonExtendOptions(true, window1.Notiflix, {
        Loading: Notiflix.Loading
    });
    else return {
        Loading: Notiflix.Loading
    };
});

});

})();
//# sourceMappingURL=index.af8d93ba.js.map
